import {
  ANNO_SCALE_MAX,
  ANNO_SCALE_MIN,
  APPROX_CHAR_WIDTH_FACTOR,
  BOOL_EPS,
  BUILTIN_LINETYPES,
  BUILTIN_TEMPLATE_ID,
  CAD_FONTS,
  CAPTURE_DPI,
  CHAR_W_RATIO,
  DEFAULT_FONT,
  DEFAULT_GEOREF,
  DEFAULT_HATCH_LINEWEIGHT,
  DEFAULT_HATCH_PATTERN,
  DEFAULT_LAYER,
  DEFAULT_LINEWEIGHT_MM,
  DEFAULT_MODEL_MARGIN_MM,
  DEFAULT_TITLE_FIELDS,
  DIMSTYLE_DEFAULTS,
  DIM_AUTOBASE_RATIO,
  DIM_OVERRIDE_FIELDS,
  DIM_OVERRIDE_KEYS,
  DIM_TEXT_K,
  DIM_TEXT_MAX,
  DIM_TEXT_MIN,
  DRAWING_SETTINGS_KEYS,
  DXFExporter_default,
  ENTITY_TYPES,
  FIELD_CODES,
  GEODATA_COORD_GEOGRAPHIC,
  GEODATA_COORD_LOCAL_GRID,
  GEODATA_COORD_PROJECTED_GRID,
  GEODATA_DICT_ENTRY,
  GEODATA_VERSION,
  GEOREF_CRS_PATTERN,
  GEOREF_MAX_BASEMAPS,
  GEOTECH_BLOCKS,
  GROUP_NAME_MAX,
  HATCH_LINEWEIGHT_MAX,
  HATCH_LINEWEIGHT_MIN,
  HATCH_PATTERNS,
  HATCH_PATTERN_NAMES,
  IDENT,
  IMAGE_MIN_EDGE,
  LARGE,
  LAYER_NAME_MAX_LENGTH,
  LEGACY_CARRIER_FIELDS,
  LINETYPE_DEFS,
  LINEWEIGHTS_MM,
  LINEWEIGHT_DISPLAY_PX_PER_MM,
  MAX_DEFINITION_CHARS,
  MAX_PAGE_MEGAPIXELS,
  MODEL_UNIT_MM,
  MTEXT_DEFAULT_LINE_SPACING,
  OCS_WORLD,
  PAPER_SIZES,
  PAPER_TEXT_MM,
  PAPER_WIDTH_MM,
  PLOT_SCALE_FIT,
  PLOT_STYLE_MAX_ENTRIES,
  PLOT_STYLE_MODES,
  PRECISE_SNAP_TYPES,
  PX_PER_MM,
  RAD2DEG,
  RESERVED_STYLE_KEYS,
  SCALEBAR_MIXED_TEXT,
  SCALEBAR_NONE_TEXT,
  SCALE_MAX,
  SCALE_MIN,
  SHEET_SYMBOL_PEN_MM,
  SHEET_SYMBOL_TYPES,
  SHEET_ZOOM_MAX_FIT,
  SHEET_ZOOM_MIN_FIT,
  SNAP_LABELS,
  STYLE_ONLY_FIELDS,
  TABLE_CELL_KEY_RE,
  TABLE_MAX_CELLS,
  TEXTSTYLE_DEFAULTS,
  VIEWPORT_SCALE_PRESETS,
  aci2int,
  addAnnotation,
  addBasemap,
  addLayout,
  addPolylineVertex,
  addViewport,
  alignEntities,
  alignTransform,
  angleInArcSweep,
  angularFromTwoLines,
  angularGeometry,
  angularMeasure,
  annotationBoxMm,
  annotationRotatable,
  annotationTextHeight,
  annotativeStyleOf,
  apply,
  applyImportOffset,
  approxMeasure,
  arcMidAngle,
  arclengthGeometry,
  arrowShape,
  arrowStrokes,
  arrowTriangle,
  asPolyline,
  attachXref,
  attachedDimensionIds,
  autoAnnotationScale,
  autoDimBaseHeight,
  autoTextHeight,
  baselineLinePoint,
  bindXref,
  booleanRegions,
  boundaryFromEntities,
  boxesOverlap,
  buildPolygons,
  bulgeToArc,
  cadModelToDXF,
  cadModelToDXFDetailed,
  captureDpiFor,
  carryStyle,
  chainStep,
  chooseHatchBoundary,
  chunkDefinition,
  circleCircleIntersections,
  clampHatchLineWeight,
  clampLineweight,
  clampScale,
  clampSheetView,
  clearBasemaps,
  cloneDefs,
  cloneEntity,
  closestEntityWithin,
  closestPointOnSegment,
  computeImportOffset,
  createBlankDocument,
  createGroup,
  crsCodeFromDefinition,
  cullToWorldRect,
  currentLayerFrozenError,
  deconflictLabels,
  defaultSettings,
  defaultViewportForModel,
  deleteLayout,
  deriveSheetScale,
  detachXref,
  dimOverrideDisplay,
  dimOverrideFieldsFor,
  dimOverrides,
  dimTextOffset,
  dimensionGeometry,
  dimensionLabel,
  dimensionMeasure,
  dimensionPrimitives,
  dimensionTextAnchor,
  dimensionTextColor,
  distance,
  distanceToDimension,
  distanceToEntity,
  distanceToHatch,
  distanceToXrefFrame,
  docAttachImageDef,
  documentAnnotationScale,
  documentBounds,
  documentGroups,
  drawnBlockChildren,
  easeInOutCubic,
  editableEntity,
  effectiveArrowSize,
  effectiveBaselineSpacing,
  effectiveEntityTextHeight,
  effectiveExtExtend,
  effectiveExtOffset,
  effectiveTextGap,
  effectiveTextHeight,
  ellipseParamAt,
  ellipsePoint,
  ellipseQuadrants,
  ellipseSweep,
  ellipseToPolyline,
  emptyPlotStyleTable,
  entitiesInLasso,
  entitiesInSelectionBox,
  entitiesThroughPoints,
  entityBounds,
  entityContext,
  entityInMarquee,
  entityLength,
  entityOutlinePoints,
  entityPaperHeight,
  entitySegments,
  entityVertices,
  expandGroupSelection,
  explodeAttributeLoss,
  explodeInsert,
  explodeRegion,
  fieldCodeLabel,
  fieldLayoutFor,
  findClosedBoundaryAt,
  findHatchIslands,
  findRegionBoundaryAt,
  findSnap,
  fitExtents,
  fitRectToCanvasRect,
  fitRectToViewport,
  fitSelection,
  fitSheetView,
  fitView,
  formatArchitectural,
  formatCoord,
  formatGridCoord,
  formatMeasure,
  formatScale,
  framingBounds,
  freezeCurrentLayerError,
  genId,
  getLayer,
  getLayout,
  gisMode,
  gridToWorld,
  groupById,
  groupOf,
  groupRefusal,
  hasDimOverrides,
  hasImageFrame,
  hatchArea,
  hatchFillsPoint,
  hatchLineWeight,
  hatchRegionsDetailed,
  hatchSourceIds,
  healFieldBindings,
  hexFromInt,
  identityCtx,
  imageCorners,
  imageDataUrl,
  imageDefFor,
  imageFlipped,
  imageFromPlacement,
  imageHeight,
  imageMatrix,
  imageRotationDeg,
  imageWidth,
  initialFieldValues,
  insertMatrix,
  int2aci,
  intersectEntities,
  intersectRegions,
  isAnnotative,
  isBasemapId,
  isBooleanOperand,
  isClosedBoundary,
  isDimOverrideKey,
  isDrawingSetting,
  isFieldCode,
  isFitSpline,
  isFullEllipse,
  isMonoPlot,
  isPrecisePointSnap,
  isSafeStyleName,
  isValidDimOverride,
  joinDefinition,
  justifyFactors,
  justifyOffset,
  layerFrozen,
  layerIndex,
  layerLocked,
  layerNameError,
  layerNameKey,
  layerOverridesHash,
  layerPlotted,
  layerRenameError,
  layerShown,
  layoutMText,
  layoutPaperDims,
  leaderGeometry,
  lerpView,
  lineIntersection,
  lineLineIntersection,
  linearOrientation,
  linetypeToDash,
  lineweightFromDxf,
  lineweightToScreenPx,
  lockedEntityIds,
  makeDimChain,
  makeDimSizing,
  makeDimension,
  makeHatch,
  makePlotPenResolver,
  makeRegions,
  mapArc,
  mapCircle,
  mapDimension,
  mapDimensionPoints,
  mapEllipse,
  mapHatch,
  mapHatchGeometry,
  mapHatchRegions,
  mapInsert,
  mapLine,
  mapMText,
  mapPoint,
  mapPolyline,
  mapSolid,
  mapSpline,
  mapSplinePoints,
  mapText,
  matMul,
  migrateAnnotativeEntity,
  minimalCrsXml,
  mirrorEntities,
  mirrorEntity,
  mmToPx,
  modelLayout,
  modelUnitMm,
  mtextBoxCorners,
  mtextGripPoints,
  mtextLocal,
  mtextToWorld,
  mtextWidthPatch,
  nearestOnEntity,
  niceGroundLength,
  normalizeCanvasRect,
  normalizeCoords,
  normalizeDocument,
  normalizeFieldTag,
  normalizeGeoref,
  normalizeGroupName,
  normalizeGroups,
  normalizeImageDef,
  normalizeImageEntity,
  normalizeLayerName,
  normalizeLinetypeName,
  normalizeMargin,
  normalizePageSetup,
  normalizePlotScale,
  normalizePlotStyleTable,
  normalizeSettings,
  normalizeSheetSymbol,
  northArrowDrawList,
  ocsCtx,
  ocsTransform,
  offsetEntity,
  offsetRefusal,
  onCirclePoint,
  ordinateAxis,
  ordinateGeometry,
  orientRing,
  orientRingSet,
  orphanImageDefIds,
  paintedArea,
  paperDims,
  paperMmToModel,
  paperPxToModel,
  parseScale,
  partitionLockedIds,
  perpendicularFoot,
  placeAttribute,
  placeBlockChild,
  placeTemplate,
  planGeodata,
  plotPenFor,
  pointInPolygon,
  pointInRotRect,
  pointToSegment,
  polygonArea,
  polygonPoints,
  polylineWidthWorld,
  pruneGroups,
  pxToMm,
  quickSelectMatch,
  radialGeometry,
  readGeodata,
  rebuildHatch,
  rectCenter,
  rectCorners,
  rectCornersRot,
  reframeAttributes,
  refreshFields,
  regionArea,
  regionFillsPoint,
  regionRings,
  reloadXref,
  removeAnnotation,
  removeBasemap,
  removePolylineVertex,
  removeViewport,
  renameGroup,
  renameLayer,
  renameLayout,
  resizeImage,
  resizeRect,
  resolveAnnotationScale,
  resolveColor,
  resolveDeferredTangent,
  resolveDimStyle,
  resolveField,
  resolveLinetypeName,
  resolveLinetypePattern,
  resolveLineweightMm,
  resolveTextCollision,
  resolveTextStyle,
  resolveUserDimScale,
  revisionCloudArcs,
  revisionCloudBumps,
  ringArea,
  ringDifference,
  ringIntersection,
  ringUnion,
  rotateEntities,
  rotateEntity,
  rotateVec,
  roundOrigin,
  sameExtrusion,
  sameGeoref,
  sameGeorefFrame,
  sameView,
  sanitizeDimOverrides,
  scaleBarDrawList,
  scaleBarSpec,
  scaleEntities,
  scaleEntity,
  scaleViewportKeepingFrame,
  scaledCtx,
  screenToPaperPx,
  screenToWorld,
  segCircleIntersections,
  segCuts,
  segSegIntersection,
  selectableEntities,
  selectableEntity,
  setBasemapsVisible,
  setGroupSelectable,
  setPageSetup,
  sheetScaleBinding,
  sheetScaleDenom,
  sheetTextBoxMm,
  shownEntities,
  signedArea,
  sizingAnnoScale,
  snapLabel,
  snapRect,
  snapToGrid,
  splineArcLengthParams,
  splineDefiningPoints,
  splinePointAt,
  splineToPolyline,
  statedExtrusion,
  stripMText,
  subtractRegions,
  supplementParsedDxf,
  supportsDimOverrides,
  syncAnnotativeEntity,
  syncAnnotativeHeights,
  tableColEdgePatch,
  tableCorners,
  tableGripPoints,
  tableLayout,
  tableLocal,
  tableMinColWidth,
  tableMinRowHeight,
  tableRowEdgePatch,
  tableScalePatch,
  tableToWorld,
  tangentPointsToCircle,
  templateBounds,
  templateToDrawList,
  tessellateHatch,
  textBox,
  textBoxCorners,
  transformEntity,
  transformImageFrame,
  transformPoint,
  translateEntity,
  unfrozenEntities,
  ungroup,
  unionRegions,
  uniqueGroupName,
  unitScaleFromHeader,
  unplaceAttribute,
  updateAnnotation,
  updateBasemap,
  updateHatchCache,
  updateLayout,
  updateViewport,
  usableMargin,
  viewportAnnotationScale,
  viewportContentAffine,
  viewportFrameMm,
  viewportPaperRectMm,
  viewportPrintMetresPerPixel,
  viewportRectPx,
  withDimOverride,
  worldToGrid,
  worldToScreen,
  worldToTableCell,
  worldToYDown,
  worldToYDownAngle,
  worldToYDownFrom,
  writeGeodataObjects,
  xrefFrameBounds,
  xrefLayerVisible,
  yDownToWorld,
  zoomAt,
  zoomByFactor,
  zoomToScreenBox
} from "./chunk-B7AQMZVU.js";

// src/cadModify/shared.js
var sub = (a, b) => ({ x: a.x - b.x, y: a.y - b.y });
var add = (a, b) => ({ x: a.x + b.x, y: a.y + b.y });
var mul = (a, s) => ({ x: a.x * s, y: a.y * s });
var dot = (a, b) => a.x * b.x + a.y * b.y;
var len = (a) => Math.hypot(a.x, a.y);
var unit = (a) => {
  const l = len(a) || 1;
  return { x: a.x / l, y: a.y / l };
};
var lerp = (a, b, t) => ({ x: a.x + (b.x - a.x) * t, y: a.y + (b.y - a.y) * t });
var norm360 = (a) => (a % 360 + 360) % 360;
var degOf = (v) => Math.atan2(v.y, v.x) * 180 / Math.PI;
var onCircle = (c, r, deg2) => ({ x: c.x + r * Math.cos(deg2 * Math.PI / 180), y: c.y + r * Math.sin(deg2 * Math.PI / 180) });
var carry = (e, props) => carryStyle(e, props);
var lineParam = (p, a, b) => {
  const d = sub(b, a);
  const l2 = dot(d, d);
  return l2 ? dot(sub(p, a), d) / l2 : 0;
};
var lineFromTo = (e, a, b) => carry(e, { type: "line", x1: a.x, y1: a.y, x2: b.x, y2: b.y });
function decimate(points, maxN = 24) {
  const n = points.length;
  if (n <= maxN) return points.map((p) => ({ ...p }));
  const out = [];
  const stride = (n - 1) / (maxN - 1);
  for (let i = 0; i < maxN; i++) out.push({ ...points[Math.round(i * stride)] });
  out[out.length - 1] = { ...points[n - 1] };
  return out;
}
var ellipseArc = (e, startDeg, endDeg) => carry(e, { type: "ellipse", cx: e.cx, cy: e.cy, rx: e.rx, ry: e.ry, rotation: e.rotation || 0, startAngle: startDeg, endAngle: endDeg });

// src/cadModify/trim.js
var dedupParams = (arr, tol = 1e-6) => {
  const s = [...arr].sort((a, b) => a - b);
  const out = [];
  for (const v of s) if (!out.length || v - out[out.length - 1] > tol) out.push(v);
  return out;
};
var intervalContaining = (bounds, ct) => {
  for (let i = 0; i < bounds.length - 1; i++) {
    if (ct >= bounds[i] - 1e-9 && ct <= bounds[i + 1] + 1e-9) return [bounds[i], bounds[i + 1]];
  }
  return [bounds[0], bounds[1]];
};
function trimEntity(entity, cuttingEdges, clickPoint) {
  return trimResult(entity, withoutImages(cuttingEdges), clickPoint).survivors;
}
function trimPreviewPiece(entity, cuttingEdges, clickPoint) {
  return trimResult(entity, withoutImages(cuttingEdges), clickPoint).removed;
}
function trimAlongFence(entities, fenceP1, fenceP2, cutters) {
  cutters = withoutImages(cutters);
  const fence = { type: "line", x1: fenceP1.x, y1: fenceP1.y, x2: fenceP2.x, y2: fenceP2.y };
  const out = [];
  for (const e of entities) {
    const hits = intersectEntities(fence, e);
    if (!hits.length) continue;
    const others = cutters.filter((c) => c.id !== e.id);
    if (!others.length) continue;
    let pieces = [e];
    for (const hp of hits) {
      const next = [];
      for (const piece of pieces) {
        if (distanceToEntity(piece, hp) <= 1e-6) next.push(...trimEntity(piece, others, hp));
        else next.push(piece);
      }
      pieces = next;
    }
    if (pieces.length === 1 && pieces[0] === e) continue;
    out.push({ id: e.id, survivors: pieces });
  }
  return out;
}
var withoutImages = (list) => Array.isArray(list) ? list.filter((e) => !e || e.type !== "image") : list;
function trimResult(entity, cutters, click) {
  switch (entity.type) {
    case "line":
      return trimLine(entity, cutters, click);
    case "arc":
      return trimArc(entity, cutters, click);
    case "circle":
      return trimCircle(entity, cutters, click);
    case "ellipse":
      return trimEllipse(entity, cutters, click);
    case "spline":
      return trimSpline(entity, cutters, click);
    case "polyline":
      return trimPolyline(entity, cutters, click);
    case "rectangle":
      return trimRectangle(entity, cutters, click);
    default:
      return { survivors: [entity], removed: null };
  }
}
function trimRectangle(e, cutters, click) {
  const corners = [
    { x: e.x, y: e.y },
    { x: e.x + e.width, y: e.y },
    { x: e.x + e.width, y: e.y + e.height },
    { x: e.x, y: e.y + e.height }
  ];
  const poly = carry(e, { type: "polyline", points: corners, closed: true });
  const res = trimPolyline(poly, cutters, click);
  if (res.survivors.length === 1 && res.survivors[0] === poly) {
    return { survivors: [e], removed: null };
  }
  return res;
}
function trimLine(e, cutters, click) {
  const a = { x: e.x1, y: e.y1 };
  const b = { x: e.x2, y: e.y2 };
  const ts = [];
  for (const ce of cutters) for (const ip of intersectEntities(e, ce)) {
    const t = lineParam(ip, a, b);
    if (t > 1e-6 && t < 1 - 1e-6) ts.push(t);
  }
  if (!ts.length) return { survivors: [e], removed: null };
  const bounds = [0, ...dedupParams(ts), 1];
  const ct = Math.min(1, Math.max(0, lineParam(click, a, b)));
  const [lo, hi] = intervalContaining(bounds, ct);
  const survivors = [];
  const pushSpan = (s, en) => {
    const A = lerp(a, b, s);
    const B = lerp(a, b, en);
    if (distance(A, B) > 1e-9) survivors.push(lineFromTo(e, A, B));
  };
  pushSpan(0, lo);
  pushSpan(hi, 1);
  const rA = lerp(a, b, lo);
  const rB = lerp(a, b, hi);
  const removed = distance(rA, rB) > 1e-9 ? lineFromTo(e, rA, rB) : null;
  return { survivors: survivors.length ? survivors : [e], removed };
}
function trimArc(e, cutters, click) {
  const c = { x: e.cx, y: e.cy };
  const sweep = norm360(e.endAngle - e.startAngle) || 360;
  const param = (p) => norm360(degOf(sub(p, c)) - e.startAngle);
  const ts = [];
  for (const ce of cutters) for (const ip of intersectEntities(e, ce)) {
    const t = param(ip);
    if (t > 1e-6 && t < sweep - 1e-6) ts.push(t);
  }
  if (!ts.length) {
    const sp = onCircle(c, e.r, e.startAngle);
    const ep = onCircle(c, e.r, e.endAngle);
    const onCutter = (p) => cutters.some((ce) => distanceToEntity(ce, p) <= 1e-6);
    if (onCutter(sp) && onCutter(ep)) return { survivors: [], removed: e };
    return { survivors: [e], removed: null };
  }
  const bounds = [0, ...dedupParams(ts), sweep];
  const ct = Math.min(sweep, Math.max(0, param(click)));
  const [lo, hi] = intervalContaining(bounds, ct);
  const arcSeg = (s, en) => carry(e, { type: "arc", cx: e.cx, cy: e.cy, r: e.r, startAngle: e.startAngle + s, endAngle: e.startAngle + en });
  const survivors = [];
  if (lo > 1e-7) survivors.push(arcSeg(0, lo));
  if (sweep - hi > 1e-7) survivors.push(arcSeg(hi, sweep));
  return { survivors: survivors.length ? survivors : [e], removed: arcSeg(lo, hi) };
}
function trimCircle(e, cutters, click) {
  const c = { x: e.cx, y: e.cy };
  const ang = (p) => norm360(degOf(sub(p, c)));
  const raw = [];
  for (const ce of cutters) for (const ip of intersectEntities(e, ce)) raw.push(ang(ip));
  const ts = dedupParams(raw);
  if (ts.length < 2) return { survivors: [e], removed: null };
  const ct = ang(click);
  let lo = null;
  let hi = null;
  for (let i = 0; i < ts.length; i++) {
    const a = ts[i];
    const next = ts[(i + 1) % ts.length];
    const b = i + 1 === ts.length ? next + 360 : next;
    let cc = ct;
    if (cc < a) cc += 360;
    if (cc >= a - 1e-9 && cc <= b + 1e-9) {
      lo = a;
      hi = next;
      break;
    }
  }
  if (lo === null) return { survivors: [e], removed: null };
  return {
    survivors: [carry(e, { type: "arc", cx: e.cx, cy: e.cy, r: e.r, startAngle: hi, endAngle: lo })],
    removed: carry(e, { type: "arc", cx: e.cx, cy: e.cy, r: e.r, startAngle: lo, endAngle: hi })
  };
}
function trimEllipse(e, cutters, click) {
  const param = (p) => ellipseParamAt(e, p);
  if (isFullEllipse(e)) {
    const raw = [];
    for (const ce of cutters) for (const ip of intersectEntities(e, ce)) raw.push(param(ip));
    const ts2 = dedupParams(raw);
    if (ts2.length < 2) return { survivors: [e], removed: null };
    const ct2 = param(click);
    let lo2 = null;
    let hi2 = null;
    for (let i = 0; i < ts2.length; i++) {
      const a = ts2[i];
      const next = ts2[(i + 1) % ts2.length];
      const b = i + 1 === ts2.length ? next + 360 : next;
      let cc = ct2;
      if (cc < a) cc += 360;
      if (cc >= a - 1e-9 && cc <= b + 1e-9) {
        lo2 = a;
        hi2 = next;
        break;
      }
    }
    if (lo2 === null) return { survivors: [e], removed: null };
    return { survivors: [ellipseArc(e, hi2, lo2)], removed: ellipseArc(e, lo2, hi2) };
  }
  const sweep = ellipseSweep(e);
  const p2t = (p) => norm360(param(p) - e.startAngle);
  const ts = [];
  for (const ce of cutters) for (const ip of intersectEntities(e, ce)) {
    const t = p2t(ip);
    if (t > 1e-6 && t < sweep - 1e-6) ts.push(t);
  }
  if (!ts.length) {
    const sp = ellipsePoint(e, e.startAngle);
    const ep = ellipsePoint(e, e.endAngle);
    const onCutter = (p) => cutters.some((ce) => distanceToEntity(ce, p) <= 1e-6);
    if (onCutter(sp) && onCutter(ep)) return { survivors: [], removed: e };
    return { survivors: [e], removed: null };
  }
  const bounds = [0, ...dedupParams(ts), sweep];
  const ct = Math.min(sweep, Math.max(0, p2t(click)));
  const [lo, hi] = intervalContaining(bounds, ct);
  const seg = (s, en) => ellipseArc(e, e.startAngle + s, e.startAngle + en);
  const survivors = [];
  if (lo > 1e-7) survivors.push(seg(0, lo));
  if (sweep - hi > 1e-7) survivors.push(seg(hi, sweep));
  return { survivors: survivors.length ? survivors : [e], removed: seg(lo, hi) };
}
function trimPolyline(e, cutters, click) {
  const pts = e.points;
  const closed = !!e.closed;
  if (pts.length < 2) return { survivors: [e], removed: null };
  const segs = [];
  for (let i = 0; i < pts.length - 1; i++) segs.push([pts[i], pts[i + 1]]);
  if (closed && pts.length > 2) segs.push([pts[pts.length - 1], pts[0]]);
  const nSeg = segs.length;
  const pointAt = (param) => {
    let p = param;
    if (closed) p = (p % nSeg + nSeg) % nSeg;
    let i = Math.floor(p + 1e-9);
    let t = p - i;
    if (i >= nSeg) {
      i = nSeg - 1;
      t = 1;
    }
    if (i < 0) {
      i = 0;
      t = 0;
    }
    return lerp(segs[i][0], segs[i][1], t);
  };
  const ts = [];
  for (let i = 0; i < nSeg; i++) {
    const [a, b] = segs[i];
    const segE = { type: "line", x1: a.x, y1: a.y, x2: b.x, y2: b.y };
    for (const ce of cutters) for (const ip of intersectEntities(segE, ce)) {
      const lp = lineParam(ip, a, b);
      if (lp > 1e-6 && lp < 1 - 1e-6) ts.push(i + lp);
    }
  }
  if (!ts.length) return { survivors: [e], removed: null };
  const uts = dedupParams(ts);
  let cp = 0;
  let bestD = Infinity;
  for (let i = 0; i < nSeg; i++) {
    const cpt = closestPointOnSegment(click, segs[i][0], segs[i][1]);
    const d = distance(click, cpt);
    if (d < bestD) {
      bestD = d;
      cp = i + lineParam(cpt, segs[i][0], segs[i][1]);
    }
  }
  const buildSub = (from, to) => {
    const out = [pointAt(from)];
    for (let v = Math.ceil(from + 1e-9); v <= Math.floor(to - 1e-9); v++) out.push({ ...pointAt(v) });
    out.push(pointAt(to));
    const dd = [out[0]];
    for (let i = 1; i < out.length; i++) if (distance(out[i], dd[dd.length - 1]) > 1e-9) dd.push(out[i]);
    return dd;
  };
  const poly = (sub2) => sub2.length >= 2 ? carry(e, { type: "polyline", points: sub2, closed: false }) : null;
  if (!closed) {
    const bounds = [0, ...uts, nSeg];
    const [lo2, hi2] = intervalContaining(bounds, Math.min(nSeg, Math.max(0, cp)));
    const survivors = [];
    const before = poly(buildSub(0, lo2));
    const after = poly(buildSub(hi2, nSeg));
    if (before) survivors.push(before);
    if (after) survivors.push(after);
    return { survivors: survivors.length ? survivors : [e], removed: poly(buildSub(lo2, hi2)) };
  }
  if (uts.length < 2) return { survivors: [e], removed: null };
  let lo = null;
  let hi = null;
  for (let i = 0; i < uts.length; i++) {
    const a = uts[i];
    const next = uts[(i + 1) % uts.length];
    const b = i + 1 === uts.length ? next + nSeg : next;
    let cc = cp;
    if (cc < a) cc += nSeg;
    if (cc >= a - 1e-9 && cc <= b + 1e-9) {
      lo = a;
      hi = next;
      break;
    }
  }
  if (lo === null) return { survivors: [e], removed: null };
  const survivor = poly(buildSub(hi, lo < hi ? lo + nSeg : lo));
  const removed = poly(buildSub(lo, hi > lo ? hi : hi + nSeg));
  return { survivors: survivor ? [survivor] : [e], removed };
}
function trimSpline(e, cutters, click) {
  const tess = splineToPolyline(e);
  if (tess.length < 2) return { survivors: [e], removed: null };
  const proxy = carry(e, { type: "polyline", points: tess, closed: !!e.closed });
  const res = trimPolyline(proxy, cutters, click);
  if (res.survivors.length === 1 && res.survivors[0] === proxy) return { survivors: [e], removed: null };
  const toSpline = (poly) => poly && poly.type === "polyline" && poly.points.length >= 2 ? carry(e, { type: "spline", fitPoints: decimate(poly.points), degree: e.degree || 3, closed: false }) : poly;
  return { survivors: res.survivors.map(toSpline), removed: toSpline(res.removed) };
}

// src/cadModify/extend.js
function extendEntity(entity, boundaryEdges, clickPoint) {
  boundaryEdges = Array.isArray(boundaryEdges) ? boundaryEdges.filter((e) => !e || e.type !== "image") : boundaryEdges;
  switch (entity.type) {
    case "line":
      return extendLine(entity, boundaryEdges, clickPoint);
    case "polyline":
      return extendPolyline(entity, boundaryEdges, clickPoint);
    case "arc":
      return extendArc(entity, boundaryEdges, clickPoint);
    case "ellipse":
      return extendEllipse(entity, boundaryEdges, clickPoint);
    default:
      return null;
  }
}
function rayHit(o, d, boundary) {
  let best = Infinity;
  const boundarySegs = (e) => {
    if (e.type === "line") return [[{ x: e.x1, y: e.y1 }, { x: e.x2, y: e.y2 }]];
    if (e.type === "polyline") {
      const s = [];
      for (let i = 0; i < e.points.length - 1; i++) s.push([e.points[i], e.points[i + 1]]);
      if (e.closed && e.points.length > 2) s.push([e.points[e.points.length - 1], e.points[0]]);
      return s;
    }
    if (e.type === "rectangle") {
      const v = [{ x: e.x, y: e.y }, { x: e.x + e.width, y: e.y }, { x: e.x + e.width, y: e.y + e.height }, { x: e.x, y: e.y + e.height }];
      return [[v[0], v[1]], [v[1], v[2]], [v[2], v[3]], [v[3], v[0]]];
    }
    if (e.type === "ellipse" || e.type === "spline") return entitySegments(e);
    return [];
  };
  for (const [a, b] of boundarySegs(boundary)) {
    const ex = b.x - a.x;
    const ey = b.y - a.y;
    const den = ex * d.y - d.x * ey;
    if (Math.abs(den) < 1e-12) continue;
    const s = (ex * (a.y - o.y) - ey * (a.x - o.x)) / den;
    const u = (d.x * (a.y - o.y) - d.y * (a.x - o.x)) / den;
    if (s > 1e-6 && u >= -1e-9 && u <= 1 + 1e-9 && s < best) best = s;
  }
  if (boundary.type === "circle" || boundary.type === "arc") {
    const f = { x: o.x - boundary.cx, y: o.y - boundary.cy };
    const b2 = dot(d, f);
    const c2 = dot(f, f) - boundary.r * boundary.r;
    const disc = b2 * b2 - c2;
    if (disc >= 0) {
      const sq = Math.sqrt(disc);
      for (const s of [-b2 - sq, -b2 + sq]) {
        if (s > 1e-6 && s < best) {
          const hit = add(o, mul(d, s));
          if (boundary.type === "circle" || inArcSweep(boundary, hit)) best = s;
        }
      }
    }
  }
  return best;
}
var inArcSweep = (e, p) => {
  const sweep = norm360(e.endAngle - e.startAngle) || 360;
  return norm360(degOf(sub(p, { x: e.cx, y: e.cy })) - e.startAngle) <= sweep + 1e-6;
};
function extendLine(e, boundaries, click) {
  const A = { x: e.x1, y: e.y1 };
  const B = { x: e.x2, y: e.y2 };
  const moving = distance(click, A) <= distance(click, B) ? A : B;
  const other = moving === A ? B : A;
  const d = unit(sub(moving, other));
  let best = Infinity;
  let hit = null;
  for (const bnd of boundaries) {
    const s = rayHit(moving, d, bnd);
    if (s < best) {
      best = s;
      hit = add(moving, mul(d, s));
    }
  }
  if (!hit) return null;
  return moving === A ? carry(e, { type: "line", x1: hit.x, y1: hit.y, x2: B.x, y2: B.y }) : carry(e, { type: "line", x1: A.x, y1: A.y, x2: hit.x, y2: hit.y });
}
function extendPolyline(e, boundaries, click) {
  if (e.closed || e.points.length < 2) return null;
  const pts = e.points;
  const first = pts[0];
  const last = pts[pts.length - 1];
  const atStart = distance(click, first) <= distance(click, last);
  const moving = atStart ? first : last;
  const inner = atStart ? pts[1] : pts[pts.length - 2];
  const d = unit(sub(moving, inner));
  let best = Infinity;
  let hit = null;
  for (const bnd of boundaries) {
    const s = rayHit(moving, d, bnd);
    if (s < best) {
      best = s;
      hit = add(moving, mul(d, s));
    }
  }
  if (!hit) return null;
  const np = pts.map((p) => ({ ...p }));
  if (atStart) np[0] = hit;
  else np[np.length - 1] = hit;
  return carry(e, { type: "polyline", points: np, closed: false });
}
function extendArc(e, boundaries, click) {
  const c = { x: e.cx, y: e.cy };
  const startPt = onCircle(c, e.r, e.startAngle);
  const endPt = onCircle(c, e.r, e.endAngle);
  const atStart = distance(click, startPt) <= distance(click, endPt);
  const angles = [];
  const fullCircle = { type: "circle", cx: e.cx, cy: e.cy, r: e.r };
  for (const bnd of boundaries) for (const ip of intersectEntities(fullCircle, bnd)) angles.push(norm360(degOf(sub(ip, c))));
  if (!angles.length) return null;
  if (atStart) {
    let bestDelta2 = Infinity;
    let chosen2 = null;
    for (const a of angles) {
      const cw = norm360(e.startAngle - a);
      if (cw > 1e-6 && cw < bestDelta2) {
        bestDelta2 = cw;
        chosen2 = a;
      }
    }
    return chosen2 === null ? null : carry(e, { type: "arc", cx: e.cx, cy: e.cy, r: e.r, startAngle: chosen2, endAngle: e.endAngle });
  }
  let bestDelta = Infinity;
  let chosen = null;
  for (const a of angles) {
    const ccw = norm360(a - e.endAngle);
    if (ccw > 1e-6 && ccw < bestDelta) {
      bestDelta = ccw;
      chosen = a;
    }
  }
  return chosen === null ? null : carry(e, { type: "arc", cx: e.cx, cy: e.cy, r: e.r, startAngle: e.startAngle, endAngle: chosen });
}
function extendEllipse(e, boundaries, click) {
  if (isFullEllipse(e)) return null;
  const startPt = ellipsePoint(e, e.startAngle);
  const endPt = ellipsePoint(e, e.endAngle);
  const atStart = distance(click, startPt) <= distance(click, endPt);
  const fullEll = { ...e, startAngle: void 0, endAngle: void 0 };
  const angles = [];
  for (const bnd of boundaries) for (const ip of intersectEntities(fullEll, bnd)) angles.push(ellipseParamAt(e, ip));
  if (!angles.length) return null;
  if (atStart) {
    let bestDelta2 = Infinity;
    let chosen2 = null;
    for (const a of angles) {
      const cw = norm360(e.startAngle - a);
      if (cw > 1e-6 && cw < bestDelta2) {
        bestDelta2 = cw;
        chosen2 = a;
      }
    }
    return chosen2 === null ? null : ellipseArc(e, chosen2, e.endAngle);
  }
  let bestDelta = Infinity;
  let chosen = null;
  for (const a of angles) {
    const ccw = norm360(a - e.endAngle);
    if (ccw > 1e-6 && ccw < bestDelta) {
      bestDelta = ccw;
      chosen = a;
    }
  }
  return chosen === null ? null : ellipseArc(e, e.startAngle, chosen);
}

// src/cadModify/fillet.js
var keptEnd = (e, click, ip) => {
  const A = { x: e.x1, y: e.y1 };
  const B = { x: e.x2, y: e.y2 };
  const near = distance(click, A) <= distance(click, B) ? A : B;
  const far = near === A ? B : A;
  return distance(near, ip) < 1e-6 ? far : near;
};
function filletEntities(e1, e2, r, click1, click2) {
  if (e1.type !== "line" || e2.type !== "line") return null;
  const ip = lineLineIntersection(
    { x: e1.x1, y: e1.y1 },
    { x: e1.x2, y: e1.y2 },
    { x: e2.x1, y: e2.y1 },
    { x: e2.x2, y: e2.y2 }
  );
  if (!ip) return null;
  const kept1 = keptEnd(e1, click1, ip);
  const kept2 = keptEnd(e2, click2, ip);
  if (distance(kept1, ip) < 1e-9 || distance(kept2, ip) < 1e-9) return null;
  const dir1 = unit(sub(kept1, ip));
  const dir2 = unit(sub(kept2, ip));
  if (!(r > 1e-9)) {
    return { entities: [lineFromTo(e1, kept1, ip), lineFromTo(e2, kept2, ip)], add: [] };
  }
  const cosFull = Math.max(-1, Math.min(1, dot(dir1, dir2)));
  const sinHalf = Math.sin(Math.acos(cosFull) / 2);
  if (sinHalf < 1e-6) return null;
  const center = add(ip, mul(unit(add(dir1, dir2)), r / sinHalf));
  const t1 = perpendicularFoot(center, { x: e1.x1, y: e1.y1 }, { x: e1.x2, y: e1.y2 });
  const t2 = perpendicularFoot(center, { x: e2.x1, y: e2.y1 }, { x: e2.x2, y: e2.y2 });
  const a1 = norm360(degOf(sub(t1, center)));
  const a2 = norm360(degOf(sub(t2, center)));
  let start = a1;
  let end = a2;
  if (norm360(a2 - a1) > 180) {
    start = a2;
    end = a1;
  }
  const arc = carry(e1, { type: "arc", cx: center.x, cy: center.y, r, startAngle: start, endAngle: end });
  return { entities: [lineFromTo(e1, kept1, t1), lineFromTo(e2, kept2, t2)], add: [arc] };
}
function chamferEntities(e1, e2, d1, d2, click1, click2) {
  if (e1.type !== "line" || e2.type !== "line") return null;
  const ip = lineLineIntersection(
    { x: e1.x1, y: e1.y1 },
    { x: e1.x2, y: e1.y2 },
    { x: e2.x1, y: e2.y1 },
    { x: e2.x2, y: e2.y2 }
  );
  if (!ip) return null;
  const kept1 = keptEnd(e1, click1, ip);
  const kept2 = keptEnd(e2, click2, ip);
  if (distance(kept1, ip) < 1e-9 || distance(kept2, ip) < 1e-9) return null;
  const t1 = add(ip, mul(unit(sub(kept1, ip)), d1));
  const t2 = add(ip, mul(unit(sub(kept2, ip)), d2));
  return { entities: [lineFromTo(e1, kept1, t1), lineFromTo(e2, kept2, t2)], add: [lineFromTo(e1, t1, t2)] };
}
function nearestEdgeIndex(entity, point) {
  if (!entity || entity.type !== "line" && entity.type !== "polyline" && entity.type !== "rectangle") return null;
  const segs = entitySegments(entity);
  if (!segs.length) return null;
  let best = -1;
  let bestD = Infinity;
  segs.forEach((s2, i) => {
    const d = pointToSegment(point, s2[0], s2[1]);
    if (d < bestD) {
      bestD = d;
      best = i;
    }
  });
  if (best < 0) return null;
  const s = segs[best];
  return { segIndex: best, seg: { x1: s[0].x, y1: s[0].y, x2: s[1].x, y2: s[1].y } };
}
var edgeAsLine = (pick) => carry(pick.entity, { type: "line", x1: pick.seg.x1, y1: pick.seg.y1, x2: pick.seg.x2, y2: pick.seg.y2 });
function filletPickedEdges(pick1, pick2, r, click1, click2, op = "fillet", d1 = r, d2 = r) {
  if (!pick1 || !pick2 || !pick1.entity || !pick2.entity) return null;
  if (pick1.id === pick2.id && pick1.segIndex === pick2.segIndex) return null;
  const w1 = edgeAsLine(pick1);
  const w2 = edgeAsLine(pick2);
  const res = op === "chamfer" ? chamferEntities(w1, w2, d1, d2, click1, click2) : filletEntities(w1, w2, r, click1, click2);
  if (!res) return null;
  const trimFor = /* @__PURE__ */ new Map([[pick1, res.entities[0]], [pick2, res.entities[1]]]);
  const byEntity = /* @__PURE__ */ new Map();
  for (const p of [pick1, pick2]) {
    if (!byEntity.has(p.id)) byEntity.set(p.id, { entity: p.entity, picks: [] });
    byEntity.get(p.id).picks.push(p);
  }
  const add3 = [];
  for (const { entity, picks } of byEntity.values()) {
    if (entity.type === "line") {
      add3.push(trimFor.get(picks[0]));
      continue;
    }
    const replaceAt = new Map(picks.map((p) => [p.segIndex, trimFor.get(p)]));
    entitySegments(entity).forEach((s, i) => {
      add3.push(replaceAt.has(i) ? replaceAt.get(i) : carry(entity, { type: "line", x1: s[0].x, y1: s[0].y, x2: s[1].x, y2: s[1].y }));
    });
  }
  add3.push(...res.add);
  return { removeIds: [...byEntity.keys()], add: add3 };
}

// src/cadModify/break.js
function breakEntityAt(entity, pA, pB) {
  switch (entity.type) {
    case "line":
      return breakLine(entity, pA, pB);
    case "arc":
      return breakArc(entity, pA, pB);
    case "circle":
      return breakCircle(entity, pA, pB);
    case "ellipse":
      return breakEllipse(entity, pA, pB);
    case "polyline":
      return breakPolyline(entity, pA, pB);
    case "rectangle": {
      const corners = [
        { x: entity.x, y: entity.y },
        { x: entity.x + entity.width, y: entity.y },
        { x: entity.x + entity.width, y: entity.y + entity.height },
        { x: entity.x, y: entity.y + entity.height }
      ];
      return breakPolyline(carry(entity, { type: "polyline", points: corners, closed: true }), pA, pB);
    }
    case "spline":
      return breakSpline(entity, pA, pB);
    default:
      return null;
  }
}
var clamp01 = (t) => Math.min(1, Math.max(0, t));
function breakLine(e, pA, pB) {
  const a = { x: e.x1, y: e.y1 };
  const b = { x: e.x2, y: e.y2 };
  let t1 = clamp01(lineParam(pA, a, b));
  let t2 = clamp01(lineParam(pB, a, b));
  if (t2 < t1) {
    const t = t1;
    t1 = t2;
    t2 = t;
  }
  const out = [];
  const push = (s, en) => {
    const A = lerp(a, b, s);
    const B = lerp(a, b, en);
    if (distance(A, B) > 1e-9) out.push(lineFromTo(e, A, B));
  };
  if (t2 - t1 < 1e-9) {
    if (t1 < 1e-9 || t1 > 1 - 1e-9) return null;
    push(0, t1);
    push(t1, 1);
    return out;
  }
  push(0, t1);
  push(t2, 1);
  return out;
}
var arcParamClamped = (t, sweep) => t <= sweep ? t : t - sweep < 360 - t ? sweep : 0;
function breakArc(e, pA, pB) {
  const c = { x: e.cx, y: e.cy };
  const sweep = norm360(e.endAngle - e.startAngle) || 360;
  const param = (p) => arcParamClamped(norm360(degOf(sub(p, c)) - e.startAngle), sweep);
  let t1 = param(pA);
  let t2 = param(pB);
  if (t2 < t1) {
    const t = t1;
    t1 = t2;
    t2 = t;
  }
  const seg = (s, en) => carry(e, { type: "arc", cx: e.cx, cy: e.cy, r: e.r, startAngle: e.startAngle + s, endAngle: e.startAngle + en });
  if (t2 - t1 < 1e-7) {
    if (t1 < 1e-7 || t1 > sweep - 1e-7) return null;
    return [seg(0, t1), seg(t1, sweep)];
  }
  const out = [];
  if (t1 > 1e-7) out.push(seg(0, t1));
  if (sweep - t2 > 1e-7) out.push(seg(t2, sweep));
  return out;
}
function breakCircle(e, pA, pB) {
  const c = { x: e.cx, y: e.cy };
  const a1 = norm360(degOf(sub(pA, c)));
  const a2 = norm360(degOf(sub(pB, c)));
  const gap = norm360(a2 - a1);
  if (gap < 1e-7 || 360 - gap < 1e-7) return null;
  return [carry(e, { type: "arc", cx: e.cx, cy: e.cy, r: e.r, startAngle: a2, endAngle: a1 })];
}
function breakEllipse(e, pA, pB) {
  const param = (p) => ellipseParamAt(e, p);
  if (isFullEllipse(e)) {
    const a1 = param(pA);
    const a2 = param(pB);
    const gap = norm360(a2 - a1);
    if (gap < 1e-7 || 360 - gap < 1e-7) return null;
    return [ellipseArc(e, a2, a1)];
  }
  const sweep = ellipseSweep(e);
  const p2t = (p) => arcParamClamped(norm360(param(p) - e.startAngle), sweep);
  let t1 = p2t(pA);
  let t2 = p2t(pB);
  if (t2 < t1) {
    const t = t1;
    t1 = t2;
    t2 = t;
  }
  const seg = (s, en) => ellipseArc(e, e.startAngle + s, e.startAngle + en);
  if (t2 - t1 < 1e-7) {
    if (t1 < 1e-7 || t1 > sweep - 1e-7) return null;
    return [seg(0, t1), seg(t1, sweep)];
  }
  const out = [];
  if (t1 > 1e-7) out.push(seg(0, t1));
  if (sweep - t2 > 1e-7) out.push(seg(t2, sweep));
  return out;
}
var polySegsOf = (e) => {
  const segs = [];
  for (let i = 0; i < e.points.length - 1; i++) segs.push([e.points[i], e.points[i + 1]]);
  if (e.closed && e.points.length > 2) segs.push([e.points[e.points.length - 1], e.points[0]]);
  return segs;
};
var polyParamOf = (segs, p) => {
  let best = 0;
  let bestD = Infinity;
  for (let i = 0; i < segs.length; i++) {
    const cpt = closestPointOnSegment(p, segs[i][0], segs[i][1]);
    const d = distance(p, cpt);
    if (d < bestD) {
      bestD = d;
      best = i + clamp01(lineParam(cpt, segs[i][0], segs[i][1]));
    }
  }
  return best;
};
var polyPointAt = (segs, closed, param) => {
  const n = segs.length;
  let p = param;
  if (closed) p = (p % n + n) % n;
  let i = Math.floor(p + 1e-9);
  let t = p - i;
  if (i >= n) {
    i = n - 1;
    t = 1;
  }
  if (i < 0) {
    i = 0;
    t = 0;
  }
  return lerp(segs[i][0], segs[i][1], t);
};
var polySub = (segs, closed, from, to) => {
  const out = [polyPointAt(segs, closed, from)];
  for (let v = Math.ceil(from + 1e-9); v <= Math.floor(to - 1e-9); v++) out.push({ ...polyPointAt(segs, closed, v) });
  out.push(polyPointAt(segs, closed, to));
  const dd = [out[0]];
  for (let i = 1; i < out.length; i++) if (distance(out[i], dd[dd.length - 1]) > 1e-9) dd.push(out[i]);
  return dd.length >= 2 ? dd : null;
};
function breakPolyline(e, pA, pB) {
  if (!e.points || e.points.length < 2) return null;
  const segs = polySegsOf(e);
  const n = segs.length;
  const poly = (pts) => pts ? carry(e, { type: "polyline", points: pts, closed: false }) : null;
  let t1 = polyParamOf(segs, pA);
  let t2 = polyParamOf(segs, pB);
  if (!e.closed) {
    if (t2 < t1) {
      const t = t1;
      t1 = t2;
      t2 = t;
    }
    if (t2 - t1 < 1e-9) {
      if (t1 < 1e-9 || t1 > n - 1e-9) return null;
      return [poly(polySub(segs, false, 0, t1)), poly(polySub(segs, false, t1, n))].filter(Boolean);
    }
    return [poly(polySub(segs, false, 0, t1)), poly(polySub(segs, false, t2, n))].filter(Boolean);
  }
  const gap = ((t2 - t1) % n + n) % n;
  if (gap < 1e-9 || n - gap < 1e-9) {
    const ring = polySub(segs, true, t1, t1 + n);
    return ring ? [poly(ring)] : null;
  }
  const sub2 = polySub(segs, true, t2, t1 < t2 ? t1 + n : t1);
  return sub2 ? [poly(sub2)] : null;
}
function breakSpline(e, pA, pB) {
  const tess = splineToPolyline(e);
  if (tess.length < 2) return null;
  const proxy = carry(e, { type: "polyline", points: tess, closed: !!e.closed });
  const res = breakPolyline(proxy, pA, pB);
  if (!res) return null;
  return res.map(
    (poly) => poly && poly.type === "polyline" && poly.points.length >= 2 ? carry(e, { type: "spline", fitPoints: decimate(poly.points), degree: e.degree || 3, closed: false }) : poly
  );
}
function breakRemovedSpan(entity, pA, pB) {
  switch (entity.type) {
    case "line": {
      const a = { x: entity.x1, y: entity.y1 };
      const b = { x: entity.x2, y: entity.y2 };
      let t1 = clamp01(lineParam(pA, a, b));
      let t2 = clamp01(lineParam(pB, a, b));
      if (t2 < t1) {
        const t = t1;
        t1 = t2;
        t2 = t;
      }
      if (t2 - t1 < 1e-9) return [];
      return [lineFromTo(entity, lerp(a, b, t1), lerp(a, b, t2))];
    }
    case "arc": {
      const c = { x: entity.cx, y: entity.cy };
      const sweep = norm360(entity.endAngle - entity.startAngle) || 360;
      const param = (p) => arcParamClamped(norm360(degOf(sub(p, c)) - entity.startAngle), sweep);
      let t1 = param(pA);
      let t2 = param(pB);
      if (t2 < t1) {
        const t = t1;
        t1 = t2;
        t2 = t;
      }
      if (t2 - t1 < 1e-7) return [];
      return [carry(entity, { type: "arc", cx: entity.cx, cy: entity.cy, r: entity.r, startAngle: entity.startAngle + t1, endAngle: entity.startAngle + t2 })];
    }
    case "circle": {
      const c = { x: entity.cx, y: entity.cy };
      const a1 = norm360(degOf(sub(pA, c)));
      const a2 = norm360(degOf(sub(pB, c)));
      const gap = norm360(a2 - a1);
      if (gap < 1e-7 || 360 - gap < 1e-7) return [];
      return [carry(entity, { type: "arc", cx: entity.cx, cy: entity.cy, r: entity.r, startAngle: a1, endAngle: a2 })];
    }
    case "ellipse": {
      const param = (p) => ellipseParamAt(entity, p);
      if (isFullEllipse(entity)) {
        const a1 = param(pA);
        const a2 = param(pB);
        const gap = norm360(a2 - a1);
        if (gap < 1e-7 || 360 - gap < 1e-7) return [];
        return [ellipseArc(entity, a1, a2)];
      }
      const sweep = ellipseSweep(entity);
      const p2t = (p) => arcParamClamped(norm360(param(p) - entity.startAngle), sweep);
      let t1 = p2t(pA);
      let t2 = p2t(pB);
      if (t2 < t1) {
        const t = t1;
        t1 = t2;
        t2 = t;
      }
      if (t2 - t1 < 1e-7) return [];
      return [ellipseArc(entity, entity.startAngle + t1, entity.startAngle + t2)];
    }
    case "polyline": {
      if (!entity.points || entity.points.length < 2) return null;
      const segs = polySegsOf(entity);
      const n = segs.length;
      const t1 = polyParamOf(segs, pA);
      const t2 = polyParamOf(segs, pB);
      const poly = (pts) => pts ? [carry(entity, { type: "polyline", points: pts, closed: false })] : [];
      if (!entity.closed) {
        const lo = Math.min(t1, t2);
        const hi = Math.max(t1, t2);
        if (hi - lo < 1e-9) return [];
        return poly(polySub(segs, false, lo, hi));
      }
      const gap = ((t2 - t1) % n + n) % n;
      if (gap < 1e-9 || n - gap < 1e-9) return [];
      return poly(polySub(segs, true, t1, t2 > t1 ? t2 : t2 + n));
    }
    case "rectangle": {
      const corners = [
        { x: entity.x, y: entity.y },
        { x: entity.x + entity.width, y: entity.y },
        { x: entity.x + entity.width, y: entity.y + entity.height },
        { x: entity.x, y: entity.y + entity.height }
      ];
      return breakRemovedSpan(carry(entity, { type: "polyline", points: corners, closed: true }), pA, pB);
    }
    case "spline": {
      const tess = splineToPolyline(entity);
      if (tess.length < 2) return null;
      return breakRemovedSpan(carry(entity, { type: "polyline", points: tess, closed: !!entity.closed }), pA, pB);
    }
    default:
      return null;
  }
}

// src/cadModify/join.js
var ptsEq = (a, b) => distance(a, b) <= 1e-6;
var collinearLines = (i, j) => {
  if (distance({ x: i.x1, y: i.y1 }, { x: i.x2, y: i.y2 }) <= 1e-9) return false;
  const d = unit(sub({ x: i.x2, y: i.y2 }, { x: i.x1, y: i.y1 }));
  const off = (p) => Math.abs((p.x - i.x1) * d.y - (p.y - i.y1) * d.x);
  return off({ x: j.x1, y: j.y1 }) <= 1e-6 && off({ x: j.x2, y: j.y2 }) <= 1e-6;
};
function joinEntities(entities) {
  const removeIds = [];
  const add3 = [];
  const used = /* @__PURE__ */ new Set();
  const lines = entities.filter((e) => e.type === "line");
  const mergedLineItems = [];
  for (let i = 0; i < lines.length; i++) {
    if (used.has(lines[i].id)) continue;
    const group = [lines[i]];
    for (let j = i + 1; j < lines.length; j++) {
      if (used.has(lines[j].id)) continue;
      if (collinearLines(lines[i], lines[j])) group.push(lines[j]);
    }
    if (group.length < 2) continue;
    group.forEach((g) => used.add(g.id));
    const a = { x: lines[i].x1, y: lines[i].y1 };
    const d = unit(sub({ x: lines[i].x2, y: lines[i].y2 }, a));
    let tMin = Infinity;
    let tMax = -Infinity;
    for (const g of group) {
      for (const p of [{ x: g.x1, y: g.y1 }, { x: g.x2, y: g.y2 }]) {
        const t = (p.x - a.x) * d.x + (p.y - a.y) * d.y;
        if (t < tMin) tMin = t;
        if (t > tMax) tMax = t;
      }
    }
    mergedLineItems.push({
      pts: [add2(a, d, tMin), add2(a, d, tMax)],
      srcIds: group.map((g) => g.id),
      proto: group[0],
      allLines: true
    });
  }
  const arcs = entities.filter((e) => e.type === "arc");
  const arcGroups = [];
  const grouped = /* @__PURE__ */ new Set();
  for (let i = 0; i < arcs.length; i++) {
    if (used.has(arcs[i].id) || grouped.has(arcs[i].id)) continue;
    const g = [arcs[i]];
    for (let j = i + 1; j < arcs.length; j++) {
      if (used.has(arcs[j].id) || grouped.has(arcs[j].id)) continue;
      if (Math.abs(arcs[i].cx - arcs[j].cx) <= 1e-6 && Math.abs(arcs[i].cy - arcs[j].cy) <= 1e-6 && Math.abs(arcs[i].r - arcs[j].r) <= 1e-6) g.push(arcs[j]);
    }
    if (g.length >= 2) {
      arcGroups.push(g);
      g.forEach((a) => grouped.add(a.id));
    }
  }
  for (const g of arcGroups) {
    const c = { x: g[0].cx, y: g[0].cy };
    const r = g[0].r;
    let items2 = g.map((e) => ({ start: norm360(e.startAngle), sweep: norm360(e.endAngle - e.startAngle) || 360, ids: [e.id] }));
    let mergedSome = true;
    while (mergedSome && items2.length > 1) {
      mergedSome = false;
      outer:
        for (let i = 0; i < items2.length; i++) {
          for (let j = 0; j < items2.length; j++) {
            if (i === j) continue;
            if (ptsEq(onCircle(c, r, items2[i].start + items2[i].sweep), onCircle(c, r, items2[j].start))) {
              items2[i] = {
                start: items2[i].start,
                sweep: Math.min(360, items2[i].sweep + items2[j].sweep),
                ids: [...items2[i].ids, ...items2[j].ids]
              };
              items2.splice(j, 1);
              mergedSome = true;
              break outer;
            }
          }
        }
    }
    for (const it of items2) {
      if (it.ids.length < 2) continue;
      it.ids.forEach((id) => used.add(id));
      removeIds.push(...it.ids);
      const proto = g.find((e) => e.id === it.ids[0]);
      add3.push(
        it.sweep >= 360 - 1e-7 ? carry(proto, { type: "circle", cx: c.x, cy: c.y, r }) : carry(proto, { type: "arc", cx: c.x, cy: c.y, r, startAngle: it.start, endAngle: it.start + it.sweep })
      );
    }
  }
  const items = [...mergedLineItems];
  for (const e of entities) {
    if (used.has(e.id)) continue;
    if (e.type === "line") items.push({ pts: [{ x: e.x1, y: e.y1 }, { x: e.x2, y: e.y2 }], srcIds: [e.id], proto: e, allLines: true });
    else if (e.type === "polyline" && !e.closed && e.points && e.points.length >= 2) {
      items.push({ pts: e.points.map((p) => ({ ...p })), srcIds: [e.id], proto: e, allLines: false });
    }
  }
  let chained = true;
  while (chained && items.length > 1) {
    chained = false;
    outer:
      for (let i = 0; i < items.length; i++) {
        for (let j = 0; j < items.length; j++) {
          if (i === j) continue;
          const A = items[i].pts;
          const B = items[j].pts;
          let joined = null;
          if (ptsEq(A[A.length - 1], B[0])) joined = [...A, ...B.slice(1)];
          else if (ptsEq(A[A.length - 1], B[B.length - 1])) joined = [...A, ...B.slice(0, -1).reverse()];
          else if (ptsEq(A[0], B[B.length - 1])) joined = [...B, ...A.slice(1)];
          else if (ptsEq(A[0], B[0])) joined = [...B.slice(1).reverse(), ...A];
          if (joined) {
            items[i] = {
              pts: joined,
              srcIds: [...items[i].srcIds, ...items[j].srcIds],
              proto: items[i].proto,
              allLines: items[i].allLines && items[j].allLines
            };
            items.splice(j, 1);
            chained = true;
            break outer;
          }
        }
      }
  }
  for (const it of items) {
    if (it.srcIds.length < 2) continue;
    removeIds.push(...it.srcIds);
    let pts = it.pts;
    const closes = pts.length >= 4 && ptsEq(pts[0], pts[pts.length - 1]);
    if (closes) pts = pts.slice(0, -1);
    const collinear = it.allLines && !closes && pts.every((p) => Math.abs((p.x - pts[0].x) * (pts[pts.length - 1].y - pts[0].y) - (p.y - pts[0].y) * (pts[pts.length - 1].x - pts[0].x)) <= 1e-6);
    add3.push(
      collinear ? lineFromTo(it.proto, pts[0], pts[pts.length - 1]) : carry(it.proto, { type: "polyline", points: pts, closed: closes })
    );
  }
  return removeIds.length ? { removeIds, add: add3 } : null;
}
var add2 = (a, d, t) => ({ x: a.x + d.x * t, y: a.y + d.y * t });

// src/cadModify/lengthen.js
var fail = (reason) => ({ ok: false, reason });
var done = (entity) => ({ ok: true, entity });
var SUPPORTED = /* @__PURE__ */ new Set(["line", "arc", "polyline", "ellipse", "spline"]);
function lengthenTarget(current, mode, value) {
  if (!(current > 0)) return fail("degenerate");
  switch (mode) {
    case "delta":
      if (!Number.isFinite(value)) return fail("invalid");
      return { ok: true, target: current + value };
    case "percent":
      if (!Number.isFinite(value) || value <= 0) return fail("invalid");
      return { ok: true, target: current * value / 100 };
    case "total":
      if (!Number.isFinite(value)) return fail("invalid");
      return { ok: true, target: value };
    default:
      return fail("invalid");
  }
}
var picksEnd = (pick, start, end) => !pick ? true : distance(pick, end) <= distance(pick, start);
function lengthenEntity(entity, opts = {}) {
  const e = entity;
  if (!e) return fail("not-supported");
  const { mode, value, target: dragTo, pick } = opts;
  if (e.type === "circle") return fail("closed");
  if (!SUPPORTED.has(e.type)) return fail("not-supported");
  if (e.type === "polyline" && e.closed) return fail("closed");
  if (e.type === "spline" && e.closed) return fail("closed");
  if (e.type === "ellipse" && isFullEllipse(e)) return fail("closed");
  const current = e.type === "ellipse" ? ellipticalArcLength(e) : e.type === "spline" ? splineArcLength(e) : entityLength(e);
  if (!(current > 1e-12)) return fail("degenerate");
  if (e.type === "line") return lengthenLine(e, mode, value, dragTo, pick, current);
  if (e.type === "arc") return lengthenArc(e, mode, value, dragTo, pick, current);
  if (e.type === "polyline") return lengthenPolyline(e, mode, value, dragTo, pick, current);
  if (e.type === "spline") return lengthenSpline(e, mode, value, dragTo, pick, current);
  return lengthenEllipticalArc(e, mode, value, dragTo, pick, current);
}
function lengthenLine(e, mode, value, dragTo, pick, current) {
  const a = { x: e.x1, y: e.y1 };
  const b = { x: e.x2, y: e.y2 };
  const atEnd = picksEnd(pick, a, b);
  const anchor = atEnd ? a : b;
  const dir = unit(sub(atEnd ? b : a, anchor));
  let target;
  if (mode === "dynamic") {
    if (!dragTo) return fail("invalid");
    target = (dragTo.x - anchor.x) * dir.x + (dragTo.y - anchor.y) * dir.y;
  } else {
    const r = lengthenTarget(current, mode, value);
    if (!r.ok) return r;
    target = r.target;
  }
  if (!(target > 1e-12)) return fail("too-short");
  const moved = add(anchor, mul(dir, target));
  return done(atEnd ? { ...e, x2: moved.x, y2: moved.y } : { ...e, x1: moved.x, y1: moved.y });
}
function lengthenArc(e, mode, value, dragTo, pick, current) {
  const c = { x: e.cx, y: e.cy };
  const p1 = onCircle(c, e.r, e.startAngle);
  const p2 = onCircle(c, e.r, e.endAngle);
  const atEnd = picksEnd(pick, p1, p2);
  let target;
  if (mode === "dynamic") {
    if (!dragTo) return fail("invalid");
    const bearing = Math.atan2(dragTo.y - c.y, dragTo.x - c.x) * 180 / Math.PI;
    const newSweep = atEnd ? norm360(bearing - e.startAngle) : norm360(e.endAngle - bearing);
    target = (newSweep || 360) * Math.PI * e.r / 180;
  } else {
    const r = lengthenTarget(current, mode, value);
    if (!r.ok) return r;
    target = r.target;
  }
  if (!(target > 1e-12)) return fail("too-short");
  const newSweepDeg = target * 180 / (Math.PI * e.r);
  if (newSweepDeg >= 360 - 1e-9) return fail("too-long");
  return done(
    atEnd ? { ...e, endAngle: e.startAngle + newSweepDeg } : { ...e, startAngle: e.endAngle - newSweepDeg }
  );
}
function lengthenPolyline(e, mode, value, dragTo, pick, current) {
  const pts = e.points || [];
  if (pts.length < 2) return fail("degenerate");
  const atEnd = picksEnd(pick, pts[0], pts[pts.length - 1]);
  const i = atEnd ? pts.length - 1 : 0;
  const j = atEnd ? pts.length - 2 : 1;
  const anchor = pts[j];
  const seg = sub(pts[i], anchor);
  if (!(len(seg) > 1e-12)) return fail("degenerate");
  const dir = unit(seg);
  const rest = current - len(seg);
  let endTarget;
  if (mode === "dynamic") {
    if (!dragTo) return fail("invalid");
    endTarget = (dragTo.x - anchor.x) * dir.x + (dragTo.y - anchor.y) * dir.y;
  } else {
    const r = lengthenTarget(current, mode, value);
    if (!r.ok) return r;
    endTarget = r.target - rest;
  }
  if (!(endTarget > 1e-12)) return fail("too-short");
  const moved = add(anchor, mul(dir, endTarget));
  const points = pts.map((p, k) => k === i ? { ...p, x: moved.x, y: moved.y } : p);
  return done({ ...e, points });
}
var ELL_MIN_STEPS = 2048;
var ELL_MAX_STEPS = 65536;
var ellSteps = (e) => {
  const hi = Math.max(Math.abs(e.rx) || 0, Math.abs(e.ry) || 0);
  const lo = Math.min(Math.abs(e.rx) || 0, Math.abs(e.ry) || 0);
  const aspect = lo > 0 ? hi / lo : 1;
  const want = Math.ceil(8 * Math.PI * aspect);
  const n = Math.min(ELL_MAX_STEPS, Math.max(ELL_MIN_STEPS, want));
  return n % 2 ? n + 1 : n;
};
var ellSpeed = (e, tDeg) => {
  const t = tDeg * Math.PI / 180;
  return Math.hypot(e.rx * Math.sin(t), e.ry * Math.cos(t));
};
function ellSimpson(e, fromDeg, dir, spanDeg, n) {
  if (!(spanDeg > 0)) return 0;
  const h = spanDeg / n;
  const hr = h * Math.PI / 180;
  let sum = ellSpeed(e, fromDeg) + ellSpeed(e, fromDeg + dir * spanDeg);
  for (let i = 1; i < n; i++) sum += (i % 2 ? 4 : 2) * ellSpeed(e, fromDeg + dir * h * i);
  return sum * hr / 3;
}
function ellCumulative(e, fromDeg, dir, spanDeg, steps) {
  const h = spanDeg / steps;
  const cum = new Float64Array(steps + 1);
  for (let i = 0; i < steps; i++) {
    cum[i + 1] = cum[i] + ellSimpson(e, fromDeg + dir * h * i, dir, h, 2);
  }
  return cum;
}
function lengthenEllipticalArc(e, mode, value, dragTo, pick, current) {
  const sweep = ellipseSweep(e);
  if (!(sweep > 1e-9)) return fail("degenerate");
  const p1 = ellipsePoint(e, e.startAngle);
  const p2 = ellipsePoint(e, e.endAngle);
  const atEnd = picksEnd(pick, p1, p2);
  const from = atEnd ? e.startAngle : e.endAngle;
  const dir = atEnd ? 1 : -1;
  const SPAN = 360 - 1e-9;
  const endAt = (sw) => ellipsePoint(e, from + dir * sw);
  const rebuild = (sw) => atEnd ? { ...e, endAngle: e.startAngle + sw } : { ...e, startAngle: e.endAngle - sw };
  const steps = ellSteps(e);
  const cum = ellCumulative(e, from, dir, SPAN, steps);
  const full = cum[steps];
  const step = SPAN / steps;
  const lengthAt = (sw) => {
    const i = Math.min(steps - 1, Math.max(0, Math.floor(sw / step)));
    return cum[i] + ellSimpson(e, from + dir * step * i, dir, sw - step * i, 2);
  };
  let target;
  if (mode === "dynamic") {
    if (!dragTo) return fail("invalid");
    const N = 720;
    let best = 0;
    let bestD = Infinity;
    for (let i = 1; i <= N; i++) {
      const sw = SPAN * i / N;
      const d = distance(endAt(sw), dragTo);
      if (d < bestD * (1 - 1e-9)) {
        bestD = d;
        best = sw;
      }
    }
    let lo2 = Math.max(1e-9, best - SPAN / N);
    let hi2 = Math.min(SPAN, best + SPAN / N);
    for (let k = 0; k < 60; k++) {
      const m1 = lo2 + (hi2 - lo2) / 3;
      const m2 = hi2 - (hi2 - lo2) / 3;
      if (distance(endAt(m1), dragTo) <= distance(endAt(m2), dragTo)) hi2 = m2;
      else lo2 = m1;
    }
    target = lengthAt((lo2 + hi2) / 2);
  } else {
    const r = lengthenTarget(current, mode, value);
    if (!r.ok) return r;
    target = r.target;
  }
  if (!(target > 1e-12)) return fail("too-short");
  if (target >= full) return fail("too-long");
  let lo = 1e-9;
  let hi = SPAN;
  for (let k = 0; k < 60; k++) {
    const mid = (lo + hi) / 2;
    if (lengthAt(mid) < target) lo = mid;
    else hi = mid;
  }
  return done(rebuild((lo + hi) / 2));
}
function ellipticalArcLength(e) {
  const sweep = ellipseSweep(e);
  if (!(sweep > 0)) return 0;
  return ellSimpson(e, e.startAngle, 1, sweep, ellSteps(e));
}
var SPLINE_LEN_STEPS = 4096;
function splineArcLength(e) {
  let total = 0;
  let prev = splinePointAt(e, 0);
  if (!prev) return 0;
  for (let i = 1; i <= SPLINE_LEN_STEPS; i++) {
    const q = splinePointAt(e, i / SPLINE_LEN_STEPS);
    if (!q) return 0;
    total += distance(prev, q);
    prev = q;
  }
  return total;
}
function lengthenSpline(e, mode, value, dragTo, pick, current) {
  const pts = splineDefiningPoints(e);
  if (!Array.isArray(pts) || pts.length < 2) return fail("degenerate");
  const first = splinePointAt(e, 0);
  const last = splinePointAt(e, 1);
  if (!first || !last) return fail("degenerate");
  const atEnd = picksEnd(pick, first, last);
  const h = 1e-4;
  const a = splinePointAt(e, atEnd ? 1 - h : h);
  const b = atEnd ? last : first;
  const dir = unit(sub(b, a));
  if (!(len(sub(b, a)) > 1e-15)) return fail("degenerate");
  const key = isFitSpline(e) ? "fitPoints" : "controlPoints";
  const i = atEnd ? pts.length - 1 : 0;
  const anchor = pts[i];
  const withOffset = (d) => {
    const moved = pts.map((p, k) => k === i ? add(anchor, mul(dir, d)) : { ...p });
    return { ...e, [key]: moved };
  };
  let target;
  if (mode === "dynamic") {
    if (!dragTo) return fail("invalid");
    const d = (dragTo.x - anchor.x) * dir.x + (dragTo.y - anchor.y) * dir.y;
    if (!(d > 1e-12)) return fail("too-short");
    const out = withOffset(d);
    return splineArcLength(out) > 1e-12 ? done(out) : fail("too-short");
  }
  const r = lengthenTarget(current, mode, value);
  if (!r.ok) return r;
  target = r.target;
  if (!(target > 1e-12)) return fail("too-short");
  if (target < current) {
    const shortest = splineArcLength(withOffset(-0.999 * distance(anchor, pts[atEnd ? i - 1 : 1])));
    if (target < shortest) return fail("too-short");
  }
  let lo = -0.999 * distance(anchor, pts[atEnd ? i - 1 : 1]);
  let hi = Math.max(1, target - current) * 4 + 1;
  for (let k = 0; k < 40 && splineArcLength(withOffset(hi)) < target; k++) hi *= 2;
  if (splineArcLength(withOffset(hi)) < target) return fail("too-long");
  for (let k = 0; k < 60; k++) {
    const mid = (lo + hi) / 2;
    if (splineArcLength(withOffset(mid)) < target) lo = mid;
    else hi = mid;
  }
  return done(withOffset((lo + hi) / 2));
}

// src/cadModify/pathSample.js
function sampleCircular(path, count) {
  const r = path.r;
  if (!Number.isFinite(r) || !(r > 1e-12)) return [];
  const n = Math.max(1, count | 0);
  const rawSweep = norm360(path.endAngle - path.startAngle);
  const closed = path.type === "circle" || !(rawSweep > 1e-9) || rawSweep > 360 - 1e-9;
  const sweep = path.type === "circle" ? 360 : rawSweep || 360;
  const start = path.type === "circle" ? 0 : path.startAngle;
  const c = { x: path.cx, y: path.cy };
  const step = n > 1 ? sweep / (closed ? n : n - 1) : 0;
  const out = [];
  for (let i = 0; i < n; i++) {
    const a = start + step * i;
    const rad = a * Math.PI / 180;
    out.push({
      pt: onCircle(c, r, a),
      tangent: degOf({ x: -Math.sin(rad), y: Math.cos(rad) })
    });
  }
  return out;
}
function sampleSpline(path, count) {
  const params = splineArcLengthParams(path, count);
  if (!params.length) return [];
  const out = [];
  for (const u of params) {
    const pt3 = splinePointAt(path, u);
    if (!pt3) return [];
    const h = 1e-6;
    const a = splinePointAt(path, Math.max(0, u - h));
    const b = splinePointAt(path, Math.min(1, u + h));
    out.push({ pt: pt3, tangent: degOf(sub(b, a)) });
  }
  return out;
}
var projectOntoEllipse = (p, e) => {
  if (!(e.rx > 1e-12) || !(e.ry > 1e-12)) return p;
  const rot = (e.rotation || 0) * Math.PI / 180;
  const ca = Math.cos(rot);
  const sa = Math.sin(rot);
  const lx = (p.x - e.cx) * ca + (p.y - e.cy) * sa;
  const ly = -(p.x - e.cx) * sa + (p.y - e.cy) * ca;
  const q = Math.hypot(lx / e.rx, ly / e.ry);
  if (!(q > 1e-12)) return p;
  const sx = lx / q;
  const sy = ly / q;
  return { x: e.cx + sx * ca - sy * sa, y: e.cy + sx * sa + sy * ca };
};
var pathPolyline = (path) => {
  if (path.type === "circle" || path.type === "arc") {
    const sweep = path.type === "circle" ? 360 : norm360(path.endAngle - path.startAngle) || 360;
    const start = path.type === "circle" ? 0 : path.startAngle;
    const n = Math.max(16, Math.ceil(sweep / 4));
    const c = { x: path.cx, y: path.cy };
    const pts2 = [];
    for (let i = 0; i <= n; i++) pts2.push(onCircle(c, path.r, start + sweep * i / n));
    return pts2;
  }
  const segs = entitySegments(path);
  if (!segs.length) return [];
  const pts = [segs[0][0]];
  for (const s of segs) pts.push(s[1]);
  return pts;
};
function samplePathPoints(path, count) {
  if (!path || !(count >= 1)) return [];
  if (path.type === "circle" || path.type === "arc") return sampleCircular(path, count);
  if (path.type === "spline") return sampleSpline(path, count);
  const pts = pathPolyline(path);
  if (pts.length < 2) return [];
  const segs = [];
  for (let i = 0; i < pts.length - 1; i++) segs.push([pts[i], pts[i + 1]]);
  const lens = segs.map((s) => distance(s[0], s[1]));
  const total = lens.reduce((acc, l) => acc + l, 0);
  if (!(total > 1e-12)) return [];
  const closed = path.type === "circle" || path.type === "rectangle" || !!path.closed || path.type === "ellipse" && isFullEllipse(path);
  const step = count > 1 ? total / (closed ? count : count - 1) : 0;
  const out = [];
  for (let i = 0; i < count; i++) {
    let d = Math.min(step * i, total);
    let k = 0;
    while (k < segs.length - 1 && d > lens[k]) {
      d -= lens[k];
      k++;
    }
    const [a, b] = segs[k];
    const t = lens[k] > 1e-12 ? Math.min(1, d / lens[k]) : 0;
    const raw = lerp(a, b, t);
    out.push({
      pt: path.type === "ellipse" ? projectOntoEllipse(raw, path) : raw,
      tangent: degOf(sub(b, a))
    });
  }
  return out;
}
function pathTotalLength(path, ctx = null) {
  if (!path) return 0;
  if (path.type === "spline") {
    return ctx && Number.isFinite(ctx.total) ? ctx.total : splineArcLength(path);
  }
  if (path.type === "circle" || path.type === "arc") {
    const r = path.r;
    if (!Number.isFinite(r) || !(r > 1e-12)) return 0;
    const sweep = path.type === "circle" ? 360 : norm360(path.endAngle - path.startAngle) || 360;
    return sweep * Math.PI * r / 180;
  }
  const pts = pathPolyline(path);
  if (pts.length < 2) return 0;
  let total = 0;
  for (let i = 0; i < pts.length - 1; i++) total += distance(pts[i], pts[i + 1]);
  return total;
}
function isClosedPath(path) {
  if (!path) return false;
  return path.type === "circle" || path.type === "rectangle" || !!path.closed || path.type === "ellipse" && isFullEllipse(path) || path.type === "arc" && isClosedArc(path);
}
function isClosedArc(path) {
  const raw = norm360(path.endAngle - path.startAngle);
  return !(raw > 1e-9) || raw > 360 - 1e-9;
}
function pointAtArcLength(path, s, ctx = null) {
  if (!path || !Number.isFinite(s)) return null;
  const total = pathTotalLength(path, ctx);
  if (!(total > 1e-12)) return null;
  const d = Math.min(Math.max(s, 0), total);
  if (path.type === "circle" || path.type === "arc") {
    const r = path.r;
    const start = path.type === "circle" ? 0 : path.startAngle;
    const a = start + d / r * (180 / Math.PI);
    const rad = a * Math.PI / 180;
    return {
      pt: onCircle({ x: path.cx, y: path.cy }, r, a),
      tangent: degOf({ x: -Math.sin(rad), y: Math.cos(rad) })
    };
  }
  if (path.type === "spline") {
    const u = splineParamAtLength(path, d, total, ctx);
    if (u === null) return null;
    const pt3 = splinePointAt(path, u);
    if (!pt3) return null;
    const h = 1e-6;
    const a = splinePointAt(path, Math.max(0, u - h));
    const b = splinePointAt(path, Math.min(1, u + h));
    return { pt: pt3, tangent: degOf(sub(b, a)) };
  }
  const pts = pathPolyline(path);
  if (pts.length < 2) return null;
  let rem = d;
  for (let i = 0; i < pts.length - 1; i++) {
    const seg = distance(pts[i], pts[i + 1]);
    if (rem <= seg || i === pts.length - 2) {
      const t = seg > 1e-12 ? Math.min(1, rem / seg) : 0;
      const raw = lerp(pts[i], pts[i + 1], t);
      return {
        // The chord sample sits inside a tessellated ellipse by the sagitta; for
        // an ellipse we can put it back on the curve exactly [BUG-A1-002].
        pt: path.type === "ellipse" ? projectOntoEllipse(raw, path) : raw,
        tangent: degOf(sub(pts[i + 1], pts[i]))
      };
    }
    rem -= seg;
  }
  return null;
}
var SPLINE_LENGTH_RUNGS = 512;
function splineParamAtLength(path, d, total, ctx) {
  if (!(total > 1e-12)) return null;
  const frac = Math.min(Math.max(d / total, 0), 1);
  const params = ctx && ctx.params || splineArcLengthParams(path, SPLINE_LENGTH_RUNGS);
  if (!params.length) return null;
  if (params.length === 1) return params[0];
  const span = path.closed ? params.length : params.length - 1;
  const x = frac * span;
  const i = Math.min(Math.floor(x), params.length - 2);
  const t = x - i;
  return params[i] + (params[i + 1] - params[i]) * t;
}
function pathSampleContext(path) {
  if (!path || path.type !== "spline") return null;
  return {
    params: splineArcLengthParams(path, SPLINE_LENGTH_RUNGS),
    total: splineArcLength(path)
  };
}

// src/cadModify/array.js
var rotateAbout = (p, c, deg2) => {
  const a = deg2 * Math.PI / 180;
  const ca = Math.cos(a);
  const sa = Math.sin(a);
  const dx = p.x - c.x;
  const dy = p.y - c.y;
  return { x: c.x + dx * ca - dy * sa, y: c.y + dx * sa + dy * ca };
};
function arrayEntities(entities, def) {
  if (!entities || !entities.length || !def) return [];
  const out = [];
  if (def.type === "rect") {
    const rows = Math.max(1, def.rows | 0);
    const cols = Math.max(1, def.cols | 0);
    for (let r = 0; r < rows; r++) {
      for (let c = 0; c < cols; c++) {
        const dx = c * (def.colSpacing || 0);
        const dy = r * (def.rowSpacing || 0);
        for (const e of entities) out.push(translateEntity(cloneEntity(e), dx, dy));
      }
    }
    return out;
  }
  if (def.type === "linear") {
    const count = Math.max(1, def.count | 0);
    const a = (def.angle || 0) * Math.PI / 180;
    const dx = (def.spacing || 0) * Math.cos(a);
    const dy = (def.spacing || 0) * Math.sin(a);
    for (let i = 0; i < count; i++) {
      for (const e of entities) out.push(translateEntity(cloneEntity(e), dx * i, dy * i));
    }
    return out;
  }
  if (def.type === "path") {
    const count = Math.max(1, def.count | 0);
    const samples = samplePathPoints(def.path, count);
    if (!samples.length) return [];
    let bb = null;
    for (const e of entities) {
      const b = entityBounds(e);
      if (!b) continue;
      bb = bb ? {
        minX: Math.min(bb.minX, b.minX),
        minY: Math.min(bb.minY, b.minY),
        maxX: Math.max(bb.maxX, b.maxX),
        maxY: Math.max(bb.maxY, b.maxY)
      } : { ...b };
    }
    const anchor = bb ? { x: (bb.minX + bb.maxX) / 2, y: (bb.minY + bb.maxY) / 2 } : samples[0].pt;
    const baseAng = samples[0].tangent;
    for (const sm of samples) {
      for (const e of entities) {
        let cpy = translateEntity(cloneEntity(e), sm.pt.x - anchor.x, sm.pt.y - anchor.y);
        if (def.align) cpy = rotateEntity(cpy, sm.pt, sm.tangent - baseAng);
        out.push(cpy);
      }
    }
    return out;
  }
  if (def.type === "polar") {
    const count = Math.max(1, def.count | 0);
    const center = def.center || { x: 0, y: 0 };
    const total = def.totalAngle != null ? def.totalAngle : 360;
    const step = polarStepAngle(total, count);
    if (step === null) return [];
    for (let i = 0; i < count; i++) {
      const ang = step * i;
      for (const e of entities) {
        const clone2 = cloneEntity(e);
        if (def.rotateItems) {
          out.push(rotateEntity(clone2, center, ang));
        } else {
          const b = entityBounds(e);
          const ref = b ? { x: (b.minX + b.maxX) / 2, y: (b.minY + b.maxY) / 2 } : center;
          const moved = rotateAbout(ref, center, ang);
          out.push(translateEntity(clone2, moved.x - ref.x, moved.y - ref.y));
        }
      }
    }
    return out;
  }
  return [];
}
function polarStepAngle(totalAngle, count) {
  if (!Number.isFinite(totalAngle) || !Number.isFinite(count)) return null;
  const n = Math.max(1, count | 0);
  if (n === 1) return 0;
  const sign = totalAngle < 0 ? -1 : 1;
  const mag = Math.min(Math.abs(totalAngle), 360);
  if (!(mag > 1e-9)) return null;
  if (mag >= 360) return sign * 360 / n;
  return sign * mag / (n - 1);
}

// src/cadModify/divide.js
var MAX_MARKS = 32767;
var measureLimit = (total) => total * (1 - 1e-12);
function divideRefusal(path, mode, value) {
  if (!path) return "no-entity";
  const total = pathTotalLength(path);
  if (!(total > 1e-12)) return "path-degenerate";
  if (!Number.isFinite(value)) return "value-not-finite";
  if (mode === "divide") {
    if (!(value >= 2)) return "count-too-small";
    if (Math.floor(value) !== value) return "count-not-integer";
    if (value > MAX_MARKS + (isClosedPath(path) ? 0 : 1)) return "count-too-large";
    return null;
  }
  if (mode === "measure") {
    if (!(value > 0)) return "interval-not-positive";
    if (value >= measureLimit(total)) return "interval-exceeds-length";
    if (total / value > MAX_MARKS) return "interval-too-small";
    return null;
  }
  return "unknown-mode";
}
function dividePoints(path, count) {
  if (divideRefusal(path, "divide", count)) return null;
  const closed = isClosedPath(path);
  const samples = samplePathPoints(path, closed ? count : count + 1);
  if (!samples.length) return null;
  const marks = closed ? samples : samples.slice(1, samples.length - 1);
  if (!marks.length) return null;
  return marks.map((s) => pointOn(path, s.pt));
}
function measurePoints(path, interval) {
  if (divideRefusal(path, "measure", interval)) return null;
  const ctx = pathSampleContext(path);
  const total = pathTotalLength(path, ctx);
  const out = [];
  const limit = measureLimit(total);
  for (let k = 1; k * interval < limit; k++) {
    const s = pointAtArcLength(path, k * interval, ctx);
    if (!s) break;
    out.push(pointOn(path, s.pt));
    if (out.length >= MAX_MARKS) break;
  }
  return out.length ? out : null;
}
var pointOn = (path, pt3) => carry(path, { type: "point", x: pt3.x, y: pt3.y });

// src/cadModify/pedit.js
var POINT_CHAIN = /* @__PURE__ */ new Set(["polyline", "revcloud"]);
function clampPolylineWidth(v) {
  if (v === null || v === void 0 || v === "") return 0;
  const n = Number(v);
  if (!Number.isFinite(n) || n < 0) return null;
  return n;
}
function peditSetWidth(entity, width) {
  if (!entity) return null;
  if (entity.type !== "polyline" && entity.type !== "rectangle") return null;
  const w = clampPolylineWidth(width);
  if (w === null) return null;
  const field = entity.type === "rectangle" ? "polyWidth" : "width";
  const next = { ...entity };
  if (w > 0) next[field] = w;
  else delete next[field];
  return next;
}
function peditSetClosed(entity, closed) {
  if (!entity) return null;
  const want = !!closed;
  if (entity.type === "rectangle") return null;
  if (!POINT_CHAIN.has(entity.type) && entity.type !== "spline") return null;
  const pts = entity.type === "spline" ? splineDefiningPoints(entity) : entity.points;
  if (!Array.isArray(pts) || pts.length < 3) return null;
  if (!!entity.closed === want) return null;
  return { ...entity, closed: want };
}
function peditReverse(entity) {
  if (!entity) return null;
  if (entity.type === "spline") {
    const next2 = { ...entity };
    if (Array.isArray(entity.fitPoints) && entity.fitPoints.length >= 2) {
      next2.fitPoints = [...entity.fitPoints].reverse().map((p) => ({ ...p }));
    } else if (Array.isArray(entity.controlPoints) && entity.controlPoints.length >= 2) {
      next2.controlPoints = [...entity.controlPoints].reverse().map((p) => ({ ...p }));
    } else {
      return null;
    }
    if (Array.isArray(entity.fitFrame))
      next2.fitFrame = [...entity.fitFrame].reverse().map((p) => ({ ...p }));
    return next2;
  }
  if (!POINT_CHAIN.has(entity.type)) return null;
  const pts = entity.points;
  if (!Array.isArray(pts) || pts.length < 2) return null;
  const next = { ...entity, points: reverseChain(pts, !!entity.closed) };
  if (Array.isArray(entity.fitFrame))
    next.fitFrame = reverseChain(entity.fitFrame, !!entity.closed);
  return next;
}
function reverseChain(pts, closed) {
  const n = pts.length;
  const rev = [];
  for (let i = 0; i < n; i++) {
    const src = pts[n - 1 - i];
    const { bulge: _dropped, ...rest } = src;
    const prevIdx = n - 2 - i;
    const prev = prevIdx >= 0 ? pts[prevIdx] : closed ? pts[n - 1] : null;
    const b = prev && Number.isFinite(prev.bulge) ? -prev.bulge : 0;
    rev.push(b !== 0 ? { ...rest, bulge: b } : { ...rest });
  }
  return rev;
}
function peditSpline(entity) {
  if (!entity) return null;
  if (entity.type !== "polyline") return null;
  const source = Array.isArray(entity.fitFrame) && entity.fitFrame.length >= 3 ? entity.fitFrame : entity.points;
  if (!Array.isArray(source) || source.length < 3) return null;
  const frame = source.map((p) => ({ x: p.x, y: p.y }));
  return carry(entity, {
    id: entity.id,
    type: "spline",
    fitPoints: frame.map((p) => ({ ...p })),
    closed: !!entity.closed,
    fitFrame: frame,
    fitMode: "spline"
  });
}
function peditFit(entity) {
  if (!entity) return null;
  if (entity.type !== "polyline") return null;
  const source = Array.isArray(entity.fitFrame) && entity.fitFrame.length >= 3 ? entity.fitFrame : entity.points;
  if (!Array.isArray(source) || source.length < 3) return null;
  const frame = source.map((p) => ({ x: p.x, y: p.y }));
  const tess = splineToPolyline({
    type: "spline",
    fitPoints: frame.map((p) => ({ ...p })),
    closed: !!entity.closed
  });
  if (!Array.isArray(tess) || tess.length < 2) return null;
  const pts = tess.map((p) => ({ x: p.x, y: p.y }));
  if (entity.closed && pts.length > 2) {
    const a = pts[0];
    const b = pts[pts.length - 1];
    if (Math.hypot(a.x - b.x, a.y - b.y) <= 1e-9) pts.pop();
  }
  return { ...entity, points: pts, fitFrame: frame, fitMode: "fit" };
}
function peditDecurve(entity) {
  if (!entity) return null;
  if (entity.type !== "polyline" && entity.type !== "spline") return null;
  const frame = entity.fitFrame;
  if (!Array.isArray(frame) || frame.length < 2) return null;
  const base = { ...entity };
  delete base.fitFrame;
  delete base.fitMode;
  delete base.fitPoints;
  delete base.controlPoints;
  delete base.degree;
  return {
    ...base,
    type: "polyline",
    points: frame.map((p) => ({ x: p.x, y: p.y })),
    closed: !!entity.closed
  };
}
function peditToPolyline(entity) {
  if (!entity) return null;
  if (entity.type !== "line") return null;
  return carry(entity, {
    id: entity.id,
    type: "polyline",
    points: [
      { x: entity.x1, y: entity.y1 },
      { x: entity.x2, y: entity.y2 }
    ],
    closed: false
  });
}
function peditJoin(entities) {
  if (!Array.isArray(entities) || entities.length < 2) return null;
  return joinEntities(entities);
}
var PEDIT_OPTIONS = [
  { key: "C", id: "close", label: "Close" },
  { key: "O", id: "open", label: "Open" },
  { key: "J", id: "join", label: "Join" },
  { key: "W", id: "width", label: "Width" },
  { key: "F", id: "fit", label: "Fit" },
  { key: "S", id: "spline", label: "Spline" },
  { key: "D", id: "decurve", label: "Decurve" },
  { key: "R", id: "reverse", label: "Reverse" }
];
function peditRefusal(entity, id, arg) {
  if (!entity) return "no-entity";
  switch (id) {
    case "close":
    case "open": {
      const want = id === "close";
      if (entity.type === "rectangle") return "rectangle-always-closed";
      if (!POINT_CHAIN.has(entity.type) && entity.type !== "spline") return "type-not-peditable";
      const pts = entity.type === "spline" ? splineDefiningPoints(entity) : entity.points;
      if (!Array.isArray(pts) || pts.length < 3) return "too-few-vertices";
      if (!!entity.closed === want) return want ? "already-closed" : "already-open";
      return null;
    }
    case "width":
      if (entity.type !== "polyline" && entity.type !== "rectangle") return "type-no-width";
      return clampPolylineWidth(arg) === null ? "width-invalid" : null;
    case "fit": {
      if (entity.type !== "polyline") return "type-not-fittable";
      const src = Array.isArray(entity.fitFrame) && entity.fitFrame.length >= 3 ? entity.fitFrame : entity.points;
      return Array.isArray(src) && src.length >= 3 ? null : "too-few-vertices";
    }
    case "spline": {
      if (entity.type !== "polyline") return "type-not-fittable";
      const src = Array.isArray(entity.fitFrame) && entity.fitFrame.length >= 3 ? entity.fitFrame : entity.points;
      return Array.isArray(src) && src.length >= 3 ? null : "too-few-vertices";
    }
    case "decurve":
      if (entity.type !== "polyline" && entity.type !== "spline") return "type-not-peditable";
      return Array.isArray(entity.fitFrame) && entity.fitFrame.length >= 2 ? null : "no-fit-frame";
    case "reverse": {
      if (entity.type === "spline") {
        const d = splineDefiningPoints(entity);
        return Array.isArray(d) && d.length >= 2 ? null : "too-few-vertices";
      }
      if (!POINT_CHAIN.has(entity.type)) return "type-not-peditable";
      return Array.isArray(entity.points) && entity.points.length >= 2 ? null : "too-few-vertices";
    }
    default:
      return "unknown-option";
  }
}
function applyPeditOption(entity, id, arg) {
  switch (id) {
    case "close":
      return peditSetClosed(entity, true);
    case "open":
      return peditSetClosed(entity, false);
    case "width":
      return peditSetWidth(entity, arg);
    case "fit":
      return peditFit(entity);
    case "spline":
      return peditSpline(entity);
    case "decurve":
      return peditDecurve(entity);
    case "reverse":
      return peditReverse(entity);
    default:
      return null;
  }
}

// src/cadModify/explode.js
var ok = (pieces) => pieces.length ? { ok: true, pieces } : { ok: false, reason: "nothing-to-explode" };
var lineFrom = (src, a, b) => carry(src, { type: "line", x1: a.x, y1: a.y, x2: b.x, y2: b.y });
function polylineEdges(points, closed) {
  const edges = [];
  for (let i = 0; i < points.length - 1; i++)
    edges.push([points[i], points[i + 1], points[i].bulge]);
  const twoVertexDuplicate = points.length === 2 && !points[0].bulge && !points[points.length - 1].bulge;
  if (closed && points.length >= 2 && !twoVertexDuplicate) {
    const last = points[points.length - 1];
    edges.push([last, points[0], last.bulge]);
  }
  return edges;
}
function explodeEntity(entity, ctx = {}) {
  if (!entity) return { ok: false, reason: "not-explodable" };
  const t = entity.type;
  if (t === "polyline" || t === "rectangle") {
    const points = t === "rectangle" ? entityVertices(entity) : entity.points || [];
    const closed = t === "rectangle" ? true : !!entity.closed;
    if (points.length < 2) return { ok: false, reason: "nothing-to-explode" };
    if (t === "rectangle" && !(Math.abs(entity.width) > 1e-12 && Math.abs(entity.height) > 1e-12))
      return { ok: false, reason: "nothing-to-explode" };
    const pieces = [];
    for (const [a, b, bulge] of polylineEdges(points, closed)) {
      const arc = bulge ? bulgeToArc(a, b, bulge) : null;
      if (arc) {
        pieces.push(
          carry(entity, {
            type: "arc",
            cx: arc.cx,
            cy: arc.cy,
            r: arc.r,
            startAngle: arc.startAngle,
            endAngle: arc.endAngle
          })
        );
      } else if (a.x !== b.x || a.y !== b.y) {
        pieces.push(lineFrom(entity, a, b));
      }
    }
    return ok(pieces);
  }
  if (t === "dimension") {
    const g = dimensionPrimitives(entity, ctx.dimStyleDefs || {}, ctx.dimStyle, ctx.dimSizing);
    if (!g) return { ok: false, reason: "nothing-to-explode" };
    const pieces = [];
    for (const [a, b] of g.lines) pieces.push(lineFrom(entity, a, b));
    for (const arc of g.arcs) {
      pieces.push(
        carry(entity, {
          type: "arc",
          cx: arc.cx,
          cy: arc.cy,
          r: arc.r,
          startAngle: arc.startAngle,
          endAngle: arc.endAngle
        })
      );
    }
    for (const ar of g.arrows) {
      const strokes = arrowStrokes(ar);
      for (const [a, b] of strokes.lines) pieces.push(lineFrom(entity, a, b));
      for (const c of strokes.circles)
        pieces.push(carry(entity, { type: "circle", cx: c.cx, cy: c.cy, r: c.r }));
    }
    if (g.text) {
      pieces.push(
        carry(entity, {
          type: "text",
          x: g.text.pos.x,
          y: g.text.pos.y,
          text: g.text.label,
          height: g.text.height,
          rotation: g.text.rotation || 0,
          // The dimension draws its value CENTRED on textPos; a plain text entity
          // anchors at its justification point, so it must be told to do the same or
          // the exploded label jumps half its width off the dimension line.
          justify: "MC"
        })
      );
    }
    return ok(pieces);
  }
  if (t === "hatch") {
    const rings = [];
    const outer = (entity.cachedBoundary || []).length ? entity.cachedBoundary : entity.explicitBoundary;
    if (outer && outer.length > 2) rings.push(outer);
    const holes = (entity.cachedHoles || []).length ? entity.cachedHoles : entity.explicitHoles;
    for (const h of holes || []) if (h && h.length > 2) rings.push(h);
    return ok(
      rings.map(
        (ring) => carry(entity, {
          type: "polyline",
          points: ring.map((p) => ({ x: p.x, y: p.y })),
          closed: true
        })
      )
    );
  }
  if (t === "region") {
    const parts = explodeRegion(entity);
    if (!parts.length) return { ok: false, reason: "not-explodable" };
    return ok(parts.map((p) => carry(entity, { type: "polyline", points: p.points, closed: true })));
  }
  if (t === "mtext") {
    const g = layoutMText(entity, ctx.measureText || void 0);
    const pieces = [];
    for (const ln of g.lines) {
      if (!ln.text) continue;
      const p = mtextToWorld(entity, ln.dx, ln.dy);
      pieces.push(
        carry(entity, {
          type: "text",
          x: p.x,
          y: p.y,
          text: ln.text,
          height: g.height,
          rotation: entity.rotation || 0,
          // The renderer anchors each line at its TOP-LEFT (Konva Text's default), so
          // an exploded line must too, or every line rises by its own height.
          justify: "TL",
          ...entity.textStyle ? { textStyle: entity.textStyle } : null,
          ...entity.fontFamily ? { fontFamily: entity.fontFamily } : null
        })
      );
    }
    return ok(pieces);
  }
  if (t === "table") {
    const g = tableLayout(entity);
    const pieces = [];
    for (const [a, b] of g.gridSegs) {
      const wa = tableToWorld(entity, a.x, a.y);
      const wb = tableToWorld(entity, b.x, b.y);
      pieces.push(lineFrom(entity, wa, wb));
    }
    for (const [key, cell] of Object.entries(entity.cells || {})) {
      if (!cell || !cell.text) continue;
      const [r, c] = key.split(",").map(Number);
      const pos = g.cellTextPos(r, c, cell.justify);
      if (!pos) continue;
      const p = tableToWorld(entity, pos.x, pos.y);
      const justify = cell.justify === "C" ? "MC" : cell.justify === "R" ? "MR" : "ML";
      pieces.push(
        carry(entity, {
          type: "text",
          x: p.x,
          y: p.y,
          text: cell.text,
          height: g.textHeight,
          rotation: entity.rotation || 0,
          justify,
          ...entity.textStyle ? { textStyle: entity.textStyle } : null
        })
      );
    }
    return ok(pieces);
  }
  if (t === "leader") {
    const g = leaderGeometry(entity, ctx.dimStyleDefs || {}, ctx.dimStyle, ctx.dimSizing);
    if (!g) return { ok: false, reason: "nothing-to-explode" };
    const pieces = [];
    for (const [a, b] of g.segs) pieces.push(lineFrom(entity, a, b));
    if (g.landing) pieces.push(lineFrom(entity, g.landing[0], g.landing[1]));
    const strokes = arrowStrokes(g.arrow);
    for (const [a, b] of strokes.lines) pieces.push(lineFrom(entity, a, b));
    for (const c of strokes.circles)
      pieces.push(carry(entity, { type: "circle", cx: c.cx, cy: c.cy, r: c.r }));
    if (entity.text && g.textPos) {
      pieces.push(
        carry(entity, {
          type: "text",
          x: g.textPos.x,
          y: g.textPos.y,
          text: entity.text,
          height: g.textHeight,
          rotation: 0,
          // The note sits ON the landing line and grows AWAY from the arrow, so its
          // vertical band is the middle and its horizontal side follows the dogleg.
          justify: g.textAlignRight ? "MR" : "ML"
        })
      );
    }
    return ok(pieces);
  }
  if (t === "revcloud") {
    const bumps = revisionCloudBumps(entity.points || [], !!entity.closed, entity.arcRadius);
    return ok(
      bumps.map(
        (b) => carry(entity, {
          type: "arc",
          cx: b.cx,
          cy: b.cy,
          r: b.r,
          startAngle: b.startAngle,
          endAngle: b.endAngle
        })
      )
    );
  }
  if (t === "insert") {
    const def = (ctx.blockDefs || {})[entity.blockName];
    if (!def) return { ok: false, reason: "missing-definition" };
    if (typeof ctx.explodeInsert !== "function") return { ok: false, reason: "not-explodable" };
    return ok(ctx.explodeInsert(entity, def));
  }
  return { ok: false, reason: "not-explodable" };
}
function explodeSelection(entities, ctx = {}) {
  const removeIds = [];
  const pieces = [];
  const refusals = [];
  for (const e of entities || []) {
    const r = explodeEntity(e, ctx);
    if (r.ok) {
      removeIds.push(e.id);
      pieces.push(...r.pieces);
    } else {
      refusals.push({ id: e.id, type: e.type, reason: r.reason });
    }
  }
  return { removeIds, pieces, refusals };
}

// src/cadModify/stretch.js
var ANCHOR_TYPES = /* @__PURE__ */ new Set(["text", "mtext", "point", "table"]);
var INSERT_TYPES = /* @__PURE__ */ new Set(["insert", "xref"]);
var ORIGIN_TYPES = /* @__PURE__ */ new Set(["image"]);
var POINT_LIST_TYPES = /* @__PURE__ */ new Set(["polyline", "revcloud", "leader"]);
function stretchEntity(e, inBox, dx, dy) {
  if (!e || !(Number.isFinite(dx) && Number.isFinite(dy))) return e;
  if (dx === 0 && dy === 0) return e;
  let touched = false;
  const move = (p) => {
    if (!p || !inBox(p)) return p;
    touched = true;
    return { ...p, x: p.x + dx, y: p.y + dy };
  };
  const t = e.type;
  if (t === "line") {
    const a = move({ x: e.x1, y: e.y1 });
    const b = move({ x: e.x2, y: e.y2 });
    return touched ? { ...e, x1: a.x, y1: a.y, x2: b.x, y2: b.y } : e;
  }
  if (POINT_LIST_TYPES.has(t)) {
    const points = (e.points || []).map(move);
    return touched ? { ...e, points } : e;
  }
  if (t === "spline") {
    const out = mapSplinePoints(e, move);
    return touched ? out : e;
  }
  if (t === "rectangle") {
    const corners = rectCorners(e);
    const inside = corners.map((p) => inBox(p));
    const n = inside.filter(Boolean).length;
    if (n === 0) return e;
    if (n === 4) return { ...e, x: e.x + dx, y: e.y + dy };
    return asPolyline(e, corners.map(move));
  }
  if (t === "circle" || t === "ellipse") {
    const c = move({ x: e.cx, y: e.cy });
    return touched ? { ...e, cx: c.x, cy: c.y } : e;
  }
  if (t === "arc") return stretchArc(e, inBox, dx, dy);
  if (t === "ray" || t === "xline") {
    const p = move({ x: e.x, y: e.y });
    return touched ? { ...e, x: p.x, y: p.y } : e;
  }
  if (ANCHOR_TYPES.has(t) || INSERT_TYPES.has(t) || ORIGIN_TYPES.has(t)) {
    const anchor = INSERT_TYPES.has(t) ? e.insertionPoint || { x: 0, y: 0 } : ORIGIN_TYPES.has(t) ? e.origin || { x: 0, y: 0 } : { x: e.x, y: e.y };
    return inBox(anchor) ? translateEntity(e, dx, dy) : e;
  }
  if (t === "dimension") {
    const out = mapDimensionPoints(e, move);
    return touched ? out : e;
  }
  if (t === "hatch") {
    const ring = (e.cachedBoundary || []).length ? e.cachedBoundary : e.explicitBoundary;
    if (!ring || !ring.length || !ring.every((p) => inBox(p))) return e;
    return mapHatchGeometry(e, (p) => ({ x: p.x + dx, y: p.y + dy }));
  }
  if (t === "region") {
    let touched2 = false;
    const rings = (e.rings || []).map(
      (ring2) => (ring2 || []).map((p) => {
        if (!inBox(p)) return p;
        touched2 = true;
        return { x: p.x + dx, y: p.y + dy };
      })
    );
    return touched2 ? { ...e, rings } : e;
  }
  return e;
}
function stretchArc(e, inBox, dx, dy) {
  const sweep = norm360(e.endAngle - e.startAngle);
  const c = { x: e.cx, y: e.cy };
  if (!(sweep > 1e-9) || sweep > 360 - 1e-9 || !(e.r > 1e-12)) {
    return inBox(c) ? { ...e, cx: e.cx + dx, cy: e.cy + dy } : e;
  }
  const p1 = onCircle(c, e.r, e.startAngle);
  const p2 = onCircle(c, e.r, e.endAngle);
  const in1 = inBox(p1);
  const in2 = inBox(p2);
  if (!in1 && !in2) return e;
  const q1 = in1 ? { x: p1.x + dx, y: p1.y + dy } : p1;
  const q2 = in2 ? { x: p2.x + dx, y: p2.y + dy } : p2;
  if (Math.hypot(q2.x - q1.x, q2.y - q1.y) <= 1e-12) return e;
  const bulge = Math.tan(sweep * Math.PI / 180 / 4);
  const c0 = Math.hypot(p2.x - p1.x, p2.y - p1.y);
  const c1 = Math.hypot(q2.x - q1.x, q2.y - q1.y);
  const arc = bulgeToArc(q1, q2, bulge * (c0 / c1));
  if (!arc || !Number.isFinite(arc.r)) return e;
  return {
    ...e,
    cx: arc.cx,
    cy: arc.cy,
    r: arc.r,
    startAngle: arc.startAngle,
    endAngle: arc.endAngle
  };
}
function stretchEntities(entities, inBox, dx, dy) {
  return (entities || []).map((e) => stretchEntity(e, inBox, dx, dy));
}
function boxContains(box) {
  return (p) => p.x >= box.minX && p.x <= box.maxX && p.y >= box.minY && p.y <= box.maxY;
}
function regionContains(region) {
  if (!region) return () => true;
  if (Array.isArray(region)) {
    return (p) => pointInPolygon(p, region);
  }
  return boxContains(region);
}

// src/cadBlockAuthor.js
var ILLEGAL_NAME_CHARS = /[<>/\\":;?*|,='`]/;
var BLOCK_NAME_MAX = 255;
var POISON_KEYS = ["__proto__", "constructor", "prototype"];
function isBuiltinBlock(name) {
  return Object.prototype.hasOwnProperty.call(GEOTECH_BLOCKS, String(name));
}
function blockNameError(name, blockDefs, opts = {}) {
  const n = String(name == null ? "" : name).trim();
  if (!n) return "empty";
  if (n.length > BLOCK_NAME_MAX) return "toolong";
  if (ILLEGAL_NAME_CHARS.test(n)) return "invalid";
  if (POISON_KEYS.includes(n)) return "invalid";
  if (!opts.allowOverwrite && blockDefs && Object.prototype.hasOwnProperty.call(blockDefs, n)) {
    return "duplicate";
  }
  return null;
}
function normalizeBlockName(name) {
  return String(name == null ? "" : name).trim();
}
function blockDeleteImpact(doc, name) {
  const n = normalizeBlockName(name);
  const defs = doc && doc.blockDefs || {};
  const exists = Object.prototype.hasOwnProperty.call(defs, n);
  const builtin = isBuiltinBlock(n);
  const instanceIds = [];
  const nestedIn = [];
  for (const e of doc && doc.entities || []) {
    if (e && e.type === "insert" && e.blockName === n) instanceIds.push(e.id);
  }
  for (const [defName, def] of Object.entries(defs)) {
    if (defName === n) continue;
    for (const se of def && def.entities || []) {
      if (se && se.type === "insert" && se.blockName === n && !nestedIn.includes(defName)) {
        nestedIn.push(defName);
      }
    }
  }
  return {
    exists,
    builtin,
    instanceIds,
    nestedIn,
    count: instanceIds.length,
    // 'builtin' wins over 'missing': a built-in cannot be deleted whether or not
    // this particular (un-normalized) document happens to list it, and "no such
    // block" would be the wrong thing to tell a user looking at BH in the panel.
    refusal: builtin ? "builtin" : !exists ? "missing" : null
  };
}
function attdefFromText(entity, spec2 = {}) {
  if (!entity || entity.type !== "text") return null;
  const tag = String(spec2.tag == null ? "" : spec2.tag).trim();
  if (!tag) return null;
  if (POISON_KEYS.includes(tag)) return null;
  const a = {
    tag,
    prompt: String(spec2.prompt == null ? "" : spec2.prompt),
    // The text the user already typed is the sensible default value — for a plain
    // attribute it is literally the placeholder they wrote ("PROJECT NAME"), and
    // for a field it is the code, which is what DXF must carry.
    default: spec2.field ? String(spec2.field) : String(entity.text == null ? "" : entity.text),
    x: entity.x || 0,
    y: entity.y || 0,
    height: entity.height || 1,
    rotation: entity.rotation || 0,
    visible: true
  };
  if (spec2.field) a.field = String(spec2.field);
  return a;
}
function planBlockDefinition(spec2) {
  const { entities = [], ids = [], basePoint = { x: 0, y: 0 }, promotions = {} } = spec2 || {};
  const source = spec2 && spec2.source === "convert" ? "convert" : spec2 && spec2.source === "delete" ? "delete" : "retain";
  const chosen = entities.filter((e) => e && ids.includes(e.id));
  const defEntities = [];
  const attdefs = [];
  const seenTags = /* @__PURE__ */ new Set();
  for (const e of chosen) {
    const promo = Object.prototype.hasOwnProperty.call(promotions, e.id) ? promotions[e.id] : null;
    let attdef = promo ? attdefFromText(e, promo) : null;
    if (attdef && seenTags.has(attdef.tag)) attdef = null;
    if (attdef) {
      seenTags.add(attdef.tag);
      attdefs.push(attdef);
    } else defEntities.push(e);
  }
  const def = {
    description: String(spec2 && spec2.description || ""),
    basePoint: { x: basePoint.x || 0, y: basePoint.y || 0 },
    entities: defEntities
  };
  if (attdefs.length) def.attdefs = attdefs;
  return {
    def,
    removeIds: source === "retain" ? [] : chosen.map((e) => e.id),
    place: source === "convert" ? { insertionPoint: { x: basePoint.x || 0, y: basePoint.y || 0 } } : null
  };
}
function attributesForInsert(def, insert, values = {}, layoutRef) {
  const defs = def && def.attdefs || [];
  if (!defs.length) return void 0;
  const base = def && def.basePoint || { x: 0, y: 0 };
  return defs.map((a) => {
    const typed = values && Object.prototype.hasOwnProperty.call(values, a.tag) ? values[a.tag] : void 0;
    const value = typed != null ? String(typed) : String(a.default == null ? "" : a.default);
    const placed = placeAttribute({ ...a, value }, insert, base);
    delete placed.default;
    if (a.field && layoutRef) placed.fieldLayout = layoutRef;
    return placed;
  });
}
function attributeValuesOf(attributes) {
  return Object.fromEntries(
    (attributes || []).filter((a) => a && a.tag).map((a) => [a.tag, a.value == null ? "" : a.value])
  );
}

// src/cadGrips.js
var GRIP_COINCIDENT = 1e-6;
function dimTextPoint(e, ctx, ignoreOffset) {
  if (!ctx) return null;
  const src = ignoreOffset ? { ...e, textOffset: null } : e;
  const a = dimensionTextAnchor(src, ctx.dimStyleDefs, ctx.dimStyle, ctx.sizing);
  if (!a || !Number.isFinite(a.x) || !Number.isFinite(a.y)) return null;
  const nudge = ignoreOffset ? null : ctx.labelNudges && ctx.labelNudges[e.id];
  if (nudge && Number.isFinite(nudge.x) && Number.isFinite(nudge.y)) return { x: nudge.x, y: nudge.y };
  return { x: a.x, y: a.y };
}
var dist = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
var angleDeg = (c, p) => Math.atan2(p.y - c.y, p.x - c.x) * 180 / Math.PI;
function arcMidAngle2(e) {
  const sweep = ((e.endAngle - e.startAngle) % 360 + 360) % 360;
  return e.startAngle + sweep / 2;
}
var onCircle2 = (cx, cy, r, deg2) => {
  const a = deg2 * Math.PI / 180;
  return { x: cx + r * Math.cos(a), y: cy + r * Math.sin(a) };
};
function entityGrips(e, ctx) {
  switch (e.type) {
    case "line":
      return [
        { x: e.x1, y: e.y1, role: "end1" },
        { x: e.x2, y: e.y2, role: "end2" },
        { x: (e.x1 + e.x2) / 2, y: (e.y1 + e.y2) / 2, role: "mid" }
      ];
    case "polyline":
      return e.points.map((p, index) => ({ x: p.x, y: p.y, role: "vertex", index }));
    // C4b. A region's vertices live in NESTED rings, so a flat `index` cannot
    // identify one — the grip carries `ring` as well, and applyGripDrag decodes
    // both. Holes get grips too: a hole's boundary is editable geometry.
    case "region":
      return (e.rings || []).flatMap(
        (ring, ringIndex) => (ring || []).map((p, index) => ({
          x: p.x,
          y: p.y,
          role: "vertex",
          index,
          ring: ringIndex
        }))
      );
    case "rectangle":
      return [
        { x: e.x, y: e.y, role: "corner", index: 0 },
        { x: e.x + e.width, y: e.y, role: "corner", index: 1 },
        { x: e.x + e.width, y: e.y + e.height, role: "corner", index: 2 },
        { x: e.x, y: e.y + e.height, role: "corner", index: 3 }
      ];
    case "circle":
      return [
        { x: e.cx, y: e.cy, role: "center" },
        { x: e.cx + e.r, y: e.cy, role: "quadrant" },
        { x: e.cx, y: e.cy + e.r, role: "quadrant" },
        { x: e.cx - e.r, y: e.cy, role: "quadrant" },
        { x: e.cx, y: e.cy - e.r, role: "quadrant" }
      ];
    case "arc": {
      const s = onCircle2(e.cx, e.cy, e.r, e.startAngle);
      const en = onCircle2(e.cx, e.cy, e.r, e.endAngle);
      const m = onCircle2(e.cx, e.cy, e.r, arcMidAngle2(e));
      return [
        { x: e.cx, y: e.cy, role: "center" },
        { x: s.x, y: s.y, role: "start" },
        { x: en.x, y: en.y, role: "end" },
        { x: m.x, y: m.y, role: "radius" }
      ];
    }
    case "ellipse": {
      const rot = (e.rotation || 0) * Math.PI / 180;
      const ux = Math.cos(rot);
      const uy = Math.sin(rot);
      const grips = [
        { x: e.cx, y: e.cy, role: "center" },
        { x: e.cx + ux * e.rx, y: e.cy + uy * e.rx, role: "axisX" },
        { x: e.cx - uy * e.ry, y: e.cy + ux * e.ry, role: "axisY" }
      ];
      if (!isFullEllipse(e)) {
        const s = ellipsePoint(e, e.startAngle);
        const en = ellipsePoint(e, e.endAngle);
        grips.push({ x: s.x, y: s.y, role: "angleStart" });
        grips.push({ x: en.x, y: en.y, role: "angleEnd" });
      }
      return grips;
    }
    case "spline":
      return splineDefiningPoints(e).map((p, index) => ({ x: p.x, y: p.y, role: "control", index }));
    case "ray":
    case "xline":
      return [
        { x: e.x, y: e.y, role: "base" },
        { x: e.x + e.dx, y: e.y + e.dy, role: "dir" }
      ];
    case "revcloud":
      return (e.points || []).map((p, index) => ({ x: p.x, y: p.y, role: "vertex", index }));
    case "leader":
      return (e.points || []).map((p, index) => ({ x: p.x, y: p.y, role: "vertex", index }));
    case "text":
      return [{ x: e.x, y: e.y, role: "position" }];
    case "mtext": {
      const g = mtextGripPoints(e);
      return [
        { x: g.position.x, y: g.position.y, role: "position" },
        { x: g.width.x, y: g.width.y, role: "width" }
      ];
    }
    case "table": {
      const g = tableGripPoints(e);
      return [
        { x: g.position.x, y: g.position.y, role: "position" },
        ...g.colEdges.map((p) => ({ x: p.x, y: p.y, role: "colEdge", index: p.index })),
        ...g.rowEdges.map((p) => ({ x: p.x, y: p.y, role: "rowEdge", index: p.index })),
        ...g.corner ? [{ x: g.corner.x, y: g.corner.y, role: "scale" }] : []
      ];
    }
    case "point":
      return [{ x: e.x, y: e.y, role: "position" }];
    // [BUG-INSERT-GRIPS-1] `insert` had NO case at all and fell to `default: []`,
    // so a block reference was the one selectable thing on the canvas with no grip —
    // its neighbour `xref` has had one since V4b. Found by [C4b] while strengthening
    // the ENTITY_TYPES sweep (the old assertion was `Array.isArray(g)`, true of every
    // type including the empty one) and assigned to [C5], which owns blocks.
    //
    // ONE grip, at the insertion point — AutoCAD's behaviour for a non-dynamic block
    // reference, and the same answer xref already gives for the same reason. A
    // bounding-box grip set was rejected: it would imply STRETCH semantics a block
    // reference does not have (its geometry lives in the definition, so dragging a
    // corner can only mean "scale", which is a different gesture), and grips on the
    // definition's extents are 4.6's dynamic-block question, not this one. Scale and
    // rotation are edited numerically in the Properties panel ([C5] criterion 2).
    // [RASTER-IMAGE-1] FOUR corner grips, deliberately unlike the insert/xref
    // answer directly below. The objection that rules out box grips for a block
    // reference does not apply here: an image's extent IS its own geometry, not a
    // definition's, so dragging a corner has an unambiguous meaning — resize —
    // and it is the gesture a drafter reaches for when scaling a photo to a known
    // dimension. The `index` is the corner being dragged; applyGripDrag anchors
    // the OPPOSITE one.
    case "image":
      return imageCorners(e).map((c, i) => ({ x: c.x, y: c.y, role: "imageCorner", index: i }));
    case "insert":
    case "xref":
      return [{ x: e.insertionPoint && e.insertionPoint.x || 0, y: e.insertionPoint && e.insertionPoint.y || 0, role: "insertion" }];
    case "dimension": {
      const textGrip = dimTextPoint(e, ctx, false);
      const withText = (gs) => {
        if (!textGrip) return gs;
        const clash = gs.some((g) => Math.hypot(g.x - textGrip.x, g.y - textGrip.y) < GRIP_COINCIDENT);
        return clash ? gs : [...gs, { ...textGrip, role: "dimText" }];
      };
      if (e.dimType === "angular") {
        return withText([
          { x: e.vertex.x, y: e.vertex.y, role: "dimVertex" },
          { x: e.p1.x, y: e.p1.y, role: "dimP1" },
          { x: e.p2.x, y: e.p2.y, role: "dimP2" }
        ]);
      }
      if (e.dimType === "radius" || e.dimType === "diameter") {
        return withText([
          { x: e.center.x, y: e.center.y, role: "dimCenter" },
          { x: e.leaderPoint.x, y: e.leaderPoint.y, role: "dimLeader" }
        ]);
      }
      if (e.dimType === "ordinate") {
        return withText([
          { x: e.feature.x, y: e.feature.y, role: "dimOrdFeature" },
          { x: e.leader.x, y: e.leader.y, role: "dimOrdLeader" }
        ]);
      }
      if (e.dimType === "arclength") {
        return withText([{ x: e.linePoint.x, y: e.linePoint.y, role: "dimArcLine" }]);
      }
      return withText([
        { x: e.p1.x, y: e.p1.y, role: "dimP1" },
        { x: e.p2.x, y: e.p2.y, role: "dimP2" },
        { x: e.linePoint.x, y: e.linePoint.y, role: "dimLine" }
      ]);
    }
    default:
      return [];
  }
}
function applyGripDrag(e, grip, p, ctx) {
  const c = { x: e.cx, y: e.cy };
  switch (e.type) {
    case "line":
      if (grip.role === "end1") return { x1: p.x, y1: p.y };
      if (grip.role === "end2") return { x2: p.x, y2: p.y };
      if (grip.role === "mid") {
        const dx = p.x - (e.x1 + e.x2) / 2;
        const dy = p.y - (e.y1 + e.y2) / 2;
        return { x1: e.x1 + dx, y1: e.y1 + dy, x2: e.x2 + dx, y2: e.y2 + dy };
      }
      return null;
    case "polyline": {
      const points = e.points.map(
        (q, i) => i === grip.index ? { x: p.x, y: p.y } : { x: q.x, y: q.y }
      );
      return { points };
    }
    case "region": {
      const rings = (e.rings || []).map(
        (ring, ri) => (ring || []).map(
          (q, i) => ri === grip.ring && i === grip.index ? { x: p.x, y: p.y } : { x: q.x, y: q.y }
        )
      );
      return { rings };
    }
    case "rectangle": {
      const corners = [
        { x: e.x, y: e.y },
        { x: e.x + e.width, y: e.y },
        { x: e.x + e.width, y: e.y + e.height },
        { x: e.x, y: e.y + e.height }
      ];
      const opp = corners[(grip.index + 2) % 4];
      return {
        x: Math.min(opp.x, p.x),
        y: Math.min(opp.y, p.y),
        width: Math.abs(opp.x - p.x),
        height: Math.abs(opp.y - p.y)
      };
    }
    case "circle":
      if (grip.role === "center") return { cx: p.x, cy: p.y };
      return { r: dist(c, p) };
    case "arc":
      if (grip.role === "center") return { cx: p.x, cy: p.y };
      if (grip.role === "start") return { startAngle: angleDeg(c, p) };
      if (grip.role === "end") return { endAngle: angleDeg(c, p) };
      if (grip.role === "radius") return { r: dist(c, p) };
      return null;
    case "ellipse": {
      if (grip.role === "center") return { cx: p.x, cy: p.y };
      const rot = (e.rotation || 0) * Math.PI / 180;
      const ux = Math.cos(rot);
      const uy = Math.sin(rot);
      const vx = p.x - e.cx;
      const vy = p.y - e.cy;
      if (grip.role === "axisX") return { rx: Math.abs(vx * ux + vy * uy) };
      if (grip.role === "axisY") return { ry: Math.abs(-vx * uy + vy * ux) };
      if (grip.role === "angleStart") return { startAngle: ellipseParamAt(e, p) };
      if (grip.role === "angleEnd") return { endAngle: ellipseParamAt(e, p) };
      return null;
    }
    case "spline": {
      const key = isFitSpline(e) ? "fitPoints" : "controlPoints";
      const pts = (e[key] || []).map((q, i) => i === grip.index ? { x: p.x, y: p.y } : { x: q.x, y: q.y });
      return { [key]: pts };
    }
    case "ray":
    case "xline":
      if (grip.role === "base") return { x: p.x, y: p.y };
      if (grip.role === "dir") return { dx: p.x - e.x, dy: p.y - e.y };
      return null;
    case "revcloud": {
      const points = e.points.map((q, i) => i === grip.index ? { x: p.x, y: p.y } : { x: q.x, y: q.y });
      return { points };
    }
    case "leader": {
      const points = e.points.map((q, i) => i === grip.index ? { x: p.x, y: p.y } : { x: q.x, y: q.y });
      return { points };
    }
    case "text":
    case "point":
      return { x: p.x, y: p.y };
    case "mtext":
      if (grip.role === "width") return mtextWidthPatch(e, p);
      return { x: p.x, y: p.y };
    case "table":
      if (grip.role === "colEdge") return tableColEdgePatch(e, grip.index, p);
      if (grip.role === "rowEdge") return tableRowEdgePatch(e, grip.index, p);
      if (grip.role === "scale") return tableScalePatch(e, p);
      return { x: p.x, y: p.y };
    // [RASTER-IMAGE-1] Dragging a corner RESIZES about the opposite corner, which
    // is what keeps the drag feeling anchored. The new edge lengths are the
    // dragged point's offset measured ALONG the frame's own axes, not along world
    // x/y — so a rotated image resizes along its own edges rather than skewing,
    // and the perpendicularity invariant (CADModel/image.js) survives a drag.
    // `resizeImage` owns the aspect lock, so the lock cannot mean one thing here
    // and another in the Properties panel.
    case "image": {
      if (grip.role !== "imageCorner" || !hasImageFrame(e)) return null;
      const i = grip.index | 0;
      const opposite = (i + 2) % 4;
      const anchor = imageCorners(e)[opposite];
      const w = imageWidth(e);
      const h = imageHeight(e);
      if (!(w > 0) || !(h > 0)) return null;
      const ux = { x: e.u.x / w, y: e.u.y / w };
      const vy = { x: e.v.x / h, y: e.v.y / h };
      const dx = p.x - anchor.x;
      const dy = p.y - anchor.y;
      const width = Math.abs(dx * ux.x + dy * ux.y);
      const height = Math.abs(dx * vy.x + dy * vy.y);
      const floorW = w / 1e3;
      const floorH = h / 1e3;
      const patch = e.lockAspect ? width / w > height / h ? { width: Math.max(width, floorW) } : { height: Math.max(height, floorH) } : { width: Math.max(width, floorW), height: Math.max(height, floorH) };
      const resized = resizeImage(e, patch, opposite);
      return { origin: resized.origin, u: resized.u, v: resized.v };
    }
    case "insert":
    case "xref": {
      const from = e.insertionPoint || { x: 0, y: 0 };
      const dx = p.x - (from.x || 0);
      const dy = p.y - (from.y || 0);
      return {
        insertionPoint: { x: p.x, y: p.y },
        ...Array.isArray(e.attributes) && e.attributes.length ? { attributes: e.attributes.map((a) => ({ ...a, x: (a.x || 0) + dx, y: (a.y || 0) + dy })) } : {}
      };
    }
    case "dimension":
      if (grip.role === "dimP1") return { p1: { x: p.x, y: p.y } };
      if (grip.role === "dimP2") return { p2: { x: p.x, y: p.y } };
      if (grip.role === "dimText") {
        const base = dimTextPoint(e, ctx, true);
        if (!base) return {};
        const dx = p.x - base.x;
        const dy = p.y - base.y;
        return {
          textOffset: Math.abs(dx) < 1e-9 && Math.abs(dy) < 1e-9 ? void 0 : { x: dx, y: dy }
        };
      }
      if (grip.role === "dimLine") return { linePoint: { x: p.x, y: p.y } };
      if (grip.role === "dimVertex") return { vertex: { x: p.x, y: p.y } };
      if (grip.role === "dimCenter") return { center: { x: p.x, y: p.y } };
      if (grip.role === "dimLeader") return { leaderPoint: { x: p.x, y: p.y } };
      if (grip.role === "dimOrdFeature") return { feature: { x: p.x, y: p.y } };
      if (grip.role === "dimOrdLeader") return { leader: { x: p.x, y: p.y } };
      if (grip.role === "dimArcLine") return { linePoint: { x: p.x, y: p.y } };
      return null;
    default:
      return null;
  }
}

// src/cadTracking.js
var DEG = Math.PI / 180;
var norm3602 = (d) => (d % 360 + 360) % 360;
var angleDeg2 = (a, b) => Math.atan2(b.y - a.y, b.x - a.x) * 180 / Math.PI;
var dist2 = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
var DEFAULT_POLAR_INCREMENT = 90;
var POLAR_APERTURE_DEG = 6;
var MAX_ACQUIRED = 7;
function constrainOrtho(raw, anchor) {
  if (!anchor) return { x: raw.x, y: raw.y };
  const dx = raw.x - anchor.x;
  const dy = raw.y - anchor.y;
  return Math.abs(dx) >= Math.abs(dy) ? { x: raw.x, y: anchor.y } : { x: anchor.x, y: raw.y };
}
function constrainPolar(raw, anchor, incrementDeg = DEFAULT_POLAR_INCREMENT) {
  if (!anchor) return { point: { x: raw.x, y: raw.y }, angle: 0, delta: 0 };
  const inc = incrementDeg > 0 ? incrementDeg : DEFAULT_POLAR_INCREMENT;
  const len2 = dist2(anchor, raw);
  const rawAng = angleDeg2(anchor, raw);
  const snapped = Math.round(rawAng / inc) * inc;
  let delta = Math.abs(norm3602(rawAng) - norm3602(snapped));
  if (delta > 180) delta = 360 - delta;
  const r = snapped * DEG;
  return {
    point: { x: anchor.x + len2 * Math.cos(r), y: anchor.y + len2 * Math.sin(r) },
    angle: norm3602(snapped),
    delta
  };
}
var lineFromAngle = (p, deg2) => {
  const r = deg2 * DEG;
  return { p, dir: { x: Math.cos(r), y: Math.sin(r) }, angle: norm3602(deg2) };
};
var lineThrough = (a, b) => {
  const dx = b.x - a.x;
  const dy = b.y - a.y;
  const L = Math.hypot(dx, dy) || 1;
  return { p: a, dir: { x: dx / L, y: dy / L }, angle: norm3602(angleDeg2(a, b)) };
};
var lineLineIntersection2 = (L1, L2) => {
  const denom = L1.dir.x * L2.dir.y - L1.dir.y * L2.dir.x;
  if (Math.abs(denom) < 1e-12) return null;
  const t = ((L2.p.x - L1.p.x) * L2.dir.y - (L2.p.y - L1.p.y) * L2.dir.x) / denom;
  return { x: L1.p.x + L1.dir.x * t, y: L1.p.y + L1.dir.y * t };
};
var footOnLine = (L, p) => {
  const t = (p.x - L.p.x) * L.dir.x + (p.y - L.p.y) * L.dir.y;
  return { x: L.p.x + L.dir.x * t, y: L.p.y + L.dir.y * t };
};
function alignmentAngles(modes) {
  const set = /* @__PURE__ */ new Set([0, 90]);
  if (modes && modes.polar) {
    const inc = modes.polarInc > 0 ? modes.polarInc : DEFAULT_POLAR_INCREMENT;
    for (let a = 0; a < 360; a += inc) set.add((a % 180 + 180) % 180);
  }
  return [...set].map((a) => (a % 180 + 180) % 180).filter((a, i, arr) => arr.indexOf(a) === i);
}
function trackingAlignments(raw, acquiredPoints, modes = {}, tol = 0, anchorRay = null) {
  const pts = Array.isArray(acquiredPoints) ? acquiredPoints : [];
  if (!pts.length || tol <= 0) return { point: null, guides: [] };
  const angles = alignmentAngles(modes);
  const lines = [];
  pts.forEach((p, i) => {
    for (const ang of angles) lines.push({ ...lineFromAngle(p, ang), src: i, base: p });
  });
  const pairCands = [];
  const rayCands = [];
  const soloCands = [];
  for (let i = 0; i < lines.length; i++) {
    if (anchorRay) {
      const x = lineLineIntersection2(lines[i], anchorRay);
      if (x && dist2(x, raw) <= tol) {
        rayCands.push({ point: x, d: dist2(x, raw), guides: [
          { a: lines[i].base, b: x, kind: "track" },
          { a: anchorRay.p, b: x, kind: "track" }
        ] });
      }
    }
    const foot = footOnLine(lines[i], raw);
    if (dist2(foot, raw) <= tol) {
      soloCands.push({ point: foot, d: dist2(foot, raw), guides: [{ a: lines[i].base, b: foot, kind: "track" }] });
    }
    for (let j = i + 1; j < lines.length; j++) {
      if (lines[j].src === lines[i].src) continue;
      const x = lineLineIntersection2(lines[i], lines[j]);
      if (x && dist2(x, raw) <= tol) {
        pairCands.push({ point: x, d: dist2(x, raw), guides: [
          { a: lines[i].base, b: x, kind: "track" },
          { a: lines[j].base, b: x, kind: "track" }
        ] });
      }
    }
  }
  const ranked = [...pairCands, ...rayCands].sort((a, b) => a.d - b.d);
  if (ranked.length) return { point: ranked[0].point, guides: ranked[0].guides };
  soloCands.sort((a, b) => a.d - b.d);
  if (soloCands.length) return { point: soloCands[0].point, guides: soloCands[0].guides };
  return { point: null, guides: [] };
}
function resolvePoint(raw, anchor, settings = {}, acquiredPoints = [], snapResult = null) {
  const s = settings || {};
  if (s.typed) return { point: { x: s.typed.x, y: s.typed.y }, guides: [] };
  if (snapResult && snapResult.point) {
    return { point: { x: snapResult.point.x, y: snapResult.point.y }, guides: [] };
  }
  const ortho = !!s.ortho;
  const polar = !s.ortho && !!s.polar;
  const polarInc = s.polarInc > 0 ? s.polarInc : DEFAULT_POLAR_INCREMENT;
  const aperture = s.aperture > 0 ? s.aperture : POLAR_APERTURE_DEG;
  const tol = s.tol > 0 ? s.tol : 0;
  let constraint = null;
  if (anchor) {
    if (ortho) {
      const pt3 = constrainOrtho(raw, anchor);
      constraint = { point: pt3, guide: { a: anchor, b: pt3, kind: "ortho" } };
    } else if (polar) {
      const cp = constrainPolar(raw, anchor, polarInc);
      if (cp.delta <= aperture) {
        constraint = { point: cp.point, guide: { a: anchor, b: cp.point, kind: "polar", angle: cp.angle } };
      }
    }
  }
  if (s.otrack && acquiredPoints && acquiredPoints.length && tol > 0) {
    const anchorRay = constraint && anchor ? lineThrough(anchor, constraint.point) : null;
    const trk = trackingAlignments(raw, acquiredPoints, { polar, polarInc }, tol, anchorRay);
    if (trk.point) return { point: trk.point, guides: trk.guides };
  }
  if (constraint) return { point: constraint.point, guides: [constraint.guide] };
  return { point: { x: raw.x, y: raw.y }, guides: [] };
}

// src/cadDynamicInput/shared.js
var dist3 = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
var angleDeg3 = (c, p) => Math.atan2(p.y - c.y, p.x - c.x) * 180 / Math.PI;
var norm3603 = (d) => (d % 360 + 360) % 360;
var F = (key, label) => ({ key, label });

// src/cadDynamicInput/draw.js
function spec(tool, draft) {
  const pts = draft && draft.points ? draft.points : [];
  const n = pts.length;
  const last = n ? pts[n - 1] : null;
  switch (tool) {
    case "line":
    case "polyline":
    case "leader":
      return n >= 1 ? { kind: "polar", anchor: last, fields: [F("length", "Length"), F("angle", "Angle")] } : null;
    case "rectangle":
    case "mtext":
      return n === 1 ? { kind: "rect", anchor: pts[0], fields: [F("width", "Width"), F("height", "Height")] } : null;
    case "circle":
      return n === 1 ? { kind: "radius", anchor: pts[0], fields: [F("radius", "Radius")] } : null;
    case "polygon":
      return n === 1 ? { kind: "polar", anchor: pts[0], fields: [F("length", "Radius"), F("angle", "Angle")] } : null;
    case "ray":
    case "xline":
      return n === 1 ? { kind: "polar", anchor: pts[0], fields: [F("angle", "Angle")] } : null;
    case "arc":
      if (n === 1) return { kind: "polar", anchor: pts[0], fields: [F("length", "Radius"), F("angle", "Angle")] };
      if (n === 2) return { kind: "polar", anchor: pts[0], fields: [F("angle", "Angle")] };
      return null;
    case "ellipse":
      if (n === 1) return { kind: "polar", anchor: pts[0], fields: [F("length", "Major"), F("angle", "Angle")] };
      if (n === 2) return { kind: "perp", anchor: pts[0], major: pts[1], fields: [F("length", "Minor")] };
      return null;
    case "move":
    case "copy":
      return n === 1 ? { kind: "polar", anchor: pts[0], fields: [F("length", "Distance"), F("angle", "Angle")] } : null;
    case "dimlinear":
    case "dimaligned":
      if (n === 1) return { kind: "polar", anchor: pts[0], fields: [F("length", "Length"), F("angle", "Angle")] };
      if (n === 2 && tool === "dimaligned") return { kind: "perp", anchor: pts[0], major: pts[1], fields: [F("length", "Offset")] };
      return null;
    case "dimordinate":
      return n === 1 ? { kind: "polar", anchor: pts[0], fields: [F("length", "Leader length"), F("angle", "Angle")] } : null;
    case "dimradius":
    case "dimdiameter":
      return draft && draft.circle ? { kind: "polar", anchor: draft.circle.center, fields: [F("length", "Leader length"), F("angle", "Angle")] } : null;
    // 'dimangular' is deliberately fieldless at every step (its picks are entity
    // picks, not points, and the placement arc radius follows the cursor) — it falls
    // to the default null below, pinned by a test. 'text' likewise (Spec 01 owns text
    // UX); 'mtext' keeps its rectangle box-drag fields from the rectangle/mtext case.
    default:
      return null;
  }
}
function dynFields(tool, draft) {
  const sp = spec(tool, draft);
  return sp ? sp.fields : [];
}
function dynLiveValues(tool, draft, cursor) {
  const sp = spec(tool, draft);
  if (!sp || !cursor) return {};
  if (sp.kind === "polar" || sp.kind === "radius") {
    const d = dist3(sp.anchor, cursor);
    return { length: d, radius: d, distance: d, angle: norm3603(angleDeg3(sp.anchor, cursor)) };
  }
  if (sp.kind === "rect") {
    return { width: cursor.x - sp.anchor.x, height: cursor.y - sp.anchor.y };
  }
  if (sp.kind === "perp") {
    const n = perpAxis(sp);
    return { length: Math.abs((cursor.x - sp.anchor.x) * n.x + (cursor.y - sp.anchor.y) * n.y) };
  }
  return {};
}
function perpAxis(sp) {
  const ux = sp.major.x - sp.anchor.x;
  const uy = sp.major.y - sp.anchor.y;
  const L = Math.hypot(ux, uy) || 1;
  return { x: -uy / L, y: ux / L };
}
function solvePlacement(tool, draft, cursor, locked = {}) {
  const sp = spec(tool, draft);
  if (!sp || !cursor) return cursor;
  const L = locked || {};
  if (sp.kind === "polar") {
    if (L.length == null && L.angle == null) return cursor;
    const len2 = L.length != null ? L.length : dist3(sp.anchor, cursor);
    const ang = L.angle != null ? L.angle : angleDeg3(sp.anchor, cursor);
    const r = ang * Math.PI / 180;
    return { x: sp.anchor.x + len2 * Math.cos(r), y: sp.anchor.y + len2 * Math.sin(r) };
  }
  if (sp.kind === "radius") {
    if (L.radius == null) return cursor;
    const len2 = L.radius;
    const r = angleDeg3(sp.anchor, cursor) * Math.PI / 180;
    return { x: sp.anchor.x + len2 * Math.cos(r), y: sp.anchor.y + len2 * Math.sin(r) };
  }
  if (sp.kind === "rect") {
    if (L.width == null && L.height == null) return cursor;
    const w = L.width != null ? L.width : cursor.x - sp.anchor.x;
    const h = L.height != null ? L.height : cursor.y - sp.anchor.y;
    return { x: sp.anchor.x + w, y: sp.anchor.y + h };
  }
  if (sp.kind === "perp") {
    if (L.length == null) return cursor;
    const n = perpAxis(sp);
    const d = (cursor.x - sp.anchor.x) * n.x + (cursor.y - sp.anchor.y) * n.y;
    const target = (d < 0 ? -1 : 1) * L.length;
    return { x: cursor.x + n.x * (target - d), y: cursor.y + n.y * (target - d) };
  }
  return cursor;
}
function dynLockValue(key, num5) {
  if (!Number.isFinite(num5)) return null;
  if (key === "angle") return num5;
  if (key === "width" || key === "height") return num5;
  return Math.abs(num5);
}
function formatDynValue(key, value) {
  if (value == null || !Number.isFinite(value)) return "";
  return key === "angle" ? `${norm3603(value).toFixed(1)}\xB0` : value.toFixed(2);
}
function previewDimensions(tool, draft, cursor) {
  const pts = draft && draft.points ? draft.points : [];
  const n = pts.length;
  const labels = [];
  const leaders = [];
  if (!cursor || !n) return { labels, leaders };
  const mid = (a, b) => ({ x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 });
  const angLabel = (a, b) => `\u2220${formatDynValue("angle", angleDeg3(a, b))}`;
  const radial = (c) => {
    const r = dist3(c, cursor);
    const a = angleDeg3(c, cursor) * Math.PI / 180;
    const edge = { x: c.x + r * Math.cos(a), y: c.y + r * Math.sin(a) };
    leaders.push({ a: c, b: edge });
    labels.push({ text: `R ${formatDynValue("radius", r)}`, at: edge });
  };
  switch (tool) {
    case "line":
    case "polyline": {
      const a = pts[n - 1];
      labels.push({ text: formatDynValue("length", dist3(a, cursor)), at: mid(a, cursor) });
      labels.push({ text: angLabel(a, cursor), at: a });
      break;
    }
    case "rectangle":
    case "mtext": {
      const a = pts[0];
      labels.push({ text: formatDynValue("width", Math.abs(cursor.x - a.x)), at: { x: (a.x + cursor.x) / 2, y: a.y } });
      labels.push({ text: formatDynValue("height", Math.abs(cursor.y - a.y)), at: { x: cursor.x, y: (a.y + cursor.y) / 2 } });
      break;
    }
    case "circle":
    case "polygon":
      radial(pts[0]);
      break;
    case "arc":
      if (n === 1) radial(pts[0]);
      else labels.push({ text: angLabel(pts[0], cursor), at: cursor });
      break;
    case "ellipse":
      if (n === 1) {
        labels.push({ text: formatDynValue("length", dist3(pts[0], cursor)), at: mid(pts[0], cursor) });
      } else if (n === 2) {
        const c = pts[0];
        const ux = pts[1].x - c.x;
        const uy = pts[1].y - c.y;
        const L = Math.hypot(ux, uy) || 1;
        const minor = Math.abs((cursor.x - c.x) * (-uy / L) + (cursor.y - c.y) * (ux / L));
        labels.push({ text: formatDynValue("length", minor), at: cursor });
      }
      break;
    case "ray":
    case "xline":
      labels.push({ text: angLabel(pts[0], cursor), at: cursor });
      break;
    default:
      break;
  }
  return { labels, leaders };
}

// src/cadDynamicInput/grip.js
function gripSpec(e, grip) {
  switch (e.type) {
    case "line": {
      if (grip.role !== "end1" && grip.role !== "end2") return null;
      const anchor = grip.role === "end1" ? { x: e.x2, y: e.y2 } : { x: e.x1, y: e.y1 };
      return { kind: "polar", anchor, fields: [F("length", "Length"), F("angle", "Angle")] };
    }
    case "circle":
      return grip.role === "quadrant" ? { kind: "radius", anchor: { x: e.cx, y: e.cy }, fields: [F("radius", "Radius")] } : null;
    case "arc": {
      const c = { x: e.cx, y: e.cy };
      if (grip.role === "radius") return { kind: "radius", anchor: c, fields: [F("radius", "Radius")] };
      if (grip.role === "start" || grip.role === "end") return { kind: "polar", anchor: c, fields: [F("angle", "Angle")] };
      return null;
    }
    case "rectangle": {
      if (grip.role !== "corner") return null;
      const corners = [
        { x: e.x, y: e.y },
        { x: e.x + e.width, y: e.y },
        { x: e.x + e.width, y: e.y + e.height },
        { x: e.x, y: e.y + e.height }
      ];
      return { kind: "rect", anchor: corners[(grip.index + 2) % 4], fields: [F("width", "Width"), F("height", "Height")] };
    }
    case "ellipse": {
      const c = { x: e.cx, y: e.cy };
      const rot = (e.rotation || 0) * Math.PI / 180;
      if (grip.role === "axisX") return { kind: "axis", anchor: c, axis: { x: Math.cos(rot), y: Math.sin(rot) }, fields: [F("radius", "Radius X")] };
      if (grip.role === "axisY") return { kind: "axis", anchor: c, axis: { x: -Math.sin(rot), y: Math.cos(rot) }, fields: [F("radius", "Radius Y")] };
      if (grip.role === "angleStart" || grip.role === "angleEnd") return { kind: "polar", anchor: c, fields: [F("angle", "Angle")] };
      return null;
    }
    case "ray":
    case "xline":
      return grip.role === "dir" ? { kind: "polar", anchor: { x: e.x, y: e.y }, fields: [F("angle", "Angle")] } : null;
    default:
      return null;
  }
}
function gripDynFields(e, grip) {
  const sp = e && grip ? gripSpec(e, grip) : null;
  return sp ? sp.fields : [];
}
function gripDynLiveValues(e, grip, cursor) {
  const sp = e && grip ? gripSpec(e, grip) : null;
  if (!sp || !cursor) return {};
  if (sp.kind === "polar" || sp.kind === "radius") {
    const d = dist3(sp.anchor, cursor);
    return { length: d, radius: d, angle: norm3603(angleDeg3(sp.anchor, cursor)) };
  }
  if (sp.kind === "rect") {
    return { width: cursor.x - sp.anchor.x, height: cursor.y - sp.anchor.y };
  }
  if (sp.kind === "axis") {
    return { radius: Math.abs((cursor.x - sp.anchor.x) * sp.axis.x + (cursor.y - sp.anchor.y) * sp.axis.y) };
  }
  return {};
}
function solveGripPlacement(e, grip, cursor, locked = {}) {
  const sp = e && grip ? gripSpec(e, grip) : null;
  if (!sp || !cursor) return cursor;
  const L = locked || {};
  if (sp.kind === "polar") {
    if (L.length == null && L.angle == null) return cursor;
    const len2 = L.length != null ? L.length : dist3(sp.anchor, cursor);
    const ang = L.angle != null ? L.angle : angleDeg3(sp.anchor, cursor);
    const r = ang * Math.PI / 180;
    return { x: sp.anchor.x + len2 * Math.cos(r), y: sp.anchor.y + len2 * Math.sin(r) };
  }
  if (sp.kind === "radius") {
    if (L.radius == null) return cursor;
    const r = angleDeg3(sp.anchor, cursor) * Math.PI / 180;
    return { x: sp.anchor.x + L.radius * Math.cos(r), y: sp.anchor.y + L.radius * Math.sin(r) };
  }
  if (sp.kind === "rect") {
    if (L.width == null && L.height == null) return cursor;
    const w = L.width != null ? L.width : cursor.x - sp.anchor.x;
    const h = L.height != null ? L.height : cursor.y - sp.anchor.y;
    return { x: sp.anchor.x + w, y: sp.anchor.y + h };
  }
  if (sp.kind === "axis") {
    if (L.radius == null) return cursor;
    const d = (cursor.x - sp.anchor.x) * sp.axis.x + (cursor.y - sp.anchor.y) * sp.axis.y;
    const s = d < 0 ? -1 : 1;
    return { x: sp.anchor.x + sp.axis.x * s * L.radius, y: sp.anchor.y + sp.axis.y * s * L.radius };
  }
  return cursor;
}
function gripPreviewDimensions(e, grip, at) {
  const labels = [];
  const leaders = [];
  if (!e || !grip) return { labels, leaders };
  const mid = (a, b) => ({ x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 });
  const angLabel = (a, b) => `\u2220${formatDynValue("angle", angleDeg3(a, b))}`;
  const radial = (c, r, text) => {
    const dir = at && dist3(c, at) > 1e-9 ? at : { x: c.x + 1, y: c.y };
    const a = angleDeg3(c, dir) * Math.PI / 180;
    const edge = { x: c.x + r * Math.cos(a), y: c.y + r * Math.sin(a) };
    leaders.push({ a: c, b: edge });
    labels.push({ text, at: edge });
  };
  switch (e.type) {
    case "line": {
      if (grip.role !== "end1" && grip.role !== "end2") break;
      const a = grip.role === "end1" ? { x: e.x2, y: e.y2 } : { x: e.x1, y: e.y1 };
      const b = grip.role === "end1" ? { x: e.x1, y: e.y1 } : { x: e.x2, y: e.y2 };
      labels.push({ text: formatDynValue("length", dist3(a, b)), at: mid(a, b) });
      labels.push({ text: angLabel(a, b), at: a });
      break;
    }
    case "circle":
      if (grip.role === "quadrant") radial({ x: e.cx, y: e.cy }, e.r, `R ${formatDynValue("radius", e.r)}`);
      break;
    case "arc": {
      const c = { x: e.cx, y: e.cy };
      if (grip.role === "radius") radial(c, e.r, `R ${formatDynValue("radius", e.r)}`);
      if (grip.role === "start" || grip.role === "end") {
        const deg2 = grip.role === "start" ? e.startAngle : e.endAngle;
        const rad = deg2 * Math.PI / 180;
        const end = { x: c.x + e.r * Math.cos(rad), y: c.y + e.r * Math.sin(rad) };
        leaders.push({ a: c, b: end });
        labels.push({ text: formatDynValue("angle", deg2), at: end });
      }
      break;
    }
    case "rectangle":
      if (grip.role !== "corner") break;
      labels.push({ text: formatDynValue("width", e.width), at: { x: e.x + e.width / 2, y: e.y } });
      labels.push({ text: formatDynValue("height", e.height), at: { x: e.x + e.width, y: e.y + e.height / 2 } });
      break;
    case "ellipse": {
      const c = { x: e.cx, y: e.cy };
      const rot = (e.rotation || 0) * Math.PI / 180;
      if (grip.role === "axisX" || grip.role === "axisY") {
        const u = grip.role === "axisX" ? { x: Math.cos(rot), y: Math.sin(rot) } : { x: -Math.sin(rot), y: Math.cos(rot) };
        const r = grip.role === "axisX" ? e.rx : e.ry;
        const s = at && (at.x - c.x) * u.x + (at.y - c.y) * u.y < 0 ? -1 : 1;
        const end = { x: c.x + u.x * s * r, y: c.y + u.y * s * r };
        leaders.push({ a: c, b: end });
        labels.push({ text: `${grip.role === "axisX" ? "Rx" : "Ry"} ${formatDynValue("radius", r)}`, at: end });
      }
      if (grip.role === "angleStart" || grip.role === "angleEnd") {
        const deg2 = grip.role === "angleStart" ? e.startAngle : e.endAngle;
        labels.push({ text: formatDynValue("angle", deg2), at: at || c });
      }
      break;
    }
    case "polyline":
    case "revcloud": {
      if (grip.role !== "vertex") break;
      const pts = e.points || [];
      const i = grip.index;
      if (i == null || !pts[i]) break;
      const n = pts.length;
      const prev = i > 0 ? pts[i - 1] : e.closed && n > 2 ? pts[n - 1] : null;
      const next = i < n - 1 ? pts[i + 1] : e.closed && n > 2 ? pts[0] : null;
      if (prev) labels.push({ text: formatDynValue("length", dist3(prev, pts[i])), at: mid(prev, pts[i]) });
      if (next) labels.push({ text: formatDynValue("length", dist3(pts[i], next)), at: mid(pts[i], next) });
      break;
    }
    case "ray":
    case "xline":
      if (grip.role === "dir") {
        const dx = Number.isFinite(e.dx) ? e.dx : 1;
        const dy = Number.isFinite(e.dy) ? e.dy : 0;
        labels.push({ text: `\u2220${formatDynValue("angle", Math.atan2(dy, dx) * 180 / Math.PI)}`, at: at || { x: e.x + dx, y: e.y + dy } });
      }
      break;
    default:
      break;
  }
  return { labels, leaders };
}

// src/cadInteraction.js
var PICKER = {
  ENTITY: "entity",
  TRIM: "trim",
  EDGE: "edge",
  // "Geometry a linear/aligned dimension can measure": the EDGE picker first (so a
  // rectangle/polyline highlights the single side you are about to dimension, like
  // fillet does), falling back to a whole-entity pick for circles and arcs.
  DIM_SOURCE: "dimSource"
};
var PICK_FILTER = {
  LINE: "line",
  CIRCLE_ARC: "circleArc",
  CLOSED: "closed",
  ARC: "arc",
  // A linear/aligned DIMENSION entity — what DIMBASELINE / DIMCONTINUE chain from.
  LINEAR_DIM: "linearDim"
};
var IDLE = { active: false };
function objectPickContext({
  tool,
  modify = null,
  selecting = false,
  hasDraft = false,
  dimAngularLines = 0,
  hasBaseDim = false,
  hasAutoBaseDim = false,
  preciseSnap = false
} = {}) {
  if (tool === "select") return { active: true, picker: PICKER.ENTITY, grips: true };
  if (tool === "mirror" || tool === "rotate" || tool === "scale") {
    return selecting ? { active: true, picker: PICKER.ENTITY } : IDLE;
  }
  if (modify && modify.tool === tool) {
    switch (modify.tool) {
      case "trim":
        if (modify.phase === "edges") return { active: true, picker: PICKER.ENTITY };
        if (modify.phase === "pick") return { active: true, picker: PICKER.TRIM };
        return IDLE;
      case "extend":
        return modify.phase === "edges" || modify.phase === "pick" ? { active: true, picker: PICKER.ENTITY } : IDLE;
      case "offset":
        return modify.phase === "select" ? { active: true, picker: PICKER.ENTITY } : IDLE;
      case "fillet":
      case "chamfer":
        return modify.phase === "line1" || modify.phase === "line2" ? { active: true, picker: PICKER.EDGE } : IDLE;
      case "erase":
        return modify.phase === "pick" ? { active: true, picker: PICKER.ENTITY } : IDLE;
      case "break":
        return modify.phase === "first" ? { active: true, picker: PICKER.ENTITY } : IDLE;
      case "join":
        return modify.phase === "pick" ? { active: true, picker: PICKER.ENTITY } : IDLE;
      case "pedit":
        return { active: true, picker: PICKER.ENTITY };
      case "lengthen":
        if (modify.phase === "value" && modify.mode !== "dynamic") return IDLE;
        if (modify.mode === "dynamic" && modify.targetId != null) return IDLE;
        return { active: true, picker: PICKER.ENTITY };
      case "divide":
      case "measure":
        return { active: true, picker: PICKER.ENTITY };
      default:
        return IDLE;
    }
  }
  if ((tool === "dimradius" || tool === "dimdiameter") && !hasDraft) {
    return { active: true, picker: PICKER.ENTITY, filter: PICK_FILTER.CIRCLE_ARC };
  }
  if (tool === "dimangular" && dimAngularLines < 2) {
    return { active: true, picker: PICKER.EDGE };
  }
  if (tool === "dimarc" && !hasDraft) {
    return { active: true, picker: PICKER.ENTITY, filter: PICK_FILTER.ARC };
  }
  if ((tool === "dimbaseline" || tool === "dimcontinue") && !hasBaseDim) {
    return hasAutoBaseDim ? IDLE : { active: true, picker: PICKER.ENTITY, filter: PICK_FILTER.LINEAR_DIM };
  }
  if ((tool === "dimlinear" || tool === "dimaligned") && !hasDraft) {
    return preciseSnap ? IDLE : { active: true, picker: PICKER.DIM_SOURCE, softPick: true };
  }
  if (tool === "hatch") {
    return { active: true, picker: PICKER.ENTITY, filter: PICK_FILTER.CLOSED, hatch: true };
  }
  return IDLE;
}
function modifyPhaseCancellable(m) {
  if (!m) return false;
  if ((m.tool === "fillet" || m.tool === "chamfer") && (m.phase === "line2" || m.phase === "preview"))
    return true;
  if (m.tool === "offset" && m.phase === "side") return true;
  if (m.tool === "break" && m.phase === "second") return true;
  if (m.tool === "join" && m.ids && m.ids.length) return true;
  if (m.tool === "pedit" && (m.phase === "width" || m.phase === "join")) return true;
  if (m.tool === "pedit" && m.phase === "option" && m.targetId) return true;
  if ((m.tool === "divide" || m.tool === "measure") && m.phase === "value" && m.targetId)
    return true;
  return false;
}
function modifyPhaseBlocksUndo(m) {
  if (!m) return false;
  if (m.tool === "pedit" && m.phase === "option") return false;
  return modifyPhaseCancellable(m);
}
function cancelModifyPhase(m) {
  if (!m) return null;
  if (!modifyPhaseCancellable(m)) return null;
  if ((m.tool === "fillet" || m.tool === "chamfer") && (m.phase === "line2" || m.phase === "preview")) {
    m.pick1 = null;
    m.pick2 = null;
    m.phase = "line1";
    return m;
  }
  if (m.tool === "offset" && m.phase === "side") {
    m.objectId = null;
    m.phase = "select";
    return m;
  }
  if (m.tool === "break" && m.phase === "second") {
    m.targetId = null;
    m.p1 = null;
    m.flip = false;
    m.phase = "first";
    return m;
  }
  if (m.tool === "join" && m.ids && m.ids.length) {
    m.ids = [];
    return m;
  }
  if (m.tool === "pedit" && (m.phase === "width" || m.phase === "join")) {
    m.joinIds = [];
    m.phase = "option";
    return m;
  }
  if (m.tool === "pedit" && m.phase === "option" && m.targetId) {
    m.targetId = null;
    m.phase = "select";
    return m;
  }
  if ((m.tool === "divide" || m.tool === "measure") && m.phase === "value" && m.targetId) {
    m.targetId = null;
    m.phase = "select";
    return m;
  }
  return null;
}
function rightClickAction({
  tool = "select",
  selection = [],
  hitId = null,
  lastCommand = null,
  repeatEnabled = true,
  menuApplicable = false
} = {}) {
  if (menuApplicable) return "menu";
  const onEntity = !!hitId || Array.isArray(selection) && selection.length > 0;
  if (tool === "select" && repeatEnabled && lastCommand && !onEntity) return "repeat";
  if (onEntity) return "menu";
  return "none";
}

// src/commandShape.js
var COMMAND_SHAPE = Object.freeze({
  // ── Draw: fixed arity, so they end on their final point ────────────────────
  rectangle: "single",
  circle: "single",
  arc: "single",
  ellipse: "single",
  ellipsearc: "single",
  // typeable only (EA) — absent from the dock
  polygon: "single",
  ray: "single",
  xline: "single",
  // POINT repeats: AutoCAD's ribbon/toolbar POINT is "Multiple Points" (it runs
  // until Esc), and `drawingTools.test.jsx` "POINT: every click places a point"
  // pins that here. The typed single-point form is the one AutoCAD ends.
  point: "repeating",
  table: "single",
  // INSERT REPEATS, and this row is not a preference — it is what the product
  // already promises in two places. [CMD-FINISH-1 review, H1]
  //
  // `e2e/canvas-blocks.spec.ts` says it in words and then asserts it: "The tool
  // STAYS armed, so a run of symbols is one arm and N clicks" → `tool` is still
  // 'insert' after the first placement, and a second click makes two inserts. The
  // same sentence is the evidence on CAPABILITY-MATRIX.md's Block-insert row,
  // which is marked VERIFIED.
  //
  // Marking it 'single' also had no repeat route to fall back on: `beginInsert`
  // sets `tool: 'insert'` through a raw `set(...)` rather than `setTool`, so
  // `lastCommand` never becomes 'tool:insert', and typed INSERT resolves to the
  // bare id (which opens the panel). Enter after a placement would therefore
  // re-arm whatever was armed BEFORE the block. Placing a run of boreholes would
  // have cost one panel trip per symbol.
  insert: "repeating",
  // armed only by the block panel's beginInsert
  // ── Draw: unbounded, so a gesture ends them ────────────────────────────────
  line: "open",
  polyline: "open",
  spline: "open",
  splinefit: "open",
  // typeable only (SPF)
  revcloud: "open",
  area: "open",
  // the polygon route; an interior click completes in one (see note)
  // ── Draw: hand off to an in-place editor ───────────────────────────────────
  text: "editor",
  mtext: "editor",
  leader: "editor",
  // ── Measure ────────────────────────────────────────────────────────────────
  dist: "single",
  // the read-out survives the end: CADMeasureOverlay reads lastMeasure
  // HATCH REPEATS. [CMD-FINISH-1 review, L2 — owner decision 2026-09-19]
  // Marking it `single` was a silent regression: before this package the tool
  // stayed armed after a region was hatched, so you could hatch several in a row.
  // Nothing pinned that, which is why no test caught the change. AutoCAD picks
  // several boundaries and then takes Enter, so ending after one region moved
  // AWAY from AutoCAD rather than toward it.
  hatch: "repeating",
  // ── Dimensions: fixed arity, but they REPEAT ───────────────────────────────
  // AutoCAD's DIMLINEAR ends after one dimension; this app has always re-armed
  // for the next, and cad-react's cadCommandCleanup "BUG-13 … a completed
  // dimension leaves no draft behind" pins that by asserting the NEXT
  // dimension's prompt after the placement click. The whole family repeats so a
  // user does not meet two behaviours across seven near-identical tools; each
  // placement still clears its draft, and a finish gesture ends the tool.
  dimlinear: "repeating",
  dimaligned: "repeating",
  dimordinate: "repeating",
  dimangular: "repeating",
  dimradius: "repeating",
  dimdiameter: "repeating",
  dimarc: "repeating",
  // ── Dimensions: chains, like AutoCAD's two Enters ──────────────────────────
  dimbaseline: "repeating",
  dimcontinue: "repeating",
  // ── Transform: end once the transform lands ────────────────────────────────
  // The SELECTION survives the end (KEEP_SELECTION_TOOLS includes 'select'), so
  // a repeat goes straight to the base-point prompt. Only the tool id changes,
  // not the noun-verb behaviour BUG-07 protected.
  //
  // NOT YET WIRED — owner decision pending. cad-react's cadCommandCleanup
  // "BUG-07 … once picking has started, the phase accumulates again" pins the
  // OLD ending: after a MOVE commits the tool re-arms its select-objects phase
  // and the next picks accumulate there. Ending the command instead (this row)
  // turns those picks into `select`-tool picks and that test goes red, while
  // commandShape.test.js pins these six as `single`. Two existing tests disagree;
  // `finishTransform` therefore still re-arms (draftLifecycle.js) and only a
  // finish GESTURE ends a transform. Resolve by changing ONE of the two tests.
  // THE TRANSFORMS REPEAT, and this row now DESCRIBES the runtime instead of
  // contradicting it. [CMD-FINISH-1 review, L1 — owner decision 2026-09-19]
  //
  // They were marked `single` while `finishTransform` re-armed the select-objects
  // phase, so `endsOnFinalInput('move')` answered true for a tool that never ends
  // on input. No user-visible defect — the ladder still ends a transform on a
  // finish gesture — but a loaded trap: adding `done = true` to the move branch
  // would have broken QA BUG-07's pinned behaviour.
  //
  // BUG-07 is why they re-arm. Moving something used to CLEAR the selection, so
  // every follow-up cost a re-select; the fix keeps the objects picked and returns
  // to "select objects". The owner chose to leave that behaviour alone. The
  // convenience survives either way — the selection now outlives a command ending
  // too (KEEP_SELECTION_TOOLS), so Enter after a move goes straight back to MOVE
  // with the same objects.
  move: "repeating",
  rotate: "repeating",
  scale: "repeating",
  mirror: "repeating",
  stretch: "repeating",
  align: "repeating",
  // ── Transform/modify: repeat per pick ──────────────────────────────────────
  copy: "repeating",
  // one base, then as many destinations as you like
  offset: "repeating",
  trim: "repeating",
  extend: "repeating",
  erase: "repeating",
  lengthen: "repeating",
  pedit: "repeating",
  // ── Modify: one operation, then done ───────────────────────────────────────
  fillet: "single",
  chamfer: "single",
  break: "single",
  join: "single",
  // DIVIDE / MEASURE repeat: `peditDivideMeasure.test.jsx` "the tool stays
  // armed, so the next click picks another object" pins the pick→count→pick
  // rhythm, so they follow LENGTHEN (value, then a repeating pick) rather than
  // AutoCAD's one-shot DIVIDE.
  divide: "repeating",
  measure: "repeating",
  // ── Owned elsewhere ────────────────────────────────────────────────────────
  // PARCEL must NOT end on its click: ending calls toolReset, whose
  // abortParcelFetch('tool') would cancel the in-flight parcel request the click
  // just started. It stays armed until the user leaves it.
  parcel: "repeating",
  // ARRAY's lifecycle belongs to its dialog (armed by setTool('array') from
  // CADArrayDialog, never by a point).
  array: "external"
});
function commandShape(tool) {
  return Object.prototype.hasOwnProperty.call(COMMAND_SHAPE, tool) ? COMMAND_SHAPE[tool] : void 0;
}
function endsOnFinalInput(tool) {
  const shape = commandShape(tool);
  return shape === "single" || shape === "open";
}
function isRepeating(tool) {
  return commandShape(tool) === "repeating";
}
function endsWithOwnSurface(tool) {
  const shape = commandShape(tool);
  return shape === "editor" || shape === "external";
}
var FINISH_MIN_POINTS = Object.freeze({
  line: 1,
  polyline: 2,
  spline: 2,
  splinefit: 2,
  revcloud: 2,
  area: 3,
  leader: 2
});
function finishDecision({ tool, draftPoints = 0, hasDraft = false, editorOpen = false, busy = false }) {
  if (editorOpen || busy) return "none";
  if (tool === "select") return "repeat";
  const shape = commandShape(tool);
  if (!shape || shape === "external") return "none";
  const min = FINISH_MIN_POINTS[tool];
  if (min != null && draftPoints >= min) return "finish";
  if (draftPoints > 0 || hasDraft) return "discard";
  return "end";
}

// src/cadLayerIsolate.js
function selectionLayerNames(entities, selectedIds) {
  const sel = new Set(selectedIds || []);
  const names = [];
  const seen = /* @__PURE__ */ new Set();
  for (const e of entities || []) {
    if (!sel.has(e.id)) continue;
    const name = e.layer || DEFAULT_LAYER;
    if (!seen.has(name)) {
      seen.add(name);
      names.push(name);
    }
  }
  return names;
}
function applyLayerIsolation(layers, keepNames, prevIsolation) {
  const all = layers || [];
  const keep = new Set(
    (keepNames || []).filter((n) => all.some((l) => l.name === n && !layerFrozen(l)))
  );
  if (!keep.size) return null;
  const prevSrc = prevIsolation && prevIsolation.prev || {};
  const prev = /* @__PURE__ */ Object.create(null);
  for (const k of Object.keys(prevSrc)) prev[k] = prevSrc[k];
  const next = all.map((l) => {
    const want = keep.has(l.name);
    const visible = l.visible !== false;
    if (visible === want) return l;
    if (!Object.prototype.hasOwnProperty.call(prev, l.name)) prev[l.name] = visible;
    return { ...l, visible: want };
  });
  return { layers: next, isolation: { prev: { ...prev } } };
}
function clearLayerIsolation(layers, isolation) {
  if (!isolation || !isolation.prev) return null;
  const prev = isolation.prev;
  const has = (n) => Object.prototype.hasOwnProperty.call(prev, n);
  const next = (layers || []).map(
    (l) => has(l.name) && l.visible !== false !== prev[l.name] ? { ...l, visible: prev[l.name] } : l
  );
  return { layers: next };
}

// src/cadDimensionAssoc.js
function entityFeaturePoints(e) {
  switch (e.type) {
    case "line":
      return [
        { kind: "end", index: 0, x: e.x1, y: e.y1 },
        { kind: "end", index: 1, x: e.x2, y: e.y2 }
      ];
    case "circle": {
      const pts = [{ kind: "center", index: 0, x: e.cx, y: e.cy }];
      [0, 90, 180, 270].forEach((a, i) => {
        const q = onCirclePoint(e.cx, e.cy, e.r, a);
        pts.push({ kind: "quadrant", index: i, x: q.x, y: q.y });
      });
      return pts;
    }
    case "arc": {
      const s0 = onCirclePoint(e.cx, e.cy, e.r, e.startAngle);
      const e0 = onCirclePoint(e.cx, e.cy, e.r, e.endAngle);
      return [
        { kind: "center", index: 0, x: e.cx, y: e.cy },
        { kind: "end", index: 0, x: s0.x, y: s0.y },
        { kind: "end", index: 1, x: e0.x, y: e0.y }
      ];
    }
    case "rectangle":
    case "polyline":
      return entityVertices(e).map((v, i) => ({ kind: "vertex", index: i, x: v.x, y: v.y }));
    case "ellipse":
      return [{ kind: "center", index: 0, x: e.cx, y: e.cy }];
    default:
      return [];
  }
}
function dimensionSourceFromEntity(e, segIndex, opts = {}) {
  if (!e || !e.id) return null;
  switch (e.type) {
    case "line":
      return {
        p1: { x: e.x1, y: e.y1 },
        p2: { x: e.x2, y: e.y2 },
        p1Ref: { id: e.id, kind: "end", index: 0 },
        p2Ref: { id: e.id, kind: "end", index: 1 },
        sourceIds: [e.id]
      };
    case "rectangle":
    case "polyline": {
      if (e.type === "polyline" && !Array.isArray(e.points)) return null;
      const vs = entityVertices(e);
      if (vs.length < 2) return null;
      const closed = e.type === "rectangle" || !!e.closed;
      const segCount = closed ? vs.length : vs.length - 1;
      const i = Number.isInteger(segIndex) && segIndex >= 0 && segIndex < segCount ? segIndex : 0;
      const j = (i + 1) % vs.length;
      if (i === j) return null;
      return {
        p1: { x: vs[i].x, y: vs[i].y },
        p2: { x: vs[j].x, y: vs[j].y },
        p1Ref: { id: e.id, kind: "vertex", index: i },
        p2Ref: { id: e.id, kind: "vertex", index: j },
        sourceIds: [e.id]
      };
    }
    case "arc": {
      const s = onCirclePoint(e.cx, e.cy, e.r, e.startAngle);
      const t = onCirclePoint(e.cx, e.cy, e.r, e.endAngle);
      return {
        p1: { x: s.x, y: s.y },
        p2: { x: t.x, y: t.y },
        p1Ref: { id: e.id, kind: "end", index: 0 },
        p2Ref: { id: e.id, kind: "end", index: 1 },
        sourceIds: [e.id]
      };
    }
    case "circle": {
      const at = opts.at;
      const vertical = !!at && Math.abs(at.y - e.cy) < Math.abs(at.x - e.cx);
      const [i, j] = vertical ? [1, 3] : [0, 2];
      const a = onCirclePoint(e.cx, e.cy, e.r, i * 90);
      const b = onCirclePoint(e.cx, e.cy, e.r, j * 90);
      return {
        p1: { x: a.x, y: a.y },
        p2: { x: b.x, y: b.y },
        p1Ref: { id: e.id, kind: "quadrant", index: i },
        p2Ref: { id: e.id, kind: "quadrant", index: j },
        sourceIds: [e.id]
      };
    }
    default:
      return null;
  }
}
function pointFeatureRef(entities, pt3, tol, opts) {
  let best = null;
  let bestD = tol;
  for (const e of entities || []) {
    if (e.type === "dimension" || e.type === "hatch") continue;
    for (const f of entityFeaturePoints(e)) {
      const d = Math.hypot(f.x - pt3.x, f.y - pt3.y);
      if (d < bestD) {
        bestD = d;
        best = { id: e.id, kind: f.kind, index: f.index };
      }
    }
  }
  if (best || !(opts && opts.span)) return best;
  return spanFeatureRef(entities, pt3, tol);
}
var spanFeatureRef = (entities, pt3, tol) => {
  let best = null;
  let bestD = tol;
  for (const e of entities || []) {
    if (e.type === "dimension" || e.type === "hatch") continue;
    const hit = projectOntoSpans(e, pt3);
    if (hit && hit.d < bestD) {
      bestD = hit.d;
      best = { id: e.id, kind: "span", index: hit.index, t: hit.t };
    }
  }
  return best;
};
function projectOntoSpans(e, pt3) {
  let best = null;
  const segs = entitySegments(e) || [];
  for (let i = 0; i < segs.length; i += 1) {
    const [a, b] = segs[i];
    const vx = b.x - a.x;
    const vy = b.y - a.y;
    const len2 = vx * vx + vy * vy;
    if (!(len2 > 0)) continue;
    let t = ((pt3.x - a.x) * vx + (pt3.y - a.y) * vy) / len2;
    t = Math.max(0, Math.min(1, t));
    const d = Math.hypot(a.x + t * vx - pt3.x, a.y + t * vy - pt3.y);
    if (!best || d < best.d) best = { index: i, t, d };
  }
  return best;
}
function resolveFeatureRef(ref, byId2) {
  const e = ref && byId2.get(ref.id);
  if (!e) return null;
  if (ref.kind === "span") {
    const segs = entitySegments(e) || [];
    const seg = segs[ref.index];
    if (!seg || !Number.isFinite(ref.t)) return null;
    const [a, b] = seg;
    return { x: a.x + ref.t * (b.x - a.x), y: a.y + ref.t * (b.y - a.y) };
  }
  const f = entityFeaturePoints(e).find((f2) => f2.kind === ref.kind && f2.index === ref.index);
  return f ? { x: f.x, y: f.y } : null;
}
var samePt = (a, b) => a.x === b.x && a.y === b.y;
function dimensionSourceIds(e) {
  const ids = new Set(Array.isArray(e.sourceIds) ? e.sourceIds : []);
  if (e.p1Ref) ids.add(e.p1Ref.id);
  if (e.p2Ref) ids.add(e.p2Ref.id);
  if (e.featureRef) ids.add(e.featureRef.id);
  return [...ids];
}
function rebuildDimension(e, byId2) {
  if (e.dimType === "radius" || e.dimType === "diameter") {
    const src = byId2.get((e.sourceIds || [])[0]);
    if (!src || src.type !== "circle" && src.type !== "arc") return e;
    if (src.cx === e.center.x && src.cy === e.center.y && src.r === e.radius) return e;
    return {
      ...e,
      center: { x: src.cx, y: src.cy },
      radius: src.r,
      leaderPoint: {
        x: src.cx + (e.leaderPoint.x - e.center.x),
        y: src.cy + (e.leaderPoint.y - e.center.y)
      }
    };
  }
  if (e.dimType === "arclength") {
    const src = byId2.get((e.sourceIds || [])[0]);
    if (!src || src.type !== "arc") return e;
    if (src.cx === e.center.x && src.cy === e.center.y && src.r === e.radius && src.startAngle === e.startAngle && src.endAngle === e.endAngle) return e;
    const dx = src.cx - e.center.x;
    const dy = src.cy - e.center.y;
    return {
      ...e,
      center: { x: src.cx, y: src.cy },
      radius: src.r,
      startAngle: src.startAngle,
      endAngle: src.endAngle,
      linePoint: { x: e.linePoint.x + dx, y: e.linePoint.y + dy }
    };
  }
  if (e.dimType === "linear" || e.dimType === "aligned") {
    const p1 = resolveFeatureRef(e.p1Ref, byId2) || e.p1;
    const p2 = resolveFeatureRef(e.p2Ref, byId2) || e.p2;
    if (samePt(p1, e.p1) && samePt(p2, e.p2)) return e;
    const dx = (p1.x + p2.x) / 2 - (e.p1.x + e.p2.x) / 2;
    const dy = (p1.y + p2.y) / 2 - (e.p1.y + e.p2.y) / 2;
    return {
      ...e,
      p1,
      p2,
      linePoint: { x: e.linePoint.x + dx, y: e.linePoint.y + dy }
    };
  }
  if (e.dimType === "ordinate") {
    const f = resolveFeatureRef(e.featureRef, byId2);
    if (!f || samePt(f, e.feature)) return e;
    const dx = f.x - e.feature.x;
    const dy = f.y - e.feature.y;
    return { ...e, feature: { x: f.x, y: f.y }, leader: { x: e.leader.x + dx, y: e.leader.y + dy } };
  }
  if (e.dimType === "angular") {
    const a = byId2.get((e.sourceIds || [])[0]);
    const b = byId2.get((e.sourceIds || [])[1]);
    if (!a || !b || a.type !== "line" || b.type !== "line") return e;
    const v = lineLineIntersection(
      { x: a.x1, y: a.y1 },
      { x: a.x2, y: a.y2 },
      { x: b.x1, y: b.y1 },
      { x: b.x2, y: b.y2 }
    );
    if (!v) return e;
    const nearer = (line, old) => {
      const c1 = { x: line.x1, y: line.y1 };
      const c2 = { x: line.x2, y: line.y2 };
      const d1 = (c1.x - old.x) ** 2 + (c1.y - old.y) ** 2;
      const d2 = (c2.x - old.x) ** 2 + (c2.y - old.y) ** 2;
      return d1 <= d2 ? c1 : c2;
    };
    const p1 = nearer(a, e.p1);
    const p2 = nearer(b, e.p2);
    if (samePt(v, e.vertex) && samePt(p1, e.p1) && samePt(p2, e.p2)) return e;
    return { ...e, vertex: { x: v.x, y: v.y }, p1, p2 };
  }
  return e;
}
function movedEndpoint(dim, fixed, moving, value) {
  if (dim.dimType === "linear" && dim.orientation === "vertical") {
    return { x: moving.x, y: fixed.y + (moving.y >= fixed.y ? value : -value) };
  }
  if (dim.dimType === "linear") {
    return { x: fixed.x + (moving.x >= fixed.x ? value : -value), y: moving.y };
  }
  const d = Math.hypot(moving.x - fixed.x, moving.y - fixed.y);
  if (d < 1e-9) return null;
  return {
    x: fixed.x + (moving.x - fixed.x) / d * value,
    y: fixed.y + (moving.y - fixed.y) / d * value
  };
}
function driveDimensionValue(dim, byId2, value) {
  if (!dim || dim.type !== "dimension" || !Number.isFinite(value) || value <= 0) return null;
  if (dim.dimType === "radius" || dim.dimType === "diameter") {
    const src = byId2.get((dim.sourceIds || [])[0]);
    if (!src || src.type !== "circle" && src.type !== "arc") return null;
    return { id: src.id, patch: { r: dim.dimType === "diameter" ? value / 2 : value } };
  }
  if (dim.dimType === "linear" || dim.dimType === "aligned") {
    const r1 = dim.p1Ref;
    const r2 = dim.p2Ref;
    if (!r1 || !r2 || r1.id !== r2.id) return null;
    const src = byId2.get(r1.id);
    if (!src) return null;
    if (src.type === "line" && r1.kind === "end" && r2.kind === "end" && r1.index !== r2.index) {
      const fixed = r1.index === 0 ? { x: src.x1, y: src.y1 } : { x: src.x2, y: src.y2 };
      const moving = r2.index === 0 ? { x: src.x1, y: src.y1 } : { x: src.x2, y: src.y2 };
      const target = movedEndpoint(dim, fixed, moving, value);
      if (!target) return null;
      const patch = r2.index === 0 ? { x1: target.x, y1: target.y } : { x2: target.x, y2: target.y };
      return { id: src.id, patch, anchors: [r1, r2] };
    }
    if (src.type === "polyline" && Array.isArray(src.points) && r1.kind === "vertex" && r2.kind === "vertex" && r1.index !== r2.index && r1.index < src.points.length && r2.index < src.points.length) {
      const fixed = src.points[r1.index];
      const moving = src.points[r2.index];
      const target = movedEndpoint(dim, fixed, moving, value);
      if (!target) return null;
      const points = src.points.map((p, i) => i === r2.index ? { x: target.x, y: target.y } : { ...p });
      return { id: src.id, patch: { points }, anchors: [r1, r2] };
    }
    if (src.type === "rectangle" && r1.kind === "vertex" && r2.kind === "vertex" && r1.index !== r2.index && r1.index >= 0 && r1.index < 4 && r2.index >= 0 && r2.index < 4) {
      const { x, y, width: w, height: h } = src;
      if (![x, y, w, h].every(Number.isFinite) || w <= 0 || h <= 0) return null;
      const onRight = (i) => i === 1 || i === 2;
      const onTop = (i) => i === 2 || i === 3;
      const spansX = onRight(r1.index) !== onRight(r2.index);
      const spansY = onTop(r1.index) !== onTop(r2.index);
      const resize = (newW, newH) => {
        if (!Number.isFinite(newW) || !Number.isFinite(newH) || newW <= 0 || newH <= 0) return null;
        const patch = {};
        if (newW !== w) {
          patch.width = newW;
          if (onRight(r1.index)) patch.x = x + w - newW;
        }
        if (newH !== h) {
          patch.height = newH;
          if (onTop(r1.index)) patch.y = y + h - newH;
        }
        return { id: src.id, patch };
      };
      if (dim.dimType === "linear") {
        if (dim.orientation === "vertical") return spansY ? resize(w, value) : null;
        return spansX ? resize(value, h) : null;
      }
      if (spansX && spansY) {
        const diag = Math.hypot(w, h);
        return resize(w / diag * value, h / diag * value);
      }
      if (spansX) return resize(value, h);
      if (spansY) return resize(w, value);
      return null;
    }
    if (src.type === "circle" && r1.kind === "quadrant" && r2.kind === "quadrant" && Math.abs(r1.index - r2.index) === 2) {
      return { id: src.id, patch: { r: value / 2 } };
    }
    if (src.type === "circle" || src.type === "arc") {
      if (![src.cx, src.cy, src.r].every(Number.isFinite) || src.r <= 0) return null;
      const fixed = resolveFeatureRef(r1, byId2);
      const moving = resolveFeatureRef(r2, byId2);
      if (!fixed || !moving) return null;
      const current = dim.dimType === "linear" ? dim.orientation === "vertical" ? Math.abs(moving.y - fixed.y) : Math.abs(moving.x - fixed.x) : Math.hypot(moving.x - fixed.x, moving.y - fixed.y);
      if (!(current > 1e-9)) return null;
      const f = value / current;
      const cx = fixed.x + f * (src.cx - fixed.x);
      const cy = fixed.y + f * (src.cy - fixed.y);
      const r = f * src.r;
      if (![f, cx, cy, r].every(Number.isFinite) || f <= 0 || r <= 0) return null;
      return { id: src.id, patch: { cx, cy, r } };
    }
    return null;
  }
  if (dim.dimType === "angular") {
    const b = byId2.get((dim.sourceIds || [])[1]);
    if (!b || b.type !== "line" || !dim.vertex || !dim.p1 || !dim.p2) return null;
    if (value >= 180) return null;
    const v = dim.vertex;
    const r1 = { x: dim.p1.x - v.x, y: dim.p1.y - v.y };
    const r2 = { x: dim.p2.x - v.x, y: dim.p2.y - v.y };
    const signed = Math.atan2(r1.x * r2.y - r1.y * r2.x, r1.x * r2.x + r1.y * r2.y);
    if (Math.abs(signed) < 1e-9) return null;
    const target = Math.sign(signed) * (value * Math.PI) / 180;
    const delta = target - signed;
    const cos = Math.cos(delta);
    const sin = Math.sin(delta);
    const rot = (pt3) => {
      const dx = pt3.x - v.x;
      const dy = pt3.y - v.y;
      return { x: v.x + dx * cos - dy * sin, y: v.y + dx * sin + dy * cos };
    };
    const n1 = rot({ x: b.x1, y: b.y1 });
    const n2 = rot({ x: b.x2, y: b.y2 });
    return { id: b.id, patch: { x1: n1.x, y1: n1.y, x2: n2.x, y2: n2.y } };
  }
  return null;
}
function dimensionEditRecord(dim, byId2, value) {
  if (!dim || dim.type !== "dimension" || !Number.isFinite(value) || value <= 0) return null;
  if (dim.dimType === "radius" || dim.dimType === "diameter") {
    const src = byId2.get((dim.sourceIds || [])[0]);
    if (!src || src.type !== "circle" && src.type !== "arc") return null;
    return { id: dim.id, type: dim.dimType, entityId: src.id, value };
  }
  if (dim.dimType === "linear" || dim.dimType === "aligned") {
    if (!dim.p1Ref || !dim.p2Ref) return null;
    if (!resolveFeatureRef(dim.p1Ref, byId2) || !resolveFeatureRef(dim.p2Ref, byId2)) return null;
    const type = dim.dimType === "aligned" ? "distance" : dim.orientation === "vertical" ? "distanceY" : "distanceX";
    return { id: dim.id, type, p1Ref: dim.p1Ref, p2Ref: dim.p2Ref, value };
  }
  if (dim.dimType === "angular") {
    const a = byId2.get((dim.sourceIds || [])[0]);
    const b = byId2.get((dim.sourceIds || [])[1]);
    if (!a || !b || a.type !== "line" || b.type !== "line") return null;
    if (value >= 180) return null;
    return { id: dim.id, type: "angle", ids: [a.id, b.id], value };
  }
  return null;
}

// src/cadConstraints.js
var CONSTRAINT_LABELS = {
  coincident: "Coincident",
  horizontal: "Horizontal",
  vertical: "Vertical",
  parallel: "Parallel",
  perpendicular: "Perpendicular",
  angle: "Angle",
  tangent: "Tangent",
  concentric: "Concentric",
  equalRadius: "Equal radius",
  equalLength: "Equal length"
};
var DIST_TOL = 1e-4;
var ANG_TOL = 0.01;
var isLine = (e) => e && e.type === "line";
var isCurve = (e) => e && (e.type === "circle" || e.type === "arc");
var isSegmented = (e) => e && (e.type === "polyline" || e.type === "rectangle");
var lineAngle = (s) => Math.atan2(s.y2 - s.y1, s.x2 - s.x1) * 180 / Math.PI;
var lineLen = (s) => Math.hypot(s.x2 - s.x1, s.y2 - s.y1);
function segmentCount(e) {
  if (isLine(e)) return 1;
  if (isSegmented(e)) {
    const vs = entityVertices(e);
    if (!vs || vs.length < 2) return 0;
    return e.type === "rectangle" || e.closed ? vs.length : vs.length - 1;
  }
  return 0;
}
function segmentOf(e, segIndex) {
  if (isLine(e)) return { x1: e.x1, y1: e.y1, x2: e.x2, y2: e.y2 };
  if (isSegmented(e)) {
    const vs = entityVertices(e);
    if (!vs || vs.length < 2) return null;
    const n = vs.length;
    const count = e.type === "rectangle" || e.closed ? n : n - 1;
    const i = segIndex | 0;
    if (i < 0 || i >= count) return null;
    const a = vs[i];
    const b = vs[(i + 1) % n];
    return { x1: a.x, y1: a.y, x2: b.x, y2: b.y };
  }
  return null;
}
var norm180 = (a) => (a % 180 + 180) % 180;
var between = (a, b) => {
  const d = norm180(a - b);
  return Math.min(d, 180 - d);
};
var lineDist = (p, e) => {
  const vx = e.x2 - e.x1;
  const vy = e.y2 - e.y1;
  const len2 = vx * vx + vy * vy;
  if (len2 < 1e-18) return { d: Math.hypot(p.x - e.x1, p.y - e.y1), t: 0 };
  const t = ((p.x - e.x1) * vx + (p.y - e.y1) * vy) / len2;
  const fx = e.x1 + t * vx;
  const fy = e.y1 + t * vy;
  return { d: Math.hypot(p.x - fx, p.y - fy), t };
};
function makeConstraint(type, ids, extra = {}) {
  return { id: genId(), type, ids: [...ids], ...extra };
}
function checkConstraint(c, byId2, opts = {}) {
  const tol = opts.tol ?? DIST_TOL;
  const ang = opts.angTol ?? ANG_TOL;
  const ents = c.ids.map((id) => byId2.get(id));
  if (ents.some((e) => !e)) return { ok: false, missing: true };
  const [a, b] = ents;
  const segAt = (k) => segmentOf(ents[k], c.segs && c.segs[k]);
  switch (c.type) {
    case "coincident": {
      const p = resolveFeatureRef(c.refs && c.refs[0], byId2);
      const q = resolveFeatureRef(c.refs && c.refs[1], byId2);
      if (!p || !q) return { ok: false, missing: true };
      return { ok: Math.hypot(p.x - q.x, p.y - q.y) <= tol, missing: false };
    }
    case "horizontal": {
      const s = segAt(0);
      return { ok: !!s && between(lineAngle(s), 0) <= ang, missing: false };
    }
    case "vertical": {
      const s = segAt(0);
      return { ok: !!s && between(lineAngle(s), 90) <= ang, missing: false };
    }
    case "parallel": {
      const s1 = segAt(0);
      const s2 = segAt(1);
      return { ok: !!s1 && !!s2 && between(lineAngle(s1), lineAngle(s2)) <= ang, missing: false };
    }
    case "perpendicular": {
      const s1 = segAt(0);
      const s2 = segAt(1);
      return { ok: !!s1 && !!s2 && Math.abs(between(lineAngle(s1), lineAngle(s2)) - 90) <= ang, missing: false };
    }
    case "angle": {
      const s1 = segAt(0);
      const s2 = segAt(1);
      if (!s1 || !s2) return { ok: false, missing: false };
      const d = between(lineAngle(s1), lineAngle(s2));
      const v = norm180(c.value || 0);
      const want = Math.min(v, 180 - v);
      return { ok: Math.abs(d - want) <= ang, missing: false };
    }
    case "tangent": {
      if (isCurve(a) && isCurve(b)) {
        const d = Math.hypot(a.cx - b.cx, a.cy - b.cy);
        const ok2 = Math.abs(d - (a.r + b.r)) <= tol || Math.abs(d - Math.abs(a.r - b.r)) <= tol;
        return { ok: ok2, missing: false };
      }
      const curve = isCurve(a) ? a : isCurve(b) ? b : null;
      const seg = isCurve(a) ? segAt(1) : segAt(0);
      if (curve && seg) {
        const { d } = lineDist({ x: curve.cx, y: curve.cy }, seg);
        return { ok: Math.abs(d - curve.r) <= tol, missing: false };
      }
      return { ok: false, missing: false };
    }
    case "concentric":
      return { ok: isCurve(a) && isCurve(b) && Math.hypot(a.cx - b.cx, a.cy - b.cy) <= tol, missing: false };
    case "equalRadius":
      return { ok: isCurve(a) && isCurve(b) && Math.abs(a.r - b.r) <= tol, missing: false };
    case "equalLength": {
      const s1 = segAt(0);
      const s2 = segAt(1);
      return { ok: !!s1 && !!s2 && Math.abs(lineLen(s1) - lineLen(s2)) <= tol, missing: false };
    }
    default:
      return { ok: true, missing: false };
  }
}
function inferConstraints(entity, entities, opts = {}) {
  const tol = opts.tol ?? DIST_TOL;
  const snapTol = opts.snapTol ?? tol;
  const ang = opts.angTol ?? ANG_TOL;
  const out = [];
  const others = entities.filter((e) => e.id !== entity.id);
  const byId2 = new Map(others.map((e) => [e.id, e]));
  if (isLine(entity)) {
    const angle = lineAngle(entity);
    const selfAxis = between(angle, 0) <= ang || between(angle, 90) <= ang;
    if (between(angle, 0) <= ang) out.push(makeConstraint("horizontal", [entity.id]));
    else if (between(angle, 90) <= ang) out.push(makeConstraint("vertical", [entity.id]));
    const ends = [
      { pt: { x: entity.x1, y: entity.y1 }, ref: { id: entity.id, kind: "end", index: 0 } },
      { pt: { x: entity.x2, y: entity.y2 }, ref: { id: entity.id, kind: "end", index: 1 } }
    ];
    const related = /* @__PURE__ */ new Set();
    for (const end of ends) {
      const hit = pointFeatureRef(others, end.pt, snapTol);
      if (!hit) continue;
      out.push(makeConstraint("coincident", [entity.id, hit.id], { refs: [end.ref, hit] }));
      const other = byId2.get(hit.id);
      if (isLine(other) && !related.has(other.id)) {
        related.add(other.id);
        const otherAngle = lineAngle(other);
        const otherAxis = between(otherAngle, 0) <= ang || between(otherAngle, 90) <= ang;
        if (!selfAxis && !otherAxis) {
          const d = between(angle, otherAngle);
          if (Math.abs(d - 90) <= ang) out.push(makeConstraint("perpendicular", [entity.id, other.id]));
          else if (d <= ang) out.push(makeConstraint("parallel", [entity.id, other.id]));
        }
      }
    }
    for (const e of others) {
      if (!isCurve(e)) continue;
      const { d, t } = lineDist({ x: e.cx, y: e.cy }, entity);
      if (Math.abs(d - e.r) <= tol && t >= -1e-9 && t <= 1 + 1e-9) {
        out.push(makeConstraint("tangent", [entity.id, e.id]));
      }
    }
    return out;
  }
  if (isCurve(entity)) {
    for (const e of others) {
      if (isCurve(e)) {
        if (Math.hypot(entity.cx - e.cx, entity.cy - e.cy) <= tol) {
          out.push(makeConstraint("concentric", [entity.id, e.id]));
        } else {
          const d = Math.hypot(entity.cx - e.cx, entity.cy - e.cy);
          if (Math.abs(d - (entity.r + e.r)) <= tol || Math.abs(d - Math.abs(entity.r - e.r)) <= tol) {
            out.push(makeConstraint("tangent", [entity.id, e.id]));
          }
        }
      } else if (isLine(e)) {
        const { d, t } = lineDist({ x: entity.cx, y: entity.cy }, e);
        if (Math.abs(d - entity.r) <= tol && t >= -1e-9 && t <= 1 + 1e-9) {
          out.push(makeConstraint("tangent", [entity.id, e.id]));
        }
      }
    }
    return out;
  }
  if (isSegmented(entity)) {
    const vs = entityVertices(entity);
    if (!vs || vs.length < 2) return out;
    const closed = entity.type === "rectangle" || entity.closed;
    const count = closed ? vs.length : vs.length - 1;
    const seg = (i) => {
      const p = vs[i];
      const q = vs[(i + 1) % vs.length];
      return { x1: p.x, y1: p.y, x2: q.x, y2: q.y };
    };
    const axis = [];
    for (let i = 0; i < count; i++) {
      const s = seg(i);
      if (between(lineAngle(s), 0) <= ang) {
        out.push(makeConstraint("horizontal", [entity.id], { segs: [i] }));
        axis[i] = true;
      } else if (between(lineAngle(s), 90) <= ang) {
        out.push(makeConstraint("vertical", [entity.id], { segs: [i] }));
        axis[i] = true;
      } else axis[i] = false;
    }
    const pairs = closed ? count : count - 1;
    for (let i = 0; i < pairs; i++) {
      const j = (i + 1) % count;
      if (axis[i] || axis[j]) continue;
      if (Math.abs(between(lineAngle(seg(i)), lineAngle(seg(j))) - 90) <= ang) {
        out.push(makeConstraint("perpendicular", [entity.id, entity.id], { segs: [i, j] }));
      }
    }
    if (!closed) {
      const ends = [
        { pt: vs[0], ref: { id: entity.id, kind: "vertex", index: 0 } },
        { pt: vs[vs.length - 1], ref: { id: entity.id, kind: "vertex", index: vs.length - 1 } }
      ];
      for (const end of ends) {
        const hit = pointFeatureRef(others, end.pt, snapTol);
        if (hit) out.push(makeConstraint("coincident", [entity.id, hit.id], { refs: [end.ref, hit] }));
      }
    }
    for (const e of others) {
      if (!isCurve(e)) continue;
      for (let i = 0; i < count; i++) {
        const { d, t } = lineDist({ x: e.cx, y: e.cy }, seg(i));
        if (Math.abs(d - e.r) <= tol && t >= -1e-9 && t <= 1 + 1e-9) {
          out.push(makeConstraint("tangent", [entity.id, e.id], { segs: [i, null] }));
          break;
        }
      }
    }
    return out;
  }
  return out;
}
function pruneConstraints(constraints, removedIds) {
  const gone = new Set(removedIds);
  const kept = (constraints || []).filter((c) => !c.ids.some((id) => gone.has(id)));
  return kept.length === (constraints || []).length ? constraints || [] : kept;
}
function entityLabel(e) {
  if (!e) return "missing";
  switch (e.type) {
    case "line":
      return "Line";
    case "circle":
      return "Circle";
    case "arc":
      return "Arc";
    case "polyline":
      return e.closed ? "Polyline (closed)" : "Polyline";
    case "rectangle":
      return "Rectangle";
    default:
      return e.type ? e.type[0].toUpperCase() + e.type.slice(1) : "Entity";
  }
}
function constraintList(doc, opts) {
  const constraints = doc && doc.constraints || [];
  const byId2 = new Map((doc && doc.entities || []).map((e) => [e.id, e]));
  return constraints.map((c) => {
    const { ok: ok2, missing } = checkConstraint(c, byId2, opts);
    return {
      id: c.id,
      type: c.type,
      label: CONSTRAINT_LABELS[c.type] || c.type,
      value: c.value,
      entities: c.ids.map((id) => ({ id, label: entityLabel(byId2.get(id)), present: byId2.has(id) })),
      ok: ok2,
      missing
    };
  });
}
function violatedConstraintEntityIds(doc, opts) {
  const ids = /* @__PURE__ */ new Set();
  const byId2 = new Map((doc && doc.entities || []).map((e) => [e.id, e]));
  for (const c of doc && doc.constraints || []) {
    const { ok: ok2, missing } = checkConstraint(c, byId2, opts);
    if (ok2 || missing) continue;
    for (const id of c.ids) if (byId2.has(id)) ids.add(id);
  }
  return ids;
}
function addableConstraints(entities, selection) {
  if (selection.length !== 2) return [];
  const byId2 = new Map(entities.map((e) => [e.id, e]));
  const a = byId2.get(selection[0]);
  const b = byId2.get(selection[1]);
  if (!a || !b) return [];
  if (isLine(a) && isLine(b)) {
    return ["parallel", "perpendicular", "equalLength", "angle"];
  }
  if (isCurve(a) && isCurve(b)) return ["concentric", "equalRadius", "tangent"];
  if (isLine(a) && isCurve(b) || isCurve(a) && isLine(b)) return ["tangent"];
  return [];
}

// src/cadLayerDelete.js
var layerOf = (e) => e && e.layer != null ? e.layer : DEFAULT_LAYER;
function layerUsage(doc, name) {
  let model = 0;
  for (const e of doc.entities || []) if (layerOf(e) === name) model += 1;
  let blocks = 0;
  const blockNames = [];
  const defs = doc.blockDefs || {};
  for (const bn of Object.keys(defs)) {
    const ents = defs[bn] && defs[bn].entities || [];
    const n = ents.reduce((c, e) => c + (layerOf(e) === name ? 1 : 0), 0);
    if (n) {
      blocks += n;
      blockNames.push(bn);
    }
  }
  return { model, blocks, blockNames, total: model + blocks };
}
function dropLayerRecord(doc, names) {
  const gone = new Set(names);
  const layers = (doc.layers || []).filter((l) => !gone.has(l.name));
  let layouts = doc.layouts;
  if (Array.isArray(layouts)) {
    let touched = false;
    const next = layouts.map((lay) => {
      const vps = lay.viewports;
      if (!Array.isArray(vps) || !vps.length) return lay;
      let vpTouched = false;
      const nvps = vps.map((v) => {
        const ov = v.layerOverrides;
        if (!ov || !names.some((n) => Object.prototype.hasOwnProperty.call(ov, n))) return v;
        vpTouched = true;
        const nov = /* @__PURE__ */ Object.create(null);
        for (const k of Object.keys(ov)) if (!gone.has(k)) nov[k] = ov[k];
        return { ...v, layerOverrides: { ...nov } };
      });
      if (!vpTouched) return lay;
      touched = true;
      return { ...lay, viewports: nvps };
    });
    if (touched) layouts = next;
  }
  return { ...doc, layers, ...layouts !== doc.layouts ? { layouts } : {} };
}
function deleteEmptyLayer(doc, name) {
  if (name === DEFAULT_LAYER) return null;
  if (!(doc.layers || []).some((l) => l.name === name)) return null;
  if (layerUsage(doc, name).total > 0) return null;
  return dropLayerRecord(doc, [name]);
}
function deleteLayersWithContents(doc, nameOrNames) {
  const asked = Array.isArray(nameOrNames) ? nameOrNames : [nameOrNames];
  const known = new Set((doc.layers || []).map((l) => l.name));
  const removedLayers = [...new Set(asked)].filter((n) => n !== DEFAULT_LAYER && known.has(n));
  if (!removedLayers.length) return null;
  const gone = new Set(removedLayers);
  const onLayer = (doc.entities || []).filter((e) => gone.has(layerOf(e))).map((e) => e.id);
  const attached = attachedDimensionIds(doc.entities || [], onLayer);
  const removedEntityIds = attached.length ? [.../* @__PURE__ */ new Set([...onLayer, ...attached])] : onLayer;
  const removeSet = new Set(removedEntityIds);
  let next = {
    ...doc,
    entities: (doc.entities || []).filter((e) => !removeSet.has(e.id)),
    constraints: pruneConstraints(doc.constraints, removedEntityIds)
  };
  const defs = doc.blockDefs || {};
  let defsTouched = false;
  const nextDefs = /* @__PURE__ */ Object.create(null);
  for (const bn of Object.keys(defs)) {
    const def = defs[bn];
    const ents = def && def.entities || [];
    const kept = ents.filter((e) => !gone.has(layerOf(e)));
    if (kept.length !== ents.length) {
      defsTouched = true;
      nextDefs[bn] = { ...def, entities: kept };
    } else {
      nextDefs[bn] = def;
    }
  }
  if (defsTouched) next = { ...next, blockDefs: { ...nextDefs } };
  return { doc: dropLayerRecord(next, removedLayers), removedLayers, removedEntityIds };
}
function mergeLayer(doc, source, target) {
  if (source === DEFAULT_LAYER || source === target) return null;
  const known = new Set((doc.layers || []).map((l) => l.name));
  if (!known.has(source) || !known.has(target)) return null;
  let next = doc;
  const ents = doc.entities || [];
  if (ents.some((e) => layerOf(e) === source)) {
    next = {
      ...next,
      entities: ents.map((e) => layerOf(e) === source ? { ...e, layer: target } : e)
    };
  }
  const defs = doc.blockDefs || {};
  let defsTouched = false;
  const nextDefs = /* @__PURE__ */ Object.create(null);
  for (const bn of Object.keys(defs)) {
    const def = defs[bn];
    const bents = def && def.entities || [];
    if (bents.some((e) => layerOf(e) === source)) {
      defsTouched = true;
      nextDefs[bn] = {
        ...def,
        entities: bents.map((e) => layerOf(e) === source ? { ...e, layer: target } : e)
      };
    } else {
      nextDefs[bn] = def;
    }
  }
  if (defsTouched) next = { ...next, blockDefs: { ...nextDefs } };
  return dropLayerRecord(next, [source]);
}

// src/cadDerive.js
var DERIVED_BUILDERS = {
  hatch: {
    sourcesOf: (e) => hatchSourceIds(e),
    rebuild: (e, byId2) => rebuildHatch(e, byId2)
  },
  // Associative dimensions: a dim measuring real entities re-derives its stored
  // geometry from them on every edit path (transforms, grips, property edits).
  // Free-space dims have no sources → never dirty → stay static.
  dimension: {
    sourcesOf: (e) => dimensionSourceIds(e),
    rebuild: (e, byId2) => rebuildDimension(e, byId2)
  }
};
function isDerived(e) {
  return !!(e && DERIVED_BUILDERS[e.type]);
}
function sourcesOf(e) {
  const b = isDerived(e) && DERIVED_BUILDERS[e.type];
  return b ? b.sourcesOf(e) || [] : [];
}
function rebuildEntity(e, byId2) {
  const b = isDerived(e) && DERIVED_BUILDERS[e.type];
  return b ? b.rebuild(e, byId2) : e;
}
var indexById = (entities) => {
  const m = /* @__PURE__ */ new Map();
  for (const e of entities || []) m.set(e.id, e);
  return m;
};
function derivedTopoOrder(entities, byId2) {
  const state = /* @__PURE__ */ new Map();
  const order = [];
  const visit = (e) => {
    if (state.has(e.id)) return;
    state.set(e.id, true);
    for (const sid of sourcesOf(e)) {
      const src = byId2.get(sid);
      if (src && isDerived(src)) visit(src);
    }
    order.push(e.id);
  };
  for (const e of entities || []) if (isDerived(e)) visit(e);
  return order;
}
function rebuildDerived(prevDoc, nextDoc) {
  const nextEntities = nextDoc.entities;
  const prevById = indexById(prevDoc.entities);
  const byId2 = indexById(nextEntities);
  const changed = (id) => prevById.get(id) !== byId2.get(id);
  let mutated = false;
  const rebuiltIds = /* @__PURE__ */ new Set();
  for (const id of derivedTopoOrder(nextEntities, byId2)) {
    const e = byId2.get(id);
    const dirty = changed(id) || sourcesOf(e).some((sid) => changed(sid) || rebuiltIds.has(sid));
    if (!dirty) continue;
    const next = rebuildEntity(e, byId2);
    if (next !== e) {
      byId2.set(id, next);
      rebuiltIds.add(id);
      mutated = true;
    }
  }
  return mutated ? { ...nextDoc, entities: nextEntities.map((e) => byId2.get(e.id) || e) } : nextDoc;
}
function rebuildAll(doc) {
  const entities = doc.entities || [];
  const byId2 = indexById(entities);
  let mutated = false;
  for (const id of derivedTopoOrder(entities, byId2)) {
    const next = rebuildEntity(byId2.get(id), byId2);
    if (next !== byId2.get(id)) {
      byId2.set(id, next);
      mutated = true;
    }
  }
  return mutated ? { ...doc, entities: entities.map((e) => byId2.get(e.id) || e) } : doc;
}
function entityLabel2(e) {
  switch (e.type) {
    case "hatch":
      return `Hatch (${e.patternName || "?"})`;
    case "dimension":
      return `Dimension (${e.dimType || "linear"})`;
    case "rectangle":
      return "Rectangle";
    case "polyline":
      return e.closed ? "Polyline (closed)" : "Polyline";
    case "circle":
      return "Circle";
    case "arc":
      return "Arc";
    case "line":
      return "Line";
    default:
      return e.type ? e.type[0].toUpperCase() + e.type.slice(1) : "Entity";
  }
}
function dependencyGraph(doc) {
  const entities = doc && doc.entities || [];
  const byId2 = indexById(entities);
  const usedBy = /* @__PURE__ */ new Map();
  const nodes = [];
  for (const e of entities) {
    if (!isDerived(e)) continue;
    const srcIds = sourcesOf(e);
    const sources = srcIds.map((id) => {
      const s = byId2.get(id);
      return { id, type: s ? s.type : null, label: s ? entityLabel2(s) : "missing", present: !!s };
    });
    nodes.push({
      id: e.id,
      type: e.type,
      label: entityLabel2(e),
      sources,
      error: e.derivedError || null
    });
    for (const id of srcIds) {
      const arr = usedBy.get(id);
      if (arr) arr.push(e.id);
      else usedBy.set(id, [e.id]);
    }
  }
  return { nodes, usedBy };
}

// src/cadSolve.js
var DIST_TOL2 = 1e-4;
var isLine2 = (e) => e && e.type === "line";
var isCurve2 = (e) => e && (e.type === "circle" || e.type === "arc");
var keyOf = (id, slot) => `${id}#${slot}`;
var splitKey = (key) => {
  const i = key.indexOf("#");
  return [key.slice(0, i), key.slice(i + 1)];
};
function refToSlot(ref, ent) {
  if (!ref || !ent) return null;
  if (ref.kind === "end" && isLine2(ent)) return "p" + ref.index;
  if (ref.kind === "vertex" && ent.type === "polyline") return "v" + ref.index;
  if (ref.kind === "center" && isCurve2(ent)) return "c";
  return null;
}
function entitySlots(e) {
  if (isLine2(e)) return ["p0", "p1"];
  if (e && e.type === "polyline" && Array.isArray(e.points)) return e.points.map((_, i) => "v" + i);
  if (isCurve2(e)) return ["c"];
  return [];
}
function getPt(ent, slot) {
  if (!ent) return null;
  if (slot === "p0") return { x: ent.x1, y: ent.y1 };
  if (slot === "p1") return { x: ent.x2, y: ent.y2 };
  if (slot === "c") return { x: ent.cx, y: ent.cy };
  if (slot && slot[0] === "v") {
    const p = ent.points && ent.points[+slot.slice(1)];
    return p ? { x: p.x, y: p.y } : null;
  }
  return null;
}
function setPt(ent, slot, x, y) {
  if (slot === "p0") {
    ent.x1 = x;
    ent.y1 = y;
    return;
  }
  if (slot === "p1") {
    ent.x2 = x;
    ent.y2 = y;
    return;
  }
  if (slot === "c") {
    ent.cx = x;
    ent.cy = y;
    return;
  }
  if (slot && slot[0] === "v") {
    const i = +slot.slice(1);
    if (ent.points && ent.points[i]) ent.points[i] = { x, y };
  }
}
function segSlots(ent, segIndex) {
  if (isLine2(ent)) return ["p0", "p1"];
  if (ent && ent.type === "polyline" && Array.isArray(ent.points)) {
    const n = ent.points.length;
    if (n < 2) return null;
    const count = ent.closed ? n : n - 1;
    const i = segIndex | 0;
    if (i < 0 || i >= count) return null;
    return ["v" + i, "v" + (i + 1) % n];
  }
  return null;
}
var dist4 = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
var angleDeg4 = (a, b) => Math.atan2(b.y - a.y, b.x - a.x) * 180 / Math.PI;
var norm1802 = (d) => (d % 180 + 180) % 180;
var undirDiff = (a, b) => {
  const d = norm1802(a - b);
  return Math.min(d, 180 - d);
};
function solveConstraints(doc, seedIds, opts = {}) {
  const constraints = doc && doc.constraints || [];
  if (!constraints.length || !seedIds || !seedIds.length) return doc;
  const tol = opts.tol ?? DIST_TOL2;
  const maxIter = opts.maxIter ?? 64;
  const orig = new Map(doc.entities.map((e) => [e.id, e]));
  const seedSet = new Set(seedIds.filter((id) => orig.has(id)));
  if (!seedSet.size) return doc;
  const beforeById = new Map((opts.before && opts.before.entities || []).map((e) => [e.id, e]));
  const work = /* @__PURE__ */ new Map();
  const ent = (id) => work.get(id) || orig.get(id);
  const mut = (id) => {
    let w = work.get(id);
    if (w) return w;
    const e = orig.get(id);
    if (!e) return null;
    w = { ...e };
    if (Array.isArray(e.points)) w.points = e.points.map((p) => ({ ...p }));
    work.set(id, w);
    return w;
  };
  const ptOf = (id, slot) => getPt(ent(id), slot);
  const curPos = (key) => {
    const [id, slot] = splitKey(key);
    return ptOf(id, slot);
  };
  const moveTo = (key, x, y) => {
    const [id, slot] = splitKey(key);
    setPt(mut(id), slot, x, y);
  };
  const anchored = /* @__PURE__ */ new Set();
  if (opts.anchors && opts.anchors.length) {
    for (const ref of opts.anchors) {
      const slot = refToSlot(ref, orig.get(ref.id));
      if (slot) anchored.add(keyOf(ref.id, slot));
    }
  } else {
    for (const id of seedSet) for (const slot of entitySlots(orig.get(id))) anchored.add(keyOf(id, slot));
  }
  if (!anchored.size) return doc;
  const grounded = /* @__PURE__ */ new Set();
  const fixedIdSet = new Set(opts.fixedIds || []);
  for (const id of opts.fixedIds || []) {
    const e = orig.get(id);
    if (!e) continue;
    for (const slot of entitySlots(e)) {
      const key = keyOf(id, slot);
      if (!anchored.has(key)) grounded.add(key);
    }
  }
  const adj = /* @__PURE__ */ new Map();
  const addEdge = (a, b, type) => {
    if (!a || !b) return;
    (adj.get(a) || adj.set(a, []).get(a)).push([b, type]);
    (adj.get(b) || adj.set(b, []).get(b)).push([a, type]);
  };
  for (const c of constraints) {
    if (c.type === "coincident") {
      const [rA, rB] = c.refs || [];
      const sA = refToSlot(rA, orig.get(rA && rA.id));
      const sB = refToSlot(rB, orig.get(rB && rB.id));
      if (sA && sB) addEdge(keyOf(rA.id, sA), keyOf(rB.id, sB), "coincident");
    } else if (c.type === "horizontal" || c.type === "vertical") {
      const id = c.ids[0];
      const slots = segSlots(orig.get(id), c.segs && c.segs[0]);
      if (slots) addEdge(keyOf(id, slots[0]), keyOf(id, slots[1]), "axis");
    }
  }
  const visited = /* @__PURE__ */ new Set([...anchored, ...grounded]);
  const queue = [];
  for (const key of anchored) {
    const cur = curPos(key);
    if (!cur) continue;
    const [id, slot] = splitKey(key);
    const prev = getPt(beforeById.get(id), slot) || cur;
    queue.push({ key, delta: { x: cur.x - prev.x, y: cur.y - prev.y } });
  }
  let mutated = false;
  while (queue.length) {
    const { key, delta } = queue.shift();
    const kPos = curPos(key);
    for (const [nb, type] of adj.get(key) || []) {
      if (visited.has(nb)) continue;
      const old = curPos(nb);
      if (!old) {
        visited.add(nb);
        continue;
      }
      const np = type === "coincident" ? { x: kPos.x, y: kPos.y } : { x: old.x + delta.x, y: old.y + delta.y };
      const nd = type === "coincident" ? { x: np.x - old.x, y: np.y - old.y } : delta;
      visited.add(nb);
      moveTo(nb, np.x, np.y);
      mutated = true;
      queue.push({ key: nb, delta: nd });
    }
  }
  const pinned = /* @__PURE__ */ new Set([...anchored, ...grounded]);
  {
    const q = [...anchored, ...grounded];
    while (q.length) {
      const k = q.shift();
      for (const [nb, type] of adj.get(k) || []) {
        if (type === "coincident" && !pinned.has(nb)) {
          pinned.add(nb);
          q.push(nb);
        }
      }
    }
  }
  const jointPts = /* @__PURE__ */ new Set();
  for (const c of constraints) {
    if (c.type !== "coincident") continue;
    const [rA, rB] = c.refs || [];
    const sA = refToSlot(rA, orig.get(rA && rA.id));
    const sB = refToSlot(rB, orig.get(rB && rB.id));
    if (sA) jointPts.add(keyOf(rA.id, sA));
    if (sB) jointPts.add(keyOf(rB.id, sB));
  }
  const movable = (key) => key != null && !pinned.has(key);
  const fixedness = (key) => pinned.has(key) ? 2 : jointPts.has(key) ? 1 : 0;
  const dirDiff = (a, b) => Math.abs(((a - b + 180) % 360 + 360) % 360 - 180);
  const setKey = (key, x, y) => {
    const p = curPos(key);
    if (p && Math.abs(p.x - x) <= tol && Math.abs(p.y - y) <= tol) return false;
    moveTo(key, x, y);
    mutated = true;
    return true;
  };
  const projectCoincident = (kA, kB) => {
    const mA = movable(kA), mB = movable(kB);
    if (!mA && !mB) return false;
    const a = curPos(kA), b = curPos(kB);
    if (!a || !b) return false;
    if (mA && mB) {
      const m = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
      return setKey(kA, m.x, m.y) | setKey(kB, m.x, m.y);
    }
    return mA ? setKey(kA, b.x, b.y) : setKey(kB, a.x, a.y);
  };
  const projectAxis = (kA, kB, coord) => {
    const mA = movable(kA), mB = movable(kB);
    if (!mA && !mB) return false;
    const a = curPos(kA), b = curPos(kB);
    if (!a || !b) return false;
    if (mA && mB) {
      const m = (a[coord] + b[coord]) / 2;
      const na = { ...a };
      const nb2 = { ...b };
      na[coord] = m;
      nb2[coord] = m;
      return setKey(kA, na.x, na.y) | setKey(kB, nb2.x, nb2.y);
    }
    if (mA) {
      const na = { ...a };
      na[coord] = b[coord];
      return setKey(kA, na.x, na.y);
    }
    const nb = { ...b };
    nb[coord] = a[coord];
    return setKey(kB, nb.x, nb.y);
  };
  const pinnedCount = (id, slots) => fixedness(keyOf(id, slots[0])) + fixedness(keyOf(id, slots[1]));
  const rotateSeg = (idL, slots, targetDeg) => {
    const kA = keyOf(idL, slots[0]), kB = keyOf(idL, slots[1]);
    const fA = fixedness(kA), fB = fixedness(kB);
    if (fA >= 2 && fB >= 2) return false;
    const A = ptOf(idL, slots[0]), B = ptOf(idL, slots[1]);
    if (!A || !B) return false;
    if (fA === fB) {
      const cur = angleDeg4(A, B);
      const tgt2 = dirDiff(targetDeg, cur) <= dirDiff(targetDeg + 180, cur) ? targetDeg : targetDeg + 180;
      const rad2 = tgt2 * Math.PI / 180;
      const mid = { x: (A.x + B.x) / 2, y: (A.y + B.y) / 2 };
      const h = dist4(A, B) / 2;
      return setKey(kA, mid.x - h * Math.cos(rad2), mid.y - h * Math.sin(rad2)) | setKey(kB, mid.x + h * Math.cos(rad2), mid.y + h * Math.sin(rad2));
    }
    const pivotA = fA > fB;
    const pivot = pivotA ? A : B;
    const moverK = pivotA ? kB : kA;
    const mover = pivotA ? B : A;
    const L = dist4(A, B);
    const curPM = angleDeg4(pivot, mover);
    const tgt = dirDiff(targetDeg, curPM) <= dirDiff(targetDeg + 180, curPM) ? targetDeg : targetDeg + 180;
    const rad = tgt * Math.PI / 180;
    return setKey(moverK, pivot.x + L * Math.cos(rad), pivot.y + L * Math.sin(rad));
  };
  const projectDirectional = (c) => {
    const [id1, id2] = c.ids;
    if (id1 === id2) return false;
    const s1 = segSlots(ent(id1), c.segs && c.segs[0]);
    const s2 = segSlots(ent(id2), c.segs && c.segs[1]);
    if (!s1 || !s2) return false;
    const pc1 = pinnedCount(id1, s1), pc2 = pinnedCount(id2, s2);
    const rotFirst = pc1 <= pc2 && !(pc1 === pc2);
    const rotId = rotFirst ? id1 : id2, rotS = rotFirst ? s1 : s2;
    const refId = rotFirst ? id2 : id1, refS = rotFirst ? s2 : s1;
    const RA = ptOf(refId, refS[0]), RB = ptOf(refId, refS[1]);
    const rotA = ptOf(rotId, rotS[0]), rotB = ptOf(rotId, rotS[1]);
    if (!RA || !RB || !rotA || !rotB) return false;
    const refDeg = angleDeg4(RA, RB);
    let target;
    if (c.type === "parallel") target = refDeg;
    else if (c.type === "perpendicular") target = refDeg + 90;
    else {
      const cur = angleDeg4(rotA, rotB);
      const v = c.value || 0;
      target = undirDiff(refDeg + v, cur) <= undirDiff(refDeg - v, cur) ? refDeg + v : refDeg - v;
    }
    return rotateSeg(rotId, rotS, target);
  };
  const projectEqualLength = (c) => {
    const [id1, id2] = c.ids;
    if (id1 === id2) return false;
    const s1 = segSlots(ent(id1), c.segs && c.segs[0]);
    const s2 = segSlots(ent(id2), c.segs && c.segs[1]);
    if (!s1 || !s2) return false;
    const pc1 = pinnedCount(id1, s1), pc2 = pinnedCount(id2, s2);
    const rotFirst = pc1 <= pc2 && !(pc1 === pc2);
    const chId = rotFirst ? id1 : id2, chS = rotFirst ? s1 : s2;
    const refId = rotFirst ? id2 : id1, refS = rotFirst ? s2 : s1;
    const A = ptOf(chId, chS[0]), B = ptOf(chId, chS[1]);
    const RA = ptOf(refId, refS[0]), RB = ptOf(refId, refS[1]);
    if (!A || !B || !RA || !RB) return false;
    const targetLen = dist4(RA, RB);
    const curLen = dist4(A, B);
    if (curLen < 1e-9 || Math.abs(curLen - targetLen) <= tol) return false;
    const kA = keyOf(chId, chS[0]), kB = keyOf(chId, chS[1]);
    const mA = movable(kA), mB = movable(kB);
    if (!mA && !mB) return false;
    const s = targetLen / curLen;
    if (mA && mB) {
      const mid = { x: (A.x + B.x) / 2, y: (A.y + B.y) / 2 };
      return setKey(kA, mid.x + (A.x - mid.x) * s, mid.y + (A.y - mid.y) * s) | setKey(kB, mid.x + (B.x - mid.x) * s, mid.y + (B.y - mid.y) * s);
    }
    const pivot = mA ? B : A;
    const moverK = mA ? kA : kB;
    const mover = mA ? A : B;
    return setKey(moverK, pivot.x + (mover.x - pivot.x) * s, pivot.y + (mover.y - pivot.y) * s);
  };
  const projectConcentric = (c) => {
    const [id1, id2] = c.ids;
    const k1 = keyOf(id1, "c"), k2 = keyOf(id2, "c");
    return projectCoincident(k1, k2);
  };
  const projectEqualRadius = (c) => {
    const [id1, id2] = c.ids;
    const e1 = ent(id1), e2 = ent(id2);
    if (!isCurve2(e1) || !isCurve2(e2)) return false;
    const r1Free = !seedSet.has(id1) && !fixedIdSet.has(id1);
    const r2Free = !seedSet.has(id2) && !fixedIdSet.has(id2);
    if (Math.abs(e1.r - e2.r) <= tol) return false;
    if (r2Free && !r1Free) {
      mut(id2).r = e1.r;
      mutated = true;
      return true;
    }
    if (r1Free && !r2Free) {
      mut(id1).r = e2.r;
      mutated = true;
      return true;
    }
    if (r1Free && r2Free) {
      const r = (e1.r + e2.r) / 2;
      mut(id1).r = r;
      mut(id2).r = r;
      mutated = true;
      return true;
    }
    return false;
  };
  const projectTangent = (c) => {
    const [id1, id2] = c.ids;
    const e1 = ent(id1), e2 = ent(id2);
    if (isCurve2(e1) && isCurve2(e2)) {
      const freeId = movable(keyOf(id2, "c")) ? id2 : movable(keyOf(id1, "c")) ? id1 : null;
      if (!freeId) return false;
      const fx = ent(freeId), ox = ent(freeId === id1 ? id2 : id1);
      const O2 = { x: ox.cx, y: ox.cy }, F2 = { x: fx.cx, y: fx.cy };
      const d2 = dist4(O2, F2);
      if (d2 < 1e-9) return false;
      const ext = fx.r + ox.r, int = Math.abs(fx.r - ox.r);
      const target = Math.abs(d2 - ext) <= Math.abs(d2 - int) ? ext : int;
      if (Math.abs(d2 - target) <= tol) return false;
      return setKey(keyOf(freeId, "c"), O2.x + (F2.x - O2.x) / d2 * target, O2.y + (F2.y - O2.y) / d2 * target);
    }
    const curve = isCurve2(e1) ? e1 : isCurve2(e2) ? e2 : null;
    const lineId = isCurve2(e1) ? id2 : id1;
    const lineSeg = segSlots(ent(lineId), isCurve2(e1) ? c.segs && c.segs[1] : c.segs && c.segs[0]);
    if (!curve || !lineSeg) return false;
    const curveId = isCurve2(e1) ? id1 : id2;
    const O = { x: curve.cx, y: curve.cy };
    const A = ptOf(lineId, lineSeg[0]), B = ptOf(lineId, lineSeg[1]);
    if (!A || !B) return false;
    const vx = B.x - A.x, vy = B.y - A.y, len2 = vx * vx + vy * vy;
    if (len2 < 1e-18) return false;
    const t = ((O.x - A.x) * vx + (O.y - A.y) * vy) / len2;
    const foot = { x: A.x + t * vx, y: A.y + t * vy };
    const d = dist4(O, foot);
    if (movable(keyOf(curveId, "c"))) {
      if (Math.abs(d - curve.r) <= tol) return false;
      const dir = d < 1e-9 ? { x: vy, y: -vx } : { x: (O.x - foot.x) / d, y: (O.y - foot.y) / d };
      const nrm = Math.hypot(dir.x, dir.y) || 1;
      return setKey(keyOf(curveId, "c"), foot.x + dir.x / nrm * curve.r, foot.y + dir.y / nrm * curve.r);
    }
    if (Math.abs(d - curve.r) <= tol) return false;
    const kA = keyOf(lineId, lineSeg[0]), kB = keyOf(lineId, lineSeg[1]);
    const fA = fixedness(kA), fB = fixedness(kB);
    if (fA >= 2 && fB >= 2) return false;
    if (fA === 0 && fB === 0) {
      const segLen = Math.sqrt(len2);
      const n = d < 1e-9 ? { x: -vy / segLen, y: vx / segLen } : { x: (O.x - foot.x) / d, y: (O.y - foot.y) / d };
      const shift = d < 1e-9 ? curve.r : d - curve.r;
      return setKey(kA, A.x + n.x * shift, A.y + n.y * shift) | setKey(kB, B.x + n.x * shift, B.y + n.y * shift);
    }
    const pivotA = fA >= fB;
    const J = pivotA ? A : B;
    const moverK = pivotA ? kB : kA;
    const M = pivotA ? B : A;
    const dJO = dist4(J, O);
    if (dJO < curve.r) return false;
    const L = dist4(J, M);
    const baseAng = Math.atan2(O.y - J.y, O.x - J.x);
    const off = Math.asin(Math.max(-1, Math.min(1, curve.r / dJO)));
    const curAng = Math.atan2(M.y - J.y, M.x - J.x);
    const cand = [baseAng + off, baseAng - off];
    const pick = Math.abs(Math.atan2(Math.sin(cand[0] - curAng), Math.cos(cand[0] - curAng))) <= Math.abs(Math.atan2(Math.sin(cand[1] - curAng), Math.cos(cand[1] - curAng))) ? cand[0] : cand[1];
    return setKey(moverK, J.x + L * Math.cos(pick), J.y + L * Math.sin(pick));
  };
  for (let iter = 0; iter < maxIter; iter++) {
    let moved = false;
    for (const c of constraints) {
      if (!Array.isArray(c.ids) || !c.ids.length) continue;
      switch (c.type) {
        case "coincident": {
          const [rA, rB] = c.refs || [];
          const sA = refToSlot(rA, orig.get(rA && rA.id));
          const sB = refToSlot(rB, orig.get(rB && rB.id));
          if (sA && sB) moved = projectCoincident(keyOf(rA.id, sA), keyOf(rB.id, sB)) ? true : moved;
          break;
        }
        case "horizontal": {
          const slots = segSlots(ent(c.ids[0]), c.segs && c.segs[0]);
          if (slots) moved = projectAxis(keyOf(c.ids[0], slots[0]), keyOf(c.ids[0], slots[1]), "y") ? true : moved;
          break;
        }
        case "vertical": {
          const slots = segSlots(ent(c.ids[0]), c.segs && c.segs[0]);
          if (slots) moved = projectAxis(keyOf(c.ids[0], slots[0]), keyOf(c.ids[0], slots[1]), "x") ? true : moved;
          break;
        }
        case "parallel":
        case "perpendicular":
        case "angle":
          if (c.ids.length >= 2) moved = projectDirectional(c) ? true : moved;
          break;
        case "equalLength":
          if (c.ids.length >= 2) moved = projectEqualLength(c) ? true : moved;
          break;
        case "concentric":
          if (c.ids.length >= 2) moved = projectConcentric(c) ? true : moved;
          break;
        case "equalRadius":
          if (c.ids.length >= 2) moved = projectEqualRadius(c) ? true : moved;
          break;
        case "tangent":
          if (c.ids.length >= 2) moved = projectTangent(c) ? true : moved;
          break;
        default:
          break;
      }
    }
    if (!moved) break;
  }
  if (!mutated || !work.size) return doc;
  const near = (a, b) => Math.abs(a - b) <= tol;
  let changed = false;
  const entities = doc.entities.map((e) => {
    const w = work.get(e.id);
    if (!w) return e;
    let same = true;
    if (isLine2(e)) same = near(e.x1, w.x1) && near(e.y1, w.y1) && near(e.x2, w.x2) && near(e.y2, w.y2);
    else if (isCurve2(e)) same = near(e.cx, w.cx) && near(e.cy, w.cy) && near(e.r, w.r);
    else if (Array.isArray(e.points)) same = e.points.length === w.points.length && e.points.every((p, i) => near(p.x, w.points[i].x) && near(p.y, w.points[i].y));
    if (same) return e;
    changed = true;
    return w;
  });
  return changed ? { ...doc, entities } : doc;
}

// src/solver/translate.js
var D2R = Math.PI / 180;
var keyOf2 = (entityId, slot) => `${entityId}#${slot}`;
var segKeyOf = (entityId, i) => `${entityId}#seg${i}`;
var isNum = (n) => typeof n === "number" && Number.isFinite(n);
var allNum = (...ns) => ns.every(isNum);
function refToSlot2(ref, ent) {
  if (!ref || !ent) return null;
  if (ref.kind === "end" && ent.type === "line") return "p" + ref.index;
  if (ref.kind === "vertex" && ent.type === "polyline") return "v" + ref.index;
  if (ref.kind === "center" && (ent.type === "circle" || ent.type === "arc")) return "c";
  return null;
}
function refToSlotKey(ref, byId2) {
  const slot = refToSlot2(ref, ref && byId2.get(ref.id));
  return slot ? keyOf2(ref.id, slot) : null;
}
function computeMergeGroups(constraints, entities, fixedSet) {
  const byId2 = /* @__PURE__ */ new Map();
  for (const e of entities) if (e && typeof e === "object" && e.id != null) byId2.set(e.id, e);
  const parent = /* @__PURE__ */ new Map();
  const find = (k) => {
    let r = k;
    while (parent.get(r) !== r) r = parent.get(r);
    let cur = k;
    while (parent.get(cur) !== r) {
      const nxt = parent.get(cur);
      parent.set(cur, r);
      cur = nxt;
    }
    return r;
  };
  const union = (a, b) => {
    if (!parent.has(a)) parent.set(a, a);
    if (!parent.has(b)) parent.set(b, b);
    parent.set(find(a), find(b));
  };
  const mergedConstraints = /* @__PURE__ */ new Set();
  const mergedPairs = /* @__PURE__ */ new Map();
  for (const c of constraints || []) {
    if (!c || c.type !== "coincident" || !Array.isArray(c.refs)) continue;
    const kA = refToSlotKey(c.refs[0], byId2);
    const kB = refToSlotKey(c.refs[1], byId2);
    if (!kA || !kB) continue;
    union(kA, kB);
    mergedConstraints.add(c.id);
    mergedPairs.set(c.id, [kA, kB]);
  }
  const groupOf2 = /* @__PURE__ */ new Map();
  const members = /* @__PURE__ */ new Map();
  for (const k of parent.keys()) {
    const r = find(k);
    groupOf2.set(k, r);
    let list = members.get(r);
    if (!list) {
      list = [];
      members.set(r, list);
    }
    list.push(k);
  }
  const groupFixed = /* @__PURE__ */ new Set();
  for (const [r, ks] of members) if (ks.some((k) => fixedSet.has(k))) groupFixed.add(r);
  return { groupOf: groupOf2, groupFixed, mergedConstraints, mergedPairs };
}
function translateDoc(doc, opts = {}) {
  const fixedSet = new Set(opts.fixedSlotKeys || []);
  const entities = doc && Array.isArray(doc.entities) ? doc.entities : [];
  const primitives = [];
  const warnings = [];
  const slotToPoint = /* @__PURE__ */ new Map();
  const pointToSlot = /* @__PURE__ */ new Map();
  const entityShapes = /* @__PURE__ */ new Map();
  const segToLine = /* @__PURE__ */ new Map();
  const segToPoints = /* @__PURE__ */ new Map();
  const arcs = /* @__PURE__ */ new Map();
  const rectRules = /* @__PURE__ */ new Map();
  const merge = opts.mergeCoincident ? computeMergeGroups(doc && doc.constraints || [], entities, fixedSet) : null;
  const groupPoint = /* @__PURE__ */ new Map();
  let counter = 1;
  const nextId = () => String(counter++);
  const warn = (entityId, reason) => warnings.push({ entityId, reason });
  const addSlotPoint = (entityId, slot, x, y) => {
    const key = keyOf2(entityId, slot);
    const root = merge ? merge.groupOf.get(key) : void 0;
    if (root !== void 0) {
      const shared = groupPoint.get(root);
      if (shared !== void 0) {
        slotToPoint.set(key, shared);
        pointToSlot.get(shared).push(key);
        return shared;
      }
    }
    const gid = nextId();
    const fixed = fixedSet.has(key) || root !== void 0 && merge.groupFixed.has(root);
    primitives.push({ id: gid, type: "point", x, y, fixed });
    slotToPoint.set(key, gid);
    pointToSlot.set(gid, [key]);
    if (root !== void 0) groupPoint.set(root, gid);
    return gid;
  };
  const addInternalPoint = (x, y) => {
    const gid = nextId();
    primitives.push({ id: gid, type: "point", x, y, fixed: false });
    return gid;
  };
  const translateLine = (e) => {
    if (!allNum(e.x1, e.y1, e.x2, e.y2)) return warn(e.id, "line has non-finite coordinates");
    const p0 = addSlotPoint(e.id, "p0", e.x1, e.y1);
    const p1 = addSlotPoint(e.id, "p1", e.x2, e.y2);
    const lid = nextId();
    primitives.push({ id: lid, type: "line", p1_id: p0, p2_id: p1 });
    entityShapes.set(e.id, lid);
    segToLine.set(segKeyOf(e.id, 0), lid);
    segToPoints.set(segKeyOf(e.id, 0), [p0, p1]);
  };
  const translatePolyline = (e) => {
    const pts = Array.isArray(e.points) ? e.points : null;
    if (!pts || pts.length < 2) return warn(e.id, "polyline needs >= 2 points");
    if (!pts.every((p) => p && allNum(p.x, p.y))) return warn(e.id, "polyline has non-finite vertices");
    const n = pts.length;
    const pointIds = pts.map((p, i) => addSlotPoint(e.id, "v" + i, p.x, p.y));
    const segCount = e.closed ? n : n - 1;
    const lineIds = [];
    for (let i = 0; i < segCount; i++) {
      const lid = nextId();
      primitives.push({ id: lid, type: "line", p1_id: pointIds[i], p2_id: pointIds[(i + 1) % n] });
      lineIds.push(lid);
      segToLine.set(segKeyOf(e.id, i), lid);
      segToPoints.set(segKeyOf(e.id, i), [pointIds[i], pointIds[(i + 1) % n]]);
    }
    entityShapes.set(e.id, lineIds);
  };
  const translateRectangle = (e) => {
    if (!allNum(e.x, e.y, e.width, e.height)) return warn(e.id, "rectangle has non-finite fields");
    const corners = [
      ["v0", e.x, e.y],
      ["v1", e.x + e.width, e.y],
      ["v2", e.x + e.width, e.y + e.height],
      ["v3", e.x, e.y + e.height]
    ];
    const pointIds = corners.map(([slot, cx, cy]) => addSlotPoint(e.id, slot, cx, cy));
    const lineIds = [];
    for (let i = 0; i < 4; i++) {
      const lid = nextId();
      primitives.push({ id: lid, type: "line", p1_id: pointIds[i], p2_id: pointIds[(i + 1) % 4] });
      lineIds.push(lid);
      segToLine.set(segKeyOf(e.id, i), lid);
      segToPoints.set(segKeyOf(e.id, i), [pointIds[i], pointIds[(i + 1) % 4]]);
    }
    entityShapes.set(e.id, lineIds);
    const ruleIds = [];
    for (let i = 0; i < 4; i++) {
      const rid = nextId();
      primitives.push({ id: rid, type: i % 2 === 0 ? "horizontal_l" : "vertical_l", l_id: lineIds[i] });
      ruleIds.push(rid);
    }
    rectRules.set(e.id, ruleIds);
  };
  const translateCircle = (e) => {
    if (!allNum(e.cx, e.cy, e.r) || e.r <= 0) return warn(e.id, "degenerate circle (non-finite or r <= 0)");
    const c = addSlotPoint(e.id, "c", e.cx, e.cy);
    const cid = nextId();
    primitives.push({ id: cid, type: "circle", c_id: c, radius: e.r });
    entityShapes.set(e.id, cid);
  };
  const translateArc = (e) => {
    if (!allNum(e.cx, e.cy, e.r, e.startAngle, e.endAngle) || e.r <= 0) {
      return warn(e.id, "degenerate arc (non-finite or r <= 0)");
    }
    const sRad = e.startAngle * D2R;
    const eRad = e.endAngle * D2R;
    const c = addSlotPoint(e.id, "c", e.cx, e.cy);
    const start = addInternalPoint(e.cx + e.r * Math.cos(sRad), e.cy + e.r * Math.sin(sRad));
    const end = addInternalPoint(e.cx + e.r * Math.cos(eRad), e.cy + e.r * Math.sin(eRad));
    const arcId = nextId();
    primitives.push({
      id: arcId,
      type: "arc",
      c_id: c,
      radius: e.r,
      start_id: start,
      end_id: end,
      start_angle: sRad,
      end_angle: eRad
    });
    const rulesId = nextId();
    primitives.push({ id: rulesId, type: "arc_rules", a_id: arcId });
    entityShapes.set(e.id, arcId);
    arcs.set(e.id, { center: c, start, end, arc: arcId, arcRules: rulesId });
  };
  for (const e of entities) {
    if (!e || typeof e !== "object" || typeof e.type !== "string") {
      warn(e && e.id, "entity is not a valid object");
      continue;
    }
    switch (e.type) {
      case "line":
        translateLine(e);
        break;
      case "polyline":
        translatePolyline(e);
        break;
      case "rectangle":
        translateRectangle(e);
        break;
      case "circle":
        translateCircle(e);
        break;
      case "arc":
        translateArc(e);
        break;
      default:
        warn(e.id, `unsupported entity type '${e.type}'`);
    }
  }
  const mergedConstraints = /* @__PURE__ */ new Set();
  if (merge) {
    for (const [cid, [kA, kB]] of merge.mergedPairs) {
      if (slotToPoint.has(kA) && slotToPoint.has(kB)) mergedConstraints.add(cid);
    }
  }
  return {
    primitives,
    maps: {
      slotToPoint,
      pointToSlot,
      entityShapes,
      segToLine,
      segToPoints,
      arcs,
      rectRules,
      mergedConstraints,
      nextId: counter
    },
    warnings
  };
}

// src/solver/constraintMap.js
var D2R2 = Math.PI / 180;
var isCurve3 = (e) => e && (e.type === "circle" || e.type === "arc");
var isSegOperand = (e) => e && (e.type === "line" || e.type === "polyline" || e.type === "rectangle");
var lineAngleDeg = (s) => Math.atan2(s.y2 - s.y1, s.x2 - s.x1) * 180 / Math.PI;
var normSigned = (a) => {
  const d = ((a + 180) % 360 + 360) % 360 - 180;
  return d === -180 ? 180 : d;
};
function segLineId(rec, k, maps, entitiesById) {
  const ent = entitiesById.get(rec.ids[k]);
  if (!isSegOperand(ent)) return null;
  const seg = ent.type === "line" ? 0 : (rec.segs && rec.segs[k]) | 0;
  return maps.segToLine.get(`${rec.ids[k]}#seg${seg}`) || null;
}
function segGeom(rec, k, entitiesById) {
  return segmentOf(entitiesById.get(rec.ids[k]), rec.segs && rec.segs[k]);
}
function directedAngleTargetDeg(s1, s2, valueDeg) {
  const cur = normSigned(lineAngleDeg(s2) - lineAngleDeg(s1));
  const v = (valueDeg % 180 + 180) % 180;
  const want = Math.min(v, 180 - v);
  const candidates = [want, -want, 180 - want, want - 180];
  let best = candidates[0];
  let bestD = Infinity;
  for (const cand of candidates) {
    const d = Math.abs(normSigned(cand - cur));
    if (d < bestD) {
      bestD = d;
      best = cand;
    }
  }
  return best;
}
function mapConstraints(constraints, maps, entitiesById, opts = {}) {
  const alloc = makeAllocator(opts.startId ?? maps.nextId, "mapConstraints");
  const primitives = [];
  const unmapped = [];
  const gcsToOurs = /* @__PURE__ */ new Map();
  const merged = maps.mergedConstraints || /* @__PURE__ */ new Set();
  const skip = (constraint, reason) => unmapped.push({ constraint, reason });
  const emit = (ourId, prim) => {
    const id = alloc.next();
    primitives.push({ id, ...prim });
    if (ourId != null) gcsToOurs.set(id, ourId);
  };
  for (const c of constraints || []) {
    if (!c || typeof c.type !== "string" || !Array.isArray(c.ids)) {
      skip(c, "malformed constraint record");
      continue;
    }
    if (merged.has(c.id)) continue;
    const ents = c.ids.map((id) => entitiesById.get(id));
    if (ents.some((e) => !e)) {
      skip(c, "missing entity");
      continue;
    }
    const [a, b] = ents;
    switch (c.type) {
      case "coincident": {
        const kA = refToSlotKey(c.refs && c.refs[0], entitiesById);
        const kB = refToSlotKey(c.refs && c.refs[1], entitiesById);
        const pA = kA && maps.slotToPoint.get(kA);
        const pB = kB && maps.slotToPoint.get(kB);
        if (!pA || !pB) {
          skip(c, "coincident refs do not resolve to settable gcs points");
          break;
        }
        if (pA === pB) break;
        emit(c.id, { type: "p2p_coincident", p1_id: pA, p2_id: pB });
        break;
      }
      case "horizontal":
      case "vertical": {
        const l = segLineId(c, 0, maps, entitiesById);
        if (!l) {
          skip(c, "operand segment not translated");
          break;
        }
        emit(c.id, { type: c.type === "horizontal" ? "horizontal_l" : "vertical_l", l_id: l });
        break;
      }
      case "parallel":
      case "perpendicular": {
        const l1 = segLineId(c, 0, maps, entitiesById);
        const l2 = segLineId(c, 1, maps, entitiesById);
        if (!l1 || !l2) {
          skip(c, "operand segment not translated");
          break;
        }
        if (l1 === l2) {
          skip(c, "both operands are the same segment");
          break;
        }
        emit(c.id, c.type === "parallel" ? { type: "parallel", l1_id: l1, l2_id: l2 } : { type: "perpendicular_ll", l1_id: l1, l2_id: l2 });
        break;
      }
      case "angle": {
        const l1 = segLineId(c, 0, maps, entitiesById);
        const l2 = segLineId(c, 1, maps, entitiesById);
        const s1 = segGeom(c, 0, entitiesById);
        const s2 = segGeom(c, 1, entitiesById);
        if (!l1 || !l2 || !s1 || !s2) {
          skip(c, "operand segment not translated");
          break;
        }
        if (l1 === l2) {
          skip(c, "both operands are the same segment");
          break;
        }
        const target = directedAngleTargetDeg(s1, s2, c.value || 0);
        emit(c.id, { type: "l2l_angle_ll", l1_id: l1, l2_id: l2, angle: target * D2R2 });
        break;
      }
      case "tangent": {
        if (isCurve3(a) && isCurve3(b)) {
          const p1 = maps.slotToPoint.get(`${a.id}#c`);
          const p2 = maps.slotToPoint.get(`${b.id}#c`);
          const s1 = maps.entityShapes.get(a.id);
          const s2 = maps.entityShapes.get(b.id);
          if (!p1 || !p2 || typeof s1 !== "string" || typeof s2 !== "string") {
            skip(c, "curve operand not translated");
            break;
          }
          const d = Math.hypot(a.cx - b.cx, a.cy - b.cy);
          const internal = Math.abs(d - Math.abs(a.r - b.r)) < Math.abs(d - (a.r + b.r));
          emit(c.id, {
            type: "tangent_circumf",
            p1_id: p1,
            p2_id: p2,
            rd1: { o_id: s1, prop: "radius" },
            rd2: { o_id: s2, prop: "radius" },
            internal
          });
          break;
        }
        const curveIdx = isCurve3(a) ? 0 : isCurve3(b) ? 1 : -1;
        if (curveIdx === -1) {
          skip(c, "tangent needs a circle/arc operand");
          break;
        }
        const curve = ents[curveIdx];
        const l = segLineId(c, curveIdx === 0 ? 1 : 0, maps, entitiesById);
        const shape = maps.entityShapes.get(curve.id);
        if (!l || typeof shape !== "string") {
          skip(c, "tangent operand not translated");
          break;
        }
        emit(c.id, curve.type === "circle" ? { type: "tangent_lc", l_id: l, c_id: shape } : { type: "tangent_la", l_id: l, a_id: shape });
        break;
      }
      case "concentric": {
        if (!isCurve3(a) || !isCurve3(b)) {
          skip(c, "concentric needs two circles/arcs");
          break;
        }
        const p1 = maps.slotToPoint.get(`${a.id}#c`);
        const p2 = maps.slotToPoint.get(`${b.id}#c`);
        if (!p1 || !p2) {
          skip(c, "curve operand not translated");
          break;
        }
        if (p1 === p2) break;
        emit(c.id, { type: "p2p_coincident", p1_id: p1, p2_id: p2 });
        break;
      }
      case "equalRadius": {
        if (!isCurve3(a) || !isCurve3(b)) {
          skip(c, "equalRadius needs two circles/arcs");
          break;
        }
        const sA = maps.entityShapes.get(a.id);
        const sB = maps.entityShapes.get(b.id);
        if (typeof sA !== "string" || typeof sB !== "string") {
          skip(c, "curve operand not translated");
          break;
        }
        if (a.type === "circle" && b.type === "circle") {
          emit(c.id, { type: "equal_radius_cc", c1_id: sA, c2_id: sB });
        } else if (a.type === "arc" && b.type === "arc") {
          emit(c.id, { type: "equal_radius_aa", a1_id: sA, a2_id: sB });
        } else {
          emit(c.id, {
            type: "equal_radius_ca",
            c1_id: a.type === "circle" ? sA : sB,
            a2_id: a.type === "arc" ? sA : sB
          });
        }
        break;
      }
      case "equalLength": {
        const l1 = segLineId(c, 0, maps, entitiesById);
        const l2 = segLineId(c, 1, maps, entitiesById);
        if (!l1 || !l2) {
          skip(c, "operand segment not translated");
          break;
        }
        if (l1 === l2) {
          skip(c, "both operands are the same segment");
          break;
        }
        emit(c.id, { type: "equal_length", l1_id: l1, l2_id: l2 });
        break;
      }
      default:
        skip(c, `unknown constraint type '${c.type}'`);
    }
  }
  return { primitives, unmapped, gcsToOurs, nextId: alloc.value() };
}
function mapDimensionDrives(edits, maps, entitiesById, opts = {}) {
  const alloc = makeAllocator(opts.startId ?? maps.nextId, "mapDimensionDrives");
  const primitives = [];
  const unmapped = [];
  const gcsToOurs = /* @__PURE__ */ new Map();
  const skip = (edit, reason) => unmapped.push({ edit, reason });
  const emit = (ourId, prim) => {
    const id = alloc.next();
    primitives.push({ id, ...prim });
    if (ourId != null) gcsToOurs.set(id, ourId);
  };
  const spanPoints = /* @__PURE__ */ new Map();
  const spanPointId = (ref) => {
    const key = `${ref.id}#seg${ref.index}@${ref.t}`;
    if (spanPoints.has(key)) return spanPoints.get(key);
    const pos = resolveFeatureRef(ref, entitiesById);
    const segKey = `${ref.id}#seg${ref.index}`;
    const lineId = maps.segToLine.get(segKey);
    const ends = maps.segToPoints.get(segKey);
    const seg = pos && segmentOf(entitiesById.get(ref.id), ref.index);
    if (!pos || !lineId || !ends || !seg) return null;
    const pid = alloc.next();
    primitives.push({ id: pid, type: "point", x: pos.x, y: pos.y, fixed: false });
    emit(null, { type: "point_on_line_pl", p_id: pid, l_id: lineId });
    emit(null, {
      type: "p2p_distance",
      p1_id: ends[0],
      p2_id: pid,
      distance: Math.hypot(pos.x - seg.x1, pos.y - seg.y1)
    });
    emit(null, {
      type: "p2p_distance",
      p1_id: ends[0],
      p2_id: ends[1],
      distance: Math.hypot(seg.x2 - seg.x1, seg.y2 - seg.y1)
    });
    spanPoints.set(key, pid);
    return pid;
  };
  const isSpan = (ref) => !!(ref && ref.kind === "span");
  const resolvePair = (ed) => {
    const slotPoint = (ref) => {
      const k = refToSlotKey(ref, entitiesById);
      return k && maps.slotToPoint.get(k) || null;
    };
    const sA = slotPoint(ed.p1Ref);
    const sB = slotPoint(ed.p2Ref);
    const okA = sA || isSpan(ed.p1Ref) && resolveFeatureRef(ed.p1Ref, entitiesById);
    const okB = sB || isSpan(ed.p2Ref) && resolveFeatureRef(ed.p2Ref, entitiesById);
    if (!okA || !okB) return null;
    const pA = sA || spanPointId(ed.p1Ref);
    const pB = sB || spanPointId(ed.p2Ref);
    if (!pA || !pB) return null;
    return { pA, pB };
  };
  for (const ed of edits || []) {
    if (!ed || typeof ed.type !== "string" || !Number.isFinite(ed.value)) {
      skip(ed, "malformed dimension edit");
      continue;
    }
    switch (ed.type) {
      case "distance": {
        if (ed.value <= 0) {
          skip(ed, "distance must be > 0");
          break;
        }
        const pair = resolvePair(ed);
        if (!pair) {
          skip(ed, "measured refs do not resolve to settable gcs points");
          break;
        }
        if (pair.pA === pair.pB) {
          skip(ed, "both measured refs resolve to the same point");
          break;
        }
        emit(ed.id, { type: "p2p_distance", p1_id: pair.pA, p2_id: pair.pB, distance: ed.value });
        break;
      }
      case "distanceX":
      case "distanceY": {
        if (ed.value <= 0) {
          skip(ed, "distance must be > 0");
          break;
        }
        const pair = resolvePair(ed);
        if (!pair) {
          skip(ed, "measured refs do not resolve to settable gcs points");
          break;
        }
        if (pair.pA === pair.pB) {
          skip(ed, "both measured refs resolve to the same point");
          break;
        }
        const prop = ed.type === "distanceX" ? "x" : "y";
        const P = resolveFeatureRef(ed.p1Ref, entitiesById);
        const Q = resolveFeatureRef(ed.p2Ref, entitiesById);
        if (!P || !Q) {
          skip(ed, "measured refs do not resolve to positions");
          break;
        }
        const signed = (prop === "x" ? Q.x - P.x : Q.y - P.y) >= 0 ? ed.value : -ed.value;
        emit(ed.id, {
          type: "difference",
          param1: { o_id: pair.pA, prop },
          param2: { o_id: pair.pB, prop },
          difference: signed
        });
        break;
      }
      case "radius":
      case "diameter": {
        if (ed.value <= 0) {
          skip(ed, `${ed.type} must be > 0`);
          break;
        }
        const e = entitiesById.get(ed.entityId);
        if (!isCurve3(e)) {
          skip(ed, `${ed.type} drive needs a circle/arc entity`);
          break;
        }
        const shape = maps.entityShapes.get(e.id);
        if (typeof shape !== "string") {
          skip(ed, "curve entity not translated");
          break;
        }
        if (ed.type === "radius") {
          emit(ed.id, e.type === "circle" ? { type: "circle_radius", c_id: shape, radius: ed.value } : { type: "arc_radius", a_id: shape, radius: ed.value });
        } else {
          emit(ed.id, e.type === "circle" ? { type: "circle_diameter", c_id: shape, diameter: ed.value } : { type: "arc_diameter", a_id: shape, diameter: ed.value });
        }
        break;
      }
      case "angle": {
        if (!Array.isArray(ed.ids) || ed.ids.length < 2) {
          skip(ed, "angle drive needs two operands");
          break;
        }
        const rec = { ids: ed.ids, segs: ed.segs };
        const l1 = segLineId(rec, 0, maps, entitiesById);
        const l2 = segLineId(rec, 1, maps, entitiesById);
        const s1 = segGeom(rec, 0, entitiesById);
        const s2 = segGeom(rec, 1, entitiesById);
        if (!l1 || !l2 || !s1 || !s2) {
          skip(ed, "operand segment not translated");
          break;
        }
        if (l1 === l2) {
          skip(ed, "both operands are the same segment");
          break;
        }
        const target = directedAngleTargetDeg(s1, s2, ed.value);
        emit(ed.id, { type: "l2l_angle_ll", l1_id: l1, l2_id: l2, angle: target * D2R2 });
        break;
      }
      default:
        skip(ed, `unknown dimension drive type '${ed.type}'`);
    }
  }
  return { primitives, unmapped, gcsToOurs, nextId: alloc.value() };
}
function makeAllocator(start, who) {
  if (!Number.isFinite(start)) {
    throw new Error(`${who}: id counter missing \u2014 pass maps.nextId from translateDoc (or opts.startId)`);
  }
  let counter = start;
  return {
    next: () => String(counter++),
    value: () => counter
  };
}

// src/solver/applyResult.js
var SOLVER_WRITE_BACK_TOL = 1e-4;
var DIST_TOL3 = SOLVER_WRITE_BACK_TOL;
var R2D = 180 / Math.PI;
function applyResult(doc, solved, maps, opts = {}) {
  const tol = opts.tol ?? DIST_TOL3;
  const warnings = opts.warnings;
  const entities = doc && Array.isArray(doc.entities) ? doc.entities : [];
  const { slotToPoint, entityShapes, arcs } = maps;
  const near = (a, b) => Math.abs(a - b) <= tol;
  const warn = (entityId, reason) => {
    if (warnings) warnings.push({ entityId, reason });
  };
  const slotPt = (entityId, slot) => {
    const gid = slotToPoint.get(`${entityId}#${slot}`);
    return gid == null ? null : solved.point(gid);
  };
  const rebuildLine = (e) => {
    const a = slotPt(e.id, "p0");
    const b = slotPt(e.id, "p1");
    if (!a || !b) return e;
    if (near(e.x1, a.x) && near(e.y1, a.y) && near(e.x2, b.x) && near(e.y2, b.y)) return e;
    return { ...e, x1: a.x, y1: a.y, x2: b.x, y2: b.y };
  };
  const rebuildPolyline = (e) => {
    const n = Array.isArray(e.points) ? e.points.length : 0;
    const solvedPts = [];
    for (let i = 0; i < n; i++) {
      const p = slotPt(e.id, "v" + i);
      if (!p) return e;
      solvedPts.push(p);
    }
    const same = e.points.every((p, i) => near(p.x, solvedPts[i].x) && near(p.y, solvedPts[i].y));
    if (same) return e;
    return { ...e, points: solvedPts.map((p) => ({ x: p.x, y: p.y })) };
  };
  const rebuildRectangle = (e) => {
    const c = [slotPt(e.id, "v0"), slotPt(e.id, "v1"), slotPt(e.id, "v2"), slotPt(e.id, "v3")];
    if (c.some((p) => !p)) return e;
    const xs = c.map((p) => p.x);
    const ys = c.map((p) => p.y);
    const minX = Math.min(...xs), maxX = Math.max(...xs);
    const minY = Math.min(...ys), maxY = Math.max(...ys);
    const width = maxX - minX, height = maxY - minY;
    const perfect = near(c[0].x, minX) && near(c[0].y, minY) && near(c[1].x, maxX) && near(c[1].y, minY) && near(c[2].x, maxX) && near(c[2].y, maxY) && near(c[3].x, minX) && near(c[3].y, maxY);
    if (!perfect) warn(e.id, "rectangle corners are not axis-aligned after solve; wrote nearest AABB");
    if (near(e.x, minX) && near(e.y, minY) && near(e.width, width) && near(e.height, height)) return e;
    return { ...e, x: minX, y: minY, width, height };
  };
  const rebuildCircle = (e) => {
    const c = slotPt(e.id, "c");
    if (!c) return e;
    const shape = solved.shape(entityShapes.get(e.id));
    const r = shape && Number.isFinite(shape.radius) ? shape.radius : e.r;
    if (near(e.cx, c.x) && near(e.cy, c.y) && near(e.r, r)) return e;
    return { ...e, cx: c.x, cy: c.y, r };
  };
  const rebuildArc = (e) => {
    const info = arcs.get(e.id);
    const c = slotPt(e.id, "c");
    if (!info || !c) return e;
    const shape = solved.shape(info.arc);
    if (!shape) return e;
    const r = Number.isFinite(shape.radius) ? shape.radius : e.r;
    const startAngle = Number.isFinite(shape.start_angle) ? shape.start_angle * R2D : e.startAngle;
    const endAngle = Number.isFinite(shape.end_angle) ? shape.end_angle * R2D : e.endAngle;
    if (near(e.cx, c.x) && near(e.cy, c.y) && near(e.r, r) && near(e.startAngle, startAngle) && near(e.endAngle, endAngle)) return e;
    return { ...e, cx: c.x, cy: c.y, r, startAngle, endAngle };
  };
  let changed = false;
  const nextEntities = entities.map((e) => {
    if (!e || !entityShapes.has(e.id)) return e;
    let rebuilt;
    switch (e.type) {
      case "line":
        rebuilt = rebuildLine(e);
        break;
      case "polyline":
        rebuilt = rebuildPolyline(e);
        break;
      case "rectangle":
        rebuilt = rebuildRectangle(e);
        break;
      case "circle":
        rebuilt = rebuildCircle(e);
        break;
      case "arc":
        rebuilt = rebuildArc(e);
        break;
      default:
        rebuilt = e;
    }
    if (rebuilt !== e) changed = true;
    return rebuilt;
  });
  if (!changed) return doc;
  return { ...doc, entities: nextEntities };
}

// src/solver/gcsModule.js
var SOLVER_MAX_ITERATIONS = 100;
var SolverNotReadyError = class extends Error {
  constructor(message = "planegcs solver is not initialised \u2014 await initSolver() first") {
    super(message);
    this.name = "SolverNotReadyError";
  }
};
var initPromise = null;
var wrapper = null;
function initSolver(opts = {}) {
  if (initPromise) return initPromise;
  const { wasmPath } = opts;
  initPromise = (async () => {
    const { make_gcs_wrapper } = await import("@salusoft89/planegcs");
    const w = await make_gcs_wrapper(wasmPath);
    w.set_max_iterations(SOLVER_MAX_ITERATIONS);
    wrapper = w;
    return w;
  })();
  initPromise.catch(() => {
    initPromise = null;
    wrapper = null;
  });
  return initPromise;
}
function getWrapper() {
  if (!wrapper) throw new SolverNotReadyError();
  return wrapper;
}
function isSolverReady() {
  return wrapper !== null;
}

// src/solver/solve.js
var SOLVE_SUCCESS = 0;
var SOLVE_CONVERGED = 1;
function solveParametric(doc, opts = {}) {
  if (!isSolverReady()) {
    return {
      doc,
      status: "solver_unavailable",
      conflicting: [],
      redundant: [],
      dof: null,
      unmapped: [],
      warnings: [],
      raw: null
    };
  }
  const wrapper2 = getWrapper();
  const t = translateDoc(doc, { fixedSlotKeys: opts.fixedSlotKeys, mergeCoincident: true });
  const warnings = [...t.warnings];
  const byId2 = new Map((doc && doc.entities || []).map((e) => [e.id, e]));
  const mc = mapConstraints(doc && doc.constraints || [], t.maps, byId2);
  const md = mapDimensionDrives(opts.dimensionEdits || [], t.maps, byId2, { startId: mc.nextId });
  const unmapped = [...mc.unmapped, ...md.unmapped];
  const fixedPointIds = /* @__PURE__ */ new Set();
  for (const p of t.primitives) if (p.type === "point" && p.fixed) fixedPointIds.add(p.id);
  const dragPrims = [];
  let dragCounter = md.nextId;
  for (const d of opts.dragTargets || []) {
    if (!d || typeof d.slotKey !== "string" || !Number.isFinite(d.x) || !Number.isFinite(d.y)) {
      warnings.push({ slotKey: d && d.slotKey, reason: "malformed drag target (needs slotKey + finite x,y)" });
      continue;
    }
    const pid = t.maps.slotToPoint.get(d.slotKey);
    if (!pid) {
      warnings.push({ slotKey: d.slotKey, reason: "drag target does not resolve to a gcs point" });
      continue;
    }
    if (fixedPointIds.has(pid)) {
      warnings.push({ slotKey: d.slotKey, reason: "drag target is fixed \u2014 fixed wins, drag dropped" });
      continue;
    }
    dragPrims.push({ id: String(dragCounter++), type: "coordinate_x", p_id: pid, x: d.x, temporary: true });
    dragPrims.push({ id: String(dragCounter++), type: "coordinate_y", p_id: pid, y: d.y, temporary: true });
  }
  if (!t.primitives.length) {
    return {
      doc,
      status: unmapped.length ? "solved_partial" : "solved",
      conflicting: [],
      redundant: [],
      dof: 0,
      unmapped,
      warnings,
      raw: null
    };
  }
  const gcsToOurs = new Map([...mc.gcsToOurs, ...md.gcsToOurs]);
  const internalOwner = /* @__PURE__ */ new Map();
  for (const [rectId, ruleIds] of t.maps.rectRules) for (const rid of ruleIds) internalOwner.set(rid, rectId);
  for (const [arcId, info] of t.maps.arcs) internalOwner.set(info.arcRules, arcId);
  const toOurIds = (gcsIds) => {
    const out = [];
    const seen = /* @__PURE__ */ new Set();
    for (const gid of gcsIds) {
      const our = gcsToOurs.get(gid) ?? internalOwner.get(gid);
      if (our != null && !seen.has(our)) {
        seen.add(our);
        out.push(our);
      }
    }
    return out;
  };
  try {
    wrapper2.clear_data();
    wrapper2.push_primitives_and_params([...t.primitives, ...mc.primitives, ...md.primitives, ...dragPrims]);
    const solveStatus = wrapper2.solve(opts.algorithm);
    const rawConflicting = wrapper2.get_gcs_conflicting_constraints();
    const rawRedundant = wrapper2.get_gcs_redundant_constraints();
    const rawPartiallyRedundant = wrapper2.get_gcs_partially_redundant_constraints();
    const dof = wrapper2.gcs.dof();
    const raw = {
      solveStatus,
      conflicting: rawConflicting,
      redundant: rawRedundant,
      partiallyRedundant: rawPartiallyRedundant
    };
    const conflicting = toOurIds(rawConflicting);
    const redundant = toOurIds([...rawRedundant, ...rawPartiallyRedundant]);
    const fail2 = (status) => ({ doc, status, conflicting, redundant, dof, unmapped, warnings, raw });
    if (rawConflicting.length) return fail2("conflicting");
    if (solveStatus !== SOLVE_SUCCESS && solveStatus !== SOLVE_CONVERGED) return fail2("not_converged");
    wrapper2.apply_solution();
    const solved = {
      point: (id) => wrapper2.sketch_index.get_sketch_point(id),
      shape: (id) => wrapper2.sketch_index.get_primitive(id)
    };
    const nextDoc = applyResult(doc, solved, t.maps, { tol: opts.tol, warnings });
    const unmappedIds = new Set(mc.unmapped.map((u) => u.constraint && u.constraint.id));
    const solvedById = new Map(nextDoc.entities.map((e) => [e.id, e]));
    const checkOpts = opts.tol != null ? { tol: opts.tol } : void 0;
    const violated = [];
    for (const c of doc && doc.constraints || []) {
      if (!c || unmappedIds.has(c.id)) continue;
      const res = checkConstraint(c, solvedById, checkOpts);
      if (!res.ok && !res.missing) violated.push(c.id);
    }
    if (violated.length) {
      raw.violatedAfterSolve = violated;
      return {
        doc,
        status: "not_converged",
        // The ids the solver could not actually satisfy ARE the red-flag payload.
        conflicting: [.../* @__PURE__ */ new Set([...conflicting, ...violated])],
        redundant,
        dof,
        unmapped,
        warnings,
        raw
      };
    }
    return {
      doc: nextDoc,
      status: redundant.length || unmapped.length ? "solved_partial" : "solved",
      conflicting,
      redundant,
      dof,
      unmapped,
      warnings,
      raw
    };
  } catch (err) {
    return {
      doc,
      status: "solver_failed",
      conflicting: [],
      redundant: [],
      dof: null,
      unmapped,
      warnings: [...warnings, { reason: "the solver aborted mid-solve", error: String(err && err.message || err) }],
      raw: null
    };
  } finally {
    try {
      wrapper2.clear_data();
    } catch {
    }
  }
}

// src/solver/flags.js
var useGcs = true;
function setUseGcsSolver(on) {
  useGcs = !!on;
}
function useGcsSolver() {
  return useGcs;
}

// src/solver/index.js
function entitySlotKeys(e) {
  if (!e) return [];
  if (e.type === "line") return [`${e.id}#p0`, `${e.id}#p1`];
  if (e.type === "polyline" && Array.isArray(e.points)) return e.points.map((_, i) => `${e.id}#v${i}`);
  if (e.type === "circle" || e.type === "arc") return [`${e.id}#c`];
  if (e.type === "rectangle") return [`${e.id}#v0`, `${e.id}#v1`, `${e.id}#v2`, `${e.id}#v3`];
  return [];
}
function slotPositions(e) {
  if (!e) return null;
  if (e.type === "line") return [{ x: e.x1, y: e.y1 }, { x: e.x2, y: e.y2 }];
  if (e.type === "polyline" && Array.isArray(e.points)) return e.points.map((p) => ({ x: p.x, y: p.y }));
  if (e.type === "circle" || e.type === "arc") return [{ x: e.cx, y: e.cy }];
  if (e.type === "rectangle") {
    return [
      { x: e.x, y: e.y },
      { x: e.x + e.width, y: e.y },
      { x: e.x + e.width, y: e.y + e.height },
      { x: e.x, y: e.y + e.height }
    ];
  }
  return null;
}
function movedSlotKeys(e, prev) {
  const all = entitySlotKeys(e);
  if (!prev || prev.type !== e.type) return all;
  const cur = slotPositions(e);
  const old = slotPositions(prev);
  if (!cur || !old || cur.length !== old.length) return all;
  const moved = [];
  for (let i = 0; i < cur.length; i++) {
    if (Math.abs(cur[i].x - old[i].x) > 1e-9 || Math.abs(cur[i].y - old[i].y) > 1e-9) moved.push(all[i]);
  }
  return moved.length ? moved : all;
}
function dimensionEditGrounding(record, byId2) {
  if (!record || !byId2) return [];
  if (record.type === "distance" || record.type === "distanceX" || record.type === "distanceY") {
    const key = refToSlotKey(record.p1Ref, byId2);
    return key ? [key] : [];
  }
  if (record.type === "radius" || record.type === "diameter") {
    const e = byId2.get(record.entityId);
    return e && (e.type === "circle" || e.type === "arc") ? [`${e.id}#c`] : [];
  }
  if (record.type === "angle") {
    const a = byId2.get((record.ids || [])[0]);
    return a && a.type === "line" ? [`${a.id}#p0`, `${a.id}#p1`] : [];
  }
  return [];
}
function lockedGroundingFor(ids, byId2) {
  const out = [];
  for (const id of ids || []) {
    const e = byId2.get(id);
    if (!e) continue;
    for (const key of entitySlotKeys(e)) out.push(key);
    if ((e.type === "circle" || e.type === "arc") && Number.isFinite(e.r) && e.r > 0) {
      out.push({ id: `${id}#r`, type: "radius", entityId: id, value: e.r });
    }
  }
  return out;
}
function lockedGrounding(doc, byIdIn) {
  const ids = lockedEntityIds(doc);
  if (!ids.length) return { fixedSlotKeys: [], dimensionEdits: [] };
  const byId2 = byIdIn || new Map((doc.entities || []).map((e) => [e.id, e]));
  const fixedSlotKeys = [];
  const dimensionEdits = [];
  for (const g of lockedGroundingFor(ids, byId2)) {
    if (typeof g === "string") fixedSlotKeys.push(g);
    else dimensionEdits.push(g);
  }
  return { fixedSlotKeys, dimensionEdits };
}
var warnedUnavailable = false;
var warnedFailed = false;
function deriveCompatSolveOpts(doc, seedIds, opts = {}) {
  const constraints = doc && doc.constraints || [];
  if (!constraints.length || !seedIds || !seedIds.length) return null;
  const byId2 = new Map(doc.entities.map((e) => [e.id, e]));
  const seedSet = new Set(seedIds.filter((id) => byId2.has(id)));
  if (!seedSet.size) return null;
  const fixed = /* @__PURE__ */ new Set();
  if (opts.anchors && opts.anchors.length) {
    for (const ref of opts.anchors) {
      const key = refToSlotKey(ref, byId2);
      if (key) fixed.add(key);
    }
  } else {
    const beforeById = opts.before && Array.isArray(opts.before.entities) ? new Map(opts.before.entities.map((e) => [e.id, e])) : null;
    for (const id of seedSet) {
      const e = byId2.get(id);
      const prev = beforeById ? beforeById.get(id) : null;
      for (const key of movedSlotKeys(e, prev)) fixed.add(key);
    }
  }
  const dimensionEdits = [];
  for (const id of seedSet) {
    const e = byId2.get(id);
    if (e && (e.type === "circle" || e.type === "arc") && Number.isFinite(e.r) && e.r > 0) {
      dimensionEdits.push({ id: `${id}#r`, type: "radius", entityId: id, value: e.r });
    }
  }
  if (!fixed.size && !dimensionEdits.length) return null;
  for (const e of doc.entities) {
    if (e && e.type === "rectangle") for (const key of entitySlotKeys(e)) fixed.add(key);
  }
  for (const g of lockedGroundingFor(opts.fixedIds, byId2)) {
    if (typeof g === "string") fixed.add(g);
    else dimensionEdits.push(g);
  }
  return { fixedSlotKeys: fixed, dimensionEdits };
}
function solveConstraintsCompat(doc, seedIds, opts = {}) {
  const derived = deriveCompatSolveOpts(doc, seedIds, opts);
  if (!derived) return doc;
  if (!isSolverReady()) {
    if (!warnedUnavailable) {
      warnedUnavailable = true;
      console.warn("[cad-engine] planegcs solver not initialised \u2014 falling back to the legacy projection solver. Call initSolver() at app bootstrap.");
    }
    return solveConstraints(doc, seedIds, opts);
  }
  const res = solveParametric(doc, { ...derived, tol: opts.tol });
  if (res.status === "solved" || res.status === "solved_partial") return res.doc;
  if (res.status === "solver_failed" && !warnedFailed) {
    warnedFailed = true;
    console.warn("[cad-engine] the planegcs solver ABORTED mid-solve (out of memory or a kernel fault) \u2014 falling back to the legacy projection solver. Geometry is still solved, but parametric relations may be only partially applied.");
  }
  return solveConstraints(doc, seedIds, opts);
}

// src/diffDocuments.ts
function drawingSettings(s) {
  const out = {};
  for (const k of DRAWING_SETTINGS_KEYS) if (s && k in s) out[k] = s[k];
  return out;
}
function isPlainObject(v) {
  return typeof v === "object" && v !== null && !Array.isArray(v);
}
function deepEqual(a, b) {
  if (a === b) return true;
  if (typeof a === "number" && typeof b === "number") {
    return Number.isNaN(a) && Number.isNaN(b);
  }
  if (a === null || b === null || typeof a !== "object" || typeof b !== "object") {
    return false;
  }
  if (Array.isArray(a) || Array.isArray(b)) {
    if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) if (!deepEqual(a[i], b[i])) return false;
    return true;
  }
  const ak = Object.keys(a);
  const bk = Object.keys(b);
  if (ak.length !== bk.length) return false;
  for (const k of ak) {
    if (!Object.prototype.hasOwnProperty.call(b, k)) return false;
    if (!deepEqual(a[k], b[k])) return false;
  }
  return true;
}
function changedFields(a, b) {
  if (isPlainObject(a) && isPlainObject(b)) {
    const keys = /* @__PURE__ */ new Set();
    for (const k of Object.keys(a)) if (!k.startsWith("_")) keys.add(k);
    for (const k of Object.keys(b)) if (!k.startsWith("_")) keys.add(k);
    const out = [];
    for (const k of keys) if (!deepEqual(a[k], b[k])) out.push(k);
    return out.sort();
  }
  return deepEqual(a, b) ? [] : ["*"];
}
function byKey(items, keyOf3) {
  const m = /* @__PURE__ */ new Map();
  for (const it of items) m.set(keyOf3(it), it);
  return m;
}
function diffEntities(a, b) {
  const am = byKey(a, (e) => String(e.id));
  const bm = byKey(b, (e) => String(e.id));
  const added = [];
  const removed = [];
  const modified = [];
  for (const id of bm.keys()) if (!am.has(id)) added.push(id);
  for (const [id, av] of am) {
    const bv = bm.get(id);
    if (bv === void 0) {
      removed.push(id);
      continue;
    }
    const cf = changedFields(av, bv);
    if (cf.length) modified.push({ id, changedFields: cf });
  }
  added.sort();
  removed.sort();
  modified.sort((x, y) => x.id < y.id ? -1 : x.id > y.id ? 1 : 0);
  return { added, removed, modified };
}
function diffKeyed(am, bm) {
  const added = [];
  const removed = [];
  const modified = [];
  for (const key of bm.keys()) if (!am.has(key)) added.push(key);
  for (const [key, av] of am) {
    if (!bm.has(key)) {
      removed.push(key);
      continue;
    }
    const cf = changedFields(av, bm.get(key));
    if (cf.length) modified.push({ key, changedFields: cf });
  }
  added.sort();
  removed.sort();
  modified.sort((x, y) => x.key < y.key ? -1 : x.key > y.key ? 1 : 0);
  return { added, removed, modified };
}
function diffArray(a, b, keyOf3) {
  return diffKeyed(byKey(a ?? [], keyOf3), byKey(b ?? [], keyOf3));
}
function diffRecord(a, b) {
  return diffKeyed(new Map(Object.entries(a ?? {})), new Map(Object.entries(b ?? {})));
}
function diffDocuments(a, b) {
  const entities = diffEntities(a.entities ?? [], b.entities ?? []);
  return {
    entities,
    layers: diffArray(a.layers ?? [], b.layers ?? [], (l) => String(l.name)),
    layouts: diffArray(a.layouts ?? [], b.layouts ?? [], (l) => String(l.id)),
    namedViews: diffArray(a.namedViews ?? [], b.namedViews ?? [], (v) => String(v.id)),
    blockDefs: diffRecord(a.blockDefs ?? {}, b.blockDefs ?? {}),
    xrefDefs: diffRecord(a.xrefDefs ?? {}, b.xrefDefs ?? {}),
    // A 1 MB base64 string compares by POINTER first (deepEqual short-circuits on
    // ===), so an unchanged def costs nothing here even at N images.
    imageDefs: diffRecord(a.imageDefs ?? {}, b.imageDefs ?? {}),
    dimStyleDefs: diffRecord(a.dimStyleDefs ?? {}, b.dimStyleDefs ?? {}),
    linetypeDefs: diffRecord(a.linetypeDefs ?? {}, b.linetypeDefs ?? {}),
    settings: diffRecord(drawingSettings(a.settings), drawingSettings(b.settings)),
    georef: diffRecord(a.georef ?? {}, b.georef ?? {}),
    counts: {
      added: entities.added.length,
      removed: entities.removed.length,
      modified: entities.modified.length
    }
  };
}

// src/threeWayDiff.ts
var ARRAY_SECTIONS = {
  layers: "name",
  layouts: "id",
  namedViews: "id",
  constraints: "id"
};
var RECORD_SECTIONS = [
  "linetypeDefs",
  "dimStyleDefs",
  "textStyleDefs",
  "blockDefs",
  "xrefDefs",
  // [RASTER-IMAGE-1] Whole-record LWW is CORRECT for image defs, unlike `layouts`
  // which had to nest to the field (VP-LOCK-1). A def is WRITE-ONCE: no field of
  // one can be edited, so two peers can only ever add or remove a whole def, and
  // there is no field-level race for nesting to protect against. The PLACEMENT —
  // the thing people actually edit concurrently — lives on the entity, which is
  // already per-entity.
  "imageDefs",
  "settings"
];
var GEOREF_SECTION = "georef";
var SECTION_KEYS = [
  ...Object.keys(ARRAY_SECTIONS),
  ...RECORD_SECTIONS
];
var isArraySection = (s) => Object.prototype.hasOwnProperty.call(ARRAY_SECTIONS, s);
function sectionConflictId(section, key) {
  return `${section}:${key}`;
}
function byId(entities) {
  const m = /* @__PURE__ */ new Map();
  for (const e of entities ?? []) m.set(String(e.id), e);
  return m;
}
function sameEntity(x, y) {
  if (x === null || y === null) return x === y;
  return changedFields(x, y).length === 0;
}
function touchedIds(base, x) {
  const out = /* @__PURE__ */ new Set();
  for (const [id, xv] of x) {
    const bv = base.get(id);
    if (bv === void 0 || !sameEntity(bv, xv)) out.add(id);
  }
  for (const id of base.keys()) if (!x.has(id)) out.add(id);
  return out;
}
var INDELIBLE = {
  linetypeDefs: (k) => Object.prototype.hasOwnProperty.call(LINETYPE_DEFS, k),
  blockDefs: (k) => Object.prototype.hasOwnProperty.call(GEOTECH_BLOCKS, k),
  dimStyleDefs: (k) => k === "Standard",
  textStyleDefs: (k) => k === "Standard",
  layouts: (k) => k === "model",
  // EVERY settings field: `normalizeSettings` rebuilds the header from a fixed whitelist
  // on load, so a field is never really absent and its absence on a branch is never a
  // deletion. Without this, a snapshot saved before a field existed would read as "that
  // branch deleted it" against a branch that has it.
  settings: () => true
};
var MERGEABLE = {
  settings: isDrawingSetting
};
function memberKey(section, member) {
  if (!member || typeof member !== "object" || Array.isArray(member)) return null;
  const k = member[ARRAY_SECTIONS[section]];
  return typeof k === "string" || typeof k === "number" ? String(k) : null;
}
function sectionMap(doc, section) {
  const raw = doc?.[section];
  if (raw == null) return null;
  if (isArraySection(section)) {
    if (!Array.isArray(raw)) return null;
    const m = /* @__PURE__ */ new Map();
    for (const member of raw) {
      const key = memberKey(section, member);
      if (key !== null) m.set(key, member);
    }
    return m;
  }
  if (typeof raw !== "object" || Array.isArray(raw)) return null;
  return new Map(Object.entries(raw));
}
function sameMember(x, y) {
  if (x === void 0 || y === void 0) return x === y;
  return changedFields(x, y).length === 0;
}
function classifySections(ancestor, a, b) {
  const cleanSections = [];
  const sectionConflicts = [];
  for (const section of SECTION_KEYS) {
    const am = sectionMap(a, section);
    if (am === null) continue;
    const base = sectionMap(ancestor, section) ?? /* @__PURE__ */ new Map();
    const bm = sectionMap(b, section);
    if (bm === null) {
      for (const key of am.keys()) {
        if (!isArraySection(section) && !isSafeStyleName(key)) continue;
        if (MERGEABLE[section] && !MERGEABLE[section](key)) continue;
        cleanSections.push({ section, key, op: "set" });
      }
      continue;
    }
    for (const key of /* @__PURE__ */ new Set([...base.keys(), ...am.keys()])) {
      if (!isArraySection(section) && !isSafeStyleName(key)) continue;
      if (MERGEABLE[section] && !MERGEABLE[section](key)) continue;
      const av = am.get(key);
      const basev = base.get(key);
      if (av === void 0 && INDELIBLE[section]?.(key)) continue;
      if (sameMember(av, basev)) continue;
      const bv = bm.get(key);
      if (!sameMember(bv, basev)) {
        if (!sameMember(av, bv)) {
          sectionConflicts.push({
            section,
            key,
            kind: basev === void 0 ? "add/add" : av === void 0 || bv === void 0 ? "modify/delete" : "modify/modify",
            ancestor: basev ?? null,
            a: av ?? null,
            b: bv ?? null
          });
        }
        continue;
      }
      cleanSections.push({ section, key, op: av === void 0 ? "delete" : "set" });
    }
  }
  {
    const baseG = normalizeGeoref(ancestor?.georef ?? null);
    const aG = normalizeGeoref(a?.georef ?? null);
    const bG = normalizeGeoref(b?.georef ?? null);
    const aSilent = aG === null && baseG === null;
    if (!aSilent && !sameGeoref(aG, baseG)) {
      if (!sameGeoref(bG, baseG)) {
        if (!sameGeoref(aG, bG)) {
          sectionConflicts.push({
            section: GEOREF_SECTION,
            key: GEOREF_SECTION,
            kind: baseG === null ? "add/add" : aG === null || bG === null ? "modify/delete" : "modify/modify",
            ancestor: baseG,
            a: aG,
            b: bG
          });
        }
      } else {
        cleanSections.push({
          section: GEOREF_SECTION,
          key: GEOREF_SECTION,
          op: aG === null ? "delete" : "set"
        });
      }
    }
  }
  const bySectionThenKey = (x, y) => x.section < y.section ? -1 : x.section > y.section ? 1 : x.key < y.key ? -1 : x.key > y.key ? 1 : 0;
  cleanSections.sort(bySectionThenKey);
  sectionConflicts.sort(bySectionThenKey);
  return { cleanSections, sectionConflicts };
}
function threeWayDiff(ancestor, a, b) {
  const base = byId(ancestor.entities);
  const am = byId(a.entities);
  const bm = byId(b.entities);
  const touchedA = touchedIds(base, am);
  const touchedB = touchedIds(base, bm);
  const cleanFromA = [];
  const conflicts = [];
  for (const id of touchedA) {
    if (!touchedB.has(id)) {
      cleanFromA.push(id);
      continue;
    }
    const av = am.get(id) ?? null;
    const bv = bm.get(id) ?? null;
    if (sameEntity(av, bv)) continue;
    const baseEnt = base.get(id) ?? null;
    const kind = baseEnt === null ? "add/add" : av === null || bv === null ? "modify/delete" : "modify/modify";
    conflicts.push({ id, kind, ancestor: baseEnt, a: av, b: bv });
  }
  cleanFromA.sort();
  conflicts.sort((x, y) => x.id < y.id ? -1 : x.id > y.id ? 1 : 0);
  const { cleanSections, sectionConflicts } = classifySections(ancestor, a, b);
  return {
    cleanFromA,
    conflicts,
    cleanSections,
    sectionConflicts,
    counts: {
      clean: cleanFromA.length,
      conflicts: conflicts.length,
      cleanSections: cleanSections.length
    }
  };
}
var clone = (v) => JSON.parse(JSON.stringify(v));
function applySectionChanges(out, a, changes) {
  for (const ch of changes) {
    if (ch.section !== GEOREF_SECTION) continue;
    out.georef = ch.op === "delete" ? null : clone(normalizeGeoref(a.georef ?? null));
  }
  for (const section of SECTION_KEYS) {
    const forSection = changes.filter((c) => c.section === section);
    if (!forSection.length) continue;
    const am = sectionMap(a, section);
    if (am === null) continue;
    if (isArraySection(section)) {
      let list = Array.isArray(out[section]) ? [...out[section]] : [];
      for (const ch of forSection) {
        const i = list.findIndex((m) => memberKey(section, m) === ch.key);
        if (ch.op === "delete") {
          if (i >= 0) list = list.filter((m) => memberKey(section, m) !== ch.key);
        } else if (i >= 0) {
          list[i] = clone(am.get(ch.key));
        } else {
          list.push(clone(am.get(ch.key)));
        }
      }
      out[section] = list;
    } else {
      const cur = out[section];
      const rec = cur && typeof cur === "object" && !Array.isArray(cur) ? { ...cur } : {};
      for (const ch of forSection) {
        if (ch.op === "delete") delete rec[ch.key];
        else rec[ch.key] = clone(am.get(ch.key));
      }
      out[section] = rec;
    }
  }
}
function applyMergeResolution(b, a, result, resolutions, sectionResolutions = {}) {
  const am = byId(a.entities);
  const out = clone(b);
  const ents = byId(out.entities);
  for (const id of result.cleanFromA) {
    const av = am.get(id);
    if (av === void 0)
      ents.delete(id);
    else ents.set(id, clone(av));
  }
  for (const c of result.conflicts) {
    const res = resolutions[c.id] ?? "b";
    if (res === "b") continue;
    if (res === "a") {
      if (c.a === null) ents.delete(c.id);
      else ents.set(c.id, clone(c.a));
      continue;
    }
    if (c.a !== null) {
      const copy = clone(c.a);
      copy.id = genId();
      ents.set(copy.id, copy);
    }
  }
  out.entities = Array.from(ents.values());
  const sectionChanges = [...result.cleanSections ?? []];
  for (const c of result.sectionConflicts ?? []) {
    if ((sectionResolutions[sectionConflictId(c.section, c.key)] ?? "b") !== "a") continue;
    sectionChanges.push({ section: c.section, key: c.key, op: c.a === null ? "delete" : "set" });
  }
  applySectionChanges(out, a, sectionChanges);
  return normalizeDocument(out);
}

// src/cadMeasure.js
function measureDistance(p1, p2) {
  const dx = p2.x - p1.x;
  const dy = p2.y - p1.y;
  const distance2 = Math.hypot(dx, dy);
  let angle = Math.atan2(dy, dx) * 180 / Math.PI;
  if (angle < 0) angle += 360;
  return { type: "distance", distance: distance2, angle, dx, dy };
}
function measureArea(points) {
  if (!points || points.length < 3) return { type: "area", area: 0, perimeter: 0 };
  let twiceArea = 0;
  let perimeter = 0;
  const n = points.length;
  for (let i = 0; i < n; i++) {
    const a = points[i];
    const b = points[(i + 1) % n];
    twiceArea += a.x * b.y - b.x * a.y;
    perimeter += Math.hypot(b.x - a.x, b.y - a.y);
  }
  return { type: "area", area: Math.abs(twiceArea) / 2, perimeter };
}
function smallerNonRegionFace(entities, point, limit) {
  const others = (entities || []).filter((e) => e && e.type !== "region");
  if (!others.length) return false;
  const choice = chooseHatchBoundary(others, point);
  if (!choice) return false;
  const ring = choice.ids ? boundaryFromEntities(others.filter((e) => choice.ids.includes(e.id))) : choice.polygon;
  if (!ring || ring.length < 3) return false;
  return polygonArea(ring) < limit;
}
function measureAreaAt(entities, point) {
  const hit = (entities || []).filter((e) => e && e.type === "region" && regionFillsPoint(e, point)).sort((a, b) => regionArea(a) - regionArea(b))[0];
  if (hit && !smallerNonRegionFace(entities, point, regionArea(hit))) {
    const rings2 = regionRings(hit);
    const perimeter2 = rings2.reduce((sum, ring2) => {
      let p = 0;
      for (let i = 0, n = ring2.length; i < n; i++) {
        const a = ring2[i];
        const b = ring2[(i + 1) % n];
        p += Math.hypot(b.x - a.x, b.y - a.y);
      }
      return sum + p;
    }, 0);
    return { type: "area", area: regionArea(hit), perimeter: perimeter2, islands: rings2.length - 1 };
  }
  const choice = chooseHatchBoundary(entities, point);
  if (!choice) return null;
  const ring = choice.ids ? boundaryFromEntities(entities.filter((e) => choice.ids.includes(e.id))) : choice.polygon;
  if (!ring || ring.length < 3) return null;
  const excludeIds = choice.ids || choice.sourceIds || [];
  const islands = findHatchIslands(entities, ring, { excludeIds, point });
  if (!islands.length) {
    if (choice.ids) {
      const ents = entities.filter((e) => choice.ids.includes(e.id));
      if (ents.length === 1 && ents[0].type === "circle") {
        const r = ents[0].r;
        return { type: "area", area: Math.PI * r * r, perimeter: 2 * Math.PI * r, islands: 0 };
      }
    }
    return { ...measureArea(ring), islands: 0 };
  }
  const rings = islands.map((i) => i.ring);
  const perimeter = [ring, ...rings].reduce((total, r) => total + measureArea(r).perimeter, 0);
  return { type: "area", area: paintedArea(ring, rings), perimeter, islands: rings.length };
}
function precisionOf(units) {
  if (typeof units === "number" && Number.isInteger(units)) return units;
  if (units && Number.isInteger(units.precision)) return units.precision;
  return 2;
}
function formatMeasureResult(result, units) {
  if (!result) return "";
  const p = precisionOf(units);
  if (result.type === "distance") {
    return `Dist ${result.distance.toFixed(p)}  \u2220 ${result.angle.toFixed(1)}\xB0  \u0394X ${result.dx.toFixed(p)}  \u0394Y ${result.dy.toFixed(p)}`;
  }
  if (result.type === "area") {
    const islands = result.islands ? `  (\u2212${result.islands} island${result.islands > 1 ? "s" : ""})` : "";
    return `Area ${result.area.toFixed(p)}  Perimeter ${result.perimeter.toFixed(p)}${islands}`;
  }
  return "";
}

// src/dxfImport.js
import DxfParser from "dxf-parser/dist/dxf-parser.js";

// src/cadImportGeoref.js
var NONE = (importOffset, notes = []) => ({
  status: "none",
  georef: null,
  importOffset,
  notes
});
function reconcileImportGeoref({ geodata, offset, unitScale, crsProposal } = {}) {
  const off = {
    x: Number.isFinite(offset && offset.x) ? offset.x : 0,
    y: Number.isFinite(offset && offset.y) ? offset.y : 0
  };
  const s = Number.isFinite(unitScale) && unitScale > 0 ? unitScale : 1;
  const notes = [];
  if (!geodata) return magnitudeOnly(off, crsProposal, notes);
  if (!geodata.ok) {
    const fallback = magnitudeOnly(off, crsProposal, notes);
    return {
      ...fallback,
      status: "refused",
      reason: geodata.reason,
      detail: geodata.detail
      // A proposal from magnitude may still be attached; the caller shows the refusal
      // first and the proposal second, which is the honest order.
    };
  }
  if (Math.abs(geodata.unitScale - s) > 1e-9) {
    const fallback = magnitudeOnly(off, crsProposal, notes);
    return {
      ...fallback,
      status: "refused",
      reason: "unit-scale",
      detail: `the GEODATA states a unit scale of ${geodata.unitScale} while the header states ${s}`
    };
  }
  if (geodata.coordinateType === 3) {
    const fallback = magnitudeOnly(off, crsProposal, notes);
    return {
      ...fallback,
      status: "refused",
      reason: "geographic",
      detail: `the reference point is longitude/latitude (${geodata.reference.e}, ${geodata.reference.n})`
    };
  }
  if (!geodata.crs) {
    const fallback = magnitudeOnly(off, crsProposal, notes);
    const head = String(geodata.crsDefinition || "").replace(/\s+/g, " ").trim().slice(0, 60);
    return {
      ...fallback,
      status: fallback.status === "proposed" ? "proposed" : "none",
      notes: [
        ...fallback.notes,
        head ? `this file declares a coordinate system we could not identify: "${head}\u2026"` : "this file carries a georeference with no coordinate system in it"
      ]
    };
  }
  const designMetres = { x: geodata.design.x * s, y: geodata.design.y * s };
  const originG = {
    e: geodata.reference.e - designMetres.x,
    n: geodata.reference.n - designMetres.y
  };
  const origin = { e: off.x + originG.e, n: off.y + originG.n };
  if (geodata.meshPoints > 0) {
    notes.push(
      `${geodata.meshPoints} mesh refinement point(s) in this file's georeference were ignored \u2014 the drawing is placed by a straight translation`
    );
  }
  return {
    status: "adopted",
    georef: { crs: geodata.crs, origin, basemaps: [] },
    importOffset: { x: 0, y: 0 },
    notes
  };
}
function magnitudeOnly(off, crsProposal, notes) {
  if (off.x === 0 && off.y === 0) return NONE(off, notes);
  return {
    status: "proposed",
    georef: null,
    importOffset: off,
    // kept until the user accepts; today's behaviour exactly
    proposal: {
      source: "magnitude",
      crs: crsProposal && crsProposal.crs || null,
      family: crsProposal && crsProposal.family || null,
      // 'zone-ambiguous' / 'circuit-ambiguous' means the family is clear and the member
      // is NOT derivable from coordinates — every MGA zone shares one easting band. The
      // UI must require a choice before assigning; it cannot be guessed here or anywhere.
      reason: crsProposal && crsProposal.reason || "unknown",
      origin: { e: off.x, n: off.y }
    },
    notes
  };
}
function mergeGeorefDecision({
  incoming,
  current,
  incomingShift,
  currentShift,
  currentAtGridOrigin = false,
  incomingLooksLikeGrid = null,
  incomingPlausible = null
} = {}) {
  const frameOf = (georef, shift, large = false) => {
    if (georef && georef.origin) {
      return { e: georef.origin.e, n: georef.origin.n, crs: georef.crs, declared: true, large };
    }
    const s = shift || { x: 0, y: 0 };
    const usable = Number.isFinite(s.x) && Number.isFinite(s.y);
    return { e: usable ? s.x : 0, n: usable ? s.y : 0, crs: null, declared: false, large };
  };
  const fIn = frameOf(incoming, incomingShift);
  const fCur = frameOf(current, currentShift, currentAtGridOrigin);
  const notes = [];
  const m = (v) => String(Number(v.toFixed(4)));
  if (fIn.declared && fCur.declared && fIn.crs !== fCur.crs) {
    return {
      action: "refuse",
      reason: "crs-mismatch",
      detail: { incoming: fIn.crs, current: fCur.crs },
      notes
    };
  }
  const hasFrame = (f) => f.declared || f.e !== 0 || f.n !== 0 || f.large;
  const currentHasFrame = hasFrame(fCur);
  const de = fIn.e - fCur.e;
  const dn = fIn.n - fCur.n;
  if (!hasFrame(fIn)) return { action: "merge", notes };
  if (!currentHasFrame) {
    if (fIn.declared) {
      return {
        action: "propose",
        proposal: {
          source: "geodata",
          crs: fIn.crs,
          origin: { e: fIn.e, n: fIn.n },
          reason: "unambiguous"
        },
        notes
      };
    }
    if (de !== 0 || dn !== 0) {
      notes.push(
        `this file's coordinates were shifted by E ${m(de)}, N ${m(dn)} to draw them, and the drawing has no georeference to place them against \u2014 check they landed where you expect`
      );
    }
    return { action: "merge", notes };
  }
  if (de === 0 && dn === 0) return { action: "merge", notes };
  if (incomingLooksLikeGrid === true && incomingPlausible === false && (fCur.declared || fCur.large)) {
    return {
      action: "refuse",
      reason: "crs-mismatch",
      detail: { incoming: null, current: fCur.crs, frame: { e: fIn.e, n: fIn.n } },
      notes
    };
  }
  if (incomingLooksLikeGrid === false && !fIn.declared) {
    notes.push(
      `this file's coordinates were shifted by E ${m(fIn.e)}, N ${m(fIn.n)} to draw them, and they match no coordinate system we know \u2014 check they landed where you expect`
    );
    return { action: "merge", notes };
  }
  if (fIn.declared !== fCur.declared) {
    const undeclared = fIn.declared ? "this drawing" : "that file";
    notes.push(
      `${undeclared} states no coordinate system, so its coordinates were assumed to be ${fIn.crs || fCur.crs}`
    );
  }
  notes.push(
    `the imported geometry was shifted by E ${m(de)}, N ${m(dn)} to match this drawing's origin`
  );
  const out = { action: "translate", delta: { x: de, y: dn }, notes };
  if (fIn.declared && !fCur.declared) {
    out.proposal = {
      source: "geodata",
      crs: fIn.crs,
      origin: { e: fCur.e, n: fCur.n },
      reason: "unambiguous"
    };
  }
  return out;
}

// src/cadImportBuild.js
var DIM_MIN_TEXT_FRACTION = 0.012;
var DIM_MAX_TEXT_OF_MEASURE = 0.5;
var dimStyleSizeCache = /* @__PURE__ */ new WeakMap();
function dimStyleSizes(parsed) {
  if (!parsed || typeof parsed !== "object") return {};
  const hit = dimStyleSizeCache.get(parsed);
  if (hit) return hit;
  const table = parsed.tables && parsed.tables.dimStyle && (parsed.tables.dimStyle.dimStyles || parsed.tables.dimStyle.styles) || {};
  const out = /* @__PURE__ */ Object.create(null);
  for (const name of Object.keys(table)) {
    const s = table[name] || {};
    const scale = Number.isFinite(s.DIMSCALE) && s.DIMSCALE > 0 ? s.DIMSCALE : 1;
    out[name] = {
      name,
      textHeight: Number.isFinite(s.DIMTXT) && s.DIMTXT > 0 ? s.DIMTXT * scale : 0,
      arrowSize: Number.isFinite(s.DIMASZ) && s.DIMASZ > 0 ? s.DIMASZ * scale : 0,
      unitsPrecision: Number.isFinite(s.DIMDEC) ? s.DIMDEC : void 0
    };
  }
  dimStyleSizeCache.set(parsed, out);
  return out;
}
function decodeV4cMarker(ent, ensureLayer) {
  const f = {};
  for (const part of String(ent.text).split("|")) {
    const eq = part.indexOf("=");
    if (eq > 0) f[part.slice(0, eq)] = part.slice(eq + 1);
  }
  const layer = ensureLayer(f.ly || ent.layer);
  const num5 = (k) => parseFloat(f[k]);
  const t = f.t;
  const base = { id: genId((t || "x")[0]), type: t, layer, color: null, linetype: null };
  if (t === "ray" || t === "xline")
    return { ...base, x: num5("x"), y: num5("y"), dx: num5("dx"), dy: num5("dy") };
  if (t === "revcloud") {
    const pts = (f.pts || "").split(";").filter(Boolean).map((pr) => {
      const a = pr.split(",");
      return { x: parseFloat(a[0]), y: parseFloat(a[1]) };
    });
    return { ...base, points: pts, closed: f.cl === "1", arcRadius: num5("ar") };
  }
  return null;
}
function decodeRegionMarker(ent, siblings, ensureLayer) {
  const f = {};
  for (const part of String(ent.text).split("|")) {
    const eq = part.indexOf("=");
    if (eq > 0) f[part.slice(0, eq)] = part.slice(eq + 1);
  }
  const carrierLayer = ent.layer;
  const want = parseInt(f.n, 10);
  if (!carrierLayer || !Number.isFinite(want) || want < 1) return null;
  const source = siblings || [];
  const rings = [];
  for (const other of source) {
    if (!other || other.layer !== carrierLayer) continue;
    if (other.type !== "LWPOLYLINE" && other.type !== "POLYLINE") continue;
    const pts = (other.vertices || []).map((v) => ({ x: v.x, y: v.y })).filter((p) => Number.isFinite(p.x) && Number.isFinite(p.y));
    if (pts.length >= 3) rings.push(pts);
  }
  if (rings.length !== want) return null;
  return {
    id: genId("rg"),
    type: "region",
    layer: ensureLayer(f.ly || "0"),
    color: f.co && f.co !== "null" && f.co !== "" ? f.co : null,
    linetype: f.lt && f.lt !== "null" && f.lt !== "" ? f.lt : null,
    rings
  };
}
function fontFamilyFromFile(file) {
  const base = String(file).replace(/\.[a-z0-9]+$/i, "").trim();
  if (!base) return void 0;
  return base.replace(/\b\w/g, (c) => c.toUpperCase());
}
function mapEntity(ent, ctx, parsed, depth, ensureLayer, stats, siblings) {
  if (ent.type === "TEXT" && typeof ent.text === "string" && ent.text.startsWith("V4CENT|")) {
    if (ent.text.startsWith("V4CENT|t=region")) {
      const rebuilt2 = decodeRegionMarker(ent, siblings, ensureLayer);
      return rebuilt2 ? [rebuilt2] : [];
    }
    const rebuilt = decodeV4cMarker(ent, ensureLayer);
    return rebuilt ? [rebuilt] : [];
  }
  if (ent.layer && String(ent.layer).startsWith("V4C$")) return [];
  const stated = statedExtrusion(ent);
  const inForce = ctx.ocsVec || OCS_WORLD;
  const curve = ent.type === "ARC" || ent.type === "CIRCLE";
  const redundant = stated && !curve && sameExtrusion(stated, inForce);
  const wcsPoints = ent.type === "ELLIPSE";
  const ocs = stated && !redundant && !wcsPoints ? ocsTransform(ent) : { identity: true };
  const ellipseMirror = wcsPoints && stated ? ocsTransform(ent).mirror : false;
  if (!ocs.identity) {
    ctx = ocsCtx(ctx, ocs, stated);
    if (ocs.tilted) {
      const note = `${ent.type} entities are drawn on a TILTED plane \u2014 projected to 2D, so their angles and radii are approximate`;
      if (!stats.warnings.includes(note)) stats.warnings.push(note);
    }
  }
  const ec = entityContext(ent, ctx, ensureLayer);
  const one = (e) => e ? [e] : [];
  switch (ent.type) {
    case "LINE":
      return one(mapLine(ent, ec));
    case "LWPOLYLINE":
    case "POLYLINE":
      return one(mapPolyline(ent, ec));
    case "CIRCLE":
      return one(mapCircle(ent, ec));
    case "ARC":
      return one(mapArc(ent, ec));
    case "ELLIPSE":
      return one(mapEllipse(ent, ec, { selfMirror: ellipseMirror }));
    case "TEXT":
      return one(mapText(ent, ec, false));
    case "MTEXT":
      return one(mapMText(ent, ec));
    // Spec 05: a real mtext block, no longer flattened
    case "POINT":
      return one(mapPoint(ent, ec));
    case "SOLID":
    case "3DFACE":
      return one(mapSolid(ent, ec));
    case "SPLINE":
      return one(mapSpline(ent, ec));
    case "HATCH": {
      const hatches = mapHatchRegions(ent, ec);
      const lost = Array.isArray(ent.regions) ? Math.max(0, ent.regions.length - hatches.length) + (Number(ent.droppedPaths) || 0) : hatches.length ? 0 : 1;
      if (lost) stats.skippedTypes.HATCH = (stats.skippedTypes.HATCH || 0) + lost;
      const hatch = hatches[0];
      if (!hatch) {
        return [];
      }
      return hatches;
    }
    case "INSERT": {
      const name = ent.name;
      const block = parsed.blocks && parsed.blocks[name];
      const anonymous = !name || name[0] === "*";
      if (block && block.entities && !anonymous) return one(mapInsert(ent, ec));
      if (depth > 4) return [];
      if (!block || !block.entities) return [];
      const sx = ent.xScale || 1;
      const sy = ent.yScale || 1;
      const reflects = sx * sy < 0;
      const ownRot = (ent.rotation || 0) + (sy < 0 ? 180 : 0);
      const childCtx = {
        m: matMul(ctx.m, insertMatrix(ent, block)),
        // A MAGNITUDE: every consumer uses it to size something. The sign lives in
        // `m` (where it belongs) and in `mirror` (which is what angles need).
        scale: ctx.scale * Math.abs(sx),
        // Under a mirror the insert's own rotation is applied BEFORE the reflection
        // (M·R(θ) = R(−θ)·M), so it SUBTRACTS from the accumulated rotation that
        // ec.ang applies after it. Adding it would rotate a mirrored block's arcs
        // and text by 2θ the wrong way while their centres sat correctly.
        rot: ctx.mirror ? ctx.rot - ownRot : ctx.rot + ownRot,
        // The reflection is a property of the MAP, so it has to descend with it —
        // otherwise a mirrored block's arcs and text come back unmirrored inside
        // correctly mirrored linework. Two reflections cancel, hence the toggle.
        mirror: reflects ? !ctx.mirror : !!ctx.mirror,
        // The block's contents live in the plane the INSERT was placed in, so one
        // that states the same normal is naming it, not asking to be transformed
        // into it again ([BUG-DWG-OCS-2]).
        ocsVec: ctx.ocsVec || OCS_WORLD
      };
      const out = [];
      for (const ce of block.entities)
        out.push(...mapEntity(ce, childCtx, parsed, depth + 1, ensureLayer, stats, block.entities));
      return out;
    }
    case "DIMENSION": {
      const block = ent.block && parsed.blocks && parsed.blocks[ent.block];
      if (block && block.entities) {
        if (depth > 4) return [];
        const out = [];
        for (const ce of block.entities) {
          for (const m of mapEntity(
            ce,
            ctx,
            parsed,
            depth + 1,
            ensureLayer,
            stats,
            block.entities
          )) {
            m.approx = true;
            out.push(m);
          }
        }
        return out;
      }
      const dimStyle = ent.dimStyleName ? dimStyleSizes(parsed)[ent.dimStyleName] : null;
      const dim = mapDimension(ent, ec, dimStyle || null);
      if (dim) return [dim];
      stats.skippedTypes.DIMENSION = (stats.skippedTypes.DIMENSION || 0) + 1;
      return [];
    }
    default:
      stats.skippedTypes[ent.type] = (stats.skippedTypes[ent.type] || 0) + 1;
      return [];
  }
}
function boundsOf(absoluteEntities) {
  const b = documentBounds(absoluteEntities);
  if (!b || !Number.isFinite(b.minX)) return { minE: 0, maxE: 0, minN: 0, maxN: 0 };
  return { minE: b.minX, maxE: b.maxX, minN: b.minY, maxN: b.maxY };
}
function pickGeodata(parsed) {
  const src = parsed && parsed.branchcadGeodata;
  if (!src || !Array.isArray(src.records) || src.records.length === 0) return null;
  const read = src.records.map((r) => readGeodata(r.pairs || []));
  if (src.hostXdict) {
    const named = read.find((r) => r.owner === String(src.hostXdict));
    if (named) return named;
  }
  return read.find((r) => r.ok) || read[0];
}
function buildDocument(parsed, { decodeLayouts, proposeCrs } = {}) {
  const doc = createBlankDocument();
  const stats = {
    imported: 0,
    approx: 0,
    skippedTypes: {},
    byType: {},
    approxByType: {},
    warnings: []
  };
  const unitScale = unitScaleFromHeader(parsed.header, stats.warnings);
  const layerTable = parsed.tables && parsed.tables.layer && parsed.tables.layer.layers || {};
  doc.layers = [
    {
      name: DEFAULT_LAYER,
      color: "#ffffff",
      visible: true,
      locked: false,
      frozen: false,
      plot: true
    }
  ];
  const haveLayer = /* @__PURE__ */ new Set([DEFAULT_LAYER]);
  for (const name of Object.keys(layerTable)) {
    if (String(name).startsWith("V4C$")) continue;
    const L = layerTable[name];
    const lw = lineweightFromDxf(L.lineWeight != null ? L.lineWeight : L.lineweight);
    const lt = normalizeLinetypeName(L.lineType || L.linetype);
    const mapped = {
      name,
      color: hexFromInt(L.color) || "#ffffff",
      // OFF (a negative group 62, which is what this app writes) and FROZEN (group 70
      // bit 1) are two different states of the same drawing, and both survive the
      // import [LAYER-FREEZE-1]. Until this package the two were COLLAPSED onto
      // `visible` (DXF-FROZEN-1) because the model had one flag: a frozen layer came
      // back merely off, so a re-export told the next reader something the file it
      // came from did not say, and the extents rule that makes freezing worth doing
      // (see cadLayerAccess.unfrozenEntities) had nothing to read.
      visible: L.visible !== false,
      // Only a reader that read group 70 can say "frozen"; absent means thawed,
      // which is the DXF table default. NOTE dxf-parser folds bit 2 ("frozen in new
      // viewports") into its own `frozen`, so cadDxfSupplement overrides this field
      // with a bit-1-only reading for every record — see readLayerRecord.
      frozen: L.frozen === true,
      // Group 70 bit 4. Only a reader that actually read the flag can say "locked";
      // absent (dxf-parser alone) means unlocked, which is the historic behaviour.
      locked: L.locked === true,
      // Group 290 [LAYER-PLOT-1] — a layer that is on screen but never on paper.
      // Absent means PLOT (the table default), so a file written before AC1015 and
      // a file whose writer omits the group both import as ordinary layers.
      // cadDxfSupplement supplies it for DXF; the DWG adapter supplies libredwg's
      // `plotFlag` under the same key.
      plot: L.plot !== false,
      ...lw != null ? { lineweight: lw } : {},
      ...lt != null ? { linetype: lt } : {}
    };
    if (haveLayer.has(name)) {
      doc.layers[doc.layers.findIndex((l) => l.name === name)] = mapped;
      continue;
    }
    doc.layers.push(mapped);
    haveLayer.add(name);
  }
  const foldedLayers = /* @__PURE__ */ new Map();
  const rememberFold = (name) => {
    const k = layerNameKey(name);
    const held = foldedLayers.get(k);
    if (held === void 0 || name < held) foldedLayers.set(k, name);
  };
  for (const l of doc.layers) rememberFold(l.name);
  const ensureLayer = (name) => {
    const n = name || DEFAULT_LAYER;
    if (haveLayer.has(n)) return n;
    const existing = foldedLayers.get(layerNameKey(n));
    if (existing !== void 0) return existing;
    doc.layers.push({
      name: n,
      color: "#ffffff",
      visible: true,
      locked: false,
      frozen: false,
      plot: true
    });
    haveLayer.add(n);
    rememberFold(n);
    return n;
  };
  const ltTable = parsed.tables && parsed.tables.lineType && parsed.tables.lineType.lineTypes || {};
  for (const name of Object.keys(ltTable)) {
    if (normalizeLinetypeName(name) === null) continue;
    const lt = ltTable[name];
    const pattern = Array.isArray(lt.pattern) ? lt.pattern.map((v) => Number(v) || 0) : [];
    doc.linetypeDefs[name] = { name, description: lt.description || "", pattern };
  }
  const dsTable = parsed.tables && parsed.tables.dimStyle && (parsed.tables.dimStyle.dimStyles || parsed.tables.dimStyle.styles) || {};
  for (const name of Object.keys(dsTable)) {
    if (name === "Standard" || !isSafeStyleName(name)) continue;
    const sizes = dimStyleSizes(parsed)[name] || {};
    const s = dsTable[name] || {};
    const fields = {};
    if (sizes.textHeight > 0) fields.textHeight = sizes.textHeight * unitScale;
    if (sizes.arrowSize > 0) fields.arrowSize = sizes.arrowSize * unitScale;
    if (Number.isFinite(s.DIMDEC)) fields.unitsPrecision = s.DIMDEC;
    if (Number.isFinite(s.DIMADEC)) fields.anglePrecision = s.DIMADEC;
    doc.dimStyleDefs[name] = fields;
  }
  const styleTable = parsed.tables && parsed.tables.style && (parsed.tables.style.styles || parsed.tables.style.textStyles) || {};
  for (const name of Object.keys(styleTable)) {
    if (name === "Standard" || !isSafeStyleName(name)) continue;
    const s = styleTable[name] || {};
    const fields = {};
    if (typeof s.fontFamily === "string" && s.fontFamily) fields.fontFamily = s.fontFamily;
    else if (typeof s.font === "string" && s.font) fields.fontFamily = fontFamilyFromFile(s.font);
    if (Number.isFinite(s.fixedHeight) && s.fixedHeight > 0) fields.fixedHeight = s.fixedHeight;
    else if (Number.isFinite(s.fixedTextHeight) && s.fixedTextHeight > 0)
      fields.fixedHeight = s.fixedTextHeight;
    if (Number.isFinite(s.widthFactor) && s.widthFactor > 0) fields.widthFactor = s.widthFactor;
    else if (Number.isFinite(s.xScale) && s.xScale > 0) fields.widthFactor = s.xScale;
    if (Number.isFinite(s.oblique)) fields.oblique = s.oblique;
    else if (Number.isFinite(s.obliqueAngle)) fields.oblique = s.obliqueAngle;
    doc.textStyleDefs[name] = fields;
  }
  const blocks = parsed.blocks || {};
  for (const name of Object.keys(blocks)) {
    if (!name || name[0] === "*") continue;
    const blk = blocks[name];
    if (!blk || !blk.entities) continue;
    const localCtx = scaledCtx(unitScale);
    const localEntities = [];
    for (const ce of blk.entities) {
      for (const me of mapEntity(ce, localCtx, parsed, 1, ensureLayer, stats, blk.entities))
        localEntities.push(me);
    }
    const bp = blk.position || { x: 0, y: 0 };
    const attdefs = Array.isArray(blk.attdefs) && blk.attdefs.length ? blk.attdefs.map(
      (a) => unitScale === 1 ? a : {
        ...a,
        x: (a.x || 0) * unitScale,
        y: (a.y || 0) * unitScale,
        height: (a.height || 1) * unitScale
      }
    ) : null;
    doc.blockDefs[name] = {
      description: blk.description || "",
      basePoint: { x: (bp.x || 0) * unitScale, y: (bp.y || 0) * unitScale },
      entities: localEntities,
      ...attdefs ? { attdefs } : {}
    };
  }
  const out = [];
  const ctx = scaledCtx(unitScale);
  const idsByHandle = /* @__PURE__ */ new Map();
  for (const ent of parsed.entities || []) {
    const handle = ent && ent.handle != null ? String(ent.handle) : null;
    let mapped;
    try {
      mapped = mapEntity(ent, ctx, parsed, 0, ensureLayer, stats, parsed.entities || []);
    } catch (err) {
      const t = ent && ent.type || "UNKNOWN";
      stats.skippedTypes[t] = (stats.skippedTypes[t] || 0) + 1;
      stats.warnings.push(`could not import a ${t} entity: ${err && err.message || err}`);
      continue;
    }
    for (const e of mapped) {
      if (handle && e && e.id != null) {
        const list = idsByHandle.get(handle);
        if (list) list.push(e.id);
        else idsByHandle.set(handle, [e.id]);
      }
      out.push(e);
      stats.imported++;
      stats.byType[e.type] = (stats.byType[e.type] || 0) + 1;
      if (e.approx) {
        stats.approx++;
        const src = ent && ent.type || e.type;
        stats.approxByType[src] = (stats.approxByType[src] || 0) + 1;
      }
    }
  }
  ensureReadableDimText(out);
  const offset = computeImportOffset(out);
  doc.entities = applyImportOffset(out, offset);
  doc.meta.importOffset = offset;
  const geodataRead = pickGeodata(parsed);
  const georefDecision = reconcileImportGeoref({
    geodata: geodataRead,
    offset,
    unitScale,
    crsProposal: typeof proposeCrs === "function" && (offset.x !== 0 || offset.y !== 0) ? proposeCrs(boundsOf(out)) : null
  });
  if (georefDecision.georef) doc.georef = georefDecision.georef;
  doc.meta.importOffset = georefDecision.importOffset;
  stats.appliedOffset = { ...offset };
  stats.georef = {
    status: georefDecision.status,
    proposal: georefDecision.proposal || null,
    reason: georefDecision.reason || null,
    detail: georefDecision.detail || null,
    notes: georefDecision.notes || []
  };
  const otherSpace = Number(parsed.otherSpaceSkipped) || 0;
  if (otherSpace > 0) {
    stats.warnings.push(
      `${otherSpace} entities live on a SHEET (paper space) and were not imported \u2014 model space only for now`
    );
  }
  const importedGroups = [];
  for (const g of parsed.branchcadGroups || []) {
    const entityIds = [
      ...new Set((g.memberHandles || []).flatMap((h) => idsByHandle.get(String(h)) || []))
    ];
    if (entityIds.length < 2) continue;
    importedGroups.push({
      id: genId("grp"),
      name: g.name || `Group ${importedGroups.length + 1}`,
      entityIds,
      selectable: g.selectable !== false
    });
  }
  if (importedGroups.length) doc.groups = importedGroups;
  doc.layouts = decodeLayouts ? decodeLayouts(blocks, offset) : [modelLayout()];
  return { doc, stats };
}
function ensureReadableDimText(entities) {
  const b = documentBounds(entities);
  if (!b) return;
  const extent = Math.max(b.maxX - b.minX, b.maxY - b.minY);
  if (!(extent > 0)) return;
  const floor = extent * DIM_MIN_TEXT_FRACTION;
  for (const e of entities) {
    if (e.type !== "dimension" || e.autoText === false) continue;
    const cap = dimMeasureExtent(e) * DIM_MAX_TEXT_OF_MEASURE;
    const h = Math.max(effectiveTextHeight(e), floor);
    const sized = cap > 0 ? Math.min(h, cap) : h;
    e.autoText = false;
    e.textHeight = sized;
    e.arrowSize = sized;
  }
}
function dimMeasureExtent(e) {
  const span = (a, c) => a && c && Number.isFinite(a.x) && Number.isFinite(c.x) ? Math.hypot(c.x - a.x, c.y - a.y) : 0;
  if (e.dimType === "radius" || e.dimType === "diameter") {
    const r = Number.isFinite(e.radius) ? Math.abs(e.radius) : 0;
    return e.dimType === "diameter" ? r * 2 : r;
  }
  if (e.dimType === "angular") {
    return Math.max(span(e.vertex, e.p1), span(e.vertex, e.p2));
  }
  if (e.dimType === "ordinate") return span(e.feature, e.leader);
  return span(e.p1, e.p2);
}

// src/dxfImport.js
function parseDXF(text) {
  const parser = new DxfParser();
  return parser.parseSync(text);
}
function dxfToDocument(text, opts = {}) {
  const dxf = supplementParsedDxf(text, parseDXF(text));
  const result = buildDocument(dxf, {
    decodeLayouts: decodeLayoutCarriers,
    proposeCrs: opts.proposeCrs
  });
  result.doc = liftXrefCarriers(result.doc, result.stats.appliedOffset);
  result.doc = dropLayoutCarriers(result.doc);
  return result;
}
function dropLayoutCarriers(doc) {
  const blockDefs = doc.blockDefs || {};
  const names = Object.keys(blockDefs).filter((n) => /^LAYOUTDEF\$/i.test(n));
  if (!names.length) return doc;
  const carriers = names.filter((n) => {
    const ents = blockDefs[n] && blockDefs[n].entities || [];
    return ents.some(
      (e) => e && typeof e.text === "string" && (e.text.startsWith("PSMETA|") || e.text.startsWith("PSVP|") || e.text.startsWith("PSFIELDS|"))
    );
  });
  if (!carriers.length) return doc;
  const next = { ...blockDefs };
  for (const n of carriers) delete next[n];
  return { ...doc, blockDefs: next };
}
function dxfToXrefSource(text) {
  return buildDocument(supplementParsedDxf(text, parseDXF(text)));
}
function parsePipe(s) {
  const out = {};
  String(s).split("|").slice(1).forEach((kv) => {
    const i = kv.indexOf("=");
    if (i > 0) out[kv.slice(0, i)] = kv.slice(i + 1);
  });
  return out;
}
var numOr = (v, d = 0) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : d;
};
function decodeLayoutCarriers(blocks, appliedOffset) {
  const shift = appliedOffset || { x: 0, y: 0 };
  const layouts = [
    {
      id: "model",
      name: "Model",
      isModel: true,
      paperSize: null,
      orientation: null,
      viewports: []
    }
  ];
  for (const name of Object.keys(blocks || {})) {
    const blk = blocks[name];
    const isPaper = /^(\*Paper_Space|LAYOUTDEF\$)/i.test(name) || blk && blk.paperSpace;
    if (!isPaper || !blk || !Array.isArray(blk.entities)) continue;
    const texts = blk.entities.filter((e) => e && e.type === "TEXT" && typeof e.text === "string");
    const meta = texts.find((t) => t.text.startsWith("PSMETA|"));
    const fieldsText = texts.find((t) => t.text.startsWith("PSFIELDS|"));
    const vpTexts = texts.filter((t) => t.text.startsWith("PSVP|"));
    if (!meta && !fieldsText && !vpTexts.length) continue;
    const f = meta ? parsePipe(meta.text) : {};
    const viewports = vpTexts.map((t) => {
      const v = parsePipe(t.text);
      const framed = String(v.v) === "2";
      const dx = framed ? shift.x : 0;
      const dy = framed ? shift.y : 0;
      return {
        id: genId("vp"),
        worldRect: {
          x: numOr(v.x) - dx,
          y: numOr(v.y) - dy,
          width: numOr(v.w, 1),
          height: numOr(v.h, 1)
        },
        scale: numOr(v.s, 0.01),
        layerOverrides: {}
      };
    });
    let titleFields;
    if (fieldsText) {
      const raw = parsePipe(fieldsText.text);
      const out = {};
      for (const [k, v] of Object.entries(raw)) {
        if (k === "PSFIELDS") continue;
        try {
          out[k] = decodeURIComponent(String(v));
        } catch {
          out[k] = String(v);
        }
      }
      if (Object.keys(out).length) titleFields = out;
    }
    layouts.push({
      id: genId("lay"),
      name: f.name || name.replace(/^\*/, ""),
      isModel: false,
      paperSize: f.paper || "A1",
      orientation: f.orient === "portrait" ? "portrait" : "landscape",
      viewports,
      ...titleFields ? { titleFields } : {}
    });
  }
  return layouts;
}
function decodeVis(s) {
  const out = {};
  if (!s) return out;
  for (const part of String(s).split(",")) {
    const n = part.trim();
    if (n) out[n] = false;
  }
  return out;
}
function liftXrefCarriers(doc, appliedOffset) {
  const blockDefs = doc.blockDefs || {};
  const names = Object.keys(blockDefs).filter((n) => /^XREFDEF\$/.test(n));
  if (!names.length) return doc;
  const off = appliedOffset || doc.meta && doc.meta.importOffset || { x: 0, y: 0 };
  const xrefDefs = { ...doc.xrefDefs || {} };
  const nextBlockDefs = { ...blockDefs };
  const xrefEntities = [];
  const lifted = /* @__PURE__ */ new Set();
  const isCarrier = (e, tag) => e && e.type === "text" && typeof e.text === "string" && e.text.startsWith(tag);
  for (const blockName of names) {
    const def = nextBlockDefs[blockName];
    if (!def || !Array.isArray(def.entities)) continue;
    const metaText = def.entities.find((e) => isCarrier(e, "XREFMETA|"));
    if (!metaText) continue;
    lifted.add(blockName);
    const meta = parsePipe(metaText.text);
    const xrefName = meta.name || blockName.replace(/^XREFDEF\$/, "");
    const instTexts = def.entities.filter((e) => isCarrier(e, "XREFINST|"));
    const geometry = def.entities.filter(
      (e) => !isCarrier(e, "XREFMETA|") && !isCarrier(e, "XREFINST|")
    );
    const layerNames = Array.from(new Set(geometry.map((e) => e.layer || "0")));
    xrefDefs[xrefName] = {
      entities: geometry,
      layers: layerNames.map((name) => ({
        name,
        color: "#ffffff",
        visible: true,
        locked: false,
        frozen: false,
        plot: true
      })),
      sourceFile: meta.src || ""
    };
    for (const it of instTexts) {
      const f = parsePipe(it.text);
      xrefEntities.push({
        id: genId("xr"),
        type: "xref",
        layer: f.layer || "0",
        color: null,
        linetype: null,
        xrefName,
        // Instances are written in restored world coords (+offset) by the exporter;
        // bring them back to the doc's local frame, mirroring applyImportOffset.
        insertionPoint: { x: numOr(f.x) - off.x, y: numOr(f.y) - off.y },
        scaleX: numOr(f.sx, 1),
        scaleY: numOr(f.sy, 1),
        rotation: numOr(f.rot, 0),
        layerVisibility: decodeVis(f.vis)
      });
    }
    delete nextBlockDefs[blockName];
  }
  const isCarrierInsert = (e) => e && e.type === "insert" && lifted.has(e.blockName);
  for (const n of Object.keys(nextBlockDefs)) {
    const def = nextBlockDefs[n];
    if (def && Array.isArray(def.entities) && def.entities.some(isCarrierInsert)) {
      nextBlockDefs[n] = { ...def, entities: def.entities.filter((e) => !isCarrierInsert(e)) };
    }
  }
  const kept = doc.entities.filter((e) => !(e && e.type === "insert" && lifted.has(e.blockName)));
  return {
    ...doc,
    blockDefs: nextBlockDefs,
    xrefDefs,
    entities: [...kept, ...xrefEntities]
  };
}

// src/cadTemplateImport.js
var TEMPLATE_MAX_BYTES = 10 * 1024 * 1024;
var TEMPLATE_MAX_ENTITIES = 2e4;
var INSERT_MAX_DEPTH = 4;
var RAD2DEG2 = 180 / Math.PI;
var THREE_D_TYPES = /* @__PURE__ */ new Set(["3DFACE", "3DSOLID", "MESH", "POLYFACE", "POLYGON_MESH", "BODY", "REGION", "SURFACE"]);
var TemplateImportError = class extends Error {
  constructor(code, message) {
    super(message);
    this.name = "TemplateImportError";
    this.code = code;
  }
};
function byteLength(text, bytes) {
  if (Number.isFinite(bytes) && bytes >= 0) return bytes;
  if (typeof TextEncoder !== "undefined") return new TextEncoder().encode(text).length;
  return (text || "").length;
}
function makeTransform(insert) {
  const sx = insert.xScale || 1;
  const sy = insert.yScale || 1;
  const rot = (insert.rotation || 0) * Math.PI / 180;
  const c = Math.cos(rot);
  const s = Math.sin(rot);
  const ox = insert.position && insert.position.x || 0;
  const oy = insert.position && insert.position.y || 0;
  return (p) => {
    const x = (p.x || 0) * sx;
    const y = (p.y || 0) * sy;
    return { x: ox + x * c - y * s, y: oy + x * s + y * c, z: p.z };
  };
}
var IDENT2 = (p) => ({ x: p.x || 0, y: p.y || 0, z: p.z });
function walkEntity(ent, tf, blocks, depth, acc) {
  if (!ent || !ent.type) return;
  const t = String(ent.type).toUpperCase();
  if (THREE_D_TYPES.has(t)) {
    acc.threeD += 1;
    return;
  }
  const z = (p) => {
    const v = Math.abs(p && p.z || 0);
    if (v > acc.maxAbsZ) acc.maxAbsZ = v;
  };
  switch (t) {
    case "LINE": {
      const v = ent.vertices || [];
      if (v.length < 2) return;
      const a = tf(v[0]);
      const b = tf(v[1]);
      z(a);
      z(b);
      acc.entities.push({ type: "line", x1: a.x, y1: a.y, x2: b.x, y2: b.y });
      acc.drawable += 1;
      break;
    }
    case "LWPOLYLINE":
    case "POLYLINE": {
      const pts = (ent.vertices || []).map((p) => {
        const q = tf(p);
        z(q);
        return { x: q.x, y: q.y };
      });
      if (pts.length < 2) return;
      acc.entities.push({ type: "polyline", points: pts, closed: !!ent.shape });
      acc.drawable += 1;
      break;
    }
    case "CIRCLE": {
      const c = tf(ent.center || { x: 0, y: 0 });
      z(c);
      acc.entities.push({ type: "circle", cx: c.x, cy: c.y, r: (ent.radius || 0) * (Math.abs(ent.xScale || 1) || 1) });
      acc.drawable += 1;
      break;
    }
    case "ARC": {
      const c = tf(ent.center || { x: 0, y: 0 });
      z(c);
      acc.entities.push({
        type: "arc",
        cx: c.x,
        cy: c.y,
        r: ent.radius || 0,
        startAngle: (ent.startAngle || 0) * RAD2DEG2,
        endAngle: (ent.endAngle || 0) * RAD2DEG2
      });
      acc.drawable += 1;
      break;
    }
    case "SOLID": {
      const pts = (ent.points || ent.vertices || []).map((p) => {
        const q = tf(p);
        z(q);
        return { x: q.x, y: q.y };
      });
      if (pts.length < 3) return;
      acc.entities.push({ type: "polyline", points: pts, closed: true });
      acc.drawable += 1;
      break;
    }
    case "TEXT":
    case "MTEXT": {
      const src = ent.startPoint || ent.position || ent.endPoint || { x: 0, y: 0 };
      const p = tf(src);
      z(p);
      const text = String(ent.text || "").replace(/\\[A-Za-z][^;]*;|[{}]/g, "").trim();
      if (!text) return;
      acc.entities.push({ type: "text", x: p.x, y: p.y, text, height: ent.textHeight || ent.height || 2.5, rotation: ent.rotation || 0 });
      acc.drawable += 1;
      break;
    }
    case "ATTDEF": {
      const src = ent.startPoint || ent.position || { x: 0, y: 0 };
      const p = tf(src);
      z(p);
      const tag = ent.tag || ent.text || "";
      if (!tag) return;
      acc.fields.push({ tag: String(tag), x: p.x, y: p.y, height: ent.textHeight || ent.height || 2.5, rotation: ent.rotation || 0, text: String(ent.text || "") });
      break;
    }
    case "INSERT": {
      if (depth >= INSERT_MAX_DEPTH) return;
      const block = blocks && blocks[ent.name];
      if (!block || !Array.isArray(block.entities)) return;
      const local = makeTransform(ent);
      const base = block.position && { x: block.position.x || 0, y: block.position.y || 0 } || { x: 0, y: 0 };
      const composed = (p) => tf(local({ x: (p.x || 0) - base.x, y: (p.y || 0) - base.y, z: p.z }));
      for (const sub2 of block.entities) {
        if (acc.entities.length + acc.fields.length > TEMPLATE_MAX_ENTITIES) break;
        walkEntity(sub2, composed, blocks, depth + 1, acc);
      }
      if (Array.isArray(ent.attributes)) {
        for (const a of ent.attributes) {
          const p = tf({ x: a.x, y: a.y });
          z(p);
          if (a.tag) acc.fields.push({ tag: String(a.tag), x: p.x, y: p.y, height: a.height || 2.5, rotation: a.rotation || 0, text: String(a.value || "") });
        }
      }
      break;
    }
    default:
      break;
  }
}
function parseTemplateFromDxf(text, opts = {}) {
  const maxBytes = Number.isFinite(opts.maxBytes) ? opts.maxBytes : TEMPLATE_MAX_BYTES;
  const size = byteLength(text, opts.bytes);
  if (size > maxBytes) {
    throw new TemplateImportError("FILE_TOO_LARGE", `Template is ${(size / 1048576).toFixed(1)} MB; the limit is ${(maxBytes / 1048576).toFixed(1)} MB. A title block should be a small DXF.`);
  }
  if (typeof text !== "string" || !text.trim()) {
    throw new TemplateImportError("NOT_DXF", "The file is empty or unreadable.");
  }
  let parsed;
  try {
    parsed = parseDXF(text);
  } catch {
    throw new TemplateImportError("NOT_DXF", "This is not a readable DXF file. Export your title block as a 2D DXF (R12+).");
  }
  if (!parsed || !Array.isArray(parsed.entities)) {
    throw new TemplateImportError("NOT_DXF", "This DXF has no drawable content.");
  }
  const insunits = parsed.header && parsed.header.$INSUNITS;
  const unit2 = insunits === 6 ? 1e3 : insunits === 1 ? 25.4 : insunits === 5 ? 10 : 1;
  const blocks = parsed.blocks || {};
  const acc = { entities: [], fields: [], drawable: 0, threeD: 0, maxAbsZ: 0 };
  for (const ent of parsed.entities) {
    if (acc.entities.length + acc.fields.length > TEMPLATE_MAX_ENTITIES) {
      throw new TemplateImportError("TOO_COMPLEX", "This DXF is too complex for a title block. Export only the title-block frame.");
    }
    walkEntity(ent, IDENT2, blocks, 0, acc);
  }
  if (acc.entities.length + acc.fields.length > TEMPLATE_MAX_ENTITIES) {
    throw new TemplateImportError("TOO_COMPLEX", "This DXF is too complex for a title block. Export only the title-block frame.");
  }
  if (!acc.drawable && !acc.fields.length) {
    throw new TemplateImportError("NO_GEOMETRY", "No 2D title-block geometry found in this DXF.");
  }
  if (unit2 !== 1) {
    for (const e of acc.entities) {
      if (e.type === "line") {
        e.x1 *= unit2;
        e.y1 *= unit2;
        e.x2 *= unit2;
        e.y2 *= unit2;
      } else if (e.type === "polyline") e.points = e.points.map((p) => ({ x: p.x * unit2, y: p.y * unit2 }));
      else if (e.type === "circle" || e.type === "arc") {
        e.cx *= unit2;
        e.cy *= unit2;
        e.r *= unit2;
      } else if (e.type === "text") {
        e.x *= unit2;
        e.y *= unit2;
        e.height *= unit2;
      }
    }
    for (const fl of acc.fields) {
      fl.x *= unit2;
      fl.y *= unit2;
      fl.height *= unit2;
    }
  }
  const template = { source: "dxf", name: opts.name || "Imported template", entities: acc.entities, fields: acc.fields };
  const b = templateBounds(template);
  const extent = Math.max(b.w, b.h, 1);
  if (acc.threeD > 0 || acc.maxAbsZ > Math.max(extent * 0.02, 1)) {
    throw new TemplateImportError("NOT_2D", "This looks like a 3D model, not a 2D title block. Export a flat 2D DXF.");
  }
  const dx = -b.minX;
  const dy = -b.minY;
  const mv = (p) => ({ x: p.x + dx, y: p.y + dy });
  for (const e of template.entities) {
    if (e.type === "line") {
      e.x1 += dx;
      e.y1 += dy;
      e.x2 += dx;
      e.y2 += dy;
    } else if (e.type === "polyline") e.points = e.points.map(mv);
    else if (e.type === "circle" || e.type === "arc") {
      e.cx += dx;
      e.cy += dy;
    } else if (e.type === "text") {
      e.x += dx;
      e.y += dy;
    }
  }
  for (const fl of template.fields) {
    fl.x += dx;
    fl.y += dy;
  }
  const logoField = template.fields.find((f) => String(f.tag).toUpperCase() === "LOGO");
  let logoBox = null;
  if (logoField) {
    const lh = Math.max(logoField.height * 4, 12);
    logoBox = { x: logoField.x, y: logoField.y, width: Math.max(lh * 1.6, 20), height: lh };
    template.fields = template.fields.filter((f) => f !== logoField);
  }
  if (logoBox) template.logoBox = logoBox;
  template.bbox = { w: b.w, h: b.h };
  return template;
}

// src/cadXrefRender.js
var TWO_PI = Math.PI * 2;
var CIRCLE_SEGS = 64;
function circlePath(cx, cy, r, seg = CIRCLE_SEGS) {
  const pts = [];
  for (let i = 0; i <= seg; i++) {
    const a = i / seg * TWO_PI;
    pts.push({ x: cx + r * Math.cos(a), y: cy + r * Math.sin(a) });
  }
  return pts;
}
function arcPath(cx, cy, r, startDeg, endDeg, seg = CIRCLE_SEGS) {
  let sweep = ((endDeg - startDeg) % 360 + 360) % 360;
  if (sweep === 0) sweep = 360;
  const n = Math.max(2, Math.ceil(sweep / 360 * seg));
  const a0 = startDeg * Math.PI / 180;
  const da = sweep * Math.PI / 180 / n;
  const pts = [];
  for (let i = 0; i <= n; i++) {
    const a = a0 + da * i;
    pts.push({ x: cx + r * Math.cos(a), y: cy + r * Math.sin(a) });
  }
  return pts;
}
function ellipsePath(cx, cy, rx, ry, rotDeg, seg = CIRCLE_SEGS) {
  const rot = rotDeg * Math.PI / 180;
  const c = Math.cos(rot);
  const s = Math.sin(rot);
  const pts = [];
  for (let i = 0; i <= seg; i++) {
    const a = i / seg * TWO_PI;
    const x = rx * Math.cos(a);
    const y = ry * Math.sin(a);
    pts.push({ x: cx + x * c - y * s, y: cy + x * s + y * c });
  }
  return pts;
}
function entityToDrawItem(e) {
  switch (e.type) {
    case "line":
      return { kind: "path", closed: false, points: [{ x: e.x1, y: e.y1 }, { x: e.x2, y: e.y2 }] };
    case "polyline":
      return { kind: "path", closed: !!e.closed, points: e.points.map((p) => ({ x: p.x, y: p.y })) };
    case "rectangle":
      return {
        kind: "path",
        closed: true,
        points: [
          { x: e.x, y: e.y },
          { x: e.x + e.width, y: e.y },
          { x: e.x + e.width, y: e.y + e.height },
          { x: e.x, y: e.y + e.height }
        ]
      };
    case "circle":
      return { kind: "path", closed: true, points: circlePath(e.cx, e.cy, e.r) };
    case "arc":
      return { kind: "path", closed: false, points: arcPath(e.cx, e.cy, e.r, e.startAngle, e.endAngle) };
    case "ellipse":
      return { kind: "path", closed: true, points: ellipsePath(e.cx, e.cy, e.rx, e.ry, e.rotation || 0) };
    case "text":
      return { kind: "text", x: e.x, y: e.y, text: e.text || "", height: e.height || 2, rotation: e.rotation || 0 };
    default:
      return null;
  }
}
function xrefDrawSegments(xref, xrefDef) {
  const paths = [];
  const texts = [];
  if (!xrefDef || !Array.isArray(xrefDef.entities)) return { paths, texts };
  for (const se of xrefDef.entities) {
    if (!xrefLayerVisible(xref, se.layer || "0")) continue;
    const t = transformEntity(se, xref, { x: 0, y: 0 });
    const item = entityToDrawItem(t);
    if (!item) continue;
    if (item.kind === "text") texts.push(item);
    else paths.push(item);
  }
  return { paths, texts };
}

// src/cadGridSpec.js
var AUTO_TARGET_PX = 80;
var MIN_LINE_PX = 4;
var GRID_DEFAULTS = Object.freeze({
  visible: true,
  mode: "auto",
  size: 10,
  majorEvery: 5,
  lockSnapToGrid: true
});
var MIN_MAJOR_EVERY = 2;
var MAX_MAJOR_EVERY = 1e3;
function niceStep(raw) {
  if (!isFinite(raw) || raw <= 0) return 1;
  const p = Math.pow(10, Math.floor(Math.log10(raw)));
  const f = raw / p;
  const n = f < 1.5 ? 1 : f < 3 ? 2 : f < 7 ? 5 : 10;
  return n * p;
}
function normalizeGrid(grid) {
  const g = grid && typeof grid === "object" ? grid : {};
  const size = Number(g.size);
  const every = Number(g.majorEvery);
  return {
    visible: g.visible === void 0 ? GRID_DEFAULTS.visible : !!g.visible,
    // Anything that is not the literal 'fixed' is auto — an unknown mode string
    // must degrade to the behaviour that always works, never to a blank canvas.
    mode: g.mode === "fixed" ? "fixed" : "auto",
    size: Number.isFinite(size) && size > 0 ? size : GRID_DEFAULTS.size,
    majorEvery: Number.isFinite(every) && every >= MIN_MAJOR_EVERY ? Math.min(Math.floor(every), MAX_MAJOR_EVERY) : GRID_DEFAULTS.majorEvery,
    lockSnapToGrid: g.lockSnapToGrid === void 0 ? GRID_DEFAULTS.lockSnapToGrid : !!g.lockSnapToGrid
  };
}
function resolveGridSpec(grid, scale) {
  const s = Number(scale);
  if (!Number.isFinite(s) || s <= 0) return null;
  const g = normalizeGrid(grid);
  const minor = g.mode === "fixed" ? g.size : niceStep(AUTO_TARGET_PX / s);
  const major = minor * g.majorEvery;
  const minorPx = minor * s;
  const majorPx = major * s;
  const drawMinor = Number.isFinite(minorPx) && minorPx >= MIN_LINE_PX;
  const drawMajor = Number.isFinite(majorPx) && majorPx >= MIN_LINE_PX;
  const suppressed = drawMinor ? "none" : drawMajor ? "minor" : "all";
  return {
    minor,
    major,
    majorEvery: g.majorEvery,
    minorPx,
    majorPx,
    drawMinor,
    drawMajor,
    suppressed,
    mode: g.mode
  };
}
var SPACING_TOKEN = /^[+-]?(\d+\.?\d*|\.\d+)$/;
function parseGridSpacingInput(text) {
  if (text == null) return { action: "auto" };
  const t = String(text).trim();
  if (t === "") return { action: "auto" };
  if (/^a(uto)?$/i.test(t)) return { action: "auto" };
  if (!SPACING_TOKEN.test(t)) return null;
  const value = parseFloat(t);
  if (!Number.isFinite(value)) return null;
  return value > 0 ? { action: "spacing", value } : { action: "auto" };
}
function gridSpacingCommit(grid, value) {
  const g = normalizeGrid(grid);
  const v = Number(value);
  const fixed = Number.isFinite(v) && v > 0;
  if (!fixed) {
    return {
      grid: { ...g, mode: "auto" },
      snapGridSize: null,
      unchanged: g.mode === "auto"
    };
  }
  if (g.mode === "fixed" && g.size === v) {
    return { grid: g, snapGridSize: null, unchanged: true };
  }
  return {
    grid: { ...g, mode: "fixed", size: v },
    snapGridSize: g.lockSnapToGrid ? v : null,
    unchanged: false
  };
}
function gridSpacingReport(commit, snapGridSize) {
  const { grid, snapGridSize: moved, unchanged } = commit;
  const cursor = Number.isFinite(snapGridSize) ? formatSpacing(snapGridSize) : null;
  if (grid.mode !== "fixed") {
    const tail = cursor ? `; snap increment still ${cursor} \u2014 SNAP <n> to change it` : "; snap increment unchanged";
    return `Grid spacing: AUTO (tracks the zoom${tail})`;
  }
  const at = `Grid spacing: ${formatSpacing(grid.size)}`;
  if (unchanged) {
    return cursor ? `${at} (unchanged; snap increment still ${cursor} \u2014 SNAP <n> to change it)` : `${at} (unchanged)`;
  }
  return moved == null ? `${at} (snap increment unchanged)` : `${at}, snap increment ${formatSpacing(moved)} \u2014 GRID LOCK OFF to unlink`;
}
function gridSpacingLabel(grid, resolvedMinor) {
  const g = normalizeGrid(grid);
  if (g.mode === "fixed") return formatSpacing(g.size);
  return Number.isFinite(resolvedMinor) && resolvedMinor > 0 ? `AUTO (${formatSpacing(resolvedMinor)})` : "AUTO";
}
function gridSuppressionNote(suppressed) {
  if (suppressed === "minor") return "minor lines hidden \u2014 too dense at this zoom";
  if (suppressed === "all") return "grid too dense to draw at this zoom";
  return "";
}
function formatSpacing(v) {
  return String(Number(v.toPrecision(12)));
}

// src/cadUnderlay.js
var UNDERLAY_DEFAULTS = { rotation: 0, opacity: 0.5 };
var num = (v, d) => Number.isFinite(v) ? v : d;
function normalizeUnderlay(u) {
  if (!u || u.src == null) return null;
  const width = num(u.width, 0);
  const height = num(u.height, 0);
  if (!(width > 0) || !(height > 0)) return null;
  const out = {
    src: u.src,
    x: num(u.x, 0),
    y: num(u.y, 0),
    width,
    height,
    rotation: num(u.rotation, UNDERLAY_DEFAULTS.rotation),
    opacity: Math.max(0, Math.min(1, num(u.opacity, UNDERLAY_DEFAULTS.opacity)))
  };
  if (u.page != null) out.page = u.page;
  if (u.name != null) out.name = String(u.name);
  if (u.ref != null) out.ref = u.ref;
  return out;
}
function underlayKonvaBox(u) {
  const n = normalizeUnderlay(u);
  if (!n) return null;
  return {
    x: n.x,
    y: -n.y,
    width: n.width,
    height: n.height,
    offsetY: n.height,
    rotation: -(n.rotation || 0),
    opacity: n.opacity
  };
}
function underlayFromNaturalSize({ src, pw, ph, x = 0, y = 0, worldWidth, rotation = 0, opacity, page, name, ref }) {
  const w = num(worldWidth, 0);
  const aspect = pw > 0 && ph > 0 ? ph / pw : 1;
  return normalizeUnderlay({
    src,
    x,
    y,
    width: w,
    height: w * aspect,
    rotation,
    opacity,
    page,
    name,
    ref
  });
}

// src/cadFidelityReport.js
var APPROX_REASONS = {
  MTEXT: "MTEXT imported as a wrapped text block; inline formatting codes stripped to plain text",
  TEXT: "text with aligned/fit justification imported as bottom-left (no 9-point equivalent)",
  SOLID: "filled SOLID imported as an outline polygon",
  "3DFACE": "3DFACE imported as a flat outline polygon",
  DIMENSION: "dimension exploded to approximate primitive geometry",
  HATCH: "hatch boundary reconstructed best-effort (islands/curved edges may differ)",
  INSERT: "block contents imported with approximation"
};
var DROP_REASONS = {
  HATCH: "hatch boundary could not be reconstructed (no fill geometry)",
  DIMENSION: "unsupported dimension kind (no faithful or approximate form)",
  REGION: "REGION/ACIS solid geometry is not supported",
  "3DSOLID": "3D solid geometry is not supported (2-D engine)",
  BODY: "ACIS BODY geometry is not supported",
  IMAGE: "raster image references are not imported",
  WIPEOUT: "WIPEOUT masks are not imported",
  OLE2FRAME: "embedded OLE objects are not imported",
  ACAD_PROXY_ENTITY: "proxy/custom-object entities cannot be decoded",
  MLINE: "multiline (MLINE) entities are not supported",
  TOLERANCE: "tolerance (feature-control-frame) entities are not supported",
  // Spec 04 note: the app has a native LEADER entity, but the DXF/DWG parsers in use
  // (dxf-parser has no LEADER/MULTILEADER handler; the DWG adapter surfaces neither)
  // never emit these records, so an imported leader is dropped rather than mapped.
  // Kept as explicit drop reasons so the fidelity report explains it if one appears.
  LEADER: "LEADER entities are not surfaced by the importer (drawn leaders are supported)",
  MULTILEADER: "MULTILEADER (MLEADER) entities are not surfaced by the importer",
  MLEADER: "MULTILEADER (MLEADER) entities are not surfaced by the importer",
  UNKNOWN: "an entity of an unrecognised type was skipped"
};
function reasonFor(map, type, fallback) {
  return map[type] || map[String(type).toUpperCase()] || fallback;
}
function buildFidelityReport(stats) {
  const s = stats || {};
  const byType = s.byType || {};
  const approxByType = s.approxByType || {};
  const skippedTypes = s.skippedTypes || {};
  const warnings = Array.isArray(s.warnings) ? s.warnings.slice() : [];
  const imported = Number.isFinite(s.imported) ? s.imported : 0;
  const approxTotal = Number.isFinite(s.approx) ? s.approx : 0;
  const approximated = Object.keys(approxByType).map((type) => ({
    type,
    count: approxByType[type],
    reason: reasonFor(APPROX_REASONS, type, "imported with approximation")
  })).sort((a, b) => b.count - a.count);
  const dropped = Object.keys(skippedTypes).map((type) => ({
    type,
    count: skippedTypes[type],
    reason: reasonFor(DROP_REASONS, type, `${type} entities are not supported`)
  })).sort((a, b) => b.count - a.count);
  const droppedTotal = dropped.reduce((n, d) => n + d.count, 0);
  const faithfulTotal = Math.max(0, imported - approxTotal);
  const THREE_D_TYPES2 = ["3DFACE", "3DSOLID", "REGION", "BODY", "MESH", "POLYFACE", "POLYFACE MESH", "SURFACE"];
  const threeD = THREE_D_TYPES2.reduce((n, t) => n + (approxByType[t] || 0) + (skippedTypes[t] || 0), 0);
  const grand = imported + droppedTotal;
  if (threeD > 0 && grand > 0 && threeD / grand >= 0.5) {
    warnings.push(
      "This drawing is mostly 3D geometry \u2014 3D faces were flattened and true solids (3DSOLID/REGION/BODY) could not be imported. It opened in the 2-D editor with what could be represented; re-export a flattened 2-D DXF for full fidelity."
    );
  }
  return {
    faithful: { total: faithfulTotal, byType: { ...byType } },
    approximated,
    dropped,
    warnings,
    totals: {
      imported,
      faithful: faithfulTotal,
      approximated: approxTotal,
      dropped: droppedTotal
    },
    clean: approxTotal === 0 && droppedTotal === 0 && warnings.length === 0
  };
}
function fidelitySummary(report) {
  if (!report || report.clean) return "";
  const bits = [];
  if (report.totals.approximated) bits.push(`${report.totals.approximated} approximated`);
  if (report.totals.dropped) bits.push(`${report.totals.dropped} dropped`);
  if (report.warnings.length) bits.push(`${report.warnings.length} warning${report.warnings.length === 1 ? "" : "s"}`);
  return `Imported ${report.totals.imported} object${report.totals.imported === 1 ? "" : "s"} with ${bits.join(", ")}.`;
}

// src/cadRenderOrigin.js
var RENDER_ORIGIN_STEP = 4096;
function renderOriginFor(entities, blockDefs, xrefDefs, prevOrigin) {
  const b = framingBounds(entities || [], blockDefs, xrefDefs);
  if (!b) return null;
  const cx = (b.minX + b.maxX) / 2;
  const cy = (b.minY + b.maxY) / 2;
  if (!Number.isFinite(cx) || !Number.isFinite(cy)) return null;
  const gate = prevOrigin ? LARGE - 2 * RENDER_ORIGIN_STEP : LARGE;
  if (Math.abs(cx) <= gate && Math.abs(cy) <= gate) return null;
  if (prevOrigin && Number.isFinite(prevOrigin.x) && Number.isFinite(prevOrigin.y) && Math.abs(cx - prevOrigin.x) <= 2 * RENDER_ORIGIN_STEP && Math.abs(cy - prevOrigin.y) <= 2 * RENDER_ORIGIN_STEP) {
    return prevOrigin;
  }
  const x = Math.round(cx / RENDER_ORIGIN_STEP) * RENDER_ORIGIN_STEP;
  const y = Math.round(cy / RENDER_ORIGIN_STEP) * RENDER_ORIGIN_STEP;
  if (!Number.isFinite(x) || !Number.isFinite(y)) return null;
  if (x === 0 && y === 0) return null;
  return { x, y };
}

// src/dwgImport.js
var RAD2DEG3 = 180 / Math.PI;
var isDwgFilename = (name) => typeof name === "string" && name.toLowerCase().endsWith(".dwg");
var _wasmDir = "/wasm";
function configureDwgWasmDir(dir) {
  _wasmDir = dir;
}
var _kernelPromise = null;
function getKernel() {
  if (!_kernelPromise) {
    _kernelPromise = (async () => {
      const { LibreDwg, Dwg_File_Type } = await import("@mlightcad/libredwg-web");
      const kernel = await LibreDwg.create(_wasmDir);
      return { kernel, Dwg_File_Type };
    })().catch((err) => {
      _kernelPromise = null;
      throw err;
    });
  }
  return _kernelPromise;
}
var macrotask = () => new Promise((resolve) => setTimeout(resolve, 0));
async function parseDWG(arrayBuffer, onProgress = () => {
}, opts = {}) {
  onProgress(0);
  const { kernel, Dwg_File_Type } = await getKernel();
  onProgress(20);
  const dwg = kernel.dwg_read_data(arrayBuffer, Dwg_File_Type.DWG);
  if (!dwg) {
    throw new Error("libredwg could not read this DWG (unsupported version or corrupt file).");
  }
  let db;
  let drawOrder;
  try {
    db = kernel.convert(dwg);
    drawOrder = readDrawOrder(kernel, dwg);
  } finally {
    kernel.dwg_free(dwg);
  }
  onProgress(80);
  await macrotask();
  applyDrawOrder(db, drawOrder);
  const parsed = dwgDbToParsed(db);
  const result = buildDocument(parsed, { proposeCrs: opts.proposeCrs });
  onProgress(100);
  return result;
}
var DWG_TYPE_SORTENTSTABLE = 714;
function handleValue(e) {
  const h = e && e.handle;
  if (typeof h === "number") return Number.isFinite(h) ? h : null;
  if (typeof h === "string" && /^[0-9a-fA-F]+$/.test(h)) {
    const v = parseInt(h, 16);
    return Number.isFinite(v) ? v : null;
  }
  return null;
}
function readDrawOrder(kernel, dwg) {
  const order = /* @__PURE__ */ new Map();
  const wasm = kernel && kernel.wasmInstance;
  if (!wasm || typeof kernel.dwg_getall_object_by_type !== "function" || typeof kernel.dwg_ptr_to_object_ref_ptr_array !== "function" || typeof kernel.dwg_dynapi_entity_value !== "function" || typeof wasm.dwg_ref_get_absref !== "function") {
    return order;
  }
  let tables;
  try {
    tables = kernel.dwg_getall_object_by_type(dwg, DWG_TYPE_SORTENTSTABLE) || [];
  } catch {
    return order;
  }
  const at = (a, i) => Array.isArray(a) ? a[i] : a && typeof a.get === "function" ? a.get(i) : void 0;
  const field = (tio, name) => {
    const v = kernel.dwg_dynapi_entity_value(tio, name);
    return v ? v.data : void 0;
  };
  for (const tio of tables) {
    try {
      const n = Number(field(tio, "num_ents")) || 0;
      const entsPtr = field(tio, "ents");
      const sortPtr = field(tio, "sort_ents");
      if (n <= 0 || !entsPtr || !sortPtr) continue;
      const ents = kernel.dwg_ptr_to_object_ref_ptr_array(entsPtr, n);
      const sorts = kernel.dwg_ptr_to_object_ref_ptr_array(sortPtr, n);
      for (let i = 0; i < n; i += 1) {
        const eRef = at(ents, i);
        const sRef = at(sorts, i);
        if (eRef == null || sRef == null) continue;
        const h = wasm.dwg_ref_get_absref(eRef);
        const k = wasm.dwg_ref_get_absref(sRef);
        if (Number.isFinite(h) && Number.isFinite(k)) order.set(h, k);
      }
    } catch {
    }
  }
  return order;
}
function sortByDrawOrder(entities, order) {
  if (!Array.isArray(entities) || !order || !order.size) return entities;
  let previous = -Infinity;
  const keyed = entities.map((e, i) => {
    const h = handleValue(e);
    let k;
    if (h == null) k = previous;
    else {
      k = order.has(h) ? order.get(h) : h;
      previous = k;
    }
    return { e, i, k };
  });
  keyed.sort((a, b) => a.k - b.k || a.i - b.i);
  return keyed.map((r) => r.e);
}
function applyDrawOrder(db, order) {
  if (!db || !order || !order.size) return db;
  if (Array.isArray(db.entities)) db.entities = sortByDrawOrder(db.entities, order);
  const entries = db.tables && db.tables.BLOCK_RECORD && db.tables.BLOCK_RECORD.entries || [];
  for (const b of entries) {
    if (b && Array.isArray(b.entities)) b.entities = sortByDrawOrder(b.entities, order);
  }
  return db;
}
var pt = (p) => p ? { x: p.x || 0, y: p.y || 0 } : { x: 0, y: 0 };
var deg = (rad) => typeof rad === "number" ? rad * RAD2DEG3 : 0;
function colorFor(e) {
  const aci = aci2int(e.colorIndex);
  if (aci != null) return aci;
  if (typeof e.color === "number" && e.color !== 16777215) return e.color;
  return void 0;
}
var LWPOLYLINE_CLOSED_BIT = 512;
var DXF70_CLOSED_BIT = 1;
function polylineClosed(e) {
  const bit = e.type === "LWPOLYLINE" ? LWPOLYLINE_CLOSED_BIT : DXF70_CLOSED_BIT;
  return ((e.flag || 0) & bit) !== 0;
}
function adaptEntity(e) {
  const base = {
    type: e.type,
    layer: e.layer,
    lineType: e.lineType,
    color: colorFor(e),
    extrusionDirection: e.extrusionDirection
  };
  switch (e.type) {
    case "LINE":
      return { ...base, vertices: [pt(e.startPoint), pt(e.endPoint)] };
    case "CIRCLE":
      return { ...base, center: pt(e.center), radius: e.radius };
    case "ARC":
      return {
        ...base,
        center: pt(e.center),
        radius: e.radius,
        startAngle: e.startAngle,
        endAngle: e.endAngle
      };
    case "ELLIPSE":
      return {
        ...base,
        center: pt(e.center),
        majorAxisEndPoint: pt(e.majorAxisEndPoint),
        axisRatio: e.axisRatio,
        startAngle: e.startAngle,
        endAngle: e.endAngle
      };
    case "LWPOLYLINE":
    case "POLYLINE2D":
    case "POLYLINE3D":
      return {
        ...base,
        type: "LWPOLYLINE",
        // [BUG-DWG-BULGE-1] carry the BULGE. A curved polyline segment is stored as
        // a bulge on the vertex it leaves, and `pt` copies x/y only — so every arc
        // segment imported as its CHORD. Measured on the reporting file: 355 of
        // 1,333 vertices are bulged and 141 of 238 polylines have at least one, with
        // 0.4142 = tan(90°/4) throughout — quarter circles, i.e. door swings
        // (A-DOOR ×58) and rounded corners. mapPolyline expands them.
        vertices: (e.vertices || []).map((v) => ({
          ...pt(v),
          ...Number.isFinite(v && v.bulge) && v.bulge !== 0 ? { bulge: v.bulge } : null
        })),
        shape: polylineClosed(e)
      };
    case "TEXT":
      return {
        ...base,
        startPoint: pt(e.startPoint),
        // Group 11 only when the kernel actually has one. `pt` would manufacture a
        // {0,0}, and mapText treats a present endPoint as the ALIGNMENT point for
        // justified text — so a fabricated origin would anchor every label there.
        endPoint: e.endPoint ? pt(e.endPoint) : void 0,
        text: e.text,
        textHeight: e.textHeight,
        rotation: deg(e.rotation),
        // [BUG-DWG-TEXT-1] justification + style. The kernel supplies all three;
        // the adapter used to drop them, so every DWG label imported bottom-left in
        // the default style. Measured on the reporting file: 150 of 151 TEXT are
        // justified (halign 4 ×111, 1 ×39) and every one names a real style
        // (CP_TITLE, CP_ROOMVNUMBER, CP_AREA, CP_ROOMSNUMBER) — 0 of either arrived.
        // The values are DXF group 72/73 as `textJustifyFromDXF` reads them: this
        // file's halign 0/1/4 and valign 0/2 are all in range, and the 0-halign row
        // is exactly the one whose group 11 is absent, which is the encoding's own
        // signature rather than a coincidence of legal-looking numbers.
        halign: e.halign,
        valign: e.valign,
        styleName: e.styleName
      };
    case "MTEXT":
      return {
        ...base,
        position: pt(e.insertionPoint),
        text: e.text,
        height: e.textHeight,
        rotation: deg(e.rotation),
        // MTEXT anchors on group 71 (attachmentPoint), NOT on 72/73. Measured: every
        // MTEXT here states 7 (bottom-left) — which is NOT our default of TL, so
        // dropping it moved each block by its own height.
        attachmentPoint: e.attachmentPoint,
        lineSpacing: e.lineSpacing,
        styleName: e.styleName,
        // The wrap width (DXF group 41). The kernel has no `width`: it splits the
        // idea three ways, and only ONE of them is the reference rectangle —
        // measured here, rectWidth is 58/101 on 4.5-high multi-line labels (a
        // sensible ~22 characters), columnWidth is 0 on every one (unused), and
        // extentsWidth is the MEASURED extent, an output rather than an input.
        // Feeding the extent back in would pin each block to the width it already
        // happened to have and defeat wrapping entirely.
        width: e.rectWidth
      };
    case "POINT":
      return { ...base, position: pt(e.position) };
    case "INSERT":
      return {
        ...base,
        name: e.name,
        position: pt(e.insertionPoint),
        xScale: e.xScale,
        yScale: e.yScale,
        rotation: deg(e.rotation),
        attributes: adaptAttribs(e.attribs)
      };
    case "SOLID":
    case "3DFACE":
      return {
        ...base,
        type: "SOLID",
        points: [e.corner1, e.corner2, e.corner4 || e.corner3, e.corner3].filter(Boolean).map(pt)
      };
    case "SPLINE":
      return {
        ...base,
        fitPoints: (e.fitPoints || []).map(pt),
        controlPoints: (e.controlPoints || []).map(pt),
        closed: ((e.flag || 0) & 1) === 1
      };
    case "HATCH":
      return adaptHatch(e, base);
    case "DIMENSION":
      return adaptDimension(e, base);
    default:
      return { ...base };
  }
}
function normalizeHatchArcEdges(paths) {
  if (!Array.isArray(paths)) return paths;
  return paths.map((p) => {
    if (!p || !Array.isArray(p.edges)) return p;
    return {
      ...p,
      edges: p.edges.map((edge) => {
        if (!edge) return edge;
        if (edge.type === 3 && edge.majorAxis === void 0 && edge.end) {
          const ccw3 = edge.isCCW !== false && edge.isCCW !== 0;
          return {
            ...edge,
            majorAxis: edge.end,
            axisRatio: Number.isFinite(edge.axisRatio) ? edge.axisRatio : Number.isFinite(edge.lengthOfMinorAxis) ? edge.lengthOfMinorAxis : 1,
            isCCW: ccw3
          };
        }
        if (edge.type !== 2 || edge.isCCW === void 0 || edge.isCCW === null) return edge;
        const ccw = edge.isCCW !== false && edge.isCCW !== 0;
        if (ccw) return { ...edge, isCCW: true };
        return {
          ...edge,
          isCCW: false,
          startAngle: -(edge.startAngle || 0),
          endAngle: -(edge.endAngle || 0)
        };
      })
    };
  });
}
function definitionLineSpacing(defs) {
  const first = Array.isArray(defs) ? defs[0] : null;
  const off = first && first.offset;
  if (!off) return void 0;
  const d = Math.hypot(off.x || 0, off.y || 0);
  return Number.isFinite(d) && d > 0 ? d : void 0;
}
function adaptHatch(e, base) {
  const { regions, droppedPaths } = hatchRegionsDetailed(normalizeHatchArcEdges(e.boundaryPaths || []));
  const { boundary, islands } = regions.length ? regions[0] : { boundary: [], islands: [] };
  return {
    ...base,
    type: "HATCH",
    boundary,
    islands,
    regions,
    droppedPaths,
    patternName: e.patternName,
    patternAngle: e.patternAngle || 0,
    patternScale: e.patternScale || 1,
    // [BUG-DWG-HPSCALE-1] The pattern's OWN definition, as the file stores it, with
    // patternScale already applied — so `|offset|` is the world-space spacing the
    // author saw. `patternScale` alone is meaningless across two pattern libraries
    // (see importedPatternScale); this is the value that is not.
    patternSpacing: definitionLineSpacing(e.definitionLines),
    // Spec 07: libredwg's solid-fill indicator (DwgHatchSolidFill: 1 = SolidFill,
    // 0 = PatternFill) — pass it through so mapHatch maps a solid-filled HATCH to our
    // SOLID pattern even when the pattern name says otherwise.
    solidFill: !!e.solidFill
  };
}
function adaptDimension(e, base) {
  const kind = (e.dimensionType || 0) & 7;
  const P = (p) => p ? pt(p) : null;
  const common = { ...base, type: "DIMENSION", dimStyleName: e.styleName || null };
  switch (kind) {
    case 0:
    // rotated / horizontal / vertical (linear)
    case 1:
      return {
        ...common,
        dimType: kind === 1 ? "aligned" : "linear",
        p1: P(e.subDefinitionPoint1),
        p2: P(e.subDefinitionPoint2),
        linePoint: P(e.definitionPoint)
      };
    case 2:
    // angular (2-line)
    case 5:
      return {
        ...common,
        dimType: "angular",
        vertex: P(e.centerPoint),
        p1: P(e.subDefinitionPoint1),
        p2: P(e.subDefinitionPoint2)
      };
    case 3:
    // diameter
    case 4:
      return {
        ...common,
        dimType: kind === 3 ? "diameter" : "radius",
        center: P(e.centerPoint),
        leaderPoint: P(e.definitionPoint)
      };
    case 6:
      return {
        ...common,
        dimType: "ordinate",
        feature: P(e.subDefinitionPoint1),
        leader: P(e.subDefinitionPoint2),
        axis: (e.dimensionType || 0) & 64 ? "x" : "y",
        measurement: e.measurement
      };
    default:
      return { ...common, dimType: null };
  }
}
function adaptAttribs(attribs) {
  if (!Array.isArray(attribs) || !attribs.length) return void 0;
  const out = [];
  for (const a of attribs) {
    if (!a) continue;
    const t = a.text || {};
    const sp = t.startPoint || {};
    out.push({
      tag: a.attrTag || a.tag || "",
      value: t.text || "",
      x: sp.x || 0,
      y: sp.y || 0,
      height: t.textHeight || 1,
      rotation: deg(t.rotation),
      visible: !((a.flags || 0) & 1)
    });
  }
  return out.length ? out : void 0;
}
function adaptBlocks(db) {
  const blocks = /* @__PURE__ */ Object.create(null);
  const entries = db.tables && db.tables.BLOCK_RECORD && db.tables.BLOCK_RECORD.entries || [];
  for (const b of entries) {
    if (!b || !b.name) continue;
    const all = b.entities || [];
    const attdefs = all.filter((x) => x && x.type === "ATTDEF").map(adaptAttdef);
    blocks[b.name] = {
      entities: all.filter((x) => !x || x.type !== "ATTDEF").map(adaptEntity),
      position: b.basePoint ? pt(b.basePoint) : { x: 0, y: 0 },
      description: b.description || "",
      ...attdefs.length ? { attdefs } : {}
    };
  }
  return blocks;
}
function adaptAttdef(e) {
  const t = e.text || {};
  const sp = t.startPoint || {};
  return {
    tag: e.attrTag || e.tag || "",
    default: t.text || "",
    prompt: e.prompt || "",
    x: sp.x || 0,
    y: sp.y || 0,
    height: t.textHeight || 1,
    rotation: deg(t.rotation),
    visible: !((e.flags || 0) & 1)
  };
}
var DWG_LINEWT_100MM = [
  0,
  5,
  9,
  13,
  15,
  18,
  20,
  25,
  30,
  35,
  40,
  50,
  53,
  60,
  70,
  80,
  90,
  100,
  106,
  120,
  140,
  158,
  200,
  211
];
function adaptTables(db) {
  const t = db.tables || {};
  const layers = /* @__PURE__ */ Object.create(null);
  for (const L of t.LAYER && t.LAYER.entries || []) {
    if (!L || !L.name) continue;
    const aci = aci2int(L.colorIndex);
    const color = aci != null ? aci : typeof L.color === "number" && L.color !== 16777215 ? L.color : void 0;
    const lw = Number.isInteger(L.lineweight) ? DWG_LINEWT_100MM[L.lineweight] : void 0;
    layers[L.name] = {
      color,
      visible: !L.off,
      lineType: L.lineType,
      locked: !!L.locked,
      frozen: !!L.frozen,
      // [LAYER-PLOT-1]: libredwg exposes the LAYER's `plotflag` as `plotFlag`, a
      // raw 0/1 — its converter forwards this dynapi value unmapped, where it
      // maps `frozen`/`off` to booleans. `!== 0` rather than truthiness so an
      // entry that carries no flag at all — an older DWG, or a converter that
      // could not read it — imports as PLOTTING, the same default the DXF reader
      // uses. Verified against the real WASM kernel on the repo's own
      // `sample.dwg`: `plot: false` arrives on exactly `View Port` and
      // `Defpoints`, AutoCAD's two standard non-plotting layers.
      //
      // `locked` above is NOT sound and this comment does not vouch for it —
      // see [BUG-DWG-LOCKED-1] in ROADMAP §Bug-Backlog. libredwg-web 0.7.1 reads
      // the lock state from a dynapi field whose NAME is garbled
      // (`'plotflockedlag'`, a splice of plotflag+locked, in lib/ and dist/
      // alike), so `.data` is `undefined`, `undefined != 0` is `true`, and EVERY
      // layer of EVERY DWG imports locked. Not fixed here: the honest replacement
      // reads the flag word's bit 4, and proving that needs a DWG fixture that
      // contains a genuinely locked layer, which this repo does not have. The
      // fidelity suite cannot see any of it — it feeds this adapter a synthetic
      // database whose booleans are hand-written.
      plot: L.plotFlag !== 0,
      ...lw != null ? { lineWeight: lw } : {}
    };
  }
  const lineTypes = {};
  for (const lt of t.LTYPE && t.LTYPE.entries || []) {
    if (!lt || !lt.name) continue;
    lineTypes[lt.name] = {
      description: lt.description || "",
      // libredwg pattern elements carry their dash length in `elementLength`.
      pattern: Array.isArray(lt.pattern) ? lt.pattern.map((el) => el.elementLength || 0) : []
    };
  }
  const dimStyles = {};
  for (const ds of t.DIMSTYLE && t.DIMSTYLE.entries || []) {
    if (!ds || !ds.name) continue;
    dimStyles[ds.name] = ds;
  }
  const styles = {};
  for (const st of t.STYLE && t.STYLE.entries || []) {
    if (!st || !st.name) continue;
    if (String(st.name).toUpperCase() === "STANDARD") continue;
    styles[st.name] = st;
  }
  return { layer: { layers }, lineType: { lineTypes }, dimStyle: { dimStyles }, style: { styles } };
}
var MODEL_SPACE_NAMES = /* @__PURE__ */ new Set(["*model_space", "$model_space", "*model"]);
function modelSpaceHandle(db) {
  const entries = db.tables && db.tables.BLOCK_RECORD && db.tables.BLOCK_RECORD.entries || [];
  for (const b of entries) {
    if (b && typeof b.name === "string" && MODEL_SPACE_NAMES.has(b.name.toLowerCase())) {
      return b.handle == null ? null : String(b.handle).toUpperCase();
    }
  }
  return null;
}
function dwgDbToParsed(db) {
  const all = db && db.entities || [];
  const model = modelSpaceHandle(db);
  const inModel = model ? all.filter((e) => e && String(e.ownerBlockRecordSoftId || "").toUpperCase() === model) : all;
  const kept = inModel.length ? inModel : all;
  return {
    entities: kept.map(adaptEntity),
    blocks: adaptBlocks(db),
    tables: adaptTables(db),
    // For the fidelity report: how much of the file was on a SHEET and left there.
    otherSpaceSkipped: kept === inModel ? all.length - inModel.length : 0
  };
}

// src/cadEntityDraw.js
function arcPoints(cx, cy, r, startDeg, endDeg, segs = 48) {
  const a0 = startDeg * Math.PI / 180;
  let sweep = ((endDeg - startDeg) % 360 + 360) % 360;
  if (sweep === 0) sweep = 360;
  const n = Math.max(2, Math.ceil(sweep / 360 * segs));
  const out = [];
  for (let i = 0; i <= n; i++) {
    const a = a0 + sweep * Math.PI / 180 * (i / n);
    out.push({ x: cx + r * Math.cos(a), y: cy + r * Math.sin(a) });
  }
  return out;
}
var OP_KINDS = ["poly", "fill", "text", "image"];
function entityDrawOps(e, ctx = {}) {
  const ops = [];
  walk(e, 0, ops, ctx);
  return ops;
}
function withResolvedHeight(e, ts, tcur, sizing) {
  const h = effectiveEntityTextHeight(e, ts, tcur, sizing);
  return h === e.height ? e : { ...e, height: h };
}
function withResolvedTableHeight(e, sizing) {
  if (e.annotative !== true) return e;
  const th = paperMmToModel(e.paperHeight, sizingAnnoScale(sizing));
  return e.textHeight === th ? e : { ...e, textHeight: th };
}
function walk(e, depth, ops, ctx) {
  if (!e || !e.type) return;
  const blockDefs = ctx.blockDefs || {};
  const xrefDefs = ctx.xrefDefs || {};
  const ds = ctx.dimStyleDefs;
  const dcur = ctx.dimStyle;
  const ts = ctx.textStyleDefs;
  const tcur = ctx.textStyle;
  const sizing = ctx.sizing;
  const warnings = ctx.warnings;
  const colorOf = typeof ctx.colorOf === "function" ? ctx.colorOf : () => "#000000";
  const warn = (msg) => {
    if (warnings) warnings.push(msg);
  };
  const stroke = (src, worldPts, closed, colorHex) => {
    if (!worldPts || worldPts.length < 2) return;
    ops.push({
      kind: "poly",
      e: src,
      pts: worldPts,
      closed: !!closed,
      colorHex: colorHex || colorOf(src)
    });
  };
  const fill = (src, worldPts, colorHex, holes) => {
    const op = { kind: "fill", e: src, pts: worldPts, colorHex: colorHex || colorOf(src) };
    if (holes) op.holes = holes;
    ops.push(op);
  };
  const text = (src, x, y, str, height, rotationDeg, colorHex, justify, style) => {
    ops.push({
      kind: "text",
      e: src,
      x,
      y,
      text: str,
      height,
      rotationDeg: rotationDeg || 0,
      colorHex,
      justify,
      style
    });
  };
  switch (e.type) {
    case "line":
      stroke(
        e,
        [
          { x: e.x1, y: e.y1 },
          { x: e.x2, y: e.y2 }
        ],
        false
      );
      break;
    case "polyline":
    case "polygon":
      stroke(e, e.points || [], e.type === "polygon" || !!e.closed);
      break;
    case "rectangle":
      stroke(
        e,
        [
          { x: e.x, y: e.y },
          { x: e.x + e.width, y: e.y },
          { x: e.x + e.width, y: e.y + e.height },
          { x: e.x, y: e.y + e.height }
        ],
        true
      );
      break;
    case "circle":
      stroke(e, arcPoints(e.cx, e.cy, e.r, 0, 360), true);
      break;
    case "arc":
      stroke(e, arcPoints(e.cx, e.cy, e.r, e.startAngle, e.endAngle), false);
      break;
    case "ellipse":
      stroke(e, ellipseToPolyline(e), e.startAngle == null || e.endAngle == null);
      break;
    case "spline":
      stroke(e, splineToPolyline(e), !!e.closed);
      break;
    case "revcloud":
      stroke(e, revisionCloudArcs(e.points || [], !!e.closed, e.arcRadius), !!e.closed);
      break;
    case "ray":
    case "xline": {
      const L = Math.hypot(e.dx || 0, e.dy || 0) || 1;
      const ux = (e.dx || 0) / L;
      const uy = (e.dy || 0) / L;
      const ext = ctx.extent || { w: 1, h: 1 };
      const big = Math.max(ext.w || 0, ext.h || 0) * 4 + 1;
      const a = e.type === "ray" ? { x: e.x, y: e.y } : { x: e.x - ux * big, y: e.y - uy * big };
      stroke(e, [a, { x: e.x + ux * big, y: e.y + uy * big }], false);
      break;
    }
    case "point": {
      const sz = Number.isFinite(ctx.pointSizeWorld) && ctx.pointSizeWorld > 0 ? ctx.pointSizeWorld : 1;
      stroke(
        e,
        [
          { x: e.x - sz, y: e.y },
          { x: e.x + sz, y: e.y }
        ],
        false
      );
      stroke(
        e,
        [
          { x: e.x, y: e.y - sz },
          { x: e.x, y: e.y + sz }
        ],
        false
      );
      break;
    }
    case "text":
      text(
        e,
        e.x,
        e.y,
        e.text,
        // Model units. For an ANNOTATIVE entity the stored height is paper millimetres
        // and this converts it with the annotation scale on `sizing` — the drawing-wide
        // setting in model space, this viewport's plot scale on a sheet (2.2 crit 1).
        effectiveEntityTextHeight(e, ts, tcur, sizing),
        e.rotation,
        colorOf(e),
        e.justify,
        resolveTextStyle(e, ts, tcur)
      );
      break;
    case "mtext": {
      const src = withResolvedHeight(e, ts, tcur, sizing);
      const g = layoutMText(src);
      const hex = colorOf(e);
      const mts = resolveTextStyle(e, ts, tcur);
      for (const ln of g.lines) {
        if (!ln.text) continue;
        const bp = mtextToWorld(src, ln.dx, ln.dy + g.height);
        text(e, bp.x, bp.y, ln.text, g.height, e.rotation || 0, hex, void 0, mts);
      }
      break;
    }
    case "table": {
      const g = tableLayout(withResolvedTableHeight(e, sizing));
      const hex = colorOf(e);
      for (const [a, bb] of g.gridSegs) {
        stroke(e, [tableToWorld(e, a.x, a.y), tableToWorld(e, bb.x, bb.y)], false);
      }
      for (const [key, cell] of Object.entries(e.cells || {})) {
        if (!cell || !cell.text) continue;
        const [r, c] = key.split(",").map(Number);
        const pos = g.cellTextPos(r, c, cell.justify);
        if (!pos) continue;
        const wp = tableToWorld(e, pos.x, pos.y);
        const j = cell.justify === "C" ? "MC" : cell.justify === "R" ? "MR" : "ML";
        text(e, wp.x, wp.y, cell.text, g.textHeight, e.rotation || 0, hex, j, {
          bold: e.bold === true,
          italic: e.italic === true
        });
      }
      break;
    }
    case "hatch": {
      const lines = Array.isArray(e.cachedLines) ? e.cachedLines : [];
      const boundary = Array.isArray(e.cachedBoundary) ? e.cachedBoundary : [];
      if (lines.length) {
        for (const ln of lines)
          stroke(
            e,
            [
              { x: ln.x1, y: ln.y1 },
              { x: ln.x2, y: ln.y2 }
            ],
            false
          );
      } else if (boundary.length >= 3) {
        const holes = (Array.isArray(e.cachedHoles) ? e.cachedHoles : []).filter(
          (h) => Array.isArray(h) && h.length >= 3
        );
        fill(e, boundary, void 0, holes);
      }
      break;
    }
    // C4b. A region is a SOLID fill with even-odd holes — the same `fill` op the
    // solid-hatch branch above emits. That one op is what gives a region THREE of
    // its four renderers at once: paper space (CADPaperSpace/helpers.js's
    // fillPolygon), the plot walk (cadModelToPlot) and the PDF export
    // (CADPdfExport's fillEvenOdd) all dispatch on op.kind, not on entity type. Only
    // the live canvas needs a case of its own.
    case "region": {
      const rings = (Array.isArray(e.rings) ? e.rings : []).filter(
        (r) => Array.isArray(r) && r.length >= 3
      );
      if (rings.length) fill(e, rings[0], void 0, rings.slice(1));
      break;
    }
    // [RASTER-IMAGE-1] A raster op. It carries the def ID and the four WORLD
    // corners — not the bytes, and not `u`/`v`.
    //
    // Corners rather than the frame because an image nested in a BLOCK arrives
    // here already transformed (the insert case below maps its children through
    // `transformEntity`), so a consumer must never have to re-derive placement
    // from fields that describe the untransformed entity. The ID rather than the
    // bytes because this walk's output is built per frame and the bytes are ~1 MB;
    // consumers resolve through `ctx.imageDefs`.
    //
    // A missing def is REPORTED and still emits the op, with `missing: true`, so
    // every renderer can draw its named placeholder frame instead of nothing —
    // "nothing" is indistinguishable from "no image here", which is the failure
    // mode this feature can least afford.
    case "image": {
      const corners = imageCorners(e);
      if (corners.length !== 4) {
        warn(`image ${e.id || ""}: no usable frame \u2014 not drawn`);
        break;
      }
      const def = (ctx.imageDefs || {})[e.imageDefId];
      if (!def) warn(`image \u2192 missing definition "${e.imageDefId}"`);
      ops.push({
        kind: "image",
        e,
        imageDefId: e.imageDefId,
        mime: def ? def.mime : null,
        pixelWidth: def ? def.width : 0,
        pixelHeight: def ? def.height : 0,
        corners,
        opacity: typeof e.opacity === "number" ? e.opacity : 1,
        behind: e.behind !== false,
        missing: !def
      });
      break;
    }
    case "insert": {
      if (depth > 6) break;
      const def = blockDefs[e.blockName];
      if (!def) {
        warn(`insert \u2192 missing block "${e.blockName}"`);
        break;
      }
      for (const se of drawnBlockChildren(e, def, ctx.isShown)) {
        try {
          walk(se, depth + 1, ops, ctx);
        } catch (err) {
          warn(`block sub-entity: ${err && err.message}`);
        }
      }
      for (const a of e.attributes || []) {
        if (a.visible !== false && a.value)
          text(e, a.x, a.y, a.value, a.height, a.rotation, colorOf(e));
      }
      break;
    }
    case "xref": {
      const def = xrefDefs[e.name];
      const { paths, texts } = xrefDrawSegments(e, def);
      const src = { ...e, color: e.color || "#888888" };
      const hex = colorOf(src);
      for (const p of paths || [])
        if (p.points && p.points.length) stroke(src, p.points, !!p.closed, hex);
      const labelSrc = { ...e, color: "#888888" };
      const labelHex = colorOf(labelSrc);
      for (const t of texts || []) text(e, t.x, t.y, t.text, t.height || 2, t.rotation, labelHex);
      break;
    }
    case "leader": {
      const g = leaderGeometry(e, ds, dcur, sizing);
      if (!g) break;
      const hex = colorOf(e);
      for (const s of g.segs) stroke(e, [s[0], s[1]], false);
      if (g.landing) stroke(e, g.landing, false);
      arrowOps(g.arrow, e, hex, stroke, fill);
      text(
        e,
        g.textPos.x,
        g.textPos.y,
        e.text,
        g.textHeight,
        0,
        hex,
        g.textAlignRight ? "BR" : "BL"
      );
      break;
    }
    case "dimension": {
      const hex = colorOf(e);
      const th = effectiveTextHeight(e, ds, dcur, sizing);
      const rawTextHex = dimensionTextColor(e, ds, dcur, null);
      const textHex = rawTextHex ? colorOf({ ...e, color: rawTextHex }) : hex;
      const arrow = (ar) => arrowOps(ar, e, hex, stroke, fill);
      if (e.dimType === "angular") {
        const g = angularGeometry(e, ds, dcur, sizing);
        stroke(e, g.ext1, false);
        stroke(e, g.ext2, false);
        stroke(e, arcPoints(g.arc.cx, g.arc.cy, g.arc.r, g.arc.startAngle, g.arc.endAngle), false);
        for (const ar of g.arrows || []) arrow(ar);
        text(e, g.textPos.x, g.textPos.y, dimensionLabel(e, ds, dcur), th, 0, textHex);
      } else if (e.dimType === "radius" || e.dimType === "diameter") {
        const g = radialGeometry(e, ds, dcur, sizing);
        stroke(e, g.line, false);
        for (const ar of g.arrows || []) arrow(ar);
        text(e, g.textPos.x, g.textPos.y, dimensionLabel(e, ds, dcur), th, 0, textHex);
      } else if (e.dimType === "ordinate") {
        const g = ordinateGeometry(e);
        stroke(e, g.leader, false);
        text(e, g.textPos.x, g.textPos.y, dimensionLabel(e, ds, dcur), th, 0, textHex);
      } else if (e.dimType === "arclength") {
        const g = arclengthGeometry(e, ds, dcur, sizing);
        if (g) {
          stroke(e, g.ext1, false);
          stroke(e, g.ext2, false);
          stroke(
            e,
            arcPoints(g.arc.cx, g.arc.cy, g.arc.r, g.arc.startAngle, g.arc.endAngle),
            false
          );
          for (const ar of g.arrows || []) arrow(ar);
          text(e, g.textPos.x, g.textPos.y, dimensionLabel(e, ds, dcur), th, 0, textHex);
        }
      } else {
        const g = dimensionGeometry(e, ds, dcur, sizing);
        stroke(e, g.ext1, false);
        stroke(e, g.ext2, false);
        stroke(e, g.dimLine, false);
        for (const ar of g.arrows || []) arrow(ar);
        text(
          e,
          g.textPos.x,
          g.textPos.y,
          dimensionLabel(e, ds, dcur),
          th,
          g.textAngle || 0,
          textHex
        );
      }
      break;
    }
    default:
      warn(`unplotted entity type "${e.type}"`);
  }
}
function arrowOps(ar, e, hex, stroke, fill) {
  if (!ar) return;
  if (ar.kind === "triangle") {
    if (ar.filled) fill(e, ar.pts, hex);
    else stroke(e, ar.pts, true, hex);
  } else if (ar.kind === "tick") {
    stroke(e, ar.seg, false, hex);
  } else if (ar.kind === "dot") {
    fill(e, arcPoints(ar.c.x, ar.c.y, ar.r, 0, 360), hex);
  }
}
function orderForDraw(entities) {
  if (!Array.isArray(entities)) return entities;
  const isBack = (e) => !!e && e.type === "image" && e.behind !== false;
  let seenOther = false;
  let needs = false;
  for (const e of entities) {
    if (isBack(e)) {
      if (seenOther) {
        needs = true;
        break;
      }
    } else seenOther = true;
  }
  if (!needs) return entities;
  const back = [];
  const front = [];
  for (const e of entities) (isBack(e) ? back : front).push(e);
  return [...back, ...front];
}

// src/cadSvgExport/format.js
function fmt(n) {
  if (!Number.isFinite(n)) return "0";
  return String(Math.round(n * 1e6) / 1e6);
}
function esc(s) {
  return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F]/g, "");
}

// src/cadSvgExport/entity.js
var ARC_SEGS = 64;
function arcPoints2(cx, cy, r, startDeg, endDeg) {
  let sweep = ((endDeg - startDeg) % 360 + 360) % 360;
  if (sweep === 0) sweep = 360;
  const n = Math.max(2, Math.ceil(sweep / 360 * ARC_SEGS));
  const a0 = startDeg * Math.PI / 180;
  const da = sweep * Math.PI / 180 / n;
  const pts = [];
  for (let i = 0; i <= n; i++) {
    const a = a0 + da * i;
    pts.push({ x: cx + r * Math.cos(a), y: cy + r * Math.sin(a) });
  }
  return pts;
}
function entityToSvg(e, ctx, depth = 0) {
  if (!e || !e.type) return "";
  const Y = (y) => -y;
  const colorOf = () => {
    const c = e.color || ctx.doc && resolveColor(e, ctx.doc.layers || []);
    return c ? ctx.adjust(c) : null;
  };
  const strokeAttr = () => {
    const c = e.color ? ctx.adjust(e.color) : null;
    let out = c ? ` stroke="${esc(c)}"` : "";
    const wWorld = polylineWidthWorld(e);
    const pen = ctx.plotPen ? ctx.plotPen(e.color || ctx.doc && resolveColor(e, ctx.doc.layers || [])) : null;
    const lwMm = pen && pen.lineweightMm != null ? pen.lineweightMm : resolveLineweightMm(e, ctx.layers || ctx.doc && ctx.doc.layers || []);
    if (wWorld > 0) {
      out += ` stroke-width="${fmt(ctx.worldMax > 0 ? Math.min(ctx.worldMax, wWorld) : wWorld)}"`;
    } else if (lwMm > 0 && lwMm !== DEFAULT_LINEWEIGHT_MM) {
      out += ` stroke-width="${fmt(ctx.strokeWidth * (lwMm / DEFAULT_LINEWEIGHT_MM))}"`;
    }
    const pattern = resolveLinetypePattern(
      e,
      ctx.layers || ctx.doc && ctx.doc.layers || [],
      ctx.linetypeDefs
    );
    if (pattern) {
      const objScale = Number.isFinite(e.ltScale) && e.ltScale > 0 ? e.ltScale : 1;
      const dash = linetypeToDash(pattern, (ctx.ltscale || 1) * objScale, 1);
      if (dash && dash.length) out += ` stroke-dasharray="${dash.map(fmt).join(",")}"`;
    }
    return out;
  };
  const ptList = (pts) => pts.map((p) => `${fmt(p.x)},${fmt(Y(p.y))}`).join(" ");
  const poly = (pts, closed) => `<${closed ? "polygon" : "polyline"} points="${ptList(pts)}"${strokeAttr()}/>`;
  switch (e.type) {
    case "line":
      return `<line x1="${fmt(e.x1)}" y1="${fmt(Y(e.y1))}" x2="${fmt(e.x2)}" y2="${fmt(Y(e.y2))}"${strokeAttr()}/>`;
    case "polyline":
      return e.points && e.points.length ? poly(e.points, !!e.closed) : "";
    case "polygon":
      return e.points && e.points.length ? poly(e.points, true) : "";
    case "rectangle":
      return poly(
        [
          { x: e.x, y: e.y },
          { x: e.x + e.width, y: e.y },
          { x: e.x + e.width, y: e.y + e.height },
          { x: e.x, y: e.y + e.height }
        ],
        true
      );
    case "circle":
      return `<circle cx="${fmt(e.cx)}" cy="${fmt(Y(e.cy))}" r="${fmt(e.r)}"${strokeAttr()}/>`;
    case "arc":
      return poly(arcPoints2(e.cx, e.cy, e.r, e.startAngle, e.endAngle), false);
    case "ellipse":
      return poly(ellipseToPolyline(e), e.startAngle == null || e.endAngle == null);
    case "spline": {
      const pts = splineToPolyline(e);
      return pts.length ? poly(pts, !!e.closed) : "";
    }
    case "revcloud": {
      const pts = revisionCloudArcs(e.points || [], !!e.closed, e.arcRadius);
      return pts.length ? poly(pts, !!e.closed) : "";
    }
    case "ray":
    case "xline":
      return infiniteLine(e, ctx, Y, strokeAttr());
    case "point":
      return pointMark(e, ctx, Y, strokeAttr());
    case "text": {
      const doc = ctx.doc;
      const cur = doc && doc.settings && doc.settings.currentTextStyle;
      const ts = resolveTextStyle(e, doc && doc.textStyleDefs, cur);
      const h = effectiveEntityTextHeight(e, doc && doc.textStyleDefs, cur, ctx.dimSizing) || 1;
      return textEl(e.x, e.y, e.text, h, e.rotation || 0, colorOf(), Y, e.justify, ts);
    }
    case "mtext": {
      const doc = ctx.doc;
      const cur = doc && doc.settings && doc.settings.currentTextStyle;
      const ts = resolveTextStyle(e, doc && doc.textStyleDefs, cur);
      const mh = effectiveEntityTextHeight(e, doc && doc.textStyleDefs, cur, ctx.dimSizing);
      return mtextEl(mh === e.height ? e : { ...e, height: mh }, Y, colorOf(), ts);
    }
    case "table":
      return tableEl(e, Y, colorOf());
    case "hatch":
      return hatchEl(e, ctx, Y);
    case "region":
      return regionEl(e, ctx, Y);
    case "dimension":
      return dimensionEl(e, ctx, Y, colorOf());
    case "leader":
      return leaderEl(e, ctx, Y, colorOf());
    case "image":
      return imageEl(e, ctx, Y);
    case "insert":
      return insertEl(e, ctx, depth, Y);
    case "xref":
      return ctx.includeXrefs ? xrefEl(e, ctx, Y) : "";
    default:
      ctx.warnings.push(`unrendered entity type "${e.type}" (${e.id})`);
      return "";
  }
}
function weightAttrs(s) {
  return (s && s.bold === true ? ' font-weight="bold"' : "") + (s && s.italic === true ? ' font-style="italic"' : "");
}
function textEl(x, y, text, h, rotDeg, fill, Y, justify, ts) {
  if (text == null || text === "") return "";
  const wf = ts && Number.isFinite(ts.widthFactor) && ts.widthFactor > 0 ? ts.widthFactor : 1;
  const ob = ts && Number.isFinite(ts.oblique) ? ts.oblique : 0;
  const shape = (wf !== 1 ? ` scale(${fmt(wf)},1)` : "") + (ob !== 0 ? ` skewX(${fmt(-ob)})` : "");
  const tr = `translate(${fmt(x)},${fmt(Y(y))})${rotDeg ? ` rotate(${fmt(-rotDeg)})` : ""}${shape}`;
  const fillAttr = fill ? ` fill="${esc(fill)}"` : "";
  const { fx, fy } = justifyFactors(justify);
  const anchorAttr = fx === 0.5 ? ' text-anchor="middle"' : fx === 1 ? ' text-anchor="end"' : "";
  const dyVal = fy === 0 ? h : fy === 0.5 ? h * 0.5 : 0;
  const dyAttr = dyVal ? ` dy="${fmt(dyVal)}"` : "";
  return `<text transform="${tr}"${anchorAttr} font-size="${fmt(h)}" font-family="sans-serif"${weightAttrs(ts)} stroke="none"${fillAttr}${dyAttr}>${esc(text)}</text>`;
}
function mtextEl(e, Y, color, ts) {
  const g = layoutMText(e);
  const rot = e.rotation || 0;
  const wf = ts && Number.isFinite(ts.widthFactor) && ts.widthFactor > 0 ? ts.widthFactor : 1;
  const ob = ts && Number.isFinite(ts.oblique) ? ts.oblique : 0;
  const shape = (wf !== 1 ? ` scale(${fmt(wf)},1)` : "") + (ob !== 0 ? ` skewX(${fmt(-ob)})` : "");
  const tr = `translate(${fmt(e.x)},${fmt(Y(e.y))})${rot ? ` rotate(${fmt(-rot)})` : ""}${shape}`;
  const parts = g.lines.filter((ln) => ln.text !== "").map((ln) => `<text x="${fmt(ln.dx)}" y="${fmt(ln.dy + g.height)}">${esc(ln.text)}</text>`);
  return `<g transform="${tr}" fill="${esc(color || "#000000")}" stroke="none" font-size="${fmt(g.height)}" font-family="sans-serif"${weightAttrs(ts)}>${parts.join("")}</g>`;
}
function tableEl(e, Y, color) {
  const g = tableLayout(e);
  if (!g.gridSegs.length) return "";
  const rot = e.rotation || 0;
  const tr = `translate(${fmt(e.x)},${fmt(Y(e.y))})${rot ? ` rotate(${fmt(-rot)})` : ""}`;
  const stroke = color || "#000000";
  const d = g.gridSegs.map(([a, b]) => `M${fmt(a.x)} ${fmt(a.y)} L${fmt(b.x)} ${fmt(b.y)}`).join(" ");
  const texts = [];
  for (const [key, cell] of Object.entries(e.cells || {})) {
    if (!cell || !cell.text) continue;
    const [r, c] = key.split(",").map(Number);
    const pos = g.cellTextPos(r, c, cell.justify);
    if (!pos) continue;
    const anchor = cell.justify === "C" ? ' text-anchor="middle"' : cell.justify === "R" ? ' text-anchor="end"' : "";
    texts.push(
      `<text x="${fmt(pos.x)}" y="${fmt(pos.y)}"${anchor} dy="${fmt(g.textHeight * 0.5)}">${esc(cell.text)}</text>`
    );
  }
  return `<g transform="${tr}" stroke="${esc(stroke)}" fill="none"><path d="${d}"/>` + (texts.length ? `<g stroke="none" fill="${esc(stroke)}" font-size="${fmt(g.textHeight)}" font-family="sans-serif"${weightAttrs(e)}>${texts.join("")}</g>` : "") + "</g>";
}
function infiniteLine(e, ctx, Y, sa) {
  const dx = e.dx || 0;
  const dy = e.dy || 0;
  const len2 = Math.hypot(dx, dy) || 1;
  const ux = dx / len2;
  const uy = dy / len2;
  const big = (ctx.strokeWidth || 1) * 4e6 + 1e6;
  const a = e.type === "ray" ? { x: e.x, y: e.y } : { x: e.x - ux * big, y: e.y - uy * big };
  const b = { x: e.x + ux * big, y: e.y + uy * big };
  return `<line x1="${fmt(a.x)}" y1="${fmt(Y(a.y))}" x2="${fmt(b.x)}" y2="${fmt(Y(b.y))}"${sa}/>`;
}
function pointMark(e, ctx, Y, sa) {
  const s = (ctx.strokeWidth || 1) * 6;
  const x = e.x;
  const y = e.y;
  return `<line x1="${fmt(x - s)}" y1="${fmt(Y(y))}" x2="${fmt(x + s)}" y2="${fmt(Y(y))}"${sa}/><line x1="${fmt(x)}" y1="${fmt(Y(y - s))}" x2="${fmt(x)}" y2="${fmt(Y(y + s))}"${sa}/>`;
}
function hatchEl(e, ctx, Y) {
  const sa = e.color ? ` stroke="${esc(ctx.adjust(e.color))}"` : "";
  const lines = Array.isArray(e.cachedLines) ? e.cachedLines : [];
  const boundary = Array.isArray(e.cachedBoundary) ? e.cachedBoundary : [];
  const out = [];
  const solid = e.patternName === "SOLID" || lines.length === 0 && boundary.length >= 3;
  if (solid && boundary.length >= 3) {
    const ringPath = (ring) => ring.map((p, i) => `${i ? "L" : "M"}${fmt(p.x)} ${fmt(Y(p.y))}`).join(" ") + " Z";
    const holes = (Array.isArray(e.cachedHoles) ? e.cachedHoles : []).filter(
      (h) => Array.isArray(h) && h.length >= 3
    );
    const d = [boundary, ...holes].map(ringPath).join(" ");
    const fill = ctx.adjust(e.color || "#888888");
    out.push(`<path d="${d}" fill="${esc(fill)}" fill-rule="evenodd" stroke="none"/>`);
  }
  if (lines.length) {
    const d = lines.map((s) => `M${fmt(s.x1)} ${fmt(Y(s.y1))} L${fmt(s.x2)} ${fmt(Y(s.y2))}`).join(" ");
    out.push(`<path d="${d}" fill="none"${sa}/>`);
  }
  return out.join("");
}
function regionEl(e, ctx, Y) {
  const rings = (Array.isArray(e.rings) ? e.rings : []).filter(
    (r) => Array.isArray(r) && r.length >= 3
  );
  if (!rings.length) return "";
  const ringPath = (ring) => ring.map((p, i) => `${i ? "L" : "M"}${fmt(p.x)} ${fmt(Y(p.y))}`).join(" ") + " Z";
  const d = rings.map(ringPath).join(" ");
  const fill = ctx.adjust(e.color || "#888888");
  return `<path d="${d}" fill="${esc(fill)}" fill-rule="evenodd" stroke="none"/>`;
}
function imageEl(e, ctx, Y) {
  const corners = imageCorners(e);
  if (corners.length !== 4) return "";
  const def = ctx.doc && ctx.doc.imageDefs && ctx.doc.imageDefs[e.imageDefId] || null;
  if (!def) {
    ctx.warnings.push(`image ${e.id}: its picture is missing \u2014 drawn as an empty frame`);
    const d = corners.map((p, i) => `${i ? "L" : "M"}${fmt(p.x)} ${fmt(Y(p.y))}`).join(" ") + " Z";
    return `<path d="${d}" fill="none" stroke="${esc(ctx.adjust("#888888"))}" stroke-dasharray="4 4"/>`;
  }
  const m = imageMatrix(e, def);
  const mat = [m[0], -m[1], m[2], -m[3], m[4], Y(m[5])];
  const op = typeof e.opacity === "number" && e.opacity < 1 ? ` opacity="${fmt(e.opacity)}"` : "";
  return `<image width="${def.width}" height="${def.height}"${op} transform="matrix(${mat.map(fmt).join(" ")})" href="${esc(imageDataUrl(def))}" preserveAspectRatio="none"/>`;
}
function dimensionEl(e, ctx, Y, color) {
  const ds = ctx.doc && ctx.doc.dimStyleDefs;
  const sz = ctx.dimSizing;
  const dcur = ctx.doc && ctx.doc.settings && ctx.doc.settings.currentDimStyle;
  const seg = (a, p) => `<line x1="${fmt(a.x)}" y1="${fmt(Y(a.y))}" x2="${fmt(p.x)}" y2="${fmt(Y(p.y))}"/>`;
  const stroke = color || "#000000";
  const th = effectiveTextHeight(e, ds, dcur, sz);
  const rawTextFill = dimensionTextColor(e, ds, dcur, null);
  const textFill = rawTextFill ? ctx.adjust(rawTextFill) : stroke;
  const arrowSvg = (ar) => {
    if (!ar) return "";
    if (ar.kind === "triangle") {
      const pts = ar.pts.map((p) => `${fmt(p.x)},${fmt(Y(p.y))}`).join(" ");
      return ar.filled ? `<polygon points="${pts}" fill="${esc(stroke)}" stroke="none"/>` : `<polygon points="${pts}" fill="none" stroke="${esc(stroke)}"/>`;
    }
    if (ar.kind === "tick") return seg(ar.seg[0], ar.seg[1]);
    if (ar.kind === "dot")
      return `<circle cx="${fmt(ar.c.x)}" cy="${fmt(Y(ar.c.y))}" r="${fmt(ar.r)}" fill="${esc(stroke)}" stroke="none"/>`;
    return "";
  };
  const parts = [];
  const open = `<g stroke="${esc(stroke)}" fill="none">`;
  if (e.dimType === "angular") {
    const g = angularGeometry(e, ds, dcur, sz);
    if (g.ext1) parts.push(seg(g.ext1[0], g.ext1[1]));
    if (g.ext2) parts.push(seg(g.ext2[0], g.ext2[1]));
    parts.push(poly2(arcPoints2(g.arc.cx, g.arc.cy, g.arc.r, g.arc.startAngle, g.arc.endAngle), Y));
    for (const ar of g.arrows || []) parts.push(arrowSvg(ar));
    parts.push(textEl(g.textPos.x, g.textPos.y, dimensionLabel(e, ds, dcur), th, 0, textFill, Y));
  } else if (e.dimType === "radius" || e.dimType === "diameter") {
    const g = radialGeometry(e, ds, dcur, sz);
    parts.push(seg(g.line[0], g.line[1]));
    if (g.landing) parts.push(seg(g.landing[0], g.landing[1]));
    for (const [a, b] of g.centerMark || []) parts.push(seg(a, b));
    for (const ar of g.arrows || []) parts.push(arrowSvg(ar));
    parts.push(textEl(g.textPos.x, g.textPos.y, dimensionLabel(e, ds, dcur), th, 0, textFill, Y));
  } else if (e.dimType === "ordinate") {
    const g = ordinateGeometry(e);
    parts.push(poly2(g.leader, Y));
    parts.push(textEl(g.textPos.x, g.textPos.y, dimensionLabel(e, ds, dcur), th, 0, textFill, Y));
  } else if (e.dimType === "arclength") {
    const g = arclengthGeometry(e, ds, dcur, sz);
    if (g) {
      if (g.ext1) parts.push(seg(g.ext1[0], g.ext1[1]));
      if (g.ext2) parts.push(seg(g.ext2[0], g.ext2[1]));
      parts.push(
        poly2(arcPoints2(g.arc.cx, g.arc.cy, g.arc.r, g.arc.startAngle, g.arc.endAngle), Y)
      );
      for (const ar of g.arrows || []) parts.push(arrowSvg(ar));
      parts.push(textEl(g.textPos.x, g.textPos.y, dimensionLabel(e, ds, dcur), th, 0, textFill, Y));
    }
  } else {
    const g = dimensionGeometry(e, ds, dcur, sz);
    if (g.ext1) parts.push(seg(g.ext1[0], g.ext1[1]));
    if (g.ext2) parts.push(seg(g.ext2[0], g.ext2[1]));
    parts.push(seg(g.dimLine[0], g.dimLine[1]));
    for (const ar of g.arrows || []) parts.push(arrowSvg(ar));
    parts.push(
      textEl(g.textPos.x, g.textPos.y, dimensionLabel(e, ds, dcur), th, g.textAngle || 0, textFill, Y)
    );
  }
  return open + parts.join("") + "</g>";
}
function poly2(pts, Y) {
  return `<polyline points="${pts.map((p) => `${fmt(p.x)},${fmt(Y(p.y))}`).join(" ")}"/>`;
}
function leaderEl(e, ctx, Y, color) {
  const dcur = ctx.doc && ctx.doc.settings && ctx.doc.settings.currentDimStyle;
  const g = leaderGeometry(e, ctx.doc && ctx.doc.dimStyleDefs, dcur, ctx.dimSizing);
  if (!g) return "";
  const stroke = color || "#000000";
  const seg = (a, b) => `<line x1="${fmt(a.x)}" y1="${fmt(Y(a.y))}" x2="${fmt(b.x)}" y2="${fmt(Y(b.y))}"/>`;
  const arrowSvg = (ar) => {
    if (!ar) return "";
    if (ar.kind === "triangle") {
      const pts = ar.pts.map((p) => `${fmt(p.x)},${fmt(Y(p.y))}`).join(" ");
      return ar.filled ? `<polygon points="${pts}" fill="${esc(stroke)}" stroke="none"/>` : `<polygon points="${pts}" fill="none" stroke="${esc(stroke)}"/>`;
    }
    if (ar.kind === "tick") return seg(ar.seg[0], ar.seg[1]);
    if (ar.kind === "dot")
      return `<circle cx="${fmt(ar.c.x)}" cy="${fmt(Y(ar.c.y))}" r="${fmt(ar.r)}" fill="${esc(stroke)}" stroke="none"/>`;
    return "";
  };
  const parts = [];
  for (const s of g.segs) parts.push(seg(s[0], s[1]));
  if (g.landing) parts.push(seg(g.landing[0], g.landing[1]));
  parts.push(arrowSvg(g.arrow));
  parts.push(
    textEl(
      g.textPos.x,
      g.textPos.y,
      e.text,
      g.textHeight,
      0,
      stroke,
      Y,
      g.textAlignRight ? "BR" : "BL"
    )
  );
  return `<g stroke="${esc(stroke)}" fill="none">` + parts.join("") + "</g>";
}
function insertEl(e, ctx, depth, Y) {
  if (depth > 6) return "";
  const def = ctx.blockDefs && ctx.blockDefs[e.blockName];
  if (!def) {
    ctx.warnings.push(`insert references missing block "${e.blockName}" (${e.id})`);
    return "";
  }
  const out = [];
  for (const se of drawnBlockChildren(e, def, ctx.isShown)) {
    try {
      const frag = entityToSvg(se, ctx, depth + 1);
      if (frag) out.push(frag);
    } catch (err) {
      ctx.warnings.push(`skipped block sub-entity in "${e.blockName}": ${err && err.message}`);
    }
  }
  for (const a of e.attributes || []) {
    if (a.visible === false) continue;
    out.push(textEl(a.x, a.y, a.value, a.height || 1, a.rotation || 0, null, Y));
  }
  return out.length ? `<g>${out.join("")}</g>` : "";
}
function xrefEl(e, ctx, Y) {
  const def = ctx.xrefDefs && ctx.xrefDefs[e.name];
  const { paths, texts } = xrefDrawSegments(e, def);
  if (!paths.length && !texts.length) return "";
  const out = [];
  for (const p of paths) {
    if (!p.points || !p.points.length) continue;
    const tag = p.closed ? "polygon" : "polyline";
    out.push(`<${tag} points="${p.points.map((q) => `${fmt(q.x)},${fmt(Y(q.y))}`).join(" ")}"/>`);
  }
  const labelFill = ctx.adjust("#888888");
  for (const t of texts)
    out.push(textEl(t.x, t.y, t.text, t.height || 2, t.rotation || 0, labelFill, Y));
  return `<g stroke="${esc(ctx.adjust("#888888"))}" fill="none" opacity="0.7">${out.join("")}</g>`;
}

// src/cadSvgExport/cadModelToSVG.js
function isNearWhite(hex) {
  if (typeof hex !== "string") return false;
  let h = hex.trim().toLowerCase();
  if (h === "white") return true;
  if (h[0] === "#") h = h.slice(1);
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  if (h.length !== 6) return false;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return r > 240 && g > 240 && b > 240;
}
function isLight(hex) {
  if (typeof hex !== "string") return true;
  let h = hex.trim().toLowerCase();
  if (h[0] === "#") h = h.slice(1);
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  if (h.length !== 6) return true;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return 0.299 * r + 0.587 * g + 0.114 * b > 140;
}
function safeBounds(entities, blockDefs, xrefDefs, warnings) {
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
  for (const e of entities) {
    try {
      const b = entityBounds(e, blockDefs, xrefDefs);
      if (!b) continue;
      if (b.minX < minX) minX = b.minX;
      if (b.minY < minY) minY = b.minY;
      if (b.maxX > maxX) maxX = b.maxX;
      if (b.maxY > maxY) maxY = b.maxY;
    } catch (err) {
      warnings.push(`bounds skipped for ${e && e.type} (${e && e.id}): ${err && err.message}`);
    }
  }
  return Number.isFinite(minX) ? { minX, minY, maxX, maxY } : null;
}
function cadModelToSVG(doc, opts = {}) {
  const {
    background = "#ffffff",
    maxPx = 1200,
    includeXrefs = true,
    flipWhiteOnLight = true,
    // Global LTSCALE for exported dashes — read from the drawing header (doc.settings),
    // with an explicit opts override winning when a caller passes one.
    ltscale = doc && doc.settings && doc.settings.ltscale || 1
  } = opts;
  const layers = doc && doc.layers || [];
  const entities = doc && doc.entities || [];
  const blockDefs = doc && doc.blockDefs || {};
  const xrefDefs = doc && doc.xrefDefs || {};
  const warnings = [];
  const framed = unfrozenEntities(entities, layers);
  const bounds = safeBounds(framed, blockDefs, xrefDefs, warnings);
  const sizingBounds = framed === entities ? bounds : safeBounds(entities, blockDefs, xrefDefs, []);
  const empty = !bounds;
  const b = bounds || { minX: 0, minY: 0, maxX: 1, maxY: 1 };
  const wWorld = Math.max(b.maxX - b.minX, 1e-6);
  const hWorld = Math.max(b.maxY - b.minY, 1e-6);
  const extent = Math.max(wWorld, hWorld);
  const margin = opts.margin != null ? opts.margin : extent * 0.02;
  const strokeWidth = opts.strokeWidth != null ? opts.strokeWidth : extent / 1e3;
  const vbX = b.minX - margin;
  const vbY = -b.maxY - margin;
  const vbW = wWorld + margin * 2;
  const vbH = hWorld + margin * 2;
  const pxScale = maxPx / Math.max(vbW, vbH);
  const pxW = Math.max(1, Math.round(vbW * pxScale));
  const pxH = Math.max(1, Math.round(vbH * pxScale));
  const bgLight = background == null ? true : isLight(background);
  const plotStyle = normalizePlotStyleTable(
    opts.plotStyle !== void 0 ? opts.plotStyle : doc && doc.settings && doc.settings.plotStyle
  );
  const mono = isMonoPlot(plotStyle, opts.colorMode);
  const plotPen = makePlotPenResolver(plotStyle);
  const flip = (hex) => flipWhiteOnLight && bgLight && isNearWhite(hex) ? "#000000" : hex;
  const adjust = (hex) => {
    if (mono) return "#000000";
    const pen = plotPen(hex);
    if (pen && pen.plotColor) return pen.plotColor;
    return flip(hex);
  };
  const layerByName = layerIndex(layers);
  const svgShows = (name) => {
    const l = layerByName.get(name);
    return layerShown(l) && layerPlotted(l);
  };
  const worldMax = Math.hypot(wWorld, hWorld);
  const ctx = { doc, layers, blockDefs, xrefDefs, strokeWidth, worldMax, adjust, plotPen, warnings, includeXrefs, ltscale, isShown: svgShows, linetypeDefs: doc && doc.linetypeDefs || LINETYPE_DEFS, dimSizing: makeDimSizing(doc, sizingBounds) };
  const byLayer = /* @__PURE__ */ new Map();
  for (const e of entities) {
    const ln = e && e.layer || "0";
    if (!byLayer.has(ln)) byLayer.set(ln, []);
    byLayer.get(ln).push(e);
  }
  const ordered = [];
  const seen = /* @__PURE__ */ new Set();
  for (const l of layers) {
    if (byLayer.has(l.name) && !seen.has(l.name)) {
      ordered.push(l.name);
      seen.add(l.name);
    }
  }
  for (const ln of byLayer.keys()) if (!seen.has(ln)) ordered.push(ln);
  const groups = [];
  for (const ln of ordered) {
    const layer = layerByName.get(ln);
    if (!layerShown(layer)) continue;
    if (!layerPlotted(layer)) continue;
    const layerColor = adjust(layer && layer.color || "#000000");
    const parts = [];
    for (const e of orderForDraw(byLayer.get(ln))) {
      try {
        const frag = entityToSvg(e, ctx);
        if (frag) parts.push(frag);
      } catch (err) {
        warnings.push(`skipped ${e && e.type} (${e && e.id}): ${err && err.message}`);
      }
    }
    if (!parts.length) continue;
    groups.push(
      `<g data-layer="${esc(ln)}" stroke="${esc(layerColor)}" fill="none" stroke-width="${fmt(strokeWidth)}" stroke-linecap="round" stroke-linejoin="round">
` + parts.join("\n") + `
</g>`
    );
  }
  const bgRect = background == null ? "" : `<rect x="${fmt(vbX)}" y="${fmt(vbY)}" width="${fmt(vbW)}" height="${fmt(vbH)}" fill="${esc(background)}" stroke="none"/>
`;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="${pxW}" height="${pxH}" viewBox="${fmt(vbX)} ${fmt(vbY)} ${fmt(vbW)} ${fmt(vbH)}">
` + bgRect + groups.join("\n") + `
</svg>
`;
  return { svg, warnings, empty };
}

// src/cadCsvPoints.js
var CSV_POINTS_LAYER = "GIS-POINTS";
var CSV_POINTS_LAYER_DEF = Object.freeze({
  name: CSV_POINTS_LAYER,
  color: "#00ff88",
  visible: true,
  locked: false,
  frozen: false,
  plot: true
});
var MAX_CSV_ROWS = 2e5;
var BOM = String.fromCharCode(65279);
var DELIMITERS = [",", ";", "	"];
var HEADER_WORDS = /^(id|point|pt|name|no|e|east|easting|x|n|north|northing|y|label|desc|description|comment)$/i;
function splitLine(line, delim) {
  const out = [];
  let cur = "";
  let quoted = false;
  for (let i = 0; i < line.length; i++) {
    const c = line[i];
    if (quoted) {
      if (c === '"') {
        if (line[i + 1] === '"') {
          cur += '"';
          i++;
        } else quoted = false;
      } else cur += c;
    } else if (c === '"') quoted = true;
    else if (c === delim) {
      out.push(cur);
      cur = "";
    } else cur += c;
  }
  out.push(cur);
  return out.map((s) => s.trim());
}
function detectDelimiter(line) {
  let best = ",";
  let bestCount = 0;
  for (const d of DELIMITERS) {
    const n = splitLine(line, d).length;
    if (n > bestCount) {
      bestCount = n;
      best = d;
    }
  }
  return best;
}
function parseNumber(s) {
  if (typeof s !== "string") return NaN;
  const t = s.trim().replace(/^\+/, "");
  if (!t || !/^-?(\d+\.?\d*|\.\d+)([eE][-+]?\d+)?$/.test(t)) return NaN;
  const v = Number(t);
  return Number.isFinite(v) ? v : NaN;
}
function parseCsvPoints(text) {
  const empty = { ok: false, rows: [], errors: [], delimiter: ",", hadHeader: false };
  if (typeof text !== "string" || !text.trim()) {
    return { ...empty, errors: [{ line: 0, reason: "empty", text: "" }] };
  }
  const body = text.startsWith(BOM) ? text.slice(BOM.length) : text;
  const lines = body.split(/\r\n|\n|\r/);
  const firstContent = lines.find((l) => l.trim() && !l.trim().startsWith("#")) ?? "";
  const delimiter = detectDelimiter(firstContent);
  const rows = [];
  const errors = [];
  let hadHeader = false;
  let seenContent = false;
  for (let i = 0; i < lines.length; i++) {
    const raw = lines[i];
    const lineNo = i + 1;
    if (!raw.trim() || raw.trim().startsWith("#")) continue;
    const f = splitLine(raw, delimiter);
    if (!seenContent) {
      seenContent = true;
      const looksHeader = f.length >= 3 && Number.isNaN(parseNumber(f[1])) && Number.isNaN(parseNumber(f[2])) && f.slice(0, 3).every((x) => HEADER_WORDS.test(x));
      if (looksHeader) {
        hadHeader = true;
        continue;
      }
    }
    if (rows.length >= MAX_CSV_ROWS) {
      errors.push({ line: lineNo, reason: "too-many-rows", text: raw.slice(0, 120) });
      break;
    }
    if (f.length < 3) {
      errors.push({ line: lineNo, reason: "needs at least id,E,N", text: raw.slice(0, 120) });
      continue;
    }
    const id = f[0];
    const e = parseNumber(f[1]);
    const n = parseNumber(f[2]);
    if (!id) {
      errors.push({ line: lineNo, reason: "empty id", text: raw.slice(0, 120) });
      continue;
    }
    if (Number.isNaN(e) || Number.isNaN(n)) {
      errors.push({
        line: lineNo,
        reason: `E/N is not a number (${f[1]}, ${f[2]})`,
        text: raw.slice(0, 120)
      });
      continue;
    }
    const label = f.length > 3 && f[3] ? f[3] : null;
    rows.push({ line: lineNo, id, e, n, label });
  }
  if (!rows.length && !errors.length) {
    errors.push({ line: 0, reason: "no data rows", text: "" });
  }
  return { ok: errors.length === 0 && rows.length > 0, rows, errors, delimiter, hadHeader };
}
function csvPointsToEntities(rows, georef, opts = {}) {
  const g = normalizeGeoref(georef);
  if (!g) return { entities: [], layers: [], refused: "no-georef" };
  if (!Array.isArray(rows) || rows.length === 0) {
    return { entities: [], layers: [], refused: "no-rows" };
  }
  const layer = typeof opts.layer === "string" && opts.layer ? opts.layer : CSV_POINTS_LAYER;
  const textHeight = Number.isFinite(opts.textHeight) && opts.textHeight > 0 ? opts.textHeight : 0.5;
  const labels = opts.labels === "never" ? "never" : "always";
  const common = { layer, color: null, linetype: null, lineweight: null, ltScale: 1 };
  const entities = [];
  for (const r of rows) {
    const { x, y } = gridToWorld(g, { e: r.e, n: r.n });
    const prov = { key: `csv:${r.id}`, source: "csv", featureId: String(r.id), role: "point" };
    entities.push({ id: genId("p"), type: "point", ...common, x, y, gis: prov });
    if (labels === "always") {
      entities.push({
        id: genId("t"),
        type: "text",
        ...common,
        x,
        y,
        text: r.label ?? String(r.id),
        height: textHeight,
        rotation: 0,
        // Middle-left: the text starts AT the point and is vertically centred on it, the
        // way a survey point label reads, without inventing an offset that would need to
        // rescale with the drawing.
        justify: "ML",
        gis: { ...prov, key: `csv:${r.id}:label`, role: "label" }
      });
    }
  }
  const layers = layer === CSV_POINTS_LAYER ? [{ ...CSV_POINTS_LAYER_DEF }] : [];
  return { entities, layers, refused: null };
}

// src/cadStyleRename.js
var BUILTIN = "Standard";
var TABLES = {
  text: { defsKey: "textStyleDefs", entityKey: "textStyle", settingKey: "currentTextStyle" },
  dim: { defsKey: "dimStyleDefs", entityKey: "dimStyle", settingKey: "currentDimStyle" }
};
var STYLE_KINDS = Object.freeze(Object.keys(TABLES));
function styleRenameError(doc, kind, from, to) {
  const t = TABLES[kind];
  if (!t) return "unknown-kind";
  const defs = doc && doc[t.defsKey] || {};
  if (!isSafeStyleName(from) || !Object.prototype.hasOwnProperty.call(defs, from))
    return "no-such-style";
  if (from === BUILTIN) return "builtin";
  if (typeof to !== "string" || to.trim() === "") return "empty-name";
  const name = to.trim();
  if (!isSafeStyleName(name)) return "reserved-name";
  if (name === from) return "unchanged";
  const lower = name.toLowerCase();
  const clash = Object.keys(defs).some((n) => n !== from && n.toLowerCase() === lower);
  if (clash) return "name-taken";
  return null;
}
var repoint = (e, entityKey, from, to) => e && e[entityKey] === from ? { ...e, [entityKey]: to } : e;
function renameStyle(doc, kind, from, to) {
  const error = styleRenameError(doc, kind, from, to);
  if (error) return { error };
  const t = TABLES[kind];
  const name = to.trim();
  const defs = /* @__PURE__ */ Object.create(null);
  for (const [k, v] of Object.entries(doc[t.defsKey] || {})) {
    defs[k === from ? name : k] = v;
  }
  const entities = (doc.entities || []).map((e) => repoint(e, t.entityKey, from, name));
  const blockDefs = /* @__PURE__ */ Object.create(null);
  let blocksTouched = false;
  for (const [bname, def] of Object.entries(doc.blockDefs || {})) {
    const ents = def && Array.isArray(def.entities) ? def.entities : null;
    if (!ents) {
      blockDefs[bname] = def;
      continue;
    }
    const next = ents.map((e) => repoint(e, t.entityKey, from, name));
    const changed = next.some((e, i) => e !== ents[i]);
    blocksTouched = blocksTouched || changed;
    blockDefs[bname] = changed ? { ...def, entities: next } : def;
  }
  const settings = doc.settings || {};
  const settingsPatch = settings[t.settingKey] === from ? { [t.settingKey]: name } : {};
  return {
    doc: {
      ...doc,
      [t.defsKey]: defs,
      entities,
      ...blocksTouched ? { blockDefs } : {}
    },
    settingsPatch
  };
}
function styleDeleteError(doc, kind, name) {
  const t = TABLES[kind];
  if (!t) return "unknown-kind";
  const defs = doc && doc[t.defsKey] || {};
  if (!isSafeStyleName(name) || !Object.prototype.hasOwnProperty.call(defs, name))
    return "no-such-style";
  if (name === BUILTIN) return "builtin";
  return null;
}
function deleteStyle(doc, kind, name) {
  const error = styleDeleteError(doc, kind, name);
  if (error) return { error };
  const t = TABLES[kind];
  const defs = /* @__PURE__ */ Object.create(null);
  for (const [k, v] of Object.entries(doc[t.defsKey] || {})) {
    if (k !== name) defs[k] = v;
  }
  let entityCount = 0;
  const entities = (doc.entities || []).map((e) => {
    if (!e || e[t.entityKey] !== name) return e;
    entityCount += 1;
    return { ...e, [t.entityKey]: BUILTIN };
  });
  let blockCount = 0;
  const blockDefs = /* @__PURE__ */ Object.create(null);
  let blocksTouched = false;
  for (const [bname, def] of Object.entries(doc.blockDefs || {})) {
    const ents = def && Array.isArray(def.entities) ? def.entities : null;
    if (!ents) {
      blockDefs[bname] = def;
      continue;
    }
    let changed = false;
    const next = ents.map((e) => {
      if (!e || e[t.entityKey] !== name) return e;
      changed = true;
      blockCount += 1;
      return { ...e, [t.entityKey]: BUILTIN };
    });
    blocksTouched = blocksTouched || changed;
    blockDefs[bname] = changed ? { ...def, entities: next } : def;
  }
  const settings = doc.settings || {};
  const settingsPatch = settings[t.settingKey] === name ? { [t.settingKey]: BUILTIN } : {};
  return {
    doc: {
      ...doc,
      [t.defsKey]: defs,
      entities,
      ...blocksTouched ? { blockDefs } : {}
    },
    settingsPatch,
    repointed: { entities: entityCount, blockEntities: blockCount }
  };
}

// src/cadPlot.js
var LW_MAX = LINEWEIGHTS_MM[LINEWEIGHTS_MM.length - 1];
var SHEET_MAX_MM = (paper) => Math.hypot(paper.w, paper.h);
var isNearWhite2 = (hex) => /^#?f[0-9a-f]?f[0-9a-f]?f[0-9a-f]?$/i.test(
  String(hex || "").replace("#", "").padStart(6, "f")
) || /^#?(f{6}|fff)$/i.test(String(hex || ""));
function plottingBasemaps(doc) {
  const list = doc && doc.georef && Array.isArray(doc.georef.basemaps) ? doc.georef.basemaps : [];
  return list.filter((m) => m && m.visible !== false && m.plot !== false);
}
var finiteRect = (r) => r && [r.minX, r.minY, r.maxX, r.maxY].every(Number.isFinite) && r.maxX > r.minX && r.maxY > r.minY ? { minX: r.minX, minY: r.minY, maxX: r.maxX, maxY: r.maxY } : null;
function cadModelToPlot(doc, opts = {}) {
  const layers = doc && doc.layers || [];
  const entities = doc && doc.entities || [];
  const blockDefs = doc && doc.blockDefs || {};
  const xrefDefs = doc && doc.xrefDefs || {};
  const warnings = [];
  const paper = opts.paper || { w: 297, h: 210 };
  const margin = normalizeMargin(opts.margin != null ? opts.margin : DEFAULT_MODEL_MARGIN_MM);
  const plotStyle = normalizePlotStyleTable(
    opts.plotStyle !== void 0 ? opts.plotStyle : doc && doc.settings && doc.settings.plotStyle
  );
  const colorMode = isMonoPlot(plotStyle, opts.colorMode) ? "mono" : "color";
  const penWidths = opts.penWidths || {};
  const ltscale = doc && doc.settings && doc.settings.ltscale || opts.ltscale || 1;
  const background = opts.background == null ? "#ffffff" : opts.background;
  const framed = unfrozenEntities(entities, layers);
  const bounds = documentBounds(framed, blockDefs, xrefDefs);
  const docBounds = framed === entities ? bounds : documentBounds(entities, blockDefs, xrefDefs);
  const empty = !bounds || !(bounds.maxX > bounds.minX || bounds.maxY > bounds.minY);
  const basemaps = plottingBasemaps(doc);
  const viewRect = empty && basemaps.length ? finiteRect(opts.viewRect) : null;
  if (viewRect) warnings.push("no geometry \u2014 plotted the current view");
  else if (empty && basemaps.length) warnings.push("no geometry and no view to frame \u2014 the imagery was not plotted");
  const b = viewRect || bounds || { minX: 0, minY: 0, maxX: 1, maxY: 1 };
  const W = Math.max(b.maxX - b.minX, 1e-9);
  const H = Math.max(b.maxY - b.minY, 1e-9);
  const um = usableMargin(margin, paper);
  const availW = Math.max(paper.w - um.left - um.right, 1);
  const availH = Math.max(paper.h - um.top - um.bottom, 1);
  const plotScale = normalizePlotScale(opts.scale);
  const s = plotScale == null || plotScale === PLOT_SCALE_FIT ? Math.min(availW / W, availH / H) : plotScale * modelUnitMm(doc);
  const drawW = W * s;
  const drawH = H * s;
  const padX = um.left + (availW - drawW) / 2;
  const padY = um.top + (availH - drawH) / 2;
  const mapPt = (p) => ({ x: padX + (p.x - b.minX) * s, y: paper.h - (padY + (p.y - b.minY) * s) });
  const mapPts = (pts) => pts.map(mapPt);
  const mmPerWorld = s;
  const paperRectToWorld = (r) => ({
    minX: b.minX + (r.x - padX) / s,
    maxX: b.minX + (r.x + r.w - padX) / s,
    minY: b.minY + (paper.h - (r.y + r.h) - padY) / s,
    maxY: b.minY + (paper.h - r.y - padY) / s
  });
  const bgLight = background == null ? true : !/^#?[0-3]/.test(String(background).replace("#", ""));
  const adjust = (hex) => bgLight && hex && isNearWhite2(hex) ? "#000000" : hex;
  const effectiveColor = (e) => e.color || resolveColor(e, layers);
  const penFor = makePlotPenResolver(plotStyle);
  const strokeOf = (e) => {
    if (colorMode === "mono") return "#000000";
    const styled = penFor(effectiveColor(e));
    if (styled && styled.plotColor) return styled.plotColor;
    return adjust(effectiveColor(e)) || "#000000";
  };
  const widthOf = (e) => {
    const wWorld = polylineWidthWorld(e);
    if (wWorld > 0) return Math.min(SHEET_MAX_MM(paper), wWorld * mmPerWorld);
    const pen = penWidths[e.layer];
    let mm;
    if (Number.isFinite(pen) && pen > 0) {
      mm = pen;
    } else {
      const styled = penFor(effectiveColor(e));
      mm = styled && styled.lineweightMm != null ? styled.lineweightMm : resolveLineweightMm(e, layers);
    }
    return Math.min(LW_MAX, Math.max(0, mm));
  };
  const dashOf = (e) => {
    const defs = doc && doc.linetypeDefs || LINETYPE_DEFS;
    const pattern = resolveLinetypePattern(e, doc && doc.layers || [], defs);
    if (!pattern) return null;
    const objScale = Number.isFinite(e.ltScale) && e.ltScale > 0 ? e.ltScale : 1;
    return linetypeToDash(pattern, mmPerWorld, ltscale * objScale);
  };
  const items = [];
  const printableMm = { x: um.left, y: um.top, w: availW, h: availH };
  if (!empty || viewRect)
    for (const m of basemaps) {
      items.push({
        kind: "image",
        role: "basemap",
        basemapId: m.id,
        sourceId: m.sourceId,
        opacity: Number.isFinite(m.opacity) ? Math.min(1, Math.max(0, m.opacity)) : 1,
        rectMm: { ...printableMm },
        worldRect: paperRectToWorld(printableMm)
      });
    }
  const stroke = (e, worldPts, closed, hex) => {
    if (!worldPts || worldPts.length < 2) return;
    items.push({
      kind: "poly",
      pts: mapPts(worldPts),
      closed: !!closed,
      strokeHex: hex || strokeOf(e),
      widthMm: widthOf(e),
      dashMm: dashOf(e)
    });
  };
  const textItem = (e, x, y, text, worldHeight, rotDeg, hex, justify, ts2) => {
    if (text == null || text === "") return;
    const { fx, fy } = justifyFactors(justify);
    const item = {
      kind: "text",
      at: mapPt({ x, y }),
      text: String(text),
      heightMm: Math.max(0.5, (worldHeight || 1) * mmPerWorld),
      rotationDeg: -(rotDeg || 0),
      fillHex: hex,
      halign: fx,
      valign: fy
    };
    if (ts2) {
      if (Number.isFinite(ts2.widthFactor) && ts2.widthFactor > 0 && ts2.widthFactor !== 1)
        item.widthFactor = ts2.widthFactor;
      if (Number.isFinite(ts2.oblique) && ts2.oblique !== 0) item.oblique = ts2.oblique;
      if (ts2.bold === true) item.bold = true;
      if (ts2.italic === true) item.italic = true;
    }
    items.push(item);
  };
  const ds = doc && doc.dimStyleDefs;
  const ts = doc && doc.textStyleDefs;
  const tcur = doc && doc.settings && doc.settings.currentTextStyle;
  const sizing = makeDimSizing(doc, docBounds);
  const drawCtx = {
    blockDefs,
    xrefDefs,
    // [RASTER-IMAGE-1] pixel size + mime only; the BYTES are resolved by the PDF
    // writer, so a per-frame structure never carries a megabyte of base64.
    imageDefs: doc.imageDefs || {},
    dimStyleDefs: ds,
    textStyleDefs: ts,
    textStyle: tcur,
    sizing,
    extent: { w: W, h: H },
    pointSizeWorld: 6 / mmPerWorld,
    // ~6 mm cross on paper
    colorOf: strokeOf,
    // [BUG-BLOCK-SUBLAYER-1] the SAME predicate the top-level loop below uses, handed
    // down so a block's sub-entities are filtered by their own layer too — including
    // the plot-only half (`layerPlotted`), which is the asymmetry [LAYER-PLOT-1]
    // keeps between paper and screen.
    isShown: (name) => plots(name),
    warnings
  };
  const emit = (op) => {
    if (op.kind === "poly") {
      stroke(op.e, op.pts, op.closed, op.colorHex);
    } else if (op.kind === "fill") {
      const item = { kind: "fill", pts: mapPts(op.pts), fillHex: op.colorHex };
      if (op.holes) item.holes = op.holes.map(mapPts);
      items.push(item);
    } else if (op.kind === "text") {
      textItem(
        op.e,
        op.x,
        op.y,
        op.text,
        op.height,
        op.rotationDeg,
        op.colorHex,
        op.justify,
        op.style
      );
    } else if (op.kind === "image") {
      if (op.missing) {
        warnings.push(`image ${op.e.id || ""}: its picture is missing \u2014 plotted as an empty frame`);
      }
      items.push({
        kind: "image",
        role: "entity",
        e: op.e,
        imageDefId: op.imageDefId,
        mime: op.mime,
        pixelWidth: op.pixelWidth,
        pixelHeight: op.pixelHeight,
        cornersMm: op.corners.map((p) => mapPt(p)),
        opacity: op.opacity,
        behind: op.behind,
        missing: op.missing
      });
    } else {
      warnings.push(`unplotted draw op "${op.kind}" for ${op.e && op.e.type} ${op.e && op.e.id}`);
    }
  };
  const plots = (name) => {
    const l = layers.find((ly) => ly.name === name);
    return layerShown(l) && layerPlotted(l);
  };
  for (const e of orderForDraw(entities)) {
    if (!plots(e.layer)) continue;
    try {
      for (const op of entityDrawOps(e, drawCtx)) emit(op);
    } catch (err) {
      warnings.push(`skipped ${e.type} ${e.id}: ${err && err.message}`);
    }
  }
  const footer = typeof opts.footer === "string" ? opts.footer.trim() : "";
  if (footer) {
    items.push({
      kind: "text",
      // Named, so a caller can re-word it once it knows what actually printed (review r2).
      role: "footer",
      // In the bottom margin's middle; with a margin under 3.5 mm it sits 1.75 mm above the
      // paper edge — inside the page, over the plot's bottom band, on purpose (review r1).
      at: { x: um.left + 1, y: paper.h - Math.max(1.75, um.bottom / 2) },
      text: footer,
      heightMm: 2.5,
      rotationDeg: 0,
      fillHex: "#000000",
      halign: 0,
      valign: 0.5
    });
  }
  return { items, warnings, paper, empty, background, framedByView: !!viewRect };
}

// src/cadPageSetup.js
var PLOT_SCALE_PRESETS = [
  { label: "Fit to page", value: PLOT_SCALE_FIT },
  // [G4a] 1:250 and 1:2000/1:5000 added — the site-plan scales a georeferenced sheet uses.
  ...[1, 2, 5, 10, 20, 50, 100, 200, 250, 500, 1e3, 2e3, 5e3].map((denom) => ({
    label: `1:${denom}`,
    value: 1 / denom
  }))
];
function defaultsFor(layout) {
  return layout && layout.isModel ? { margin: normalizeMargin(DEFAULT_MODEL_MARGIN_MM), scale: PLOT_SCALE_FIT } : { margin: normalizeMargin(0), scale: 1 };
}
function resolvePageSetup(doc, layout) {
  const d = defaultsFor(layout);
  const ps = normalizePageSetup(layout && layout.pageSetup) || {};
  const sheet = layout && !layout.isModel ? layoutPaperDims(layout) : paperDims("A3", "landscape");
  const paper = ps.paperSize || ps.orientation || ps.custom ? paperDims(
    ps.paperSize || layout && layout.paperSize || "A3",
    ps.orientation || layout && layout.orientation || "landscape",
    ps.custom || layout && layout.custom || null
  ) : sheet;
  return {
    paper,
    sheet,
    margin: { ...d.margin, ...ps.margin || {} },
    scale: ps.scale == null ? d.scale : ps.scale,
    unitMm: modelUnitMm(doc)
  };
}
function pageContentRect({ paper, sheet, margin, scale }) {
  const m = usableMargin(normalizeMargin(margin, 0), paper);
  const availW = paper.w - m.left - m.right;
  const availH = paper.h - m.top - m.bottom;
  const s = scale === PLOT_SCALE_FIT ? Math.min(availW / Math.max(sheet.w, 1e-9), availH / Math.max(sheet.h, 1e-9)) : scale;
  const w = sheet.w * s;
  const h = sheet.h * s;
  return { x: m.left + (availW - w) / 2, y: m.top + (availH - h) / 2, w, h };
}
function batchPlotPlan(doc, opts = {}) {
  const only = Array.isArray(opts.layoutIds) ? new Set(opts.layoutIds.map(String)) : null;
  return (doc && doc.layouts || []).filter((l) => l.isModel ? !!opts.includeModel : true).filter((l) => only ? only.has(String(l.id)) : true).map((l) => {
    const ps = resolvePageSetup(doc, l);
    return {
      layoutId: l.id,
      name: l.name,
      isModel: !!l.isModel,
      paper: ps.paper,
      sheet: ps.sheet,
      margin: ps.margin,
      scale: ps.scale
    };
  });
}
function sheetScaleConflict(doc, layout) {
  if (!layout || layout.isModel) return null;
  const vps = (layout.viewports || []).filter((v) => v && Number.isFinite(v.scale) && v.scale > 0);
  if (!vps.length) return null;
  const ps = resolvePageSetup(doc, layout);
  const pageScale = ps.scale;
  if (pageScale === 1) return null;
  const denoms = [...new Set(vps.map((v) => Math.round(1 / v.scale)))].sort((a, b) => a - b);
  const effective = pageScale === PLOT_SCALE_FIT || !Number.isFinite(pageScale) ? null : denoms.map((d) => Math.round(d / pageScale));
  return { pageScale, viewportDenoms: denoms, effectiveDenoms: effective };
}

// src/commandParse.js
var NUM = "[+-]?(?:\\d+\\.?\\d*|\\.\\d+)";
var POLAR_RE = new RegExp(`^(${NUM})\\s*<\\s*(${NUM})$`);
var CART_RE = new RegExp(`^(${NUM})\\s*,\\s*(${NUM})$`);
var GRID_RE = new RegExp(`^[Gg]\\s*(${NUM})\\s*,\\s*(${NUM})$`);
function isGridCoordinateText(text) {
  return text != null && GRID_RE.test(String(text).trim());
}
function parseCoordinate(text, anchor, opts) {
  if (text == null) return null;
  const s = String(text).trim();
  if (!s) return null;
  const grid = s.match(GRID_RE);
  if (grid) {
    const georef = opts && opts.georef;
    if (!georef || !georef.origin) return null;
    return {
      x: parseFloat(grid[1]) - georef.origin.e,
      y: parseFloat(grid[2]) - georef.origin.n
    };
  }
  const rel = s[0] === "@";
  const body = (rel ? s.slice(1) : s).trim();
  const base = rel ? anchor : { x: 0, y: 0 };
  if (!base) return null;
  const polar = body.match(POLAR_RE);
  if (polar) {
    const d = parseFloat(polar[1]);
    const rad = parseFloat(polar[2]) * Math.PI / 180;
    return { x: base.x + d * Math.cos(rad), y: base.y + d * Math.sin(rad) };
  }
  const cart = body.match(CART_RE);
  if (cart) {
    return { x: base.x + parseFloat(cart[1]), y: base.y + parseFloat(cart[2]) };
  }
  return null;
}
function draftOption(tool, draft, text) {
  if (!draft) return null;
  const t = String(text || "").trim().toUpperCase();
  const pts = draft.points ? draft.points.length : 0;
  if (t === "U" && pts > 0) return "undo-point";
  if (t === "C") {
    if (tool === "line" && (draft.lineIds || []).length >= 2) return "close";
    if ((tool === "polyline" || tool === "spline" || tool === "splinefit" || tool === "area") && pts >= 3)
      return "close";
    if (tool === "revcloud" && pts >= 3) return "close";
  }
  if (t === "D" && tool === "circle" && pts === 1) return "diameter";
  return null;
}
function lengthenOption(tool, text) {
  if (tool !== "lengthen") return null;
  switch (String(text || "").trim().toUpperCase()) {
    case "DE":
    case "DELTA":
      return "delta";
    case "P":
    case "PERCENT":
      return "percent";
    case "T":
    case "TOTAL":
      return "total";
    case "DY":
    case "DYNAMIC":
      return "dynamic";
    default:
      return null;
  }
}
var PEDIT_KEYS = new Map(PEDIT_OPTIONS.map((o) => [o.key, o.id]));
function peditOption(tool, _draft, text) {
  if (tool !== "pedit") return null;
  const t = String(text || "").trim().toUpperCase();
  if (PEDIT_KEYS.has(t)) return PEDIT_KEYS.get(t);
  for (const o of PEDIT_OPTIONS) if (t === o.label.toUpperCase()) return o.id;
  return null;
}
var LENGTHEN_OPTION_KEYS = /* @__PURE__ */ new Set(["d", "p", "t"]);
function insertOption(tool, text) {
  if (tool !== "insert") return null;
  switch (String(text || "").trim().toUpperCase()) {
    case "S":
    case "SCALE":
      return "scale";
    case "R":
    case "ROTATE":
      return "rotate";
    default:
      return null;
  }
}
function commandReservesText(tool, draft, text) {
  const t = String(text || "").trim().toUpperCase();
  if (!t) return false;
  if (tool === "polygon" && (t === "I" || t === "C")) return true;
  if (tool === "area" && t === "D") return true;
  if (tool === "break" && t === "F") return true;
  if (lengthenOption(tool, t)) return true;
  if (insertOption(tool, t)) return true;
  if (peditOption(tool, draft, t)) return true;
  if (tool === "lengthen" && t.length === 1 && LENGTHEN_OPTION_KEYS.has(t.toLowerCase()))
    return true;
  if (tool === "align" && draft && (draft.points || []).length === 4 && /^(Y|YES|N|NO)$/.test(t))
    return true;
  return !!draftOption(tool, draft, t);
}
var ALIASES = {
  L: "tool:line",
  LINE: "tool:line",
  PL: "tool:polyline",
  PLINE: "tool:polyline",
  POLYLINE: "tool:polyline",
  C: "tool:circle",
  CIRCLE: "tool:circle",
  A: "tool:arc",
  ARC: "tool:arc",
  EL: "tool:ellipse",
  ELLIPSE: "tool:ellipse",
  EA: "tool:ellipsearc",
  ELLIPSEARC: "tool:ellipsearc",
  ELLIPTICALARC: "tool:ellipsearc",
  SPL: "tool:spline",
  SPLINE: "tool:spline",
  SPLINECV: "tool:spline",
  SPF: "tool:splinefit",
  SPLINEFIT: "tool:splinefit",
  POL: "tool:polygon",
  POLYGON: "tool:polygon",
  PO: "tool:point",
  POINT: "tool:point",
  DDPTYPE: "point-style",
  PTYPE: "point-style",
  RAY: "tool:ray",
  XL: "tool:xline",
  XLINE: "tool:xline",
  REVCLOUD: "tool:revcloud",
  REVC: "tool:revcloud",
  RC: "tool:revcloud",
  REC: "tool:rectangle",
  RECTANG: "tool:rectangle",
  RECTANGLE: "tool:rectangle",
  T: "tool:text",
  TEXT: "tool:text",
  DTEXT: "tool:text",
  // Spec 05: multiline wrapped text block (two-corner box, in-canvas textarea).
  MT: "tool:mtext",
  MTEXT: "tool:mtext",
  // Spec 13: model-space table (one-click place; cells edit in place on double-click).
  TB: "tool:table",
  TABLE: "tool:table",
  // C4b: regions and the boolean operations.
  //
  // These are NOUN-VERB ACTIONS on the current selection — bare ids, not `tool:`
  // ids — which is how GROUP, UNGROUP and EXPLODE already work here. AutoCAD also
  // offers the verb-noun form ("UNION" then "Select objects:"); that would mean
  // arming the transform-tool machinery and is deliberately NOT done here, because
  // the noun-verb half is the whole feature and the arming half is UI scaffolding
  // that would land untested. Recorded as a follow-up rather than half-built.
  //
  // NOTE on INTERSECT: AutoCAD's alias is `IN`, and this map does NOT claim it.
  // Being precise, because the first version of this comment was wrong: bare `IN`
  // is not a shipped top-level alias — `IN` is a member of ZOOM_OPTIONS, which
  // resolveCommand consults only when the first token is Z or ZOOM, so `IN: 'intersect'`
  // here could not actually collide with `ZOOM IN`. The reason is readability, not
  // collision: `IN` reads as a zoom sub-option to anyone who has typed `Z E` or
  // `ZOOM IN`, and a two-letter alias that means one thing alone and another after
  // ZOOM is a trap. INTERSECT therefore takes `INT` and its full name.
  REG: "region",
  REGION: "region",
  BO: "region",
  BOUNDARY: "region",
  UNI: "union",
  UNION: "union",
  SU: "subtract",
  SUBTRACT: "subtract",
  INT: "intersect",
  INTERSECT: "intersect",
  S: "tool:select",
  SELECT: "tool:select",
  M: "tool:move",
  MOVE: "tool:move",
  CO: "tool:copy",
  CP: "tool:copy",
  COPY: "tool:copy",
  MI: "tool:mirror",
  MIRROR: "tool:mirror",
  RO: "tool:rotate",
  ROTATE: "tool:rotate",
  SC: "tool:scale",
  SCALE: "tool:scale",
  O: "tool:offset",
  OFFSET: "tool:offset",
  TR: "tool:trim",
  TRIM: "tool:trim",
  EX: "tool:extend",
  EXTEND: "tool:extend",
  F: "tool:fillet",
  FILLET: "tool:fillet",
  CHA: "tool:chamfer",
  CHAMFER: "tool:chamfer",
  BR: "tool:break",
  BREAK: "tool:break",
  J: "tool:join",
  JOIN: "tool:join",
  // C3. AutoCAD's alias for STRETCH is `S`, which this app has meant `tool:select`
  // since long before STRETCH existed — silently repointing it would change a gesture
  // users already have in their fingers, so STRETCH keeps only its full name. `LEN`
  // and `AL` are AutoCAD's own and were both free.
  STRETCH: "tool:stretch",
  // C4. PEDIT and its AutoCAD short form. Two of PEDIT's functions — the Closed
  // toggle and per-vertex editing — already shipped through the Properties
  // panel; the command is the second door onto the same rules, not a second
  // implementation of them (see cadModify/pedit.js).
  PE: "tool:pedit",
  PEDIT: "tool:pedit",
  // C4. DIVIDE and MEASURE mark a path with POINT entities. `DIV` and `ME` are
  // AutoCAD's own aliases and both were free here. The marks are drawn, sized
  // and snapped by the POINT display machinery that already ships (DDPTYPE).
  // C4. GROUP binds the selection into a named saved set; UNGROUP dissolves the
  // groups the selection belongs to. Both are ACTIONS on the selection rather
  // than tools that arm (nothing is picked afterwards), so they dispatch
  // straight from CADCommandLine like UNDO and LAYISO do. `G` is AutoCAD's own
  // alias for GROUP and was free here.
  G: "group",
  GROUP: "group",
  UNGROUP: "ungroup",
  UNG: "ungroup",
  // The group manager (AutoCAD's CLASSICGROUP / GROUPEDIT live here as one panel).
  GROUPS: "groups-panel",
  DIV: "tool:divide",
  DIVIDE: "tool:divide",
  ME: "tool:measure",
  MEASURE: "tool:measure",
  LEN: "tool:lengthen",
  LENGTHEN: "tool:lengthen",
  AL: "tool:align",
  ALIGN: "tool:align",
  DLI: "tool:dimlinear",
  DIMLINEAR: "tool:dimlinear",
  DAL: "tool:dimaligned",
  DIMALIGNED: "tool:dimaligned",
  DAN: "tool:dimangular",
  DIMANG: "tool:dimangular",
  DIMANGULAR: "tool:dimangular",
  DRA: "tool:dimradius",
  DIMRAD: "tool:dimradius",
  DIMRADIUS: "tool:dimradius",
  DDI: "tool:dimdiameter",
  DIMDIA: "tool:dimdiameter",
  DIMDIAMETER: "tool:dimdiameter",
  // Spec 10: ordinate dimension (feature coordinate relative to the datum). Two
  // clicks — feature point, then leader endpoint (axis auto-detected from the drag).
  DOR: "tool:dimordinate",
  DIMORD: "tool:dimordinate",
  DIMORDINATE: "tool:dimordinate",
  ORDINATE: "tool:dimordinate",
  // Spec 11: arc length dimension (⌒ length of a source arc). Pick an arc, then place
  // the concentric dimension arc.
  DAR: "tool:dimarc",
  DIMARC: "tool:dimarc",
  // Spec 12: baseline / continue chaining off an existing linear or aligned dim.
  DBA: "tool:dimbaseline",
  DIMBASELINE: "tool:dimbaseline",
  DCO: "tool:dimcontinue",
  DIMCONT: "tool:dimcontinue",
  DIMCONTINUE: "tool:dimcontinue",
  // Spec 04: LEADER (arrow-tipped note line). MLD/MLEADER alias the same tool — v1 has
  // no multileader styles, so they resolve to the single leader tool.
  LE: "tool:leader",
  LEAD: "tool:leader",
  LEADER: "tool:leader",
  MLD: "tool:leader",
  MLEADER: "tool:leader",
  U: "undo",
  UNDO: "undo",
  REDO: "redo",
  MREDO: "redo",
  E: "erase",
  ERASE: "erase",
  DEL: "erase",
  DELETE: "erase",
  LA: "layer",
  LAYER: "layer",
  // 1.2 layer ops: isolate the selection's layers / restore the pre-isolation
  // visibility. Action ids (not tools) — CADCommandLine dispatches them straight
  // into the store, mirroring undo/redo.
  LAYISO: "layiso",
  LAYUNISO: "layuniso",
  // Layer removal, AutoCAD's two deliberate forms (plain delete lives in the
  // Layers panel with its safety dialog): LAYDEL destroys the selection's
  // layers with their contents; LAYMRG merges them into the current layer.
  LAYDEL: "laydel",
  LAYMRG: "laymrg",
  MA: "matchprop",
  MATCHPROP: "matchprop",
  // ── v4 ──
  LT: "linetype",
  LINETYPE: "linetype",
  LTSCALE: "ltscale",
  LTS: "ltscale",
  DIMSTYLE: "dimstyle",
  D: "dimstyle",
  DST: "dimstyle",
  // Spec 06: named text styles (STYLE). Opens the Text Style panel via the command
  // dispatch (CADCommandLine fires the cad:open-panel event for 'textstyle').
  ST: "textstyle",
  STYLE: "textstyle",
  TEXTSTYLE: "textstyle",
  H: "tool:hatch",
  HATCH: "tool:hatch",
  BHATCH: "tool:hatch",
  BH: "tool:hatch",
  HE: "hatchedit",
  HATCHEDIT: "hatchedit",
  B: "block",
  BLOCK: "block",
  I: "insert",
  INSERT: "insert",
  // [RASTER-IMAGE-1] AutoCAD's names for attaching a raster. They open the same
  // file picker IMPORT does — the routing by file type lives in `useFileIO`, so
  // there is one door and one set of refusals however the user got there.
  IMAGE: "image-attach",
  IMAGEATTACH: "image-attach",
  IAT: "image-attach",
  // [C5] `INSERT <name>` (AutoCAD's -INSERT) is deliberately NOT supported: the
  // resolver maps a whole token to an id and has no argument channel, and adding
  // one for a single command would give ZOOM's multi-word branch a second, subtly
  // different splitter. INSERT opens the Blocks panel, whose Insert button ARMS the
  // placement tool — from there the placement point, Scale and Rotate are the
  // tool's own prompt (insertOption).
  //
  // [C5 criterion 4] Recompute every field-bound block attribute. AutoCAD's own
  // command is UPDATEFIELD; FIELDUPDATE is accepted because it is the name half of
  // the world reaches for first.
  UPDATEFIELD: "fieldupdate",
  FIELDUPDATE: "fieldupdate",
  X: "explode",
  EXPLODE: "explode",
  AR: "array",
  ARRAY: "array",
  DI: "tool:dist",
  DIST: "tool:dist",
  DISTANCE: "tool:dist",
  AA: "tool:area",
  AREA: "tool:area",
  // ── V4b paper space ──
  LO: "layout",
  LAYOUT: "layout",
  MV: "mview",
  MVIEW: "mview",
  PLOT: "plot",
  PRINT: "plot",
  // PAGE-SETUP-1: the page setup manager for the ACTIVE layout (AutoCAD's PAGESETUP).
  // LAYOUT still CREATES a sheet; this edits the one you are on, which is why they are
  // two commands rather than one dialog with a mode the user has to notice.
  // (Not PS — that is PSPACE to a CAD user; reassigning it would be a surprise.)
  PAGESETUP: "pagesetup",
  PAGESET: "pagesetup",
  // [G1-GEOREF] The georeference panel: choose the drawing's projected CRS and
  // where local (0,0) sits on that grid. Opens the panel (cad:open-panel 'georef');
  // GEOGRAPHICLOCATION is AutoCAD's name for the same dialog.
  GEOREF: "georef",
  // [G2-BASEMAP] The GIS panel: basemap imagery and GIS mode. Not a coordinate —
  // the `G` grid prefix needs digits after it, so "GIS" still resolves here.
  GIS: "gis",
  // [G3-PARCELS] PARCEL arms a pick-a-point tool that fetches the parcel under the
  // click (and inserts it on the locked GIS-* layers); ADDRESS opens the GIS panel
  // with the address field focused. Neither is a coordinate: `G` needs digits.
  PARCEL: "tool:parcel",
  // [G6i] BUILDING arms the same pick-a-point gesture for a building footprint: click a
  // house, its outline arrives as a closed polyline. The tool stays armed, so clicking the
  // next house grabs the next one — which is the "select each house" experience without any
  // image analysis, because LINZ already publishes the footprints.
  BUILDING: "tool:building",
  BLDG: "tool:building",
  ADDRESS: "address",
  GEOGRAPHICLOCATION: "georef",
  GEO: "georef",
  // [G6-MAPMODE] The two ENVIRONMENTS. MAP puts the drawing over an interactive
  // Mapbox map (satellite/streets/terrain, pan-zoom-rotate, no tilt); CAD returns
  // to the projected-tile canvas. Two words rather than one toggle on purpose: a
  // toggle in a command line is a state the user cannot see before pressing Enter,
  // and these are a mode the whole editor wears.
  //
  // Neither is a coordinate: the `G` grid prefix needs digits after it, and
  // neither token collides with anything in this map (checked, 2026-09-25).
  MAP: "env-map",
  MAPMODE: "env-map",
  CAD: "env-cad",
  CADMODE: "env-cad",
  // [G6f-MAP-AOI] Restrict the on-screen map to one AREA OF INTEREST: a rubber-band
  // rectangle, like ZOOM WINDOW but committing to the map's clip instead of the view.
  // `AOI` is the surveyor's term; `MAPAREA` spells it out. Neither collides (checked:
  // `A`/`ALL` are the ZOOM family's and resolve only after `ZOOM`, and no other entry
  // begins `AOI`/`MAPAREA`).
  AOI: "map-area",
  MAPAREA: "map-area",
  // ── V4b phase 2: file import (DXF + native DWG). Opens the file picker, which
  // accepts .dxf and .dwg; the chosen file is routed by extension in CADEditor. ──
  IMPORT: "import-file",
  IMPORTDWG: "import-file",
  OPEN: "import-file",
  // EXPORT had no command id at all — the tool dock called `onExport` directly,
  // so the one door that could reach it was a single icon. A menu item must
  // resolve to a REGISTERED id (the coverage guard this package is held to), and
  // a typed EXPORT should work for the same reason IMPORT does. DXFOUT is
  // AutoCAD's own name for it; SAVEAS is what people reach for by habit.
  // [G5-INTEROP] Bringing GIS data IN. `CSVIN` mirrors AutoCAD's `…IN`/`…OUT` pairing
  // that `DXFIN`/`DXFOUT` already set here; `POINTSIN` is what a surveyor reaches for,
  // since the file they have is a point schedule rather than "a CSV".
  CSVIN: "csvin",
  POINTSIN: "csvin",
  GEOJSONIN: "geojsonin",
  EXPORT: "export-dxf",
  DXFOUT: "export-dxf",
  SAVEAS: "export-dxf",
  // ── V4b phase 3: XREF underlays. XR/XREF open the manager panel; XATTACH opens
  // the attach picker; XBIND/XDETACH act on the selected XREF (or prompt by name). ──
  XR: "xref",
  XREF: "xref",
  XATTACH: "xref-attach",
  XA: "xref-attach",
  XBIND: "xref-bind",
  XDETACH: "xref-detach",
  // ── V4c phase 2: navigation. Named views + one-token zoom shortcuts (the
  // multi-word "ZOOM <opt>" forms are handled in the ZOOM family branch below). ──
  V: "named-views",
  VIEW: "named-views",
  VIEWS: "named-views",
  NAV: "nav-settings",
  // PAN (hand-drag pan). `P` is AutoCAD's alias for it and is free here — POLYLINE
  // is PL, POLYGON is POL, POINT is PO, so nothing else claims the bare letter. (An
  // earlier comment asserted "P is POLYLINE in this app" and left it unbound, which
  // meant the single most-typed navigation key in CAD answered "Unknown command".)
  P: "pan",
  PAN: "pan",
  ZW: "zoom-window",
  ZP: "zoom-previous",
  ZE: "zoom-extents",
  ZO: "zoom-object",
  // ── V4c phase 4: drafting aids + quick-select. The F8/F10/F11 function keys are
  // bound in CADEditor's keydown (function keys never reach the command line); these
  // TYPED aliases toggle the same session toggles, and QSELECT opens the property
  // filter dialog. OTRACK ≙ F11 (object-snap tracking). ──
  ORTHO: "ortho",
  POLAR: "polar",
  OTRACK: "otrack",
  OST: "otrack",
  QSELECT: "qselect",
  QSE: "qselect",
  // [GRID-UNIT-1] The two AutoCAD grid commands, which are two commands because
  // they are two settings: GRID is what is DRAWN (GRIDUNIT), SNAP is what the
  // CURSOR does (SNAPUNIT). Both take an optional argument — see
  // `parseGridCommand`, which owns the argument grammar; these bare entries are
  // what `listCommands` advertises and what a bare token resolves to.
  GRID: "grid",
  GRIDUNIT: "grid",
  SNAP: "snap-unit",
  SNAPUNIT: "snap-unit",
  SN: "snap-unit"
};
var GRID_COMMAND_IDS = { GRID: "grid", GRIDUNIT: "grid", SNAP: "snap-unit", SNAPUNIT: "snap-unit", SN: "snap-unit" };
function parseGridCommand(text) {
  if (text == null) return null;
  const parts = String(text).trim().toUpperCase().split(/\s+/).filter(Boolean);
  if (!parts.length) return null;
  const id = GRID_COMMAND_IDS[parts[0]];
  if (!id) return null;
  if (parts.length === 1) return { id, action: "toggle" };
  if (parts.length === 3 && id === "grid" && parts[1] === "LOCK") {
    if (parts[2] === "ON") return { id, action: "lock-on" };
    if (parts[2] === "OFF") return { id, action: "lock-off" };
    return null;
  }
  if (parts.length > 2) return null;
  const arg = parts[1];
  if (arg === "LOCK") return id === "grid" ? { id, action: "lock-toggle" } : null;
  if (arg === "ON") return { id, action: "on" };
  if (arg === "OFF") return { id, action: "off" };
  if (arg === "A" || arg === "AUTO") return id === "grid" ? { id, action: "auto" } : null;
  const read = parseGridSpacingInput(arg);
  if (!read) return null;
  if (read.action === "auto") return id === "grid" ? { id, action: "auto" } : null;
  return { id, action: "spacing", value: read.value };
}
var ZOOM_OPTIONS = {
  E: "zoom-extents",
  EXTENTS: "zoom-extents",
  A: "zoom-extents",
  ALL: "zoom-extents",
  W: "zoom-window",
  WINDOW: "zoom-window",
  P: "zoom-previous",
  PREVIOUS: "zoom-previous",
  PREV: "zoom-previous",
  O: "zoom-object",
  OBJECT: "zoom-object",
  S: "zoom-object",
  SELECTION: "zoom-object",
  I: "zoom-in",
  IN: "zoom-in",
  OUT: "zoom-out",
  R: "zoom-realtime",
  REALTIME: "zoom-realtime"
};
function listCommands() {
  const byId2 = /* @__PURE__ */ new Map();
  const add3 = (id, alias) => {
    if (!byId2.has(id)) byId2.set(id, { id, aliases: [] });
    const e = byId2.get(id);
    if (!e.aliases.includes(alias)) e.aliases.push(alias);
  };
  for (const [alias, id] of Object.entries(ALIASES)) add3(id, alias);
  add3("zoom-extents", "ZOOM");
  for (const [opt, id] of Object.entries(ZOOM_OPTIONS)) add3(id, `ZOOM ${opt}`);
  add3("export-dxf-grid", "DXFOUT GRID");
  return [...byId2.values()];
}
var EXPORT_VERBS = /* @__PURE__ */ new Set(["EXPORT", "DXFOUT", "SAVEAS"]);
var EXPORT_FRAMES = { GRID: "export-dxf-grid", G: "export-dxf-grid" };
function resolveCommand(text) {
  if (text == null) return null;
  const s = String(text).trim().toUpperCase();
  if (!s) return null;
  const parts = s.split(/\s+/);
  if (parts[0] === "Z" || parts[0] === "ZOOM") {
    if (parts.length === 1) return "zoom-extents";
    return ZOOM_OPTIONS[parts[1]] || null;
  }
  if (EXPORT_VERBS.has(parts[0]) && parts.length > 1) {
    return parts.length === 2 && EXPORT_FRAMES[parts[1]] ? EXPORT_FRAMES[parts[1]] : null;
  }
  const gridCmd = parseGridCommand(s);
  if (gridCmd) return gridCmd.id;
  if (GRID_COMMAND_IDS[parts[0]] && parts.length > 1) return null;
  return ALIASES[s] || null;
}

// src/inference/flags.js
var enabled = true;
function setInferenceEnabled(on) {
  enabled = !!on;
}
function inferenceEnabled() {
  return enabled;
}

// src/inference/constants.js
var RULE = {
  ENDPOINT: "endpoint",
  MIDPOINT: "midpoint",
  CENTER: "center",
  QUADRANT: "quadrant",
  INTERSECTION: "intersection",
  NEAREST: "nearest",
  GRID: "grid",
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
  PARALLEL: "parallel",
  PERPENDICULAR: "perpendicular",
  COLLINEAR: "collinear",
  POLAR: "polar",
  // ── Session B ──────────────────────────────────────────────────────────────
  ALIGNMENT: "alignment",
  // AutoTrack lines through acquired points
  TANGENT: "tangent",
  // line tangent to a circle/arc
  PERPENDICULAR_FOOT: "perpendicularFoot",
  // foot of the perpendicular onto an entity
  CONCENTRIC: "concentric",
  // share an existing circle/arc's centre
  EQUAL_LENGTH: "equalLength",
  // match a recently drawn segment's length
  // ── Session D ──────────────────────────────────────────────────────────────
  AUTO_ALIGNMENT: "autoAlignment"
  // implicit alignment — no hover ritual
};
var GUIDE = {
  GLYPH: "glyph",
  DASHED_LINE: "dashedLine",
  HIGHLIGHT_ENTITY: "highlightEntity"
};
var GUIDE_STYLE = {
  EXTENSION: "extension",
  // the prolongation of real geometry (collinear)
  POLAR: "polar",
  // an angular ray from the drafting anchor
  /**
   * Session B — an AutoTrack line radiating from an ACQUIRED point. Distinct
   * from `polar` because it does not start at the drafting anchor: it starts at
   * a point the user deliberately acquired, which is the whole reason the guide
   * is legible ("this line exists because you hovered THAT corner").
   */
  ALIGNMENT: "alignment"
};
var EXCLUSIVE = {
  ANCHOR_DIRECTION: "direction:anchor",
  /** @param {string} id */
  entityDirection: (id) => `direction:entity:${id}`,
  /**
   * Session B — one group PER ACQUIRED POINT. Two alignment lines from the SAME
   * acquired point (its horizontal and its vertical) are contradictory readings
   * of one cursor; lines from DIFFERENT acquired points are not, and must both
   * survive resolution — that is precisely what lets the two-point corner
   * (horizontal-from-P1 ∩ vertical-from-P2) reach the composition solver.
   * @param {string} pointKey
   */
  trackingDirection: (pointKey) => `direction:tracking:${pointKey}`,
  /**
   * Session D — the same per-source reasoning for IMPLICIT alignment sources,
   * in its own namespace so an implicit line and the explicit line through the
   * same point are never accidentally grouped together. (They cannot both
   * exist: AutoAlignmentRule suppresses a source that is already acquired — see
   * autoAlignment.js. The namespace keeps that a rule decision rather than an
   * accident of key formatting.)
   * @param {string} pointKey
   */
  autoDirection: (pointKey) => `direction:auto:${pointKey}`
};
var RULE_PRIORITY = Object.freeze({
  [RULE.INTERSECTION]: 1,
  [RULE.ENDPOINT]: 0.96,
  [RULE.MIDPOINT]: 0.92,
  [RULE.CENTER]: 0.88,
  [RULE.QUADRANT]: 0.88,
  // ── Session B, slotted INTO the Session A ordering ─────────────────────────
  // Each new weight sits strictly between two existing ones, so no Session A
  // pairwise ordering changes — asserted by a test.
  //
  // concentric < center: a centre the cursor is actually ON must always beat the
  //   suggestion to share a centre it is merely NEAR.
  // tangent / perpendicular-foot: exact, intentional curve relations — above the
  //   collinear extension, below the discrete feature points they might sit on.
  // equalLength < collinear: a length match is a weaker claim than real geometry.
  // alignment > horizontal/vertical: an AutoTrack line comes from a point the
  //   user deliberately acquired, so it outranks a bare axis through the anchor;
  //   still below parallel/perpendicular, which name a specific object.
  [RULE.CONCENTRIC]: 0.87,
  [RULE.TANGENT]: 0.86,
  [RULE.PERPENDICULAR_FOOT]: 0.85,
  [RULE.COLLINEAR]: 0.84,
  [RULE.EQUAL_LENGTH]: 0.83,
  [RULE.PARALLEL]: 0.8,
  [RULE.PERPENDICULAR]: 0.8,
  [RULE.ALIGNMENT]: 0.78,
  // ── Session D ──────────────────────────────────────────────────────────────
  // Just below explicit alignment and just above the bare axes, which is the
  // whole ordering argument in one line: a point the user DELIBERATELY acquired
  // outranks one the engine merely noticed (explicit intent wins), and a line
  // through a real feature point outranks a bare axis through the anchor for
  // the same reason ALIGNMENT does — it names something in the drawing. Far
  // above nearest (0.6) and grid (0.5), as the spec requires.
  [RULE.AUTO_ALIGNMENT]: 0.77,
  [RULE.HORIZONTAL]: 0.76,
  [RULE.VERTICAL]: 0.76,
  [RULE.POLAR]: 0.72,
  [RULE.NEAREST]: 0.6,
  [RULE.GRID]: 0.5
});
var DEFAULT_PRIORITY = 0.5;
var TIER = Object.freeze({
  FEATURE: 0,
  FALLBACK: 1,
  TERMINAL: 2
});
var HIGHLIGHT_ROLE = Object.freeze({
  OWNER: "owner",
  REFERENCE: "reference"
});
var DEFAULT_INFERENCE_SETTINGS = Object.freeze({
  /**
   * Point-lock capture radius (px) — a HARD boundary, identical for every rule.
   *
   * 11, not 10, because this must not reach less far than the path it replaces:
   * the legacy editor captured object snaps within `PICK_PX * 1.8` = 10.8px
   * (cad-react `constants.js`). AutoCAD's default aperture is 10px, so 11 sits
   * at parity with both and above neither by enough to feel sticky.
   *
   * Since `scoreCandidate` no longer folds `priorityWeight` into the capture
   * test, this number now means exactly itself for endpoint, grid and every rule
   * between — see the CAPTURE vs ORDERING note there.
   */
  snapRadiusPx: 11,
  /** Directional perpendicular-deviation radius (px). */
  trackRadiusPx: 4,
  /**
   * Directional angular tolerance (deg). angleFactor reaches 0 here.
   *
   * 6, not 3, and ONE value for every directional rule.
   *
   * The legacy drafting path engaged polar within a 6° half-aperture
   * (`POLAR_APERTURE_DEG`), so a 3° engine tolerance would have halved the
   * angular band the user could reach — a silent regression from the rewrite.
   *
   * Widening only polar was tried and is worse: a rule's angular error is scored
   * as a FRACTION of its tolerance, so a wide-aperture rule reports a smaller
   * normalised error and scores HIGHER at the same true error. Horizontal then
   * outranked Parallel, inverting the priority table — the one thing that
   * expresses which reading the user means. A single shared envelope keeps
   * `RULE_PRIORITY` the sole arbiter of ordering, which is what it is for.
   *
   * The perpendicular-distance gate (`trackRadiusPx`) still applies on top, and
   * that is the half the legacy angle-only aperture got wrong: 6° is a huge
   * screen distance far from the anchor and sub-pixel close to it.
   */
  angleTolDeg: 6,
  /** Candidates scoring below this are discarded — the cursor stays free. */
  minScore: 0.3,
  /** PolarTrackingRule increment (deg). */
  polarIncrementDeg: 45,
  /**
   * PolarTrackingRule's OWN angular aperture (deg), separate from `angleTolDeg`.
   *
   * The legacy drafting path engaged polar within a 6° half-aperture
   * (`POLAR_APERTURE_DEG`). The engine's shared `angleTolDeg` is 3°, which is the
   * right envelope for Horizontal/Vertical/Parallel — those are *suggestions*
   * layered on top of geometry — but applying it to polar would make polar
   * tracking engage over HALF the angular band it used to. Replacing a path must
   * not narrow what the user can reach, so polar keeps its legacy aperture and
   * still gains the engine's perpendicular-distance gate on top.
   *
   * Reported through `mapAngleDeg` so the frozen ScoringEngine keeps comparing
   * every directional candidate on one scale — see envelope.js.
   */
  polarApertureDeg: 6,
  /** Grid pitch in WORLD units (GridRule); 0 disables the rule. */
  gridStep: 0,
  /** Score multiplier for the candidate that was active on the previous frame. */
  hysteresisBonus: 1.15,
  /** Point candidates closer than this merge into one (px). */
  coincidencePx: 0.5,
  /**
   * Widening factor on the spatial query radius, so an entity whose BOUNDS sit
   * just outside the capture radius can still contribute a feature point that
   * lands inside it. Mirrors findSnap's `gather = tol * 1.5`.
   */
  gatherFactor: 1.5,
  /**
   * Reference-entity search radius for Parallel/Perpendicular (px), measured
   * from the in-progress segment's start point.
   */
  referenceRadiusPx: 60,
  /**
   * How far past a segment's end CollinearRule still finds it (px, measured
   * from the cursor). The snap radius is the wrong envelope here: an extension
   * is tracked precisely from where the source geometry ISN'T. Unbounded
   * tracking needs Session B's acquired references.
   */
  extensionRadiusPx: 60,
  /**
   * Upper bound on entities fed to the O(k²) IntersectionRule pair scan. The
   * spatial query already keeps k tiny; this is the pathological-input guard
   * (hundreds of overlapping entities under one pixel). Entities are taken in
   * document order, so the cap is deterministic.
   */
  maxIntersectionEntities: 24,
  /** Extra score a composed candidate earns from its weaker half (see resolver). */
  composeBonus: 0.25,
  /**
   * How far a point lock may sit off a line of action and still be judged
   * consistent with it during composition (px).
   */
  composeTolPx: 1.5,
  // ── Session B: alignment tracking ───────────────────────────────────────────
  /**
   * Acquired-point cap. AutoCAD keeps this small on purpose: every acquired
   * point multiplies the alignment lines in play, and a screen full of dashed
   * guides is worse than none. The 9th acquisition evicts the least recently
   * used one.
   */
  maxTrackingPoints: 8,
  /**
   * Hover DWELL, in interactions — not milliseconds. The engine has no clock
   * (determinism), so "held still on that feature" is counted in pointer
   * observations; the React layer converts ~300ms of real hovering into this
   * many `observeHover` calls. See tracking.js.
   */
  trackDwellCount: 3,
  /**
   * How close (px) the cursor must be to a feature point for a hover
   * observation to count towards acquiring it — and, once acquired, to count as
   * a RE-hover that releases it.
   */
  acquireRadiusPx: 10,
  /** How many recently hovered entities the reference-selection hook remembers. */
  hoverHistoryCount: 4,
  // ── Session B: curve intelligence + equality ────────────────────────────────
  /**
   * Capture radius (px) for CONCENTRIC. Deliberately much larger than
   * snapRadiusPx: the whole point of the rule is to suggest a shared centre from
   * FURTHER AWAY than a centre snap would reach. See envelope.js for how a rule
   * with its own radius reports an error the shared falloff can read.
   */
  concentricRadiusPx: 40,
  /**
   * Capture radius (px) for EQUAL-LENGTH: how far the in-progress length may sit
   * from a recent one and still be offered as a match.
   *
   * 6, not 12. Two reasons, both learned from a drafting session that went
   * wrong:
   *
   * 1. A 12px window fires almost continuously. "Within 12 screen pixels of some
   *    recent segment's length" is true most of the time while drawing, so the
   *    suggestion stopped being a suggestion.
   * 2. Equal-length COMPOSES with a directional lock, and the resolver solves a
   *    direction ∩ point pair to the POINT — correct when the point is an exact
   *    feature of real geometry, but this one is derived from the cursor ray and
   *    may sit up to `composeTolPx` off the line of action. Drawing a vertical
   *    segment after a 30-unit one, the pair committed a point 0.3px off
   *    vertical AND truncated the run to 30: the segment was neither vertical
   *    nor what the user drew. A tighter window keeps that offset negligible.
   *
   * The composition subtlety is worth revisiting when constraints are persisted
   * — a solved intersection of "vertical" and "length 30" is a better answer
   * than either half.
   */
  equalLengthTolPx: 6,
  /**
   * Depth of the recently-drawn-segment ring buffer EqualLengthRule matches
   * against. "Recent" is interaction-count based (a ring buffer), never
   * timestamps — a wall clock would break determinism.
   */
  recentSegmentCount: 8,
  /**
   * Relevance multiplier applied by `contextFactor` to a rule the active tool
   * state makes IRRELEVANT but not impossible (e.g. tangent while drawing a
   * polyline). Not 0 — that would delete the candidate rather than demote it —
   * and not 1, which would make the gating a no-op.
   */
  offContextFactor: 0.5,
  // ── Session C: constraint persistence ───────────────────────────────────────
  /**
   * Write the winning candidate's `constraintHint`s to `doc.constraints` when
   * the geometry commits, so the sketch REMEMBERS the relation the user was
   * shown rather than only the coordinates it produced (persist.js).
   *
   * DEFAULT OFF, and deliberately so. A persisted constraint changes what later
   * edits are allowed to do — it is the difference between a drawing and a
   * parametric model — and that is a mode a user opts into, not a surprise the
   * first time they draw a line parallel to a wall. It belongs to a future
   * "parametric mode"; this session only reads the setting.
   */
  persistConstraints: false,
  // ── Session D: automatic alignment ──────────────────────────────────────────
  /**
   * Per-source-type gates for the alignment corridor.
   *
   * Endpoints ON, midpoints and centres OFF — the same reasoning AutoCAD uses
   * for its osnap defaults. Every extra kind multiplies the sources competing
   * for one cursor, and a corner is what a drafter lines things up with almost
   * every time. A user who wants centres says so once, in the panel.
   */
  autoAlignEndpoints: true,
  autoAlignMidpoints: false,
  autoAlignCenters: false,
  /**
   * Upper bound on IMPLICIT alignment sources considered per frame.
   *
   * Unlike the candidate cap (32, a pathological-input guard), this one binds in
   * ordinary use: a floor plan has hundreds of endpoints, and at any moment a
   * few dozen can share the cursor's x or y to within 4px. Sixteen is far more
   * than a user can distinguish on screen, and taking them NEAREST FIRST keeps
   * the ones a person would plausibly mean. Ties break on entity id, so a dense
   * drawing still gives the same answer every frame.
   */
  maxAutoAlignSources: 16,
  /**
   * How far past the viewport edge (px) an alignment source still counts, when
   * the host supplies a viewport. A point just off-screen still draws a guide
   * ACROSS the screen, so a hard clip at the edge would make guides blink out
   * as the user pans.
   */
  corridorMarginPx: 200,
  /**
   * Corridor half-length (px) when the host supplies NO viewport. Larger than
   * any display, so the no-viewport path admits a superset of what a viewport
   * bound would — and still bounded, which is the property the perf budget
   * needs. See corridor.js.
   */
  corridorSpanPx: 4e3
});

// src/inference/settings.js
var MAX_RADIUS_PX = 1e4;
var MAX_AUTO_ALIGN_SOURCES = 256;
var positive = (v, dflt) => typeof v === "number" && Number.isFinite(v) && v > 0 ? v : dflt;
var radiusPx = (v, dflt) => Math.min(MAX_RADIUS_PX, positive(v, dflt));
var nonNegative = (v, dflt) => typeof v === "number" && Number.isFinite(v) && v >= 0 ? v : dflt;
var clamped = (v, lo, hi, dflt) => typeof v === "number" && Number.isFinite(v) ? Math.min(hi, Math.max(lo, v)) : dflt;
var positiveInt = (v, dflt) => typeof v === "number" && Number.isFinite(v) && v >= 1 ? Math.floor(v) : dflt;
function normalizeInferenceSettings(partial) {
  const s = partial && typeof partial === "object" ? partial : {};
  const D = DEFAULT_INFERENCE_SETTINGS;
  return {
    snapRadiusPx: radiusPx(s.snapRadiusPx, D.snapRadiusPx),
    trackRadiusPx: radiusPx(s.trackRadiusPx, D.trackRadiusPx),
    // Above 90° every bearing is "within tolerance" of every line of action
    // (angles compare mod 180, so the maximum possible error is 90°) and the
    // directional rules would fire everywhere at once.
    angleTolDeg: clamped(s.angleTolDeg, 1e-6, 90, D.angleTolDeg),
    // minScore 0 keeps every candidate; 1 rejects all but a perfect one.
    minScore: clamped(s.minScore, 0, 1, D.minScore),
    // Nonsense (0, negative, NaN) falls back to the default rather than being
    // clamped: clamping 0 up to 1° would silently emit 180 lines of action per
    // frame. A genuine, positive value is then capped — an increment above 180°
    // yields a single line (angles are mod 180), and below 1° the candidates
    // are indistinguishable at any zoom.
    polarIncrementDeg: Math.min(180, Math.max(1, positive(s.polarIncrementDeg, D.polarIncrementDeg))),
    // Same bound as angleTolDeg: above 90° every bearing is inside the aperture
    // (angles compare mod 180, so the maximum error is 90°) and polar would fire
    // at every increment at once.
    polarApertureDeg: clamped(s.polarApertureDeg, 1e-6, 90, D.polarApertureDeg),
    gridStep: nonNegative(s.gridStep, D.gridStep),
    // 0 = GridRule off
    // A bonus below 1 would make the ACTIVE candidate easier to displace than a
    // fresh one — the opposite of hysteresis.
    hysteresisBonus: Math.max(1, nonNegative(s.hysteresisBonus, D.hysteresisBonus)),
    coincidencePx: nonNegative(s.coincidencePx, D.coincidencePx),
    gatherFactor: Math.max(1, positive(s.gatherFactor, D.gatherFactor)),
    referenceRadiusPx: radiusPx(s.referenceRadiusPx, D.referenceRadiusPx),
    extensionRadiusPx: radiusPx(s.extensionRadiusPx, D.extensionRadiusPx),
    maxIntersectionEntities: positiveInt(s.maxIntersectionEntities, D.maxIntersectionEntities),
    composeBonus: clamped(s.composeBonus, 0, 1, D.composeBonus),
    composeTolPx: nonNegative(s.composeTolPx, D.composeTolPx),
    // ── Session B ─────────────────────────────────────────────────────────────
    // A cap of 0 would mean "tracking is on but can hold nothing", which reads
    // as a broken feature rather than a disabled one; the floor is 1 and the
    // host turns tracking off by not feeding a store.
    maxTrackingPoints: positiveInt(s.maxTrackingPoints, D.maxTrackingPoints),
    // Dwell 1 = acquire on the first observation (no dwell). Below that is
    // meaningless, so the floor is 1 rather than 0.
    trackDwellCount: positiveInt(s.trackDwellCount, D.trackDwellCount),
    acquireRadiusPx: radiusPx(s.acquireRadiusPx, D.acquireRadiusPx),
    // 0 is meaningful here: "remember no hovered entities" restores Session A's
    // anchor-nearest reference selection exactly.
    hoverHistoryCount: Math.floor(nonNegative(s.hoverHistoryCount, D.hoverHistoryCount)),
    concentricRadiusPx: radiusPx(s.concentricRadiusPx, D.concentricRadiusPx),
    equalLengthTolPx: radiusPx(s.equalLengthTolPx, D.equalLengthTolPx),
    recentSegmentCount: positiveInt(s.recentSegmentCount, D.recentSegmentCount),
    // 0 is a valid "hard-gate off-context rules entirely"; 1 disables gating.
    offContextFactor: clamped(s.offContextFactor, 0, 1, D.offContextFactor),
    // ── Session C ─────────────────────────────────────────────────────────────
    // A plain boolean: anything non-boolean is a caller mistake, and the safe
    // reading of a mistake here is "do not silently start writing constraints".
    persistConstraints: s.persistConstraints === true,
    // ── Session D ─────────────────────────────────────────────────────────────
    // Booleans WITH a default, so `undefined` keeps the shipped value rather
    // than reading as false — unlike persistConstraints, whose safe reading of
    // a malformed value is "off". Turning endpoints off by accident would be a
    // silently missing feature; turning constraint writing on by accident would
    // change what later edits do.
    autoAlignEndpoints: typeof s.autoAlignEndpoints === "boolean" ? s.autoAlignEndpoints : D.autoAlignEndpoints,
    autoAlignMidpoints: typeof s.autoAlignMidpoints === "boolean" ? s.autoAlignMidpoints : D.autoAlignMidpoints,
    autoAlignCenters: typeof s.autoAlignCenters === "boolean" ? s.autoAlignCenters : D.autoAlignCenters,
    // A cap of 0 is meaningful: "consider no implicit sources", i.e. the rule
    // off without removing it — so the floor is 0, not 1.
    //
    // The CEILING exists for the same reason MAX_RADIUS_PX does: settings are
    // persisted to localStorage, so they are user-editable input read back at
    // boot. A stored 1e9 would disable the cap entirely and let a dense frame
    // build a candidate per source before the engine's own 32-candidate cap
    // threw all but 32 away. 256 is an order of magnitude past anything a person
    // could tell apart on screen, and it keeps the work bounded.
    maxAutoAlignSources: Math.min(
      MAX_AUTO_ALIGN_SOURCES,
      Math.floor(nonNegative(s.maxAutoAlignSources, D.maxAutoAlignSources))
    ),
    corridorMarginPx: Math.min(MAX_RADIUS_PX, nonNegative(s.corridorMarginPx, D.corridorMarginPx)),
    corridorSpanPx: radiusPx(s.corridorSpanPx, D.corridorSpanPx)
  };
}

// src/inference/safety.js
function tryGeometry(fn, fallback) {
  try {
    return fn();
  } catch {
    return fallback;
  }
}

// src/inference/spatialIndex.js
var UNBOUNDED_TYPES = /* @__PURE__ */ new Set(["ray", "xline"]);
var MAX_CELLS_PER_ENTITY = 256;
var MAX_CELLS_TOTAL = 1 << 18;
function createSpatialIndex(entities) {
  const list = Array.isArray(entities) ? entities : [];
  const byId2 = /* @__PURE__ */ new Map();
  const boxed = [];
  const unbounded = [];
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
  for (let i = 0; i < list.length; i++) {
    const e = list[i];
    if (!e || typeof e !== "object") continue;
    if (e.id != null && !byId2.has(e.id)) byId2.set(e.id, e);
    if (UNBOUNDED_TYPES.has(e.type)) {
      unbounded.push(i);
      continue;
    }
    const b = tryGeometry(() => entityBounds(e), null);
    if (!b || !Number.isFinite(b.minX) || !Number.isFinite(b.minY) || !Number.isFinite(b.maxX) || !Number.isFinite(b.maxY)) {
      unbounded.push(i);
      continue;
    }
    boxed.push({ e, i, b });
    if (b.minX < minX) minX = b.minX;
    if (b.minY < minY) minY = b.minY;
    if (b.maxX > maxX) maxX = b.maxX;
    if (b.maxY > maxY) maxY = b.maxY;
  }
  const n = boxed.length;
  const cells = /* @__PURE__ */ new Map();
  let cellSize = 0;
  let cols = 0;
  let rows = 0;
  if (n > 0) {
    const w = maxX - minX;
    const h = maxY - minY;
    const area = w * h;
    const ideal = area > 0 ? Math.sqrt(area / n) : (w + h) / Math.max(1, Math.sqrt(n));
    cellSize = ideal > 0 && Number.isFinite(ideal) ? ideal : 1;
    cols = Math.max(1, Math.ceil(w / cellSize) + 1);
    rows = Math.max(1, Math.ceil(h / cellSize) + 1);
    if (cols * rows > MAX_CELLS_TOTAL) {
      const grow = Math.sqrt(cols * rows / MAX_CELLS_TOTAL);
      cellSize *= grow;
      cols = Math.max(1, Math.ceil(w / cellSize) + 1);
      rows = Math.max(1, Math.ceil(h / cellSize) + 1);
    }
    for (const item of boxed) {
      const c0 = Math.floor((item.b.minX - minX) / cellSize);
      const c1 = Math.floor((item.b.maxX - minX) / cellSize);
      const r0 = Math.floor((item.b.minY - minY) / cellSize);
      const r1 = Math.floor((item.b.maxY - minY) / cellSize);
      if ((c1 - c0 + 1) * (r1 - r0 + 1) > MAX_CELLS_PER_ENTITY) {
        unbounded.push(item.i);
        continue;
      }
      for (let c = c0; c <= c1; c++) {
        for (let r = r0; r <= r1; r++) {
          const key = r * cols + c;
          const bucket = cells.get(key);
          if (bucket) bucket.push(item.i);
          else cells.set(key, [item.i]);
        }
      }
    }
  }
  unbounded.sort((a, b) => a - b);
  const boundsByIndex = new Map(boxed.map((it) => [it.i, it.b]));
  const rectQuery = (qx0, qy0, qx1, qy1) => {
    const hits = new Set(unbounded);
    if (cellSize > 0) {
      const c0 = Math.max(0, Math.floor((qx0 - minX) / cellSize));
      const c1 = Math.min(cols - 1, Math.floor((qx1 - minX) / cellSize));
      const r0 = Math.max(0, Math.floor((qy0 - minY) / cellSize));
      const r1 = Math.min(rows - 1, Math.floor((qy1 - minY) / cellSize));
      if ((c1 - c0 + 1) * (r1 - r0 + 1) > cells.size + MAX_CELLS_PER_ENTITY) {
        for (const item of boxed) {
          const b = item.b;
          if (qx1 < b.minX || qx0 > b.maxX || qy1 < b.minY || qy0 > b.maxY) continue;
          hits.add(item.i);
        }
        const wide = [...hits].sort((a, b) => a - b);
        return wide.map((i) => list[i]);
      }
      for (let c = c0; c <= c1; c++) {
        for (let row = r0; row <= r1; row++) {
          const bucket = cells.get(row * cols + c);
          if (!bucket) continue;
          for (const idx of bucket) {
            if (hits.has(idx)) continue;
            const b = boundsByIndex.get(idx);
            if (b && (qx1 < b.minX || qx0 > b.maxX || qy1 < b.minY || qy0 > b.maxY)) continue;
            hits.add(idx);
          }
        }
      }
    }
    const out = [...hits].sort((a, b) => a - b);
    return out.map((i) => list[i]);
  };
  const query = (p, radius) => {
    if (!p || !Number.isFinite(p.x) || !Number.isFinite(p.y)) return [];
    const r = Number.isFinite(radius) && radius > 0 ? radius : 0;
    return rectQuery(p.x - r, p.y - r, p.x + r, p.y + r);
  };
  const queryRect = (rect2) => {
    if (!rect2) return [];
    const { minX: x0, minY: y0, maxX: x1, maxY: y1 } = rect2;
    if (!Number.isFinite(x0) || !Number.isFinite(y0) || !Number.isFinite(x1) || !Number.isFinite(y1)) {
      return [];
    }
    return rectQuery(Math.min(x0, x1), Math.min(y0, y1), Math.max(x0, x1), Math.max(y0, y1));
  };
  return {
    query,
    queryRect,
    byId: (id) => byId2.get(id),
    all: () => list.slice(),
    size: list.length,
    cellSize,
    unboundedCount: unbounded.length
  };
}
var cache = /* @__PURE__ */ new WeakMap();
function getSpatialIndex(entities) {
  if (!Array.isArray(entities)) return createSpatialIndex([]);
  const hit = cache.get(entities);
  if (hit) return hit;
  const built = createSpatialIndex(entities);
  cache.set(entities, built);
  return built;
}

// src/inference/context.js
var vec = (p, dflt = null) => p && Number.isFinite(p.x) && Number.isFinite(p.y) ? { x: p.x, y: p.y } : dflt;
var rect = (r) => {
  if (!r) return null;
  const { minX, minY, maxX, maxY } = r;
  if (![minX, minY, maxX, maxY].every(Number.isFinite)) return null;
  return {
    minX: Math.min(minX, maxX),
    minY: Math.min(minY, maxY),
    maxX: Math.max(minX, maxX),
    maxY: Math.max(minY, maxY)
  };
};
function createInferenceContext(raw) {
  const r = raw && typeof raw === "object" ? raw : {};
  const cursor = vec(r.cursor, { x: 0, y: 0 });
  const entities = Array.isArray(r.entities) ? r.entities : [];
  const index = r.index && typeof r.index.query === "function" ? r.index : getSpatialIndex(entities);
  const points = Array.isArray(r.toolState && r.toolState.points) ? r.toolState.points.map((p) => vec(p)).filter(Boolean) : [];
  const anchor = vec(r.toolState && r.toolState.anchor) ?? (points.length ? points[points.length - 1] : null);
  const pixelScale = Number.isFinite(r.pixelScale) && r.pixelScale > 0 ? r.pixelScale : 1;
  const m = r.modifiers && typeof r.modifiers === "object" ? r.modifiers : {};
  const modifiers = {
    shift: !!m.shift,
    alt: !!m.alt,
    ctrl: !!m.ctrl,
    meta: !!m.meta
  };
  const settings = normalizeInferenceSettings(r.settings);
  const tracking = r.tracking && typeof r.tracking.list === "function" ? r.tracking : null;
  const recentSegments = Array.isArray(r.recentSegments) ? r.recentSegments.filter((s) => s && vec(s.a) && vec(s.b)).slice(0, settings.recentSegmentCount).map((s) => {
    const a = vec(s.a);
    const b = vec(s.b);
    return { a, b, length: Math.hypot(b.x - a.x, b.y - a.y) };
  }).filter((s) => s.length > 0) : [];
  const hoverHistory = Array.isArray(r.hoverHistory) ? r.hoverHistory.filter((id) => typeof id === "string" && id).slice(0, settings.hoverHistoryCount) : [];
  const viewport = rect(r.viewport);
  const queryMemo = /* @__PURE__ */ new Map();
  const ctx = {
    cursor,
    tool: typeof r.tool === "string" ? r.tool : "",
    // `entityType` lets a host say WHAT is being drawn independently of the tool
    // id, which is how curve relevance stays tool-agnostic (toolContext.js).
    toolState: {
      anchor,
      points,
      entityType: typeof (r.toolState && r.toolState.entityType) === "string" ? r.toolState.entityType : null
    },
    entities,
    index,
    pixelScale,
    modifiers,
    settings,
    activeKey: typeof r.activeKey === "string" ? r.activeKey : null,
    lockedRuleId: typeof r.lockedRuleId === "string" ? r.lockedRuleId : null,
    // Alt held (AutoCAD-style freehand override) or an explicit host suppression
    // (Esc). Either way the engine returns the raw cursor untouched.
    suppressed: !!r.suppressed || modifiers.alt,
    selectReference: typeof r.selectReference === "function" ? r.selectReference : null,
    tracking,
    recentSegments,
    hoverHistory,
    viewport,
    toPx: (world) => pixelScale > 0 ? world / pixelScale : world,
    toWorld: (px) => px * pixelScale,
    // MEMOISED PER FRAME, per radius. A context is built once per inference pass
    // and the cursor cannot move inside one, so `queryPx(r)` is a pure function
    // of `r` for the whole frame — but eight point rules ask for the SAME radius
    // (`snapRadiusPx × gatherFactor`) and each was re-walking the grid for the
    // identical answer. At 10k entities that was the dominant cost of the pass,
    // and it bought nothing.
    //
    // A cache, not a change of behaviour: same arguments, same result, and the
    // array is the one the index returns. Rules must not mutate it — none does,
    // and none ever could safely, since the index has always been shared.
    queryPx: (radiusPx2) => {
      const hit = queryMemo.get(radiusPx2);
      if (hit) return hit;
      const found = index.query(cursor, radiusPx2 * pixelScale);
      queryMemo.set(radiusPx2, found);
      return found;
    }
  };
  return ctx;
}
function isRuleLocked(ctx, ruleId) {
  return !!(ctx.modifiers.shift && ctx.lockedRuleId && ctx.lockedRuleId === ruleId);
}

// src/inference/scoring.js
var clamp012 = (v) => v < 0 ? 0 : v > 1 ? 1 : v;
function falloff(error, radius) {
  if (!Number.isFinite(error) || error < 0) return 0;
  if (!(radius > 0)) return 0;
  const t = error / radius;
  if (t >= 1) return 0;
  return clamp012(1 - t);
}
function contextFactor(cand, _ctx) {
  const v = cand && cand.contextFactor;
  return typeof v === "number" && Number.isFinite(v) ? clamp012(v) : 1;
}
function makePriorityOf(rulesById) {
  return (ruleId) => {
    const rule = rulesById && rulesById.get(ruleId);
    if (rule && typeof rule.priority === "number" && Number.isFinite(rule.priority)) {
      return clamp012(rule.priority);
    }
    const w = RULE_PRIORITY[ruleId];
    return typeof w === "number" ? w : DEFAULT_PRIORITY;
  };
}
function scoreCandidate(cand, ctx, priorityOf) {
  const s = ctx.settings;
  const directional = !!cand.direction && !cand.point;
  const radiusPx2 = directional ? s.trackRadiusPx : s.snapRadiusPx;
  const locked = isRuleLocked(ctx, cand.ruleId);
  const distanceFactor = locked ? 1 : falloff(cand.errorPx, radiusPx2);
  const angleFactor = locked || cand.angleErrorDeg === void 0 ? 1 : falloff(cand.angleErrorDeg, s.angleTolDeg);
  const ctxFactor = contextFactor(cand, ctx);
  const priorityWeight = priorityOf(cand.ruleId);
  const base = clamp012(cand.baseScore);
  const score = base * distanceFactor * angleFactor * ctxFactor * priorityWeight;
  const relevance = base * ctxFactor;
  const qualifies = distanceFactor > 0 && angleFactor > 0 && relevance >= minScoreOf(ctx);
  return {
    ...cand,
    score,
    qualifies,
    factors: { base, distanceFactor, angleFactor, contextFactor: ctxFactor, priorityWeight, relevance }
  };
}
function minScoreOf(ctx) {
  const v = ctx && ctx.settings && ctx.settings.minScore;
  return typeof v === "number" && Number.isFinite(v) ? v : 0;
}
function scoreCandidates(candidates, ctx, priorityOf) {
  const out = [];
  for (const cand of candidates) {
    if (!cand) continue;
    const scored = scoreCandidate(cand, ctx, priorityOf);
    if (scored.qualifies) out.push(scored);
  }
  return out;
}

// src/inference/lineOfAction.js
var DEG2 = Math.PI / 180;
var RAD = 180 / Math.PI;
var EPS = 1e-12;
function normalizeAngle180(deg2) {
  if (!Number.isFinite(deg2)) return 0;
  const a = deg2 % 180;
  return a < 0 ? a + 180 : a;
}
function segmentAngle(a, b) {
  return normalizeAngle180(Math.atan2(b.y - a.y, b.x - a.x) * RAD);
}
function lineOfAction(through, angleDeg5) {
  return { through: { x: through.x, y: through.y }, angle: normalizeAngle180(angleDeg5) };
}
function lineDirection(loa) {
  if (loa.angle === 0) return { x: 1, y: 0 };
  if (loa.angle === 90) return { x: 0, y: 1 };
  const r = loa.angle * DEG2;
  return { x: Math.cos(r), y: Math.sin(r) };
}
function footOnLine2(loa, p) {
  const d = lineDirection(loa);
  const t = (p.x - loa.through.x) * d.x + (p.y - loa.through.y) * d.y;
  return { x: loa.through.x + d.x * t, y: loa.through.y + d.y * t };
}
function projectionLength(loa, p) {
  const d = lineDirection(loa);
  return (p.x - loa.through.x) * d.x + (p.y - loa.through.y) * d.y;
}
function perpDistance(loa, p) {
  const d = lineDirection(loa);
  return Math.abs((p.x - loa.through.x) * d.y - (p.y - loa.through.y) * d.x);
}
function angleDelta(aDeg, bDeg) {
  const d = Math.abs(normalizeAngle180(aDeg) - normalizeAngle180(bDeg));
  return d > 90 ? 180 - d : d;
}
function bearingError(loa, p) {
  const dx = p.x - loa.through.x;
  const dy = p.y - loa.through.y;
  if (Math.abs(dx) < EPS && Math.abs(dy) < EPS) return 0;
  return angleDelta(Math.atan2(dy, dx) * RAD, loa.angle);
}
function intersectLines(a, b) {
  const da = lineDirection(a);
  const db = lineDirection(b);
  const den = da.x * db.y - da.y * db.x;
  if (Math.abs(den) < 1e-9) return null;
  const t = ((b.through.x - a.through.x) * db.y - (b.through.y - a.through.y) * db.x) / den;
  return { x: a.through.x + da.x * t, y: a.through.y + da.y * t };
}
function dist5(a, b) {
  return Math.hypot(a.x - b.x, a.y - b.y);
}

// src/inference/candidate.js
function candidateKey(c) {
  const ids = Array.isArray(c.refs) ? c.refs.map((r) => r && r.id || "?").join("+") : "";
  const slot = c.slot === void 0 || c.slot === null ? "" : String(c.slot);
  return `${c.ruleId}|${ids}|${slot}`;
}
var glyphGuide = (at, glyph) => ({ kind: GUIDE.GLYPH, at: { x: at.x, y: at.y }, glyph });
var dashedGuide = (from, to, style = GUIDE_STYLE.POLAR) => ({
  kind: GUIDE.DASHED_LINE,
  from: { x: from.x, y: from.y },
  to: { x: to.x, y: to.y },
  style
});
var highlightGuide = (ref, role = HIGHLIGHT_ROLE.OWNER) => ({
  kind: GUIDE.HIGHLIGHT_ENTITY,
  ref,
  role
});
function pointCandidate(spec2) {
  const refs = spec2.refs || [];
  const cand = {
    ruleId: spec2.ruleId,
    point: { x: spec2.point.x, y: spec2.point.y },
    baseScore: spec2.baseScore === void 0 ? 1 : spec2.baseScore,
    errorPx: spec2.errorPx,
    guides: spec2.guides || [],
    refs,
    slot: spec2.slot
  };
  if (spec2.contextFactor !== void 0) cand.contextFactor = spec2.contextFactor;
  if (spec2.tier) cand.tier = spec2.tier;
  if (spec2.constraintHint) cand.constraintHint = spec2.constraintHint;
  if (spec2.exclusive) cand.exclusive = spec2.exclusive;
  cand.key = candidateKey(cand);
  return cand;
}
function directionCandidate(spec2) {
  const refs = spec2.refs || [];
  const cand = {
    ruleId: spec2.ruleId,
    direction: {
      through: { x: spec2.direction.through.x, y: spec2.direction.through.y },
      angle: spec2.direction.angle
    },
    baseScore: spec2.baseScore === void 0 ? 1 : spec2.baseScore,
    errorPx: spec2.errorPx,
    guides: spec2.guides || [],
    refs,
    slot: spec2.slot
  };
  if (spec2.angleErrorDeg !== void 0) cand.angleErrorDeg = spec2.angleErrorDeg;
  if (spec2.contextFactor !== void 0) cand.contextFactor = spec2.contextFactor;
  if (spec2.tier) cand.tier = spec2.tier;
  if (spec2.constraintHint) cand.constraintHint = spec2.constraintHint;
  if (spec2.exclusive) cand.exclusive = spec2.exclusive;
  if (spec2.derivedFrom && spec2.derivedFrom.length) cand.derivedFrom = [...spec2.derivedFrom];
  cand.key = candidateKey(cand);
  return cand;
}
function candidatePoint(cand, cursor) {
  if (cand && cand.point) return { x: cand.point.x, y: cand.point.y };
  if (cand && cand.direction) return footOnLine2(cand.direction, cursor);
  return { x: cursor.x, y: cursor.y };
}
function constraintHints(cand) {
  if (!cand) return [];
  if (Array.isArray(cand.constraintHints)) return cand.constraintHints;
  return cand.constraintHint ? [cand.constraintHint] : [];
}

// src/inference/resolver.js
var MAX_COMPOSE_PARTS = 6;
function sortCandidates(list) {
  return [...list].sort((a, b) => {
    const ta = a.tier || 0;
    const tb = b.tier || 0;
    if (ta !== tb) return ta - tb;
    if (b.score !== a.score) return b.score - a.score;
    return a.key < b.key ? -1 : a.key > b.key ? 1 : 0;
  });
}
function applyHysteresis(scored, ctx) {
  const activeKey = ctx.activeKey;
  if (!activeKey) return scored;
  const bonus = ctx.settings.hysteresisBonus;
  return scored.map(
    (c) => c.key === activeKey ? { ...c, score: c.score * bonus, hysteresis: true } : c
  );
}
function pruneExclusive(sorted) {
  const taken = /* @__PURE__ */ new Set();
  const out = [];
  for (const c of sorted) {
    if (c.exclusive) {
      if (taken.has(c.exclusive)) continue;
      taken.add(c.exclusive);
    }
    out.push(c);
  }
  return out;
}
function mergeCoincident(sorted, ctx) {
  const tolWorld = ctx.toWorld(ctx.settings.coincidencePx);
  const out = [];
  for (const c of sorted) {
    if (!c.point) {
      out.push(c);
      continue;
    }
    const host = out.find((h) => h.point && dist5(h.point, c.point) <= tolWorld);
    if (!host) {
      out.push({ ...c });
      continue;
    }
    host.guides = dedupeGuides([...host.guides, ...c.guides]);
    host.refs = dedupeRefs([...host.refs, ...c.refs]);
    host.constraintHints = dedupeHints([...constraintHints(host), ...constraintHints(c)]);
    host.mergedFrom = [...host.mergedFrom || [host.key], c.key];
  }
  return out;
}
function composeCandidates(list, ctx) {
  const s = ctx.settings;
  const points = list.filter((c) => c.point).slice(0, MAX_COMPOSE_PARTS);
  const directions = list.filter((c) => c.direction && !c.point).slice(0, MAX_COMPOSE_PARTS);
  if (!directions.length) return [];
  const composeTolWorld = ctx.toWorld(s.composeTolPx);
  const out = [];
  for (const d of directions) {
    for (const p of points) {
      if (isTautological(d, p)) continue;
      if (perpDistance(d.direction, p.point) > composeTolWorld) continue;
      out.push(makeComposed(p, d, { x: p.point.x, y: p.point.y }, ctx));
    }
  }
  for (let i = 0; i < directions.length; i++) {
    for (let j = i + 1; j < directions.length; j++) {
      const a = directions[i];
      const b = directions[j];
      if (a.exclusive && a.exclusive === b.exclusive) continue;
      const x = intersectLines(a.direction, b.direction);
      if (!x) continue;
      if (ctx.toPx(dist5(x, ctx.cursor)) > s.snapRadiusPx) continue;
      out.push(makeComposed(a, b, x, ctx));
    }
  }
  return out;
}
function isTautological(direction, point) {
  const from = direction.derivedFrom;
  if (!from || !from.length) return false;
  if (!point.refs || !point.refs.length) return false;
  return point.refs.every((r) => from.includes(r.id));
}
function makeComposed(a, b, point, ctx) {
  const hi = Math.max(a.score, b.score);
  const lo = Math.min(a.score, b.score);
  const score = Math.min(1, hi + ctx.settings.composeBonus * lo);
  const [first, second] = a.score > b.score || a.score === b.score && a.key <= b.key ? [a, b] : [b, a];
  return {
    ruleId: `${first.ruleId}+${second.ruleId}`,
    key: `${first.key}&${second.key}`,
    point: { x: point.x, y: point.y },
    baseScore: Math.min(first.baseScore, second.baseScore),
    errorPx: ctx.toPx(dist5(point, ctx.cursor)),
    guides: dedupeGuides([...first.guides, ...second.guides]),
    refs: dedupeRefs([...first.refs, ...second.refs]),
    constraintHints: dedupeHints([...constraintHints(first), ...constraintHints(second)]),
    composedFrom: [first.key, second.key],
    score,
    factors: { composed: true }
  };
}
function supersedeParts(list, composed, ctx) {
  if (!composed.length) return list;
  const tolWorld = ctx.toWorld(ctx.settings.coincidencePx);
  const partOf = /* @__PURE__ */ new Set();
  for (const c of composed) for (const k of c.composedFrom) partOf.add(k);
  return list.filter((c) => {
    if (!partOf.has(c.key)) return true;
    const pt3 = candidatePoint(c, ctx.cursor);
    return !composed.some(
      (x) => x.composedFrom.includes(c.key) && dist5(x.point, pt3) <= tolWorld
    );
  });
}
var guideKey = (g) => {
  if (!g) return "~";
  if (g.kind === "glyph") return `g:${g.glyph}:${g.at.x}:${g.at.y}`;
  if (g.kind === "dashedLine") return `d:${g.style}:${g.from.x}:${g.from.y}:${g.to.x}:${g.to.y}`;
  if (g.kind === "highlightEntity") return `h:${g.role || "owner"}:${g.ref && g.ref.id}`;
  return `?:${g.kind}`;
};
function dedupeGuides(guides) {
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const g of guides) {
    const k = guideKey(g);
    if (seen.has(k)) continue;
    seen.add(k);
    out.push(g);
  }
  return out;
}
function dedupeRefs(refs) {
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const r of refs) {
    if (!r || !r.id || seen.has(r.id)) continue;
    seen.add(r.id);
    out.push(r);
  }
  return out;
}
function dedupeHints(hints) {
  const seen = /* @__PURE__ */ new Set();
  const out = [];
  for (const h of hints) {
    if (!h) continue;
    const k = `${h.type}:${(h.refs || []).join(",")}`;
    if (seen.has(k)) continue;
    seen.add(k);
    out.push(h);
  }
  return out;
}
function resolveConflicts(scored, ctx) {
  const biased = applyHysteresis(scored, ctx);
  const sorted = sortCandidates(biased);
  const pruned = pruneExclusive(sorted);
  const merged = mergeCoincident(pruned, ctx);
  const composed = applyHysteresis(composeCandidates(merged, ctx), ctx);
  const survivors = supersedeParts(merged, composed, ctx);
  const all = sortCandidates([...survivors, ...composed]);
  const best = all.length ? all[0] : null;
  return {
    best,
    all,
    point: best ? candidatePoint(best, ctx.cursor) : { x: ctx.cursor.x, y: ctx.cursor.y }
  };
}

// src/inference/refs.js
var SIGNATURE_FIELDS = [
  "x",
  "y",
  "x1",
  "y1",
  "x2",
  "y2",
  "cx",
  "cy",
  "r",
  "rx",
  "ry",
  "startAngle",
  "endAngle",
  "rotation",
  "width",
  "height",
  "dx",
  "dy",
  "arcRadius",
  "closed"
];
var num2 = (v) => Number.isFinite(v) ? v.toFixed(9) : String(v);
var signatureCache = /* @__PURE__ */ new WeakMap();
function entitySignature(e) {
  if (!e || typeof e !== "object") return "";
  const cached = signatureCache.get(e);
  if (cached !== void 0) return cached;
  let h = 2166136261;
  const mix = (s) => {
    for (let i = 0; i < s.length; i++) {
      h ^= s.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
  };
  mix(String(e.type));
  for (const k of SIGNATURE_FIELDS) {
    const v = e[k];
    if (typeof v === "number") {
      mix(k);
      mix(num2(v));
    } else if (typeof v === "boolean") {
      mix(k);
      mix(v ? "1" : "0");
    }
  }
  if (Array.isArray(e.points)) {
    mix("points");
    mix(String(e.points.length));
    for (const p of e.points) {
      if (!p || typeof p !== "object") {
        mix("~");
        continue;
      }
      mix(num2(p.x));
      mix(",");
      mix(num2(p.y));
      if (typeof p.bulge === "number" && p.bulge !== 0) {
        mix("b");
        mix(num2(p.bulge));
      }
    }
  }
  const sig = (h >>> 0).toString(36);
  signatureCache.set(e, sig);
  return sig;
}
function entityRef(e) {
  if (!e || typeof e !== "object" || !e.id) return null;
  return { id: e.id, version: entitySignature(e), type: String(e.type) };
}
function resolveRef(ref, lookup) {
  if (!ref || !ref.id || !lookup) return null;
  let e;
  if (typeof lookup === "function") e = lookup(ref.id);
  else if (typeof lookup.get === "function") e = lookup.get(ref.id);
  else if (Array.isArray(lookup)) e = lookup.find((x) => x && x.id === ref.id);
  if (!e) return null;
  if (ref.version && entitySignature(e) !== ref.version) return null;
  return e;
}
function resolveRefs(refs, lookup) {
  if (!Array.isArray(refs)) return null;
  const out = [];
  for (const ref of refs) {
    const e = resolveRef(ref, lookup);
    if (!e) return null;
    out.push(e);
  }
  return out;
}
function refsAreLive(refs, lookup) {
  if (!Array.isArray(refs) || refs.length === 0) return true;
  return resolveRefs(refs, lookup) !== null;
}

// src/inference/rules/makeFeaturePointRule.js
function makeFeaturePointRule(spec2) {
  const { id, extract, glyph, constraintType, baseScore } = spec2;
  return {
    id,
    detect(ctx) {
      const { snapRadiusPx, gatherFactor } = ctx.settings;
      const near = ctx.queryPx(snapRadiusPx * gatherFactor);
      const out = [];
      for (let i = 0; i < near.length; i++) {
        const e = near[i];
        if (!e) continue;
        const ref = entityRef(e);
        const refs = ref ? [ref] : [];
        const idPart = e.id || `#${i}`;
        for (const f of extract(e)) {
          const errorPx = ctx.toPx(dist5(ctx.cursor, f.point));
          if (errorPx > snapRadiusPx) continue;
          out.push(
            pointCandidate({
              ruleId: id,
              point: f.point,
              errorPx,
              baseScore,
              slot: `${idPart}:${f.slot}`,
              refs,
              guides: ref ? [glyphGuide(f.point, glyph), highlightGuide(ref)] : [glyphGuide(f.point, glyph)],
              constraintHint: constraintType ? { type: constraintType, refs: ref ? [ref.id] : [] } : void 0
            })
          );
        }
      }
      return out;
    }
  };
}

// src/inference/rules/featurePoints.js
var DEFINING_POINT_TYPES = /* @__PURE__ */ new Set(["spline", "circle", "arc", "ellipse"]);
var NON_GEOMETRIC = /* @__PURE__ */ new Set(["dimension", "hatch", "xref", "table", "mtext"]);
var pt2 = (p, slot) => ({ point: { x: p.x, y: p.y }, slot });
var EMPTY = Object.freeze([]);
function endpointsOfRaw(e) {
  if (!e || NON_GEOMETRIC.has(e.type)) return [];
  switch (e.type) {
    case "arc":
      return [
        pt2(onCirclePoint(e.cx, e.cy, e.r, e.startAngle), "start"),
        pt2(onCirclePoint(e.cx, e.cy, e.r, e.endAngle), "end")
      ];
    case "circle":
      return [];
    // a full circle has no ends — its quadrants are its features
    case "ellipse": {
      if (isFullEllipse(e)) return [];
      return [pt2(ellipsePoint(e, e.startAngle), "start"), pt2(ellipsePoint(e, e.endAngle), "end")];
    }
    case "spline": {
      if (e.closed) return [];
      const tess = splineToPolyline(e);
      if (tess.length < 2) return [];
      return [pt2(tess[0], "start"), pt2(tess[tess.length - 1], "end")];
    }
    case "revcloud": {
      const v = e.points || [];
      if (e.closed || v.length < 2) return [];
      return [pt2(v[0], "start"), pt2(v[v.length - 1], "end")];
    }
    case "ray":
      return [pt2({ x: e.x, y: e.y }, "base")];
    // the base; the other end is at infinity
    case "xline":
      return [];
    // infinite in both directions
    default: {
      if (DEFINING_POINT_TYPES.has(e.type)) return [];
      return entityVertices(e).map((v, i) => pt2(v, `v${i}`));
    }
  }
}
function midpointsOfRaw(e) {
  if (!e || NON_GEOMETRIC.has(e.type)) return [];
  switch (e.type) {
    case "arc":
      return [pt2(onCirclePoint(e.cx, e.cy, e.r, arcMidAngle(e)), "mid")];
    case "circle":
      return [];
    case "ellipse":
      return isFullEllipse(e) ? [] : [pt2(ellipsePoint(e, e.startAngle + ellipseSweep(e) / 2), "mid")];
    case "line":
      return [pt2({ x: (e.x1 + e.x2) / 2, y: (e.y1 + e.y2) / 2 }, "mid")];
    case "polyline":
    case "rectangle": {
      return entitySegments(e).map(
        (s, i) => pt2({ x: (s[0].x + s[1].x) / 2, y: (s[0].y + s[1].y) / 2 }, `s${i}`)
      );
    }
    case "revcloud": {
      const v = e.points || [];
      const out = [];
      for (let i = 0; i < v.length - 1; i++) {
        out.push(pt2({ x: (v[i].x + v[i + 1].x) / 2, y: (v[i].y + v[i + 1].y) / 2 }, `s${i}`));
      }
      return out;
    }
    default:
      return [];
  }
}
function centersOfRaw(e) {
  if (!e) return [];
  if (e.type === "circle" || e.type === "arc" || e.type === "ellipse") {
    return [pt2({ x: e.cx, y: e.cy }, "c")];
  }
  return [];
}
function quadrantsOfRaw(e) {
  if (!e) return [];
  if (e.type === "circle" || e.type === "arc") {
    const quads = [
      { a: 0, p: { x: e.cx + e.r, y: e.cy } },
      { a: 90, p: { x: e.cx, y: e.cy + e.r } },
      { a: 180, p: { x: e.cx - e.r, y: e.cy } },
      { a: 270, p: { x: e.cx, y: e.cy - e.r } }
    ];
    const inSweep = e.type === "arc" ? quads.filter(({ p }) => angleInArcSweep(e, p)) : quads;
    return inSweep.map(({ a, p }) => pt2(p, `q${a}`));
  }
  if (e.type === "ellipse") {
    if (isFullEllipse(e)) return ellipseQuadrants(e).map((q, i) => pt2(q, `q${i * 90}`));
    const start0 = (e.startAngle % 360 + 360) % 360;
    const sweep = ellipseSweep(e);
    const out = [];
    for (const t of [0, 90, 180, 270]) {
      if ((t - start0 + 360) % 360 <= sweep + 1e-6) out.push(pt2(ellipsePoint(e, t), `q${t}`));
    }
    return out;
  }
  return [];
}
function directionSegmentsOfRaw(e) {
  if (!e) return [];
  if (e.type === "ray" || e.type === "xline") {
    const L = Math.hypot(e.dx, e.dy);
    if (!(L > 0)) return [];
    return [{ a: { x: e.x, y: e.y }, b: { x: e.x + e.dx / L, y: e.y + e.dy / L }, slot: "s0" }];
  }
  if (e.type === "line" || e.type === "polyline" || e.type === "rectangle") {
    return entitySegments(e).map((s, i) => ({ a: s[0], b: s[1], slot: `s${i}` }));
  }
  if (e.type === "revcloud") {
    const v = e.points || [];
    const out = [];
    for (let i = 0; i < v.length - 1; i++) out.push({ a: v[i], b: v[i + 1], slot: `s${i}` });
    if (e.closed && v.length > 2) out.push({ a: v[v.length - 1], b: v[0], slot: `s${v.length - 1}` });
    return out;
  }
  return [];
}
function outlineSegmentsOfRaw(e) {
  if (!e) return [];
  if (e.type === "revcloud") {
    const tess = revisionCloudArcs(e.points || [], !!e.closed, e.arcRadius);
    const out = [];
    for (let i = 0; i < tess.length - 1; i++) out.push([tess[i], tess[i + 1]]);
    return out;
  }
  return entitySegments(e);
}
var endpointsOf = (e) => tryGeometry(() => endpointsOfRaw(e), EMPTY);
var midpointsOf = (e) => tryGeometry(() => midpointsOfRaw(e), EMPTY);
var centersOf = (e) => tryGeometry(() => centersOfRaw(e), EMPTY);
var quadrantsOf = (e) => tryGeometry(() => quadrantsOfRaw(e), EMPTY);
var directionSegmentsOf = (e) => tryGeometry(() => directionSegmentsOfRaw(e), EMPTY);
var outlineSegmentsOf = (e) => tryGeometry(() => outlineSegmentsOfRaw(e), EMPTY);

// src/inference/rules/endpoint.js
var EndpointRule = makeFeaturePointRule({
  id: RULE.ENDPOINT,
  extract: endpointsOf,
  glyph: "endpoint",
  constraintType: "coincident"
});

// src/inference/rules/midpoint.js
var MidpointRule = makeFeaturePointRule({
  id: RULE.MIDPOINT,
  extract: midpointsOf,
  glyph: "midpoint",
  constraintType: "coincident"
});

// src/inference/rules/center.js
var CenterRule = makeFeaturePointRule({
  id: RULE.CENTER,
  extract: centersOf,
  glyph: "center",
  // Placing a point at a circle's centre is the seed of a CONCENTRIC relation;
  // the hint is recorded now and consumed when constraint persistence lands.
  constraintType: "concentric"
});

// src/inference/rules/quadrant.js
var QuadrantRule = makeFeaturePointRule({
  id: RULE.QUADRANT,
  extract: quadrantsOf,
  glyph: "quadrant",
  constraintType: "coincident"
});

// src/inference/rules/intersection.js
var EMPTY2 = Object.freeze([]);
var MAX_SELF_SEGMENTS = 2048;
var MAX_SELF_NEAR_SEGMENTS = 64;
var isPoint = (p) => !!p && Number.isFinite(p.x) && Number.isFinite(p.y);
function outlineIsClosed(e, outline) {
  if (e.closed === true || e.type === "rectangle") return true;
  const first = outline[0];
  const last = outline[outline.length - 1];
  if (!first || !last) return false;
  const a = first[0];
  const b = last[1];
  return isPoint(a) && isPoint(b) && a.x === b.x && a.y === b.y;
}
function selfIntersections(e, poolIndex, ctx) {
  const { snapRadiusPx, gatherFactor } = ctx.settings;
  const outline = outlineSegmentsOf(e);
  if (outline.length < 3) return EMPTY2;
  const closed = outlineIsClosed(e, outline);
  const lastIndex = outline.length - 1;
  const limit = Math.min(outline.length, MAX_SELF_SEGMENTS);
  const gatherWorld = ctx.toWorld(snapRadiusPx * gatherFactor);
  const near = [];
  for (let i = 0; i < limit && near.length < MAX_SELF_NEAR_SEGMENTS; i++) {
    const s = outline[i];
    const a = s && s[0];
    const b = s && s[1];
    if (!isPoint(a) || !isPoint(b)) continue;
    if (pointToSegment(ctx.cursor, a, b) > gatherWorld) continue;
    near.push({ a, b, i });
  }
  if (near.length < 2) return EMPTY2;
  const ref = entityRef(e);
  const id = e.id || `#${poolIndex}`;
  const out = [];
  for (let x = 0; x < near.length; x++) {
    const s = near[x];
    for (let y = x + 1; y < near.length; y++) {
      const t = near[y];
      if (t.i === s.i + 1) continue;
      if (closed && s.i === 0 && t.i === lastIndex) continue;
      const p = segSegIntersection(s.a, s.b, t.a, t.b);
      if (!p || !Number.isFinite(p.x) || !Number.isFinite(p.y)) continue;
      const errorPx = ctx.toPx(dist5(ctx.cursor, p));
      if (errorPx > snapRadiusPx) continue;
      const refs = ref ? [ref] : [];
      out.push(
        pointCandidate({
          ruleId: RULE.INTERSECTION,
          point: p,
          errorPx,
          // The segment index PAIR is the crossing's natural identity: a shape
          // that folds over itself twice raises two candidates that must not
          // collide. The id is carried too, so two id-less entities (whose refs
          // contribute nothing to the key) still get distinct keys.
          slot: `self:${id}:s${s.i}xs${t.i}`,
          refs,
          guides: [glyphGuide(p, "intersection"), ...refs.map(highlightGuide)],
          constraintHint: { type: "coincident", refs: refs.map((r) => r.id) }
        })
      );
    }
  }
  return out;
}
var IntersectionRule = {
  id: RULE.INTERSECTION,
  detect(ctx) {
    const { snapRadiusPx, gatherFactor, maxIntersectionEntities } = ctx.settings;
    const near = ctx.queryPx(snapRadiusPx * gatherFactor);
    const pool = near.length > maxIntersectionEntities ? near.slice(0, maxIntersectionEntities) : near;
    const out = [];
    for (let i = 0; i < pool.length; i++) {
      const a = pool[i];
      if (!a) continue;
      const refA = entityRef(a);
      for (let j = i + 1; j < pool.length; j++) {
        const b = pool[j];
        if (!b) continue;
        if (a === b || a.id && a.id === b.id) continue;
        const refB = entityRef(b);
        const points = tryGeometry(() => intersectEntities(a, b), EMPTY2);
        for (let k = 0; k < points.length; k++) {
          const p = points[k];
          if (!p || !Number.isFinite(p.x) || !Number.isFinite(p.y)) continue;
          const errorPx = ctx.toPx(dist5(ctx.cursor, p));
          if (errorPx > snapRadiusPx) continue;
          const refs = [refA, refB].filter(Boolean);
          out.push(
            pointCandidate({
              ruleId: RULE.INTERSECTION,
              point: p,
              errorPx,
              slot: `${a.id || `#${i}`}x${b.id || `#${j}`}:${k}`,
              refs,
              guides: [glyphGuide(p, "intersection"), ...refs.map(highlightGuide)],
              constraintHint: { type: "coincident", refs: refs.map((r) => r.id) }
            })
          );
        }
      }
    }
    const seen = /* @__PURE__ */ new Set();
    for (let i = 0; i < pool.length; i++) {
      const e = pool[i];
      if (!e) continue;
      const dedupeKey = e.id != null ? e.id : e;
      if (seen.has(dedupeKey)) continue;
      seen.add(dedupeKey);
      const found = tryGeometry(() => selfIntersections(e, i, ctx), EMPTY2);
      for (let k = 0; k < found.length; k++) out.push(found[k]);
    }
    return out;
  }
};

// src/inference/rules/nearest.js
var NearestRule = {
  id: RULE.NEAREST,
  detect(ctx) {
    const { snapRadiusPx, gatherFactor } = ctx.settings;
    const near = ctx.queryPx(snapRadiusPx * gatherFactor);
    const out = [];
    for (let i = 0; i < near.length; i++) {
      const e = near[i];
      if (!e) continue;
      const hit = tryGeometry(() => nearestOnEntity(ctx.cursor, e), null);
      if (!hit || !hit.point) continue;
      const errorPx = ctx.toPx(hit.dist);
      if (errorPx > snapRadiusPx) continue;
      const ref = entityRef(e);
      out.push(
        pointCandidate({
          ruleId: RULE.NEAREST,
          point: hit.point,
          errorPx,
          // A FALLBACK, never a competitor: "somewhere on that object" must not
          // take a click away from a corner the user is aiming at, however much
          // closer to the cursor the body happens to be. Legacy encoded this by
          // consulting its nearest candidate only `if (!best)`; AutoCAD does the
          // same. See TIER in constants.js and `sortCandidates`.
          tier: TIER.FALLBACK,
          slot: e.id || `#${i}`,
          refs: ref ? [ref] : [],
          guides: ref ? [glyphGuide(hit.point, "nearest"), highlightGuide(ref)] : [glyphGuide(hit.point, "nearest")]
        })
      );
    }
    return out;
  }
};

// src/inference/envelope.js
function mapErrorPx(errorPx, ruleRadiusPx, snapRadiusPx) {
  if (!Number.isFinite(errorPx) || errorPx < 0) return Infinity;
  if (!(ruleRadiusPx > 0) || !(snapRadiusPx > 0)) return Infinity;
  if (ruleRadiusPx <= snapRadiusPx) return errorPx;
  return errorPx / ruleRadiusPx * snapRadiusPx;
}
function mapAngleDeg(angleErrorDeg, apertureDeg, angleTolDeg) {
  if (!Number.isFinite(angleErrorDeg) || angleErrorDeg < 0) return Infinity;
  if (!(apertureDeg > 0) || !(angleTolDeg > 0)) return Infinity;
  if (apertureDeg <= angleTolDeg) return angleErrorDeg;
  return angleErrorDeg / apertureDeg * angleTolDeg;
}

// src/inference/rules/grid.js
var GridRule = {
  id: RULE.GRID,
  detect(ctx) {
    const step = ctx.settings.gridStep;
    if (!(step > 0)) return [];
    const p = snapToGrid(ctx.cursor, step);
    const cellPx = ctx.toPx(step);
    return [
      pointCandidate({
        ruleId: RULE.GRID,
        point: p,
        errorPx: mapErrorPx(ctx.toPx(dist5(ctx.cursor, p)), cellPx, ctx.settings.snapRadiusPx),
        tier: TIER.TERMINAL,
        // One candidate per frame, and the grid is a global lattice — the rule
        // id alone is a stable identity across frames.
        slot: "",
        refs: [],
        guides: [glyphGuide(p, "grid")]
      })
    ];
  }
};

// src/inference/rules/directional.js
function makeDirectionalCandidate(spec2) {
  const {
    ctx,
    ruleId,
    through,
    angleDeg: angleDeg5,
    slot,
    exclusive,
    refs = [],
    derivedFrom,
    constraintHint,
    extraGuides = [],
    guideStyle = GUIDE_STYLE.POLAR,
    guideFrom,
    requireBearing = true,
    baseScore,
    contextFactor: contextFactor2,
    apertureDeg
  } = spec2;
  const { trackRadiusPx, angleTolDeg } = ctx.settings;
  const aperture = Number.isFinite(apertureDeg) && apertureDeg > 0 ? apertureDeg : angleTolDeg;
  const loa = lineOfAction(through, angleDeg5);
  const errorPx = ctx.toPx(perpDistance(loa, ctx.cursor));
  const trueAngleErrorDeg = requireBearing ? bearingError(loa, ctx.cursor) : void 0;
  const locked = isRuleLocked(ctx, ruleId);
  if (!locked) {
    if (errorPx > trackRadiusPx) return null;
    if (trueAngleErrorDeg !== void 0 && trueAngleErrorDeg > aperture) return null;
  }
  const angleErrorDeg = trueAngleErrorDeg === void 0 ? void 0 : mapAngleDeg(trueAngleErrorDeg, aperture, angleTolDeg);
  const foot = footOnLine2(loa, ctx.cursor);
  return directionCandidate({
    ruleId,
    direction: loa,
    errorPx,
    angleErrorDeg,
    baseScore,
    contextFactor: contextFactor2,
    slot,
    exclusive,
    refs,
    derivedFrom,
    constraintHint,
    guides: [dashedGuide(guideFrom || through, foot, guideStyle), ...extraGuides]
  });
}

// src/inference/rules/axis.js
function makeAxisRule(id, angleDeg5, constraintType) {
  return {
    id,
    detect(ctx) {
      const anchor = ctx.toolState.anchor;
      if (!anchor) return [];
      const cand = makeDirectionalCandidate({
        ctx,
        ruleId: id,
        through: anchor,
        angleDeg: angleDeg5,
        slot: "",
        exclusive: EXCLUSIVE.ANCHOR_DIRECTION,
        // Same envelope as polar's cardinal increments — never narrower than
        // either knob, so widening one can never orphan the axes.
        apertureDeg: Math.max(ctx.settings.polarApertureDeg, ctx.settings.angleTolDeg),
        constraintHint: { type: constraintType, refs: [] }
      });
      return cand ? [cand] : [];
    }
  };
}
var HorizontalRule = makeAxisRule(RULE.HORIZONTAL, 0, "horizontal");
var VerticalRule = makeAxisRule(RULE.VERTICAL, 90, "vertical");

// src/inference/rules/referenceEntity.js
function nearestSegmentOf(entity, anchor) {
  let best = null;
  for (const seg of directionSegmentsOf(entity)) {
    if (seg.a.x === seg.b.x && seg.a.y === seg.b.y) continue;
    const d = pointToSegment(anchor, seg.a, seg.b);
    if (!best || d < best.distance) best = { entity, seg, distance: d };
  }
  return best;
}
function defaultSelectReference(ctx) {
  const anchor = ctx.toolState.anchor;
  if (!anchor) return null;
  const history = Array.isArray(ctx.hoverHistory) ? ctx.hoverHistory : [];
  for (const id of history) {
    const e = ctx.index.byId(id);
    if (!e) continue;
    const best2 = nearestSegmentOf(e, anchor);
    if (best2) return best2;
  }
  const radiusPx2 = ctx.settings.referenceRadiusPx;
  const radiusWorld = ctx.toWorld(radiusPx2);
  const near = ctx.index.query(anchor, radiusWorld);
  let best = null;
  for (const e of near) {
    if (!e) continue;
    for (const seg of directionSegmentsOf(e)) {
      const d = pointToSegment(anchor, seg.a, seg.b);
      if (d > radiusWorld) continue;
      if (!best || d < best.distance) best = { entity: e, seg, distance: d };
    }
  }
  return best;
}
function selectReference(ctx) {
  const picked = ctx.selectReference ? ctx.selectReference(ctx) : defaultSelectReference(ctx);
  if (!picked || !picked.entity || !picked.seg) return null;
  const { a, b } = picked.seg;
  if (!a || !b || a.x === b.x && a.y === b.y) return null;
  return picked;
}

// src/inference/rules/parallelPerp.js
function makeReferenceDirectionRule(id, angleOffsetDeg, glyph, constraintType) {
  return {
    id,
    detect(ctx) {
      const anchor = ctx.toolState.anchor;
      if (!anchor) return [];
      const picked = selectReference(ctx);
      if (!picked) return [];
      const { entity, seg } = picked;
      const ref = entityRef(entity);
      const refs = ref ? [ref] : [];
      const at = { x: (seg.a.x + seg.b.x) / 2, y: (seg.a.y + seg.b.y) / 2 };
      const cand = makeDirectionalCandidate({
        ctx,
        ruleId: id,
        through: anchor,
        angleDeg: segmentAngle(seg.a, seg.b) + angleOffsetDeg,
        // The reference segment is the identity: while the anchor's reference
        // stays the same object+edge, this is the same suggestion frame to frame.
        slot: `${entity.id || "#"}:${seg.slot}`,
        exclusive: EXCLUSIVE.ANCHOR_DIRECTION,
        refs,
        constraintHint: { type: constraintType, refs: ref ? [ref.id] : [] },
        extraGuides: ref ? [glyphGuide(at, glyph), highlightGuide(ref, HIGHLIGHT_ROLE.REFERENCE)] : [glyphGuide(at, glyph)]
      });
      return cand ? [cand] : [];
    }
  };
}
var ParallelRule = makeReferenceDirectionRule(RULE.PARALLEL, 0, "parallel", "parallel");
var PerpendicularRule = makeReferenceDirectionRule(
  RULE.PERPENDICULAR,
  90,
  "perpendicular",
  "perpendicular"
);

// src/inference/rules/collinear.js
var CollinearRule = {
  id: RULE.COLLINEAR,
  detect(ctx) {
    const { trackRadiusPx, extensionRadiusPx } = ctx.settings;
    const near = ctx.queryPx(extensionRadiusPx);
    const slack = ctx.toWorld(trackRadiusPx);
    const out = [];
    for (let i = 0; i < near.length; i++) {
      const e = near[i];
      if (!e) continue;
      const ref = entityRef(e);
      const refs = ref ? [ref] : [];
      const idPart = e.id || `#${i}`;
      for (const seg of directionSegmentsOf(e)) {
        const len2 = dist5(seg.a, seg.b);
        if (!(len2 > 0)) continue;
        const loa = lineOfAction(seg.a, segmentAngle(seg.a, seg.b));
        const t = projectionLength(loa, ctx.cursor);
        const ta = 0;
        const tb = projectionLength(loa, seg.b);
        const lo = Math.min(ta, tb);
        const hi = Math.max(ta, tb);
        if (t >= lo - slack && t <= hi + slack) continue;
        const loEnd = ta <= tb ? seg.a : seg.b;
        const hiEnd = ta <= tb ? seg.b : seg.a;
        const from = t < lo ? loEnd : hiEnd;
        const cand = makeDirectionalCandidate({
          ctx,
          ruleId: RULE.COLLINEAR,
          through: seg.a,
          angleDeg: loa.angle,
          slot: `${idPart}:${seg.slot}`,
          exclusive: EXCLUSIVE.entityDirection(`${idPart}:${seg.slot}`),
          refs,
          // This line of action LIES ON the entity, so every feature point of
          // that entity is trivially on it. Declaring the provenance lets the
          // resolver skip the tautological composition ("snap to this line's
          // endpoint, which is — of course — on this line's extension") without
          // the resolver needing to know this rule exists.
          derivedFrom: ref ? [ref.id] : [],
          // A collinear continuation IS a parallel relation in the engine's
          // constraint vocabulary (cadConstraints: "parallel — two lines share a
          // direction (also collinear continuations)").
          constraintHint: { type: "parallel", refs: ref ? [ref.id] : [] },
          // No bearing test: this line of action is anchored to the ENTITY, not
          // to the drafting anchor, so there is no drawing bearing to compare
          // against. Perpendicular deviation alone decides.
          requireBearing: false,
          guideStyle: GUIDE_STYLE.EXTENSION,
          guideFrom: from,
          extraGuides: ref ? [highlightGuide(ref, HIGHLIGHT_ROLE.REFERENCE)] : []
        });
        if (cand) out.push(cand);
      }
    }
    return out;
  }
};

// src/inference/rules/polar.js
var PolarTrackingRule = {
  id: RULE.POLAR,
  detect(ctx) {
    const anchor = ctx.toolState.anchor;
    if (!anchor) return [];
    const inc = ctx.settings.polarIncrementDeg;
    const out = [];
    const steps = Math.max(1, Math.ceil(180 / inc));
    for (let k = 0; k < steps; k++) {
      const angle = k * inc;
      if (angle >= 180) break;
      const cand = makeDirectionalCandidate({
        ctx,
        ruleId: RULE.POLAR,
        through: anchor,
        angleDeg: angle,
        // The angle IS the identity: the same increment across frames is the
        // same suggestion, which is what hysteresis latches onto.
        slot: String(angle),
        exclusive: EXCLUSIVE.ANCHOR_DIRECTION,
        // Polar keeps the legacy drafting path's 6° aperture rather than the
        // engine's tighter shared 3°: the rollout replaces that path, and it
        // must not halve the angular band the user could previously reach. The
        // perpendicular-distance gate still applies on top, which is the part
        // the legacy angle-only aperture got wrong at long range.
        //
        // MAX, not a plain override: `angleTolDeg` is the knob that governed
        // every directional rule, so a host widening it expected polar to widen
        // too. Taking polar's own aperture alone would silently sever that —
        // narrowing what a caller could reach through a setting that still
        // exists. Taking the larger of the two means polar is never narrower
        // than EITHER knob, whatever the configuration.
        apertureDeg: Math.max(ctx.settings.polarApertureDeg, ctx.settings.angleTolDeg)
        // No constraint hint: a bare bearing is not a relation between two
        // objects, and the cadConstraints `angle` type needs two lines. The 0°
        // and 90° cases are already covered, with hints, by Horizontal/Vertical.
      });
      if (cand) out.push(cand);
    }
    return out;
  }
};

// src/inference/rules/alignment.js
function alignmentAngles2(incDeg) {
  const angles = [0, 90];
  const steps = Math.max(1, Math.ceil(180 / incDeg));
  for (let k = 0; k < steps; k++) {
    if (k * incDeg >= 180) break;
    const a = normalizeAngle180(k * incDeg);
    if (!angles.includes(a)) angles.push(a);
  }
  return angles.sort((x, y) => x - y);
}
var AlignmentRule = {
  id: RULE.ALIGNMENT,
  detect(ctx) {
    const store = ctx.tracking;
    if (!store || typeof store.live !== "function") return [];
    const lookup = ctx.index && typeof ctx.index.byId === "function" ? ctx.index.byId : ctx.entities;
    const points = store.live(lookup);
    if (!Array.isArray(points) || !points.length) return [];
    const angles = alignmentAngles2(ctx.settings.polarIncrementDeg);
    const out = [];
    for (const p of points) {
      if (!p || !p.key || !p.point || !Number.isFinite(p.point.x) || !Number.isFinite(p.point.y)) {
        continue;
      }
      const refs = p.ref ? [p.ref] : [];
      const extraGuides = [glyphGuide(p.point, "acquired")];
      if (p.ref) extraGuides.push(highlightGuide(p.ref, HIGHLIGHT_ROLE.REFERENCE));
      for (const angle of angles) {
        const constraintHint = angle === 0 ? { type: "horizontal", refs: [] } : angle === 90 ? { type: "vertical", refs: [] } : void 0;
        const cand = makeDirectionalCandidate({
          ctx,
          ruleId: RULE.ALIGNMENT,
          through: p.point,
          angleDeg: angle,
          // The (point, angle) pair is the identity: the same acquired point's
          // horizontal is the same suggestion frame to frame (hysteresis), and
          // no two candidates of this rule can collide.
          slot: `${p.key}:${angle}`,
          exclusive: EXCLUSIVE.trackingDirection(p.key),
          refs,
          constraintHint,
          requireBearing: false,
          guideStyle: GUIDE_STYLE.ALIGNMENT,
          guideFrom: p.point,
          extraGuides
        });
        if (cand) out.push(cand);
      }
    }
    return out;
  }
};

// src/inference/rules/tangent.js
var RAD2 = 180 / Math.PI;
var isCircular = (e) => !!e && (e.type === "circle" || e.type === "arc");
var hasGeometry = (e) => Number.isFinite(e.cx) && Number.isFinite(e.cy) && Number.isFinite(e.r) && e.r > 0;
var TangentRule = {
  id: RULE.TANGENT,
  detect(ctx) {
    const anchor = ctx.toolState.anchor;
    if (!anchor) return deferredCandidates(ctx);
    const { snapRadiusPx, gatherFactor } = ctx.settings;
    const out = [];
    const nearCursor = ctx.queryPx(snapRadiusPx * gatherFactor);
    for (let i = 0; i < nearCursor.length; i++) {
      const e = nearCursor[i];
      if (!isCircular(e)) continue;
      const cand = tryGeometry(() => touchPointCandidate(ctx, e, anchor, i), null);
      if (cand) out.push(cand);
    }
    const nearAnchor = ctx.index.query(anchor, ctx.toWorld(snapRadiusPx * gatherFactor));
    for (let i = 0; i < nearAnchor.length; i++) {
      const e = nearAnchor[i];
      if (!isCircular(e)) continue;
      const cand = tryGeometry(() => tangentDirectionCandidate(ctx, e, anchor, i), null);
      if (cand) out.push(cand);
    }
    return out;
  }
};
var DEFERRED_START_TYPES = /* @__PURE__ */ new Set(["line", "polyline"]);
function deferredCandidates(ctx) {
  if (!DEFERRED_START_TYPES.has(ctx.toolState.entityType)) return [];
  const { snapRadiusPx, gatherFactor } = ctx.settings;
  const near = ctx.queryPx(snapRadiusPx * gatherFactor);
  const out = [];
  for (let i = 0; i < near.length; i++) {
    const e = near[i];
    if (!isCircular(e)) continue;
    const cand = tryGeometry(() => deferredCandidate(ctx, e, i), null);
    if (cand) out.push(cand);
  }
  return out;
}
function deferredCandidate(ctx, e, i) {
  if (!hasGeometry(e)) return null;
  const dx = ctx.cursor.x - e.cx;
  const dy = ctx.cursor.y - e.cy;
  const d = Math.hypot(dx, dy);
  if (!(d > 0)) return null;
  const point = { x: e.cx + dx / d * e.r, y: e.cy + dy / d * e.r };
  if (!angleInArcSweep(e, point)) return null;
  const errorPx = ctx.toPx(dist5(ctx.cursor, point));
  if (!(errorPx <= ctx.settings.snapRadiusPx)) return null;
  const ref = entityRef(e);
  const cand = pointCandidate({
    ruleId: RULE.TANGENT,
    point,
    errorPx,
    slot: `${e.id || `#${i}`}:d`,
    refs: ref ? [ref] : [],
    guides: ref ? [glyphGuide(point, "tangent"), highlightGuide(ref)] : [glyphGuide(point, "tangent")]
  });
  cand.deferred = true;
  return cand;
}
function touchPointCandidate(ctx, e, anchor, i) {
  if (!hasGeometry(e)) return null;
  const solutions = tangentPointsToCircle(anchor, { x: e.cx, y: e.cy }, e.r).map((p, k) => ({ p, k })).filter(({ p }) => angleInArcSweep(e, p));
  if (!solutions.length) return null;
  let best = solutions[0];
  for (let s = 1; s < solutions.length; s++) {
    if (dist5(ctx.cursor, solutions[s].p) < dist5(ctx.cursor, best.p)) best = solutions[s];
  }
  const errorPx = ctx.toPx(dist5(ctx.cursor, best.p));
  if (!(errorPx <= ctx.settings.snapRadiusPx)) return null;
  const ref = entityRef(e);
  return pointCandidate({
    ruleId: RULE.TANGENT,
    point: best.p,
    errorPx,
    slot: `${e.id || `#${i}`}:t${best.k}`,
    refs: ref ? [ref] : [],
    constraintHint: { type: "tangent", refs: ref ? [ref.id] : [] },
    guides: ref ? [glyphGuide(best.p, "tangent"), highlightGuide(ref)] : [glyphGuide(best.p, "tangent")]
  });
}
function tangentDirectionCandidate(ctx, e, anchor, i) {
  if (!hasGeometry(e)) return null;
  const dx = anchor.x - e.cx;
  const dy = anchor.y - e.cy;
  const d = Math.hypot(dx, dy);
  if (!(d > 0)) return null;
  if (!(ctx.toPx(Math.abs(d - e.r)) <= ctx.settings.coincidencePx)) return null;
  if (!angleInArcSweep(e, anchor)) return null;
  const touch = { x: e.cx + dx / d * e.r, y: e.cy + dy / d * e.r };
  const ref = entityRef(e);
  return makeDirectionalCandidate({
    ctx,
    ruleId: RULE.TANGENT,
    through: anchor,
    angleDeg: Math.atan2(dy, dx) * RAD2 + 90,
    // tangent ⊥ radial
    slot: `${e.id || `#${i}`}:at`,
    // A direction THROUGH THE DRAFTING ANCHOR answers the same question as
    // horizontal/polar/parallel — "what bearing is being drawn?" — so it joins
    // their conflict group (constants.js).
    exclusive: EXCLUSIVE.ANCHOR_DIRECTION,
    refs: ref ? [ref] : [],
    constraintHint: { type: "tangent", refs: ref ? [ref.id] : [] },
    extraGuides: ref ? [glyphGuide(touch, "tangent"), highlightGuide(ref)] : [glyphGuide(touch, "tangent")]
  });
}

// src/inference/rules/perpFoot.js
var STRAIGHT = /* @__PURE__ */ new Set(["line", "polyline", "rectangle", "ray", "xline"]);
var EMPTY3 = Object.freeze([]);
var PerpendicularFootRule = {
  id: RULE.PERPENDICULAR_FOOT,
  detect(ctx) {
    const anchor = ctx.toolState.anchor;
    if (!anchor) return [];
    const { snapRadiusPx, gatherFactor, coincidencePx } = ctx.settings;
    const near = ctx.queryPx(snapRadiusPx * gatherFactor);
    const out = [];
    for (let i = 0; i < near.length; i++) {
      const e = near[i];
      if (!e) continue;
      const feet = tryGeometry(() => feetOf(e, anchor), EMPTY3);
      if (!feet.length) continue;
      const ref = entityRef(e);
      const refs = ref ? [ref] : [];
      const idPart = e.id || `#${i}`;
      for (const f of feet) {
        if (ctx.toPx(dist5(f.point, anchor)) < coincidencePx) continue;
        const errorPx = ctx.toPx(dist5(ctx.cursor, f.point));
        if (!(errorPx <= snapRadiusPx)) continue;
        out.push(
          pointCandidate({
            ruleId: RULE.PERPENDICULAR_FOOT,
            point: f.point,
            errorPx,
            slot: `${idPart}:${f.slot}`,
            refs,
            constraintHint: { type: "perpendicular", refs: ref ? [ref.id] : [] },
            guides: ref ? [glyphGuide(f.point, "perpendicular"), highlightGuide(ref)] : [glyphGuide(f.point, "perpendicular")]
          })
        );
      }
    }
    return out;
  }
};
function feetOf(e, anchor) {
  if (e.type === "circle" || e.type === "arc") {
    const dx = anchor.x - e.cx;
    const dy = anchor.y - e.cy;
    const d = Math.hypot(dx, dy);
    if (!(d > 0) || !(e.r > 0)) return [];
    const ux = dx / d;
    const uy = dy / d;
    return [
      { point: { x: e.cx + ux * e.r, y: e.cy + uy * e.r }, slot: "near" },
      { point: { x: e.cx - ux * e.r, y: e.cy - uy * e.r }, slot: "far" }
    ].filter((f) => angleInArcSweep(e, f.point));
  }
  if (!STRAIGHT.has(e.type)) return [];
  const out = [];
  for (const seg of directionSegmentsOf(e)) {
    const vx = seg.b.x - seg.a.x;
    const vy = seg.b.y - seg.a.y;
    const len2 = vx * vx + vy * vy;
    if (!(len2 > 0)) continue;
    const t = ((anchor.x - seg.a.x) * vx + (anchor.y - seg.a.y) * vy) / len2;
    if (e.type === "ray") {
      if (t < 0) continue;
    } else if (e.type !== "xline" && (t < 0 || t > 1)) {
      continue;
    }
    out.push({ point: perpendicularFoot(anchor, seg.a, seg.b), slot: seg.slot });
  }
  return out;
}

// src/inference/toolContext.js
var CURVE_TOOLS = /* @__PURE__ */ new Set(["circle", "arc", "ellipse", "donut", "revcloud"]);
var LINEAR_DRAW_TOOLS = /* @__PURE__ */ new Set(["line", "polyline", "rectangle", "polygon"]);
var TRANSFORM_TOOLS = /* @__PURE__ */ new Set(["move", "copy", "rotate", "scale", "mirror", "stretch", "array"]);
var CURVE_TYPES = /* @__PURE__ */ new Set(["circle", "arc", "ellipse"]);
var offFactor = (ctx) => {
  const v = ctx && ctx.settings && ctx.settings.offContextFactor;
  return Number.isFinite(v) ? v : DEFAULT_INFERENCE_SETTINGS.offContextFactor;
};
function isCurveTool(ctx) {
  return CURVE_TOOLS.has(ctx.tool);
}
function isLinearDrawTool(ctx) {
  return LINEAR_DRAW_TOOLS.has(ctx.tool);
}
function isTransformTool(ctx) {
  return TRANSFORM_TOOLS.has(ctx.tool);
}
function curveAffinity(ctx) {
  if (isCurveTool(ctx)) return 1;
  if (ctx.toolState && CURVE_TYPES.has(ctx.toolState.entityType)) return 1;
  return offFactor(ctx);
}
function curveGate(ctx) {
  return curveAffinity(ctx) === 1 ? 1 : 0;
}
function linearDrawGate(ctx) {
  if (isTransformTool(ctx)) return 0;
  if (!isLinearDrawTool(ctx)) return 0;
  return ctx.toolState && ctx.toolState.anchor ? 1 : 0;
}

// src/inference/rules/concentric.js
var ConcentricRule = {
  id: RULE.CONCENTRIC,
  detect(ctx) {
    const { snapRadiusPx, concentricRadiusPx, gatherFactor } = ctx.settings;
    const near = ctx.queryPx(concentricRadiusPx * gatherFactor);
    const relevance = curveGate(ctx);
    const out = [];
    for (let i = 0; i < near.length; i++) {
      const e = near[i];
      if (!e) continue;
      const ref = entityRef(e);
      const refs = ref ? [ref] : [];
      const idPart = e.id || `#${i}`;
      for (const f of centersOf(e)) {
        const truePx = ctx.toPx(dist5(ctx.cursor, f.point));
        if (!(truePx <= concentricRadiusPx)) continue;
        if (truePx <= snapRadiusPx) continue;
        out.push(
          pointCandidate({
            ruleId: RULE.CONCENTRIC,
            point: f.point,
            // NOT a screen distance: the true error rescaled into the engine's
            // envelope (see the module comment and envelope.js).
            errorPx: mapErrorPx(truePx, concentricRadiusPx, snapRadiusPx),
            slot: `${idPart}:${f.slot}`,
            refs,
            contextFactor: relevance,
            constraintHint: { type: "concentric", refs: ref ? [ref.id] : [] },
            guides: ref ? [glyphGuide(f.point, "center"), highlightGuide(ref, HIGHLIGHT_ROLE.REFERENCE)] : [glyphGuide(f.point, "center")]
          })
        );
      }
    }
    return out;
  }
};

// src/inference/rules/equalLength.js
var EqualLengthRule = {
  id: RULE.EQUAL_LENGTH,
  detect(ctx) {
    const gate = linearDrawGate(ctx);
    if (gate === 0) return [];
    const anchor = ctx.toolState.anchor;
    const L = dist5(anchor, ctx.cursor);
    if (!(L > 0)) return [];
    const { snapRadiusPx, equalLengthTolPx } = ctx.settings;
    const ux = (ctx.cursor.x - anchor.x) / L;
    const uy = (ctx.cursor.y - anchor.y) / L;
    const seen = /* @__PURE__ */ new Set();
    const out = [];
    for (let i = 0; i < ctx.recentSegments.length; i++) {
      const s = ctx.recentSegments[i];
      const target = s.length;
      if (seen.has(target)) continue;
      const diffPx = ctx.toPx(Math.abs(L - target));
      if (!(diffPx <= equalLengthTolPx)) continue;
      seen.add(target);
      const point = { x: anchor.x + ux * target, y: anchor.y + uy * target };
      out.push(
        pointCandidate({
          ruleId: RULE.EQUAL_LENGTH,
          point,
          errorPx: mapErrorPx(diffPx, equalLengthTolPx, snapRadiusPx),
          // Buffer position: stable for the whole gesture (the host appends
          // only between gestures), so hysteresis recognises the match.
          slot: `r${i}`,
          refs: [],
          contextFactor: gate,
          constraintHint: {
            type: "equalLength",
            refs: [],
            match: { a: { x: s.a.x, y: s.a.y }, b: { x: s.b.x, y: s.b.y } }
          },
          // The '=' marker on BOTH segments — the one being drawn and the one
          // being matched — is what makes the suggestion legible: length
          // equality is invisible in the geometry itself.
          guides: [
            glyphGuide({ x: (anchor.x + point.x) / 2, y: (anchor.y + point.y) / 2 }, "equal"),
            glyphGuide({ x: (s.a.x + s.b.x) / 2, y: (s.a.y + s.b.y) / 2 }, "equal")
          ]
        })
      );
    }
    return out;
  }
};

// src/inference/corridor.js
var num3 = (v) => v.toFixed(9);
var sourceKey = (point, ref, kind) => `${ref ? ref.id : "~"}|${kind}|${num3(point.x)},${num3(point.y)}`;
function corridorRects(ctx) {
  const { cursor, settings } = ctx;
  const halfWidth = ctx.toWorld(settings.trackRadiusPx);
  const vp = ctx.viewport;
  let x0, y0, x1, y1;
  if (vp) {
    const margin = ctx.toWorld(settings.corridorMarginPx);
    x0 = vp.minX - margin;
    x1 = vp.maxX + margin;
    y0 = vp.minY - margin;
    y1 = vp.maxY + margin;
  } else {
    const span = ctx.toWorld(settings.corridorSpanPx);
    x0 = cursor.x - span;
    x1 = cursor.x + span;
    y0 = cursor.y - span;
    y1 = cursor.y + span;
  }
  return {
    halfWidth,
    vertical: { minX: cursor.x - halfWidth, maxX: cursor.x + halfWidth, minY: y0, maxY: y1 },
    horizontal: { minX: x0, maxX: x1, minY: cursor.y - halfWidth, maxY: cursor.y + halfWidth }
  };
}
var EXTRACTORS = [
  ["endpoint", endpointsOf, "autoAlignEndpoints"],
  ["midpoint", midpointsOf, "autoAlignMidpoints"],
  ["center", centersOf, "autoAlignCenters"]
];
function corridorPoints(ctx) {
  const index = ctx.index;
  if (!index || typeof index.queryRect !== "function") return [];
  const kinds = EXTRACTORS.filter(([, , setting]) => ctx.settings[setting] === true);
  if (!kinds.length) return [];
  const { halfWidth, vertical, horizontal } = corridorRects(ctx);
  const { cursor } = ctx;
  const out = [];
  const seen = /* @__PURE__ */ new Set();
  const harvest = (entities) => {
    for (const e of entities) {
      if (!e || !e.id || seen.has(e.id)) continue;
      seen.add(e.id);
      let ref;
      for (const [kind, extract] of kinds) {
        for (const { point } of extract(e)) {
          const v = Math.abs(point.x - cursor.x) <= halfWidth && point.y >= vertical.minY && point.y <= vertical.maxY;
          const h = Math.abs(point.y - cursor.y) <= halfWidth && point.x >= horizontal.minX && point.x <= horizontal.maxX;
          if (!v && !h) continue;
          if (ref === void 0) ref = entityRef(e);
          out.push({
            point: { x: point.x, y: point.y },
            entityId: e.id,
            ref: ref || null,
            kind,
            vertical: v,
            horizontal: h
          });
        }
      }
    }
  };
  harvest(index.queryRect(vertical));
  harvest(index.queryRect(horizontal));
  return out;
}

// src/inference/rules/autoAlignment.js
var AXES = [
  { angle: 90, axis: "vertical", hint: "vertical" },
  { angle: 0, axis: "horizontal", hint: "horizontal" }
];
var SOURCE_GLYPH = /* @__PURE__ */ new Set(["endpoint", "midpoint", "center"]);
function hostSources(ctx) {
  const out = [];
  const seen = /* @__PURE__ */ new Set();
  const add3 = (p) => {
    if (!p || !Number.isFinite(p.x) || !Number.isFinite(p.y)) return;
    const key = sourceKey(p, null, "endpoint");
    if (seen.has(key)) return;
    seen.add(key);
    out.push({ point: { x: p.x, y: p.y }, entityId: null, ref: null, kind: "endpoint" });
  };
  const pts = ctx.toolState.points;
  for (let i = 0; i < pts.length - 1; i++) add3(pts[i]);
  for (const s of ctx.recentSegments) {
    add3(s.a);
    add3(s.b);
  }
  return out;
}
var dist22 = (a, b) => (a.x - b.x) ** 2 + (a.y - b.y) ** 2;
var AutoAlignmentRule = {
  id: RULE.AUTO_ALIGNMENT,
  detect(ctx) {
    const s = ctx.settings;
    if (!(s.maxAutoAlignSources > 0)) return [];
    if (!s.autoAlignEndpoints && !s.autoAlignMidpoints && !s.autoAlignCenters) return [];
    const { cursor } = ctx;
    const sources = corridorPoints(ctx);
    if (s.autoAlignEndpoints) {
      const { vertical, horizontal } = corridorRects(ctx);
      const inBand = (p, b) => p.x >= b.minX && p.x <= b.maxX && p.y >= b.minY && p.y <= b.maxY;
      for (const src of hostSources(ctx)) {
        const v = inBand(src.point, vertical);
        const h = inBand(src.point, horizontal);
        if (!v && !h) continue;
        sources.push({ ...src, vertical: v, horizontal: h });
      }
    }
    if (!sources.length) return [];
    const minDist2 = ctx.toWorld(s.snapRadiusPx) ** 2;
    const acquired = [];
    if (ctx.tracking && typeof ctx.tracking.live === "function") {
      const lookup = ctx.index && typeof ctx.index.byId === "function" ? ctx.index.byId : ctx.entities;
      for (const p of ctx.tracking.live(lookup)) if (p && p.point) acquired.push(p.point);
    }
    const acquiredTol2 = ctx.toWorld(s.coincidencePx) ** 2;
    const eligible = [];
    for (const src of sources) {
      if (!src.vertical && !src.horizontal) continue;
      const d2 = dist22(src.point, cursor);
      if (d2 < minDist2) continue;
      if (acquired.some((a) => dist22(a, src.point) <= acquiredTol2)) continue;
      eligible.push({ src, d2 });
    }
    if (!eligible.length) return [];
    eligible.sort((a, b) => {
      if (a.d2 !== b.d2) return a.d2 - b.d2;
      const ai = a.src.entityId || "~";
      const bi = b.src.entityId || "~";
      if (ai !== bi) return ai < bi ? -1 : 1;
      if (a.src.kind !== b.src.kind) return a.src.kind < b.src.kind ? -1 : 1;
      if (a.src.point.x !== b.src.point.x) return a.src.point.x - b.src.point.x;
      return a.src.point.y - b.src.point.y;
    });
    const out = [];
    const lines = /* @__PURE__ */ new Set();
    let used = 0;
    for (const { src } of eligible) {
      if (used >= s.maxAutoAlignSources) break;
      let contributed = false;
      let key;
      for (const { angle, axis, hint } of AXES) {
        if (!src[axis]) continue;
        const lineId = `${axis}:${(axis === "vertical" ? src.point.x : src.point.y).toFixed(9)}`;
        if (lines.has(lineId)) continue;
        if (key === void 0) key = sourceKey(src.point, src.ref, src.kind);
        const cand = makeDirectionalCandidate({
          ctx,
          ruleId: RULE.AUTO_ALIGNMENT,
          through: src.point,
          angleDeg: angle,
          // Identity is (source, bearing): stable frame to frame, so hysteresis
          // recognises the same suggestion, and unique across sources.
          slot: `${key}:${angle}`,
          exclusive: EXCLUSIVE.autoDirection(key),
          refs: src.ref ? [src.ref] : [],
          // Horizontal and vertical are UNARY constraints on the segment being
          // drawn, so `refs` is empty exactly as in axis.js and alignment.js:
          // the source point's entity is provenance (it rides on the candidate's
          // own refs), not a participant in the relation.
          constraintHint: { type: hint, refs: [] },
          // The line runs through a source point, not through the drafting
          // anchor, so there is no bearing for it to disagree with — the same
          // reasoning as AlignmentRule and CollinearRule. It is also what makes
          // alignment work while placing a FIRST point, when no anchor exists.
          requireBearing: false,
          guideStyle: GUIDE_STYLE.ALIGNMENT,
          guideFrom: src.point,
          extraGuides: SOURCE_GLYPH.has(src.kind) ? [glyphGuide(src.point, src.kind)] : []
        });
        if (!cand) continue;
        lines.add(lineId);
        out.push(cand);
        contributed = true;
      }
      if (contributed) used++;
    }
    return out;
  }
};

// src/inference/rules/index.js
var DEFAULT_RULES = Object.freeze([
  // Point locks
  IntersectionRule,
  EndpointRule,
  MidpointRule,
  CenterRule,
  QuadrantRule,
  NearestRule,
  GridRule,
  // Directional locks
  CollinearRule,
  ParallelRule,
  PerpendicularRule,
  HorizontalRule,
  VerticalRule,
  PolarTrackingRule,
  // ── Session B ──────────────────────────────────────────────────────────────
  // Point locks first, then the directional one, matching the reading order
  // above. Every one of these is inert until the host supplies what it needs
  // (an acquired-point store, a recent-segment buffer, a curve tool context),
  // so registering them cannot change an existing host's behaviour.
  ConcentricRule,
  TangentRule,
  PerpendicularFootRule,
  EqualLengthRule,
  AlignmentRule,
  // ── Session D ──────────────────────────────────────────────────────────────
  // Inert, like every Session B rule, until the host feeds it something: it
  // needs a spatial index that answers rect queries (`corridor.js`), and it
  // stays silent while the cursor is not near any feature point's x or y.
  AutoAlignmentRule
]);

// src/inference/engine.js
var MAX_CANDIDATES = 32;
function capCandidates(candidates, ctx) {
  if (candidates.length <= MAX_CANDIDATES) return candidates;
  const ranked = [...candidates].sort((a, b) => {
    const ta = a.tier || 0;
    const tb = b.tier || 0;
    if (ta !== tb) return ta - tb;
    const ea = Number.isFinite(a.errorPx) ? a.errorPx : Infinity;
    const eb = Number.isFinite(b.errorPx) ? b.errorPx : Infinity;
    if (ea !== eb) return ea - eb;
    return a.key < b.key ? -1 : a.key > b.key ? 1 : 0;
  });
  const kept = ranked.slice(0, MAX_CANDIDATES);
  kept.truncated = candidates.length - MAX_CANDIDATES;
  void ctx;
  return kept;
}
function createInferenceEngine(options = {}) {
  const rules = Array.isArray(options.rules) ? options.rules.filter(Boolean) : DEFAULT_RULES;
  const rulesById = new Map(rules.map((r) => [r.id, r]));
  const priorityOf = makePriorityOf(rulesById);
  function infer(rawCtx) {
    const ctx = createInferenceContext(rawCtx);
    if (ctx.suppressed) {
      return { best: null, all: [], point: { x: ctx.cursor.x, y: ctx.cursor.y } };
    }
    const candidates = [];
    const errors = [];
    for (const rule of rules) {
      try {
        const found = rule.detect(ctx);
        if (Array.isArray(found)) {
          for (const c of found) if (c) candidates.push(c);
        }
      } catch (err) {
        errors.push({ ruleId: rule.id, message: err && err.message || String(err) });
      }
    }
    const scored = scoreCandidates(capCandidates(candidates, ctx), ctx, priorityOf);
    const result = resolveConflicts(scored, ctx);
    return errors.length ? { ...result, errors } : result;
  }
  function commit(result, live) {
    const cursor = live && live.cursor && Number.isFinite(live.cursor.x) && Number.isFinite(live.cursor.y) ? { x: live.cursor.x, y: live.cursor.y } : { x: 0, y: 0 };
    const entities = live && Array.isArray(live.entities) ? live.entities : [];
    const byId2 = /* @__PURE__ */ new Map();
    for (const e of entities) if (e && e.id != null && !byId2.has(e.id)) byId2.set(e.id, e);
    const ranked = result && Array.isArray(result.all) ? result.all : [];
    const ordered = live && live.preferKey ? [...ranked.filter((c) => c.key === live.preferKey), ...ranked.filter((c) => c.key !== live.preferKey)] : ranked;
    let stale = 0;
    for (const cand of ordered) {
      if (!refsAreLive(cand.refs, byId2)) {
        stale++;
        continue;
      }
      return { point: candidatePoint(cand, cursor), candidate: cand, stale };
    }
    return { point: cursor, candidate: null, stale };
  }
  return { rules, rulesById, infer, commit };
}
var inferenceEngine = createInferenceEngine();
function runInference(rawCtx) {
  return inferenceEngine.infer(rawCtx);
}
function nextCandidate(result, currentKey) {
  const all = result && Array.isArray(result.all) ? result.all : [];
  if (!all.length) return null;
  if (!currentKey) return all[0];
  const i = all.findIndex((c) => c.key === currentKey);
  if (i < 0) return all[0];
  return all[(i + 1) % all.length];
}

// src/inference/tracking.js
var positiveInt2 = (v, dflt) => typeof v === "number" && Number.isFinite(v) && v >= 1 ? Math.floor(v) : dflt;
var num4 = (v) => v.toFixed(9);
var featureKey = (point, ref, kind) => `${ref ? ref.id : "~"}|${kind}|${num4(point.x)},${num4(point.y)}`;
function createTrackingStore(options) {
  const o = options && typeof options === "object" ? options : {};
  const max = positiveInt2(o.max, DEFAULT_INFERENCE_SETTINGS.maxTrackingPoints);
  const dwell = positiveInt2(o.dwell, DEFAULT_INFERENCE_SETTINGS.trackDwellCount);
  const acquired = /* @__PURE__ */ new Map();
  let pending = null;
  let settled = null;
  let tick = 0;
  const use = (entry) => {
    entry.lastUsed = ++tick;
  };
  function evictLRU() {
    let victim = null;
    for (const entry of acquired.values()) {
      if (!victim || entry.lastUsed < victim.lastUsed) victim = entry;
    }
    if (victim) acquired.delete(victim.key);
  }
  const snapshot = (e) => ({ key: e.key, point: { x: e.point.x, y: e.point.y }, ref: e.ref, kind: e.kind });
  const isLive = (entry, lookup) => {
    if (!entry.ref) return true;
    try {
      return resolveRef(entry.ref, lookup) != null;
    } catch {
      return false;
    }
  };
  function observeHover(obs) {
    const p = obs && typeof obs === "object" ? obs.point : null;
    const point = p && Number.isFinite(p.x) && Number.isFinite(p.y) ? { x: p.x, y: p.y } : null;
    if (!point) {
      pending = null;
      settled = null;
      return { state: "idle", key: null, count: 0 };
    }
    const ref = obs.ref && typeof obs.ref === "object" && obs.ref.id ? obs.ref : null;
    const kind = typeof obs.kind === "string" && obs.kind ? obs.kind : "point";
    const key = featureKey(point, ref, kind);
    const held = acquired.get(key);
    if (held) use(held);
    if (settled === key) {
      return { state: held ? "acquired" : "idle", key, count: 0 };
    }
    settled = null;
    if (!pending || pending.key !== key) pending = { key, count: 0, point, ref, kind };
    pending.count += 1;
    if (pending.count < dwell) {
      return { state: held ? "releasing" : "pending", key, count: pending.count };
    }
    pending = null;
    settled = key;
    if (held) {
      acquired.delete(key);
      return { state: "released", key, count: dwell };
    }
    if (acquired.size >= max) evictLRU();
    const entry = { key, point, ref, kind, lastUsed: 0 };
    use(entry);
    acquired.set(key, entry);
    return { state: "acquired", key, count: dwell };
  }
  function list() {
    const out = [];
    for (const e of acquired.values()) out.push(snapshot(e));
    return out;
  }
  function live(lookup) {
    const out = [];
    for (const e of acquired.values()) if (isLive(e, lookup)) out.push(snapshot(e));
    return out;
  }
  function prune(lookup) {
    const stale = [];
    for (const e of acquired.values()) if (!isLive(e, lookup)) stale.push(e.key);
    for (const key of stale) acquired.delete(key);
    return stale.length;
  }
  function touch(key) {
    const e = acquired.get(key);
    if (!e) return false;
    use(e);
    return true;
  }
  function release(key) {
    if (pending && pending.key === key) pending = null;
    return acquired.delete(key);
  }
  function clear() {
    acquired.clear();
    pending = null;
    settled = null;
  }
  return {
    observeHover,
    list,
    live,
    prune,
    touch,
    release,
    clear,
    has: (key) => acquired.has(key),
    get size() {
      return acquired.size;
    }
  };
}

// src/inference/persist.js
var MATCH_TOL = 1e-6;
var FEATURE_TOL = 1e-6;
var isCurve4 = (e) => e && (e.type === "circle" || e.type === "arc");
var isLinear = (e) => e && (e.type === "line" || e.type === "polyline" || e.type === "rectangle");
var SEGMENT_HINTS = /* @__PURE__ */ new Set(["horizontal", "vertical", "parallel", "perpendicular", "tangent", "equalLength"]);
var POINT_HINTS = /* @__PURE__ */ new Set(["coincident", "concentric"]);
function segmentForVertex(entity, i) {
  if (!entity) return null;
  if (entity.type === "line") return i >= 1 ? 0 : null;
  if (entity.type === "polyline") {
    if (i < 1) return null;
    const n = segmentCount(entity);
    return i - 1 < n ? i - 1 : null;
  }
  return null;
}
function sameSegment(s, a, b) {
  if (!s) return false;
  const near = (p, q) => Math.abs(p.x - q.x) <= MATCH_TOL && Math.abs(p.y - q.y) <= MATCH_TOL;
  return near({ x: s.x1, y: s.y1 }, a) && near({ x: s.x2, y: s.y2 }, b) || near({ x: s.x1, y: s.y1 }, b) && near({ x: s.x2, y: s.y2 }, a);
}
function findSegment(entities, match, excludeId) {
  if (!match || !match.a || !match.b) return null;
  for (const e of entities || []) {
    if (!e || e.id === excludeId || !isLinear(e)) continue;
    const n = segmentCount(e);
    for (let i = 0; i < n; i++) {
      if (sameSegment(segmentOf(e, i), match.a, match.b)) {
        return { id: e.id, seg: e.type === "line" ? null : i };
      }
    }
  }
  return null;
}
function constraintKey(c) {
  if (!c) return "~";
  const parts = (c.ids || []).map((id, i) => `${id}#${(c.segs && c.segs[i]) ?? ""}`);
  return `${c.type}|${[...parts].sort().join("&")}`;
}
function coincidentKey(c) {
  const r = (x) => x ? `${x.id}:${x.kind}:${x.index}` : "~";
  return `coincident|${[r(c.refs && c.refs[0]), r(c.refs && c.refs[1])].sort().join("&")}`;
}
function keysOf(c) {
  return c && c.type === "coincident" ? [constraintKey(c), coincidentKey(c)] : [constraintKey(c)];
}
function axisOf(constraints, id, seg) {
  for (const c of constraints) {
    if (c.type !== "horizontal" && c.type !== "vertical") continue;
    if (c.ids[0] !== id) continue;
    if (((c.segs && c.segs[0]) ?? null) !== (seg ?? null)) continue;
    return c.type;
  }
  return null;
}
function dropRedundant(candidates, existing) {
  const seen = /* @__PURE__ */ new Set();
  for (const c of existing || []) for (const k of keysOf(c)) seen.add(k);
  const axisPool = [...existing || [], ...candidates.filter((c) => c.type === "horizontal" || c.type === "vertical")];
  const out = [];
  for (const c of candidates) {
    const keys = keysOf(c);
    if (keys.some((k) => seen.has(k))) continue;
    if (c.ids.length === 2) {
      const [a, b] = c.ids;
      const sa = (c.segs && c.segs[0]) ?? null;
      const sb = (c.segs && c.segs[1]) ?? null;
      if (a === b && sa === sb) continue;
      if (c.type === "parallel" || c.type === "perpendicular") {
        const axA = axisOf(axisPool, a, sa);
        const axB = axisOf(axisPool, b, sb);
        if (axA && axB) {
          const implied = c.type === "parallel" ? axA === axB : axA !== axB;
          if (implied) continue;
        }
      }
    }
    for (const k of keys) seen.add(k);
    out.push(c);
  }
  return out;
}
function constraintsFromHints({ entity, hintsByVertex, entities, existing = [] }) {
  if (!entity || !entity.id || !Array.isArray(hintsByVertex)) return [];
  const others = (entities || []).filter((e) => e && e.id !== entity.id);
  const out = [];
  for (const entry of hintsByVertex) {
    if (!entry || !Array.isArray(entry.hints)) continue;
    const i = entry.vertex;
    const seg = segmentForVertex(entity, i);
    for (const hint of entry.hints) {
      if (!hint || typeof hint.type !== "string") continue;
      const refId = (hint.refs || [])[0] || null;
      const other = refId ? others.find((e) => e.id === refId) : null;
      if (POINT_HINTS.has(hint.type)) {
        if (!other) continue;
        if (hint.type === "coincident") {
          const mine = pointFeatureRef([entity], entry.point, FEATURE_TOL);
          const theirs = pointFeatureRef([other], entry.point, FEATURE_TOL);
          if (!mine || !theirs) continue;
          out.push(makeConstraint("coincident", [entity.id, other.id], { refs: [mine, theirs] }));
        } else if (isCurve4(entity) && isCurve4(other)) {
          out.push(makeConstraint("concentric", [entity.id, other.id]));
        }
        continue;
      }
      if (!SEGMENT_HINTS.has(hint.type)) continue;
      if (hint.type === "horizontal" || hint.type === "vertical") {
        if (seg === null) continue;
        out.push(makeConstraint(hint.type, [entity.id], { segs: [entity.type === "line" ? null : seg] }));
        continue;
      }
      if (hint.type === "equalLength") {
        if (seg === null) continue;
        const match = findSegment(others, hint.match, entity.id);
        if (!match) continue;
        out.push(
          makeConstraint("equalLength", [entity.id, match.id], {
            segs: [entity.type === "line" ? null : seg, match.seg]
          })
        );
        continue;
      }
      if (!other) continue;
      if (hint.type === "tangent") {
        if (!isCurve4(other) && !isCurve4(entity)) continue;
        out.push(makeConstraint("tangent", [entity.id, other.id], seg === null ? {} : { segs: [entity.type === "line" ? null : seg, null] }));
        continue;
      }
      if (seg === null || !isLinear(other)) continue;
      out.push(
        makeConstraint(hint.type, [entity.id, other.id], {
          segs: [entity.type === "line" ? null : seg, null]
        })
      );
    }
  }
  return dropRedundant(out, existing);
}

// src/inference/registry.js
var RULE_GROUPS = Object.freeze([
  { id: "point", label: "Object snaps", hint: "Exact points on existing geometry" },
  { id: "direction", label: "Directions", hint: "Constrain the bearing you are drawing at" },
  { id: "curve", label: "Curves", hint: "Relations only curves can have" },
  { id: "tracking", label: "Tracking", hint: "Guides from points you acquire by hovering" },
  { id: "fallback", label: "Fallbacks", hint: "Only used when nothing else applies" }
]);
var INFERENCE_RULE_REGISTRY = Object.freeze([
  // ── Object snaps ───────────────────────────────────────────────────────────
  { id: RULE.ENDPOINT, group: "point", label: "Endpoint", hint: "The ends of a line, arc or polyline segment" },
  { id: RULE.MIDPOINT, group: "point", label: "Midpoint", hint: "The middle of a segment or arc" },
  { id: RULE.CENTER, group: "point", label: "Center", hint: "The centre of a circle, arc or ellipse" },
  { id: RULE.QUADRANT, group: "point", label: "Quadrant", hint: "A circle's 0\xB0, 90\xB0, 180\xB0 and 270\xB0 points" },
  { id: RULE.INTERSECTION, group: "point", label: "Intersection", hint: "Where two objects truly cross" },
  // ── Directions ─────────────────────────────────────────────────────────────
  { id: RULE.HORIZONTAL, group: "direction", label: "Horizontal", hint: "Level with the last point" },
  { id: RULE.VERTICAL, group: "direction", label: "Vertical", hint: "Plumb from the last point" },
  { id: RULE.PARALLEL, group: "direction", label: "Parallel", hint: "Along a nearby edge" },
  { id: RULE.PERPENDICULAR, group: "direction", label: "Perpendicular", hint: "Square to a nearby edge" },
  { id: RULE.COLLINEAR, group: "direction", label: "Extension", hint: "The continuation of an edge's line" },
  { id: RULE.POLAR, group: "direction", label: "Polar", hint: "Fixed angle increments (F10)" },
  // ── Curves ─────────────────────────────────────────────────────────────────
  { id: RULE.TANGENT, group: "curve", label: "Tangent", hint: "Touching a circle or arc without crossing it" },
  { id: RULE.PERPENDICULAR_FOOT, group: "curve", label: "Perpendicular foot", hint: "The square landing point on an object" },
  { id: RULE.CONCENTRIC, group: "curve", label: "Concentric", hint: "Share a nearby circle's centre" },
  { id: RULE.EQUAL_LENGTH, group: "curve", label: "Equal length", hint: "Match a segment you drew recently" },
  // ── Tracking ───────────────────────────────────────────────────────────────
  { id: RULE.ALIGNMENT, group: "tracking", label: "Alignment tracking", hint: "Guides through points you hover (F11)" },
  { id: RULE.AUTO_ALIGNMENT, group: "tracking", label: "Automatic alignment", hint: "Guides to points level with the cursor, without hovering them first" },
  // ── Fallbacks ──────────────────────────────────────────────────────────────
  { id: RULE.NEAREST, group: "fallback", label: "Nearest", hint: "Anywhere on an object, when no feature is in range" },
  { id: RULE.GRID, group: "fallback", label: "Grid", hint: "Quantise to the drawing grid" }
]);
var INFERENCE_SETTING_SECTIONS = Object.freeze([
  { id: "tolerance", label: "Tolerances", hint: "How close is close enough" },
  { id: "alignment", label: "Alignment sources", hint: "Which points automatic alignment may line up with" },
  { id: "parametric", label: "Parametric", hint: "Settings that change what later EDITS do, not what a click does" }
]);
var INFERENCE_SETTING_SCHEMA = Object.freeze([
  {
    key: "snapRadiusPx",
    kind: "number",
    section: "tolerance",
    label: "Snap radius",
    unit: "px",
    min: 4,
    max: 30,
    step: 1,
    hint: "How close the cursor must be for a point snap to be offered. A hard boundary \u2014 identical for every rule."
  },
  {
    key: "trackRadiusPx",
    kind: "number",
    section: "tolerance",
    label: "Tracking radius",
    unit: "px",
    min: 1,
    max: 20,
    step: 1,
    hint: "How far the cursor may sit off a guide line and still lock to it. Also the width of the alignment corridor."
  },
  {
    key: "angleTolDeg",
    kind: "number",
    section: "tolerance",
    label: "Angle tolerance",
    unit: "\xB0",
    min: 1,
    max: 20,
    step: 1,
    hint: "How far off a bearing you can be and still be offered it."
  },
  // NOT HERE: `polarIncrementDeg`. It is a real engine setting, but the STATUS
  // BAR owns it — the editor passes `tracking.polarInc` as a host override, and
  // `resolveInferenceSettings` applies overrides last, so a value set here could
  // never reach the engine. It shipped as a slider that moved and did nothing,
  // with a test pinning the override that made it inert. One control per
  // setting, and the one the user can see beside the drawing wins.
  {
    key: "minScore",
    kind: "number",
    section: "tolerance",
    label: "Minimum relevance",
    unit: "",
    min: 0,
    max: 1,
    step: 0.05,
    hint: "Below this, a suggestion is not offered at all and the cursor stays free."
  },
  {
    key: "hysteresisBonus",
    kind: "number",
    section: "tolerance",
    label: "Stickiness",
    unit: "\xD7",
    min: 1,
    max: 2,
    step: 0.05,
    hint: "How strongly the current suggestion resists being displaced by a near-equal one. 1 = not at all."
  },
  // ── Alignment sources (Session D) ──────────────────────────────────────────
  // Which feature points automatic alignment may line up with. Endpoints only,
  // by default: see DEFAULT_INFERENCE_SETTINGS for why the other two are off.
  {
    key: "autoAlignEndpoints",
    kind: "boolean",
    section: "alignment",
    label: "Endpoints",
    hint: "Line up with the ends of lines, arcs and polyline segments."
  },
  {
    key: "autoAlignMidpoints",
    kind: "boolean",
    section: "alignment",
    label: "Midpoints",
    hint: "Also line up with the middle of segments. More guides to choose between."
  },
  {
    key: "autoAlignCenters",
    kind: "boolean",
    section: "alignment",
    label: "Centres",
    hint: "Also line up with the centres of circles, arcs and ellipses."
  },
  {
    key: "persistConstraints",
    kind: "boolean",
    section: "parametric",
    label: "Remember relations",
    advanced: true,
    hint: "Write the relation behind each snap into the sketch, so later edits keep it. Changes how edits behave \u2014 a badge shows what was added, and one click removes it."
  }
]);
function settingDefault(key) {
  return DEFAULT_INFERENCE_SETTINGS[key];
}
function resolveInferenceSettings(patch, overrides) {
  const out = {};
  const p = patch && typeof patch === "object" ? patch : {};
  for (const entry of INFERENCE_SETTING_SCHEMA) {
    if (p[entry.key] !== void 0) out[entry.key] = p[entry.key];
  }
  return { ...out, ...overrides || {} };
}
function ruleEnabled(patch, ruleId) {
  const rules = patch && patch.rules;
  return !rules || rules[ruleId] !== false;
}
function inferenceOn(patch) {
  return !patch || patch.enabled !== false;
}

// src/inference/telemetry.js
var wins = /* @__PURE__ */ new Map();
var freeCommits = 0;
function recordCommit(candidate) {
  if (!candidate || typeof candidate.ruleId !== "string") {
    freeCommits++;
    return;
  }
  for (const id of candidate.ruleId.split("+")) {
    if (id) wins.set(id, (wins.get(id) || 0) + 1);
  }
}
function inferenceTelemetry() {
  const rules = [...wins.entries()].map(([ruleId, n]) => ({ ruleId, wins: n })).sort((a, b) => b.wins - a.wins || (a.ruleId < b.ruleId ? -1 : 1));
  const total = rules.reduce((n, r) => n + r.wins, 0) + freeCommits;
  return { rules, free: freeCommits, total };
}
function resetInferenceTelemetry() {
  wins.clear();
  freeCommits = 0;
}
export {
  ANNO_SCALE_MAX,
  ANNO_SCALE_MIN,
  APPROX_CHAR_WIDTH_FACTOR,
  AUTO_TARGET_PX,
  AlignmentRule,
  AutoAlignmentRule,
  BLOCK_NAME_MAX,
  BOOL_EPS,
  BUILTIN_LINETYPES,
  BUILTIN_TEMPLATE_ID,
  CAD_FONTS,
  CAPTURE_DPI,
  CHAR_W_RATIO,
  COMMAND_SHAPE,
  CONSTRAINT_LABELS,
  CSV_POINTS_LAYER,
  CSV_POINTS_LAYER_DEF,
  CenterRule,
  CollinearRule,
  ConcentricRule,
  DEFAULT_FONT,
  DEFAULT_GEOREF,
  DEFAULT_HATCH_LINEWEIGHT,
  DEFAULT_HATCH_PATTERN,
  DEFAULT_INFERENCE_SETTINGS,
  DEFAULT_LAYER,
  DEFAULT_LINEWEIGHT_MM,
  DEFAULT_MODEL_MARGIN_MM,
  DEFAULT_POLAR_INCREMENT,
  DEFAULT_PRIORITY,
  DEFAULT_RULES,
  DEFAULT_TITLE_FIELDS,
  DERIVED_BUILDERS,
  DIMSTYLE_DEFAULTS,
  DIM_AUTOBASE_RATIO,
  DIM_OVERRIDE_FIELDS,
  DIM_OVERRIDE_KEYS,
  DIM_TEXT_K,
  DIM_TEXT_MAX,
  DIM_TEXT_MIN,
  DXFExporter_default as DXFExporter,
  ENTITY_TYPES,
  EXCLUSIVE,
  EndpointRule,
  EqualLengthRule,
  FIELD_CODES,
  FINISH_MIN_POINTS,
  GEODATA_COORD_GEOGRAPHIC,
  GEODATA_COORD_LOCAL_GRID,
  GEODATA_COORD_PROJECTED_GRID,
  GEODATA_DICT_ENTRY,
  GEODATA_VERSION,
  GEOREF_CRS_PATTERN,
  GEOREF_MAX_BASEMAPS,
  GEOTECH_BLOCKS,
  GRID_DEFAULTS,
  GROUP_NAME_MAX,
  GUIDE,
  GUIDE_STYLE,
  GridRule,
  HATCH_LINEWEIGHT_MAX,
  HATCH_LINEWEIGHT_MIN,
  HATCH_PATTERNS,
  HATCH_PATTERN_NAMES,
  HIGHLIGHT_ROLE,
  HorizontalRule,
  IDENT,
  IMAGE_MIN_EDGE,
  INFERENCE_RULE_REGISTRY,
  INFERENCE_SETTING_SCHEMA,
  INFERENCE_SETTING_SECTIONS,
  IntersectionRule,
  LARGE,
  LAYER_NAME_MAX_LENGTH,
  LEGACY_CARRIER_FIELDS,
  LENGTHEN_OPTION_KEYS,
  LINETYPE_DEFS,
  LINEWEIGHTS_MM,
  LINEWEIGHT_DISPLAY_PX_PER_MM,
  MAX_ACQUIRED,
  MAX_CSV_ROWS,
  MAX_DEFINITION_CHARS,
  MAX_MARKS,
  MAX_PAGE_MEGAPIXELS,
  MIN_LINE_PX,
  MODEL_UNIT_MM,
  MTEXT_DEFAULT_LINE_SPACING,
  MidpointRule,
  NearestRule,
  OP_KINDS,
  PAPER_SIZES,
  PAPER_TEXT_MM,
  PAPER_WIDTH_MM,
  PEDIT_OPTIONS,
  PICKER,
  PICK_FILTER,
  PLOT_SCALE_FIT,
  PLOT_SCALE_PRESETS,
  PLOT_STYLE_MAX_ENTRIES,
  PLOT_STYLE_MODES,
  POLAR_APERTURE_DEG,
  PRECISE_SNAP_TYPES,
  PX_PER_MM,
  ParallelRule,
  PerpendicularFootRule,
  PerpendicularRule,
  PolarTrackingRule,
  QuadrantRule,
  RAD2DEG,
  RENDER_ORIGIN_STEP,
  RESERVED_STYLE_KEYS,
  RULE,
  RULE_GROUPS,
  RULE_PRIORITY,
  SCALEBAR_MIXED_TEXT,
  SCALEBAR_NONE_TEXT,
  SCALE_MAX,
  SCALE_MIN,
  SHEET_SYMBOL_PEN_MM,
  SHEET_SYMBOL_TYPES,
  SHEET_ZOOM_MAX_FIT,
  SHEET_ZOOM_MIN_FIT,
  SNAP_LABELS,
  SOLVER_WRITE_BACK_TOL,
  STYLE_KINDS,
  STYLE_ONLY_FIELDS,
  SolverNotReadyError,
  TABLE_CELL_KEY_RE,
  TABLE_MAX_CELLS,
  TEMPLATE_MAX_BYTES,
  TEMPLATE_MAX_ENTITIES,
  TEXTSTYLE_DEFAULTS,
  TIER,
  TangentRule,
  TemplateImportError,
  UNDERLAY_DEFAULTS,
  VIEWPORT_SCALE_PRESETS,
  VerticalRule,
  aci2int,
  addAnnotation,
  addBasemap,
  addLayout,
  addPolylineVertex,
  addViewport,
  addableConstraints,
  alignEntities,
  alignTransform,
  angleDelta,
  angleInArcSweep,
  angularFromTwoLines,
  angularGeometry,
  angularMeasure,
  annotationBoxMm,
  annotationRotatable,
  annotationTextHeight,
  annotativeStyleOf,
  apply,
  applyGripDrag,
  applyHysteresis,
  applyImportOffset,
  applyLayerIsolation,
  applyMergeResolution,
  applyPeditOption,
  approxMeasure,
  arclengthGeometry,
  arrayEntities,
  arrowShape,
  arrowStrokes,
  arrowTriangle,
  attachXref,
  attachedDimensionIds,
  attdefFromText,
  attributeValuesOf,
  attributesForInsert,
  autoAnnotationScale,
  autoDimBaseHeight,
  autoTextHeight,
  baselineLinePoint,
  batchPlotPlan,
  bearingError,
  bindXref,
  blockDeleteImpact,
  blockNameError,
  booleanRegions,
  boundaryFromEntities,
  boxContains,
  boxesOverlap,
  breakEntityAt,
  breakRemovedSpan,
  buildDocument,
  buildFidelityReport,
  buildPolygons,
  bulgeToArc,
  cadModelToDXF,
  cadModelToDXFDetailed,
  cadModelToPlot,
  cadModelToSVG,
  cancelModifyPhase,
  candidateKey,
  candidatePoint,
  captureDpiFor,
  carryStyle,
  chainStep,
  chamferEntities,
  changedFields,
  checkConstraint,
  chooseHatchBoundary,
  chunkDefinition,
  circleCircleIntersections,
  clampHatchLineWeight,
  clampLineweight,
  clampPolylineWidth,
  clampScale,
  clampSheetView,
  clearBasemaps,
  clearLayerIsolation,
  cloneDefs,
  cloneEntity,
  closestEntityWithin,
  closestPointOnSegment,
  commandReservesText,
  commandShape,
  composeCandidates,
  computeImportOffset,
  configureDwgWasmDir,
  constrainOrtho,
  constrainPolar,
  constraintHints,
  constraintKey,
  constraintList,
  constraintsFromHints,
  contextFactor,
  corridorPoints,
  corridorRects,
  createBlankDocument,
  createGroup,
  createInferenceContext,
  createInferenceEngine,
  createSpatialIndex,
  createTrackingStore,
  crsCodeFromDefinition,
  csvPointsToEntities,
  cullToWorldRect,
  currentLayerFrozenError,
  curveAffinity,
  curveGate,
  dashedGuide,
  deconflictLabels,
  defaultSelectReference,
  defaultSettings,
  defaultViewportForModel,
  deleteEmptyLayer,
  deleteLayersWithContents,
  deleteLayout,
  deleteStyle,
  dependencyGraph,
  deriveCompatSolveOpts,
  deriveSheetScale,
  detachXref,
  diffDocuments,
  dimOverrideDisplay,
  dimOverrideFieldsFor,
  dimOverrides,
  dimTextOffset,
  dimensionEditGrounding,
  dimensionEditRecord,
  dimensionGeometry,
  dimensionLabel,
  dimensionMeasure,
  dimensionPrimitives,
  dimensionSourceFromEntity,
  dimensionSourceIds,
  dimensionTextAnchor,
  dimensionTextColor,
  directionCandidate,
  distance,
  distanceToDimension,
  distanceToEntity,
  distanceToHatch,
  distanceToXrefFrame,
  dividePoints,
  divideRefusal,
  docAttachImageDef,
  documentAnnotationScale,
  documentBounds,
  documentGroups,
  draftOption,
  drawnBlockChildren,
  driveDimensionValue,
  dropRedundant,
  dwgDbToParsed,
  dxfToDocument,
  dxfToXrefSource,
  dynFields,
  dynLiveValues,
  dynLockValue,
  easeInOutCubic,
  editableEntity,
  effectiveArrowSize,
  effectiveBaselineSpacing,
  effectiveEntityTextHeight,
  effectiveExtExtend,
  effectiveExtOffset,
  effectiveTextGap,
  effectiveTextHeight,
  ellipseParamAt,
  ellipsePoint,
  ellipseQuadrants,
  ellipseSweep,
  ellipseToPolyline,
  ellipticalArcLength,
  emptyPlotStyleTable,
  endsOnFinalInput,
  endsWithOwnSurface,
  entitiesInLasso,
  entitiesInSelectionBox,
  entitiesThroughPoints,
  entityBounds,
  entityContext,
  entityDrawOps,
  entityGrips,
  entityInMarquee,
  entityLength,
  entityOutlinePoints,
  entityPaperHeight,
  entityRef,
  entitySegments,
  entitySignature,
  entityToDrawItem,
  entityVertices,
  expandGroupSelection,
  explodeAttributeLoss,
  explodeEntity,
  explodeInsert,
  explodeRegion,
  explodeSelection,
  extendEntity,
  falloff,
  fidelitySummary,
  fieldCodeLabel,
  fieldLayoutFor,
  filletEntities,
  filletPickedEdges,
  findClosedBoundaryAt,
  findHatchIslands,
  findRegionBoundaryAt,
  findSnap,
  finishDecision,
  fitExtents,
  fitRectToCanvasRect,
  fitRectToViewport,
  fitSelection,
  fitSheetView,
  fitView,
  footOnLine2 as footOnLine,
  formatArchitectural,
  formatCoord,
  formatDynValue,
  formatGridCoord,
  formatMeasure,
  formatMeasureResult,
  formatScale,
  framingBounds,
  freezeCurrentLayerError,
  genId,
  getLayer,
  getLayout,
  getSpatialIndex,
  getWrapper,
  gisMode,
  glyphGuide,
  gridSpacingCommit,
  gridSpacingLabel,
  gridSpacingReport,
  gridSuppressionNote,
  gridToWorld,
  gripDynFields,
  gripDynLiveValues,
  gripPreviewDimensions,
  groupById,
  groupOf,
  groupRefusal,
  hasDimOverrides,
  hasImageFrame,
  hatchArea,
  hatchFillsPoint,
  hatchLineWeight,
  hatchSourceIds,
  healFieldBindings,
  hexFromInt,
  highlightGuide,
  identityCtx,
  imageCorners,
  imageDataUrl,
  imageDefFor,
  imageFlipped,
  imageFromPlacement,
  imageHeight,
  imageMatrix,
  imageRotationDeg,
  imageWidth,
  inferConstraints,
  inferenceEnabled,
  inferenceEngine,
  inferenceOn,
  inferenceTelemetry,
  initSolver,
  initialFieldValues,
  insertMatrix,
  insertOption,
  int2aci,
  intersectEntities,
  intersectLines,
  intersectRegions,
  isAnnotative,
  isBasemapId,
  isBooleanOperand,
  isBuiltinBlock,
  isClosedBoundary,
  isCurveTool,
  isDerived,
  isDimOverrideKey,
  isDwgFilename,
  isFieldCode,
  isFitSpline,
  isFullEllipse,
  isGridCoordinateText,
  isLinearDrawTool,
  isMonoPlot,
  isPrecisePointSnap,
  isRepeating,
  isRuleLocked,
  isSafeStyleName,
  isSolverReady,
  isTransformTool,
  isValidDimOverride,
  joinDefinition,
  joinEntities,
  justifyFactors,
  justifyOffset,
  layerFrozen,
  layerIndex,
  layerLocked,
  layerNameError,
  layerNameKey,
  layerOverridesHash,
  layerPlotted,
  layerRenameError,
  layerShown,
  layerUsage,
  layoutMText,
  layoutPaperDims,
  leaderGeometry,
  lengthenEntity,
  lengthenOption,
  lengthenTarget,
  lerpView,
  lineDirection,
  lineIntersection,
  lineLineIntersection,
  lineOfAction,
  linearDrawGate,
  linearOrientation,
  linetypeToDash,
  lineweightToScreenPx,
  listCommands,
  lockedEntityIds,
  lockedGrounding,
  makeConstraint,
  makeDimChain,
  makeDimSizing,
  makeDimension,
  makeHatch,
  makePlotPenResolver,
  makePriorityOf,
  makeRegions,
  mapAngleDeg,
  mapArc,
  mapCircle,
  mapDimension,
  mapEllipse,
  mapErrorPx,
  mapHatch,
  mapHatchRegions,
  mapInsert,
  mapLine,
  mapPoint,
  mapPolyline,
  mapSolid,
  mapSpline,
  mapText,
  matMul,
  measureArea,
  measureAreaAt,
  measureDistance,
  measurePoints,
  mergeCoincident,
  mergeGeorefDecision,
  mergeLayer,
  migrateAnnotativeEntity,
  minimalCrsXml,
  mirrorEntities,
  mirrorEntity,
  mmToPx,
  modelLayout,
  modelUnitMm,
  modifyPhaseBlocksUndo,
  modifyPhaseCancellable,
  mtextBoxCorners,
  mtextGripPoints,
  mtextLocal,
  mtextToWorld,
  mtextWidthPatch,
  nearestEdgeIndex,
  nearestOnEntity,
  nextCandidate,
  niceGroundLength,
  niceStep,
  normalizeAngle180,
  normalizeBlockName,
  normalizeCanvasRect,
  normalizeCoords,
  normalizeDocument,
  normalizeFieldTag,
  normalizeGeoref,
  normalizeGrid,
  normalizeGroupName,
  normalizeGroups,
  normalizeImageDef,
  normalizeImageEntity,
  normalizeInferenceSettings,
  normalizeLayerName,
  normalizeLinetypeName,
  normalizeMargin,
  normalizePageSetup,
  normalizePlotScale,
  normalizePlotStyleTable,
  normalizeSettings,
  normalizeSheetSymbol,
  normalizeUnderlay,
  northArrowDrawList,
  objectPickContext,
  offsetEntity,
  offsetRefusal,
  orderForDraw,
  ordinateAxis,
  ordinateGeometry,
  orientRing,
  orientRingSet,
  orphanImageDefIds,
  pageContentRect,
  paintedArea,
  paperDims,
  paperMmToModel,
  paperPxToModel,
  parseCoordinate,
  parseCsvPoints,
  parseDWG,
  parseDXF,
  parseGridCommand,
  parseGridSpacingInput,
  parseScale,
  parseTemplateFromDxf,
  partitionLockedIds,
  pathTotalLength,
  peditDecurve,
  peditFit,
  peditJoin,
  peditOption,
  peditRefusal,
  peditReverse,
  peditSetClosed,
  peditSetWidth,
  peditSpline,
  peditToPolyline,
  perpDistance,
  perpendicularFoot,
  placeAttribute,
  placeBlockChild,
  placeTemplate,
  planBlockDefinition,
  planGeodata,
  plotPenFor,
  plottingBasemaps,
  pointAtArcLength,
  pointCandidate,
  pointFeatureRef,
  pointInPolygon,
  pointInRotRect,
  pointToSegment,
  polarStepAngle,
  polygonArea,
  polygonPoints,
  polylineWidthWorld,
  previewDimensions,
  projectionLength,
  pruneConstraints,
  pruneExclusive,
  pruneGroups,
  pxToMm,
  quickSelectMatch,
  radialGeometry,
  readGeodata,
  rebuildAll,
  rebuildDerived,
  rebuildDimension,
  rebuildEntity,
  rebuildHatch,
  reconcileImportGeoref,
  recordCommit,
  rectCenter,
  rectCornersRot,
  reframeAttributes,
  refreshFields,
  refsAreLive,
  regionArea,
  regionContains,
  regionFillsPoint,
  regionRings,
  reloadXref,
  removeAnnotation,
  removeBasemap,
  removePolylineVertex,
  removeViewport,
  renameGroup,
  renameLayer,
  renameLayout,
  renameStyle,
  renderOriginFor,
  resetInferenceTelemetry,
  resizeImage,
  resizeRect,
  resolveAnnotationScale,
  resolveColor,
  resolveCommand,
  resolveConflicts,
  resolveDeferredTangent,
  resolveDimStyle,
  resolveFeatureRef,
  resolveField,
  resolveGridSpec,
  resolveInferenceSettings,
  resolveLinetypeName,
  resolveLinetypePattern,
  resolveLineweightMm,
  resolvePageSetup,
  resolvePoint,
  resolveRef,
  resolveRefs,
  resolveTextCollision,
  resolveTextStyle,
  resolveUserDimScale,
  revisionCloudArcs,
  revisionCloudBumps,
  rightClickAction,
  ringArea,
  ringDifference,
  ringIntersection,
  ringUnion,
  rotateEntities,
  rotateEntity,
  rotateVec,
  roundOrigin,
  ruleEnabled,
  runInference,
  sameGeoref,
  sameGeorefFrame,
  sameView,
  samplePathPoints,
  sanitizeDimOverrides,
  scaleBarDrawList,
  scaleBarSpec,
  scaleEntities,
  scaleEntity,
  scaleViewportKeepingFrame,
  scoreCandidate,
  scoreCandidates,
  screenToPaperPx,
  screenToWorld,
  sectionConflictId,
  segCircleIntersections,
  segCuts,
  segSegIntersection,
  segmentAngle,
  segmentCount,
  segmentOf,
  selectReference,
  selectableEntities,
  selectableEntity,
  selectionLayerNames,
  setBasemapsVisible,
  setGroupSelectable,
  setInferenceEnabled,
  setPageSetup,
  setUseGcsSolver,
  settingDefault,
  sheetScaleBinding,
  sheetScaleConflict,
  sheetScaleDenom,
  sheetTextBoxMm,
  shownEntities,
  signedArea,
  sizingAnnoScale,
  snapLabel,
  snapRect,
  snapToGrid,
  solveConstraints,
  solveConstraintsCompat,
  solveGripPlacement,
  solveParametric,
  solvePlacement,
  sortCandidates,
  sourceKey,
  sourcesOf,
  splineArcLength,
  splineArcLengthParams,
  splineDefiningPoints,
  splinePointAt,
  splineToPolyline,
  stretchEntities,
  stretchEntity,
  stripMText,
  styleDeleteError,
  styleRenameError,
  subtractRegions,
  supplementParsedDxf,
  supportsDimOverrides,
  syncAnnotativeEntity,
  syncAnnotativeHeights,
  tableColEdgePatch,
  tableCorners,
  tableGripPoints,
  tableLayout,
  tableLocal,
  tableMinColWidth,
  tableMinRowHeight,
  tableRowEdgePatch,
  tableScalePatch,
  tableToWorld,
  tangentPointsToCircle,
  templateBounds,
  templateToDrawList,
  tessellateHatch,
  textBox,
  textBoxCorners,
  threeWayDiff,
  trackingAlignments,
  transformEntity,
  transformImageFrame,
  transformPoint,
  translateEntity,
  trimAlongFence,
  trimEntity,
  trimPreviewPiece,
  underlayFromNaturalSize,
  underlayKonvaBox,
  unfrozenEntities,
  ungroup,
  unionRegions,
  uniqueGroupName,
  unplaceAttribute,
  updateAnnotation,
  updateBasemap,
  updateHatchCache,
  updateLayout,
  updateViewport,
  useGcsSolver,
  viewportAnnotationScale,
  viewportContentAffine,
  viewportFrameMm,
  viewportPaperRectMm,
  viewportPrintMetresPerPixel,
  viewportRectPx,
  violatedConstraintEntityIds,
  withDimOverride,
  worldToGrid,
  worldToScreen,
  worldToTableCell,
  worldToYDown,
  worldToYDownAngle,
  worldToYDownFrom,
  writeGeodataObjects,
  xrefDrawSegments,
  xrefFrameBounds,
  xrefLayerVisible,
  yDownToWorld,
  zoomAt,
  zoomByFactor,
  zoomToScreenBox
};
//# sourceMappingURL=index.js.map